var _defineProperty = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

/*! For license information please see bundle.js.LICENSE.txt */
(function () {
  var t = {
    5061: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        init: function init(t, e, r) {
          this.length = t, this.untilFrame = e, this.finish = r;
        },
        tick: function tick(t) {
          if (this.loaded) {
            this.facing && this.facing != this.sprite.facing && this.sprite.setFacing(this.facing);
            var e = this.startTime + this.length,
                r = (t - this.startTime) / this.length;
            t >= e && (r = 1, this.finish && this.finish(!0));
            var n = Math.floor(r * this.untilFrame);
            return n != this.sprite.animFrame && this.sprite.setFrame(n), t >= e;
          }
        }
      };
    },
    1183: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return p;
        }
      });
      var n = r(8348),
          o = r(4180);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a() {
        a = function a() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            s = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, a, s, c) {
            var u = f(t[o], t, a);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == i(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, s, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function s(t, e, r) {
        return s = c() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && u(o, r.prototype), o;
        }, s.apply(null, arguments);
      }

      function c() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function u(t, e) {
        return u = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, u(t, e);
      }

      function l(t) {
        return function (t) {
          if (Array.isArray(t)) return f(t);
        }(t) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return f(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? f(t, e) : void 0;
          }
        }(t) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function f(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      function h(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      var p = {
        init: (d = a().mark(function t(e, r, i, c, u) {
          return a().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.sprite.zone.world.loadZone(e);

                case 2:
                  return this.fromZone = t.sent, t.next = 5, this.sprite.zone.world.loadZone(i);

                case 5:
                  this.toZone = t.sent, this.from = s(n.OW, l(r)), this.to = s(n.OW, l(c)), this.facing = o.N.fromOffset([Math.round(c.x - r.x), Math.round(c.y - r.y)]), this.length = u;

                case 10:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        }), y = function y() {
          var t = this,
              e = arguments;
          return new Promise(function (r, n) {
            var o = d.apply(t, e);

            function i(t) {
              h(o, r, n, i, a, "next", t);
            }

            function a(t) {
              h(o, r, n, i, a, "throw", t);
            }

            i(void 0);
          });
        }, function (t, e, r, n, o) {
          return y.apply(this, arguments);
        }),
        tick: function tick(t) {
          if (this.toZone.loaded && this.fromZone.loaded) {
            this.facing && this.facing != this.sprite.facing && (this.sprite.facing = this.facing, this.sprite.setFrame(0));
            var e = this.startTime + this.length,
                r = (t - this.startTime) / this.length;
            t >= e ? ((0, n.t8)(this.to, this.sprite.pos), r = 1) : (0, n.t7)(this.from, this.to, r, this.sprite.pos);
            var o = Math.floor(4 * r);
            o != this.sprite.animFrame && this.sprite.setFrame(o), this.sprite.zone.isInZone(this.sprite.pos.x, this.sprite.pos.y) || (this.fromZone.removeSprite(this.sprite.id), this.sprite.zone.world.runAfterTick(function () {
              this.toZone.addSprite(this.sprite), console.log("sprite '" + this.sprite.id + "' changed zone from '" + this.fromZone.id + "' to '" + this.toZone.id + "'");
            }.bind(this)));
            var i = this.sprite.pos.x + this.sprite.hotspotOffset.x,
                a = this.sprite.pos.y + this.sprite.hotspotOffset.y;
            return this.switchRenderZone || this.fromZone.isInZone(i, a) || (this.switchRenderZone = !0), this.sprite.pos.z = (this.switchRenderZone ? this.toZone : this.fromZone).getHeight(i, a), t >= e;
          }
        }
      };
      var d, y;
    },
    5317: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        init: function init(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.engine = this.sprite.engine, this.text = "", this.prompt = t, this.scrolling = e, this.line = 0, this.options = r, this.completed = !1, this.lastKey = new Date().getTime();
        },
        tick: function tick(t) {
          var e;
          if (this.loaded) return this.options && this.options.autoclose && (this.endTime = this.endTime ? this.endTime : null !== (e = this.options.endTime) && void 0 !== e ? e : new Date().getTime() + 1e4, t > this.endTime && (this.completed = !0)), this.checkInput(t), this.textbox = this.engine.scrollText(this.prompt + this.text, this.scrolling, this.options), this.completed;
        },
        checkInput: function checkInput(t) {
          if (t > this.lastKey + 100) {
            var e = !1;

            switch (this.engine.keyboard.lastPressedCode()) {
              case "Escape":
                this.completed = !0, e = !0;
                break;

              case "Backspace":
                var r = this.text.split("");
                r.pop(), this.text = r.join(""), this.lastKey = t, e = !0;
                break;

              case "Enter":
                this.engine.setGreeting(this.text), this.sprite.speech.clearHud && this.sprite.speech.clearHud(), this.speechbox = this.sprite.speech.scrollText(this.text), this.sprite.speech.loadImage(), this.completed = !0, e = !0;
            }

            if (!e) {
              var n = this.engine.keyboard.lastPressedKey();
              n && (this.lastKey = t, this.text += "" + n);
            }
          }
        }
      };
    },
    8304: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return o;
        }
      });
      var n = r(4180);
      var o = {
        init: function init(t, e) {
          this.zone = e, this.moveLength = t, this.startTime = new Date().getTime(), this.lastKey = new Date().getTime(), this.completed = !1, this.audio = this.zone.engine.audioLoader.load("/pixos/audio/brass-loop.mp3"), this.audio.playAudio(), this.audioContext = new AudioContext(), this.analyser = this.audioContext.createAnalyser(), this.audioSource = this.audioContext.createMediaElementSource(this.audio.audio), this.audioSource.connect(this.analyser), this.analyser.connect(this.audioContext.destination);
        },
        tick: function tick(t) {
          if (this.loaded) {
            var e = new Uint8Array(this.analyser.frequencyBinCount);

            if (this.analyser.getByteFrequencyData(e), this.checkInput(t), t > this.startTime + this.moveLength) {
              for (var r = this.sprite.facing == n.N.Right ? n.N.Left : n.N.Right, o = null, i = 0; i < 16; i++) {
                o = -e[i] / 2;
              }

              r = o > 80 ? this.sprite.facing == n.N.Right ? n.N.Down : n.N.Left : this.sprite.facing == n.N.Up ? n.N.Left : n.N.Down, this.sprite.addAction(this.sprite.faceDir(r)), this.startTime = t;
            }

            return this.completed;
          }
        },
        checkInput: function checkInput(t) {
          if (t > this.lastKey + this.moveLength) return "q" === this.sprite.engine.keyboard.lastPressed("q") && (this.audio.pauseAudio(), this.completed = !0), this.lastKey = new Date().getTime(), null;
        }
      };
    },
    2282: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        init: function init(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.engine = this.sprite.engine, this.text = t, this.displayText = "string" == typeof t ? t : this.text.shift(), this.scrolling = e, this.options = r, this.completed = !1, this.lastText = !1, this.speechOutput = !0, this.lastKey = new Date().getTime(), this.loaded = !0;
        },
        tick: function tick(t) {
          var e;
          if (this.loaded) return this.options && this.options.autoclose && (this.endTime = this.endTime ? this.endTime : null !== (e = this.options.endTime) && void 0 !== e ? e : new Date().getTime() + 1e4, t > this.endTime && (this.completed = !0)), this.checkInput(t), this.sprite.speak(this.displayText, !1, this), this.completed && this.options.onClose && (this.sprite.speech.clearHud && this.sprite.speech.clearHud(), this.options.onClose()), this.completed;
        },
        checkInput: function checkInput(t) {
          if (t > this.lastKey + 100) {
            switch (this.engine.keyboard.lastPressedCode()) {
              case "Escape":
                this.sprite.speak(!1), this.completed = !0;
                break;

              case "Enter":
                "string" == typeof this.text || 0 === this.text.length ? this.completed = !0 : (this.completed = !1, this.displayText = this.text.shift(), window.speechSynthesis.cancel(), this.speechOutput = !0, this.sprite.speak(this.displayText, !1, this));
            }

            if (this.engine.gamepad.keyPressed("a")) return void ("string" == typeof this.text || 0 === this.text.length ? this.completed = !0 : (this.completed = !1, this.displayText = this.text.shift(), window.speechSynthesis.cancel(), this.speechOutput = !0, this.sprite.speak(this.displayText, !1, this)));
            if (this.engine.gamepad.keyPressed("a")) return this.sprite.speak(!1), void (this.completed = !0);
          }
        }
      };
    },
    2813: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        init: function init(t) {
          this.facing = t;
        },
        tick: function tick(t) {
          return this.facing && this.facing != this.sprite.facing && this.sprite.setFacing(this.facing), !0;
        }
      };
    },
    1162: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        init: function init(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.engine = this.sprite.engine, this.greeting = t, this.options = e, this.completed = !1;
        },
        tick: function tick(t) {
          if (this.loaded) return this.engine.setGreeting(this.text), !0;
        }
      };
    },
    5544: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return l;
        }
      });
      var n = r(8348),
          o = r(4180);

      function i(t, e, r) {
        return i = a() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && s(o, r.prototype), o;
        }, i.apply(null, arguments);
      }

      function a() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function s(t, e) {
        return s = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, s(t, e);
      }

      function c(t) {
        return function (t) {
          if (Array.isArray(t)) return u(t);
        }(t) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return u(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? u(t, e) : void 0;
          }
        }(t) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function u(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      var l = {
        init: function init(t, e, r) {
          var a = this;
          this.world = r, this.from = i(n.OW, c(t)), this.facing = e, this.offset = o.N.toOffset(e), this.lastKey = new Date().getTime(), this.completed = !1, this.to = [t[0] + this.offset[0], t[1] + this.offset[1]], this.zone = r.zoneContaining.apply(r, c(this.to)), this.spriteList = this.zone.spriteList.filter(function (t) {
            return t.pos.x === a.to[0] && t.pos.y === a.to[1];
          }), this.objectList = this.zone.objectList.filter(function (t) {
            return t.pos.x === a.to[0] && t.pos.y === a.to[1];
          }), this.finish = this.finish.bind(this), this.interact();
        },
        interact: function interact() {
          var t = this;
          0 === this.spriteList.length && 0 === this.objectList.length && (this.completed = !0), this.objectList.forEach(function (e) {
            var r = e.faceDir(o.N.reverse(t.facing));
            return r && e.addAction(r), e.interact ? t.zone.objectDict[e.id].interact(t.sprite, t.finish) : null;
          }), this.spriteList.forEach(function (e) {
            var r = e.faceDir(o.N.reverse(t.facing));
            return r && e.addAction(r), e.interact ? t.zone.spriteDict[e.id].interact(t.sprite, t.finish) : null;
          });
        },
        finish: function finish(t) {
          t && (this.completed = !0);
        },
        tick: function tick(t) {
          if (this.loaded) return this.checkInput(t), this.completed;
        },
        checkInput: function checkInput(t) {
          if (t > this.lastKey + this.length) {
            if ("q" !== this.sprite.engine.keyboard.lastPressed("q")) return this.lastKey = new Date().getTime(), null;
            this.completed = !0;
          }

          this.sprite.engine.gamepad.keyPressed("a") && (this.completed = !0);
        }
      };
    },
    2897: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return l;
        }
      });
      var n = r(8348),
          o = r(4180);

      function i(t, e, r) {
        return i = a() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && s(o, r.prototype), o;
        }, i.apply(null, arguments);
      }

      function a() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function s(t, e) {
        return s = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, s(t, e);
      }

      function c(t) {
        return function (t) {
          if (Array.isArray(t)) return u(t);
        }(t) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return u(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? u(t, e) : void 0;
          }
        }(t) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function u(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      var l = {
        init: function init(t, e, r, a) {
          var s = this;
          this.zone = a, this.from = i(n.OW, c(t)), this.to = i(n.OW, c(e)), this.facing = o.N.fromOffset([Math.round(e.x - t.x), Math.round(e.y - t.y)]), this.length = r, console.log(this.zone), this.spriteList = this.zone.spriteList.filter(function (t) {
            return t.pos.x === s.to.x && t.pos.y === s.to.y;
          });
        },
        tick: function tick(t) {
          if (this.loaded) {
            this.facing && this.facing != this.sprite.facing && this.sprite.setFacing(this.facing);
            var e = this.startTime + this.length,
                r = (t - this.startTime) / this.length;
            t >= e ? ((0, n.t8)(this.to, this.sprite.pos), r = 1, this.onStep()) : (0, n.t7)(this.from, this.to, r, this.sprite.pos);
            var o = Math.floor(4 * r);
            o != this.sprite.animFrame && this.sprite.setFrame(o);
            var i = this.sprite.pos.x + this.sprite.hotspotOffset.x,
                a = this.sprite.pos.y + this.sprite.hotspotOffset.y;
            return this.sprite.pos.z = this.sprite.zone.getHeight(i, a), t >= e;
          }
        },
        onStep: function onStep() {
          var t = this;
          console.log("on steppping", this.spriteList), 0 === this.spriteList.length && (this.completed = !0), this.spriteList.forEach(function (e) {
            return e.onStep ? t.zone.spriteDict[e.id].onStep(t.sprite) : null;
          });
        }
      };
    },
    2704: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return h;
        }
      });
      var n = r(8348),
          o = r(4180),
          i = r(3569);

      function a(t, e, r) {
        return a = s() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && c(o, r.prototype), o;
        }, a.apply(null, arguments);
      }

      function s() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function c(t, e) {
        return c = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, c(t, e);
      }

      function u(t) {
        return function (t) {
          if (Array.isArray(t)) return f(t);
        }(t) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || l(t) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function l(t, e) {
        if (t) {
          if ("string" == typeof t) return f(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? f(t, e) : void 0;
        }
      }

      function f(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      var h = {
        init: function init(t, e, r, o) {
          this.zone = o, this.from = a(n.OW, u(t)), this.to = a(n.OW, u(e)), this.lastKey = new Date().getTime(), this.completed = !1, this.direction = 1, this.audio = this.zone.engine.audioLoader.load("/pixos/audio/sewer-beat.mp3");
          var i,
              s,
              c = (i = this.sprite.zone.world.pathFind(t, e), s = 2, function (t) {
            if (Array.isArray(t)) return t;
          }(i) || function (t, e) {
            var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

            if (null != r) {
              var n,
                  o,
                  i = [],
                  a = !0,
                  s = !1;

              try {
                for (r = r.call(t); !(a = (n = r.next()).done) && (i.push(n.value), !e || i.length !== e); a = !0) {
                  ;
                }
              } catch (t) {
                s = !0, o = t;
              } finally {
                try {
                  a || null == r.return || r.return();
                } finally {
                  if (s) throw o;
                }
              }

              return i;
            }
          }(i, s) || l(i, s) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }());
          this.hasMoves = c[0], this.moveList = c[1], this.hasMoves || (this.completed = !0), this.moveIndex = 1, this.moveLength = r, this.zone.audio && this.zone.audio.pauseAudio(), this.audio.playAudio();
        },
        tick: function tick(t) {
          if (this.loaded) {
            if (this.checkInput(t), t > this.startTime + this.moveLength) {
              var e = this.moveList[this.moveIndex];

              if (this.moveList.length > 2) {
                var r = 0 == this.moveIndex ? this.moveList[this.moveIndex + 1] : this.moveIndex + 1 >= this.moveList.length ? this.moveList[this.moveList.length - 1] : this.moveList[this.moveIndex - 1],
                    n = o.N.fromOffset([Math.round(e[0] - r[0]), Math.round(e[1] - r[1])]);
                if (this.sprite.zone.isInZone(e[0], e[1])) this.currentAction = new i.aW(this.sprite.engine, "move", [r, e, this.moveLength, this.zone], this.sprite);else {
                  var a = this.sprite.zone.world.zoneContaining(e[0], e[1]);
                  a && a.loaded && a.isWalkable(e[0], e[1], o.N.reverse(n)) ? this.currentAction = new i.aW(this.sprite.engine, "changezone", [this.sprite.zone.id, this.sprite.pos.toArray(), a.id, e, this.moveLength], this.sprite) : this.currentAction = this.sprite.faceDir(n);
                }
                this.currentAction && (this.currentAction.facing = n, this.sprite.addAction(this.currentAction));
              }

              this.moveIndex + this.direction >= this.moveList.length && (this.direction *= -1, this.completed = !0, this.zone.audio && this.zone.audio.playAudio(), this.audio.pauseAudio()), this.moveIndex += this.direction, this.startTime = t;
            }

            return this.completed;
          }
        },
        checkInput: function checkInput(t) {
          if (t > this.lastKey + this.moveLength) return "q" === this.sprite.engine.keyboard.lastPressed("q") && (this.audio.pauseAudio(), this.completed = !0), this.lastKey = new Date().getTime(), null;
        }
      };
    },
    3382: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        init: function init(t, e) {
          var r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
              n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          this.engine = this.sprite.engine, this.text = "", this.scrolling = r, this.line = 0, this.options = n, this.completed = !1, this.lastKey = new Date().getTime(), this.listenerId = this.engine.gamepad.attachListener(this.hookListener()), this.touches = [], this.menuDict = null != t ? t : {}, this.activeMenus = null != e ? e : [], this.selectedMenu = {}, this.selectedMenuId = null, this.isTouched = !1;
        },
        tick: function tick(t) {
          var e,
              r = this;
          if (this.loaded) return this.options && this.options.autoclose && (this.endTime = this.endTime ? this.endTime : null !== (e = this.options.endTime) && void 0 !== e ? e : new Date().getTime() + 1e4, t > this.endTime && (this.completed = !0)), this.checkInput(t), Object.keys(this.menuDict).filter(function (t) {
            return r.activeMenus.includes(t);
          }).map(function (t) {
            var e = r.menuDict[t],
                n = e.colours;
            e.active && (n.background = "#555"), r.engine.drawButton(e.text, e.x, e.y, e.w, e.h, e.colours);
          }), this.textbox = this.engine.scrollText(this.prompt + this.text, this.scrolling, this.options), this.completed && this.unhookListener(), this.completed;
        },
        unhookListener: function unhookListener() {
          this.engine.gamepad.removeListener(this.listenerId), this.listenerId = null;
        },
        hookListener: function hookListener() {
          var t = this,
              e = function e(_e2) {
            var r = _e2.touches;

            if (t.isTouched = !0, t.touches = r, t.isTouched && t.touches.length > 0 && t.lastKey + 100 < new Date().getTime()) {
              var n = t.touches[0].x,
                  o = t.touches[0].y,
                  i = t;
              i.activeMenus.filter(function (t) {
                var e = i.menuDict[t];
                return n < e.x + e.w && n > e.x && o < e.y + e.h && o > e.y;
              }).map(function (e) {
                var r = i.menuDict[e];
                r.trigger && r.trigger(t), r.children && (i.activeMenus = r.children);
              });
            }
          },
              r = function r(e) {
            t.touches = e;
          },
              n = function n(e) {
            t.isTouched = !1, t.touches = e;
          };

          return {
            touchstart: e,
            touchmove: r,
            touchend: n,
            mousedown: e,
            mousemove: r,
            mouseup: n
          };
        },
        checkInput: function checkInput(t) {
          if (t > this.lastKey + 100) {
            var e = !1;

            switch (this.engine.keyboard.lastPressedCode()) {
              case "Escape":
                this.completed = !0, e = !0;
                break;

              case "Backspace":
                var r = this.text.split("");
                r.pop(), this.text = r.join(""), this.lastKey = t, e = !0;
                break;

              case "Enter":
                this.engine.setGreeting(this.text), this.sprite.speech.clearHud && this.sprite.speech.clearHud(), this.speechbox = this.sprite.speech.scrollText(this.text), this.sprite.speech.loadImage(), this.completed = !0, e = !0;
            }

            if (!e) {
              var n = this.engine.keyboard.lastPressedKey();
              n && (this.lastKey = t, this.text += "" + n);
            }
          }
        }
      };
    },
    5744: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o() {
        o = function o() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            s = i.asyncIterator || "@@asyncIterator",
            c = i.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, a, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, a) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function o(i, a, s, c) {
            var u = f(t[i], t, a);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == n(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                o("next", t, s, c);
              }, function (t) {
                o("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return o("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var i;

          this._invoke = function (t, r) {
            function n() {
              return new e(function (e, n) {
                o(t, r, e, n);
              });
            }

            return i = i ? i.then(n, n) : n();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[a];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  o = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return o.next = o;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, s, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, a, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function i(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return a;
        }
      });
      var a = {
        init: function init(t, e) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          this.zone = e, this.world = e.world, this.lastKey = new Date().getTime(), this.completed = !1, this.onCompleted = function () {
            return console.log("script finished");
          }, r && (this.onCompleted = r), this.triggerId = t, this.triggerScript();
        },
        triggerScript: function triggerScript() {
          var t = this;
          this.triggerId || (this.completed = !0), Promise.all(this.zone.scripts.filter(function (e) {
            return e.id === t.triggerId;
          }).map(function () {
            var e,
                r = (e = o().mark(function e(r) {
              return o().wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, r.trigger.call(t.zone);

                    case 2:
                      return e.abrupt("return", e.sent);

                    case 3:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            }), function () {
              var t = this,
                  r = arguments;
              return new Promise(function (n, o) {
                var a = e.apply(t, r);

                function s(t) {
                  i(a, n, o, s, c, "next", t);
                }

                function c(t) {
                  i(a, n, o, s, c, "throw", t);
                }

                s(void 0);
              });
            });
            return function (t) {
              return r.apply(this, arguments);
            };
          }())).then(function () {
            t.completed = !0;
          });
        },
        tick: function tick(t) {
          if (this.loaded) return this.completed && this.onCompleted(), this.completed;
        }
      };
    },
    6180: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return d;
        }
      });
      var n = r(8348),
          o = r(4180),
          i = r(3569);

      function a(t) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, a(t);
      }

      function s(t, e, r) {
        return s = h() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && u(o, r.prototype), o;
        }, s.apply(null, arguments);
      }

      function c(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function u(t, e) {
        return u = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, u(t, e);
      }

      function l(t, e) {
        if (e && ("object" === a(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return f(t);
      }

      function f(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }

      function h() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function p(t) {
        return p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, p(t);
      }

      var d = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && u(t, e);
        }(m, t);
        var e,
            r,
            a,
            d,
            y = (e = m, r = h(), function () {
          var t,
              n = p(e);

          if (r) {
            var o = p(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);

          return l(this, t);
        });

        function m(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, m), (e = y.call(this, t)).handleWalk = e.handleWalk.bind(f(e)), e;
        }

        return a = m, d = [{
          key: "init",
          value: function value() {
            console.log("- avatar hook", this.id, this.pos);
          }
        }, {
          key: "tick",
          value: function value(t) {
            if (!this.actionList.length) {
              var e = this.checkInput();
              e && this.addAction(e);
            }

            this.bindCamera && (0, n.t8)(this.pos, this.engine.cameraPosition);
          }
        }, {
          key: "openMenu",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
            return new i.aW(this.engine, "prompt", [t, e, !1, {
              autoclose: !1
            }], this);
          }
        }, {
          key: "checkInput",
          value: function value() {
            var t = this.engine.keyboard.lastPressedCode(),
                e = this.engine.gamepad.checkInput();

            switch (t) {
              case "b":
                this.bindCamera = !0;
                break;

              case "c":
                this.bindCamera = !1;
                break;

              case "m":
                return this.openMenu({
                  main: {
                    text: "Close Menu",
                    x: 100,
                    y: 100,
                    w: 150,
                    h: 75,
                    colours: {
                      top: "#333",
                      bottom: "#777",
                      background: "#999"
                    },
                    trigger: function trigger(t) {
                      t.completed = !0;
                    }
                  }
                }, ["main"]);

              case "z":
                this.zone.world.removeZone("room"), this.zone.world.loadZone("dungeon-top"), this.zone.world.loadZone("dungeon-bottom");
                break;

              case "y":
                this.zone.world.removeZone("dungeon-top"), this.zone.world.removeZone("dungeon-bottom"), this.zone.world.loadZone("room");
                break;

              case "k":
              case "Enter":
                return new i.aW(this.engine, "interact", [this.pos.toArray(), this.facing, this.zone.world], this);

              case "h":
                return new i.aW(this.engine, "dialogue", ["Welcome! You pressed help! Press Escape to close", !1, {
                  autoclose: !0
                }], this);

              case " ":
                return new i.aW(this.engine, "chat", [">:", !0, {
                  autoclose: !1
                }], this);

              case "q":
              case "Escape":
                this.speech.clearHud();
            }

            return this.engine.gamepad.keyPressed("a") ? new i.aW(this.engine, "interact", [this.pos.toArray(), this.facing, this.zone.world], this) : (1 === e.x && (this.bindCamera = !this.bindCamera), 1 === e.y ? this.openMenu({
              main: {
                text: "Close Menu",
                x: 100,
                y: 100,
                w: 150,
                h: 75,
                colours: {
                  top: "#333",
                  bottom: "#777",
                  background: "#999"
                },
                trigger: function trigger(t) {
                  t.completed = !0;
                }
              }
            }, ["main"]) : this.handleWalk(this.engine.keyboard.lastPressedKey(), e));
          }
        }, {
          key: "handleWalk",
          value: function value(t, e) {
            var r,
                a = o.N.None;

            switch (t) {
              case "w":
                a = o.N.Up;
                break;

              case "s":
                a = o.N.Down;
                break;

              case "a":
                a = o.N.Left;
                break;

              case "d":
                a = o.N.Right;
                break;

              case "u":
                return new i.aW(this.engine, "dance", [300, this.zone], this);

              case "p":
                return new i.aW(this.engine, "patrol", [this.pos.toArray(), new n.OW(8, 13, this.pos.z).toArray(), 600, this.zone], this);

              case "r":
                return new i.aW(this.engine, "patrol", [this.pos.toArray(), new n.OW(8, 13, this.pos.z).toArray(), 200, this.zone], this);
            }

            if (1 === e["x-dir"] && (a = o.N.Right), -1 === e["x-dir"] && (a = o.N.Left), 1 === e["y-dir"] && (a = o.N.Down), -1 === e["y-dir"] && (a = o.N.Up), r = this.engine.keyboard.shift || this.engine.gamepad.keyPressed("y") ? 200 : 600, this.facing !== a) return this.faceDir(a);
            var c = this.pos,
                u = o.N.toOffset(a),
                l = s(n.OW, [Math.round(c.x + u[0]), Math.round(c.y + u[1]), 0]);

            if (!this.zone.isInZone(l.x, l.y)) {
              var f = this.zone.world.zoneContaining(l.x, l.y);
              return f && f.loaded && f.isWalkable(l.x, l.y, o.N.reverse(a)) ? new i.aW(this.engine, "changezone", [this.zone.id, this.pos.toArray(), f.id, l.toArray(), r], this) : this.faceDir(a);
            }

            return this.zone.isWalkable(l.x, l.y, o.N.reverse(a)) ? new i.aW(this.engine, "move", [this.pos.toArray(), l.toArray(), r, this.zone], this) : this.faceDir(a);
          }
        }], d && c(a.prototype, d), Object.defineProperty(a, "prototype", {
          writable: !1
        }), m;
      }(r(5870).Z);
    },
    7408: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      r.d(e, {
        Z: function Z() {
          return o;
        }
      });

      var o = function () {
        function t() {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.actions = [];
        }

        var e, r;
        return e = t, r = [{
          key: "add",
          value: function value(t) {
            this.actions.push(t);
          }
        }, {
          key: "run",
          value: function value() {
            var t = arguments;
            this.actions = this.actions.filter(function (e) {
              return e(t);
            });
          }
        }], r && n(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();
    },
    1: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return p;
        }
      });
      var n = r(3162),
          o = r(5733),
          i = r(3793);

      function a(t) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, a(t);
      }

      function s() {
        s = function s() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, s, c) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == a(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function c(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function u(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(t) {
              c(i, n, o, a, s, "next", t);
            }

            function s(t) {
              c(i, n, o, a, s, "throw", t);
            }

            a(void 0);
          });
        };
      }

      function l(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function f(t, e, r) {
        return e && l(t.prototype, e), r && l(t, r), Object.defineProperty(t, "prototype", {
          writable: !1
        }), t;
      }

      function h(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      var p = f(function t() {
        var e = this;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), h(this, "init", function () {
          var r = u(s().mark(function r(n) {
            var o;
            return s().wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    t._instance.engine = n, (o = t._instance.world = new i.Z(n, "scene")).zoneList.forEach(function (t) {
                      return t.runWhenLoaded(function () {
                        return console.log("loading...done");
                      });
                    }), o.startMenu({
                      start: {
                        text: "Start Game",
                        prompt: "Please press the button to start...",
                        x: n.screenSize().width / 2 - 75,
                        y: n.screenSize().height / 2 - 50,
                        w: 150,
                        h: 75,
                        quittable: !1,
                        colours: {
                          top: "#333",
                          bottom: "#777",
                          background: "#999"
                        },
                        onOpen: function onOpen(t) {
                          e.isPaused = !0;
                        },
                        trigger: function trigger(t) {
                          console.log(t), t.world.isPaused = !1, t.completed = !0;
                        }
                      }
                    });

                  case 4:
                  case "end":
                    return r.stop();
                }
              }
            }, r);
          }));
          return function (t) {
            return r.apply(this, arguments);
          };
        }()), h(this, "loadSceneManifest", function () {
          var t = u(s().mark(function t(e) {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }));
          return function (e) {
            return t.apply(this, arguments);
          };
        }()), h(this, "loadAvatar", function () {
          var t = u(s().mark(function t(e, r) {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }));
          return function (e, r) {
            return t.apply(this, arguments);
          };
        }()), h(this, "exportAvatar", u(s().mark(function t() {
          var e, r, i;
          return s().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return e = new o(), r = {}, e.folder("pixos").file("avatar.json", JSON.stringify(r)), t.next = 5, e.generateAsync({
                    type: "blob"
                  });

                case 5:
                  i = t.sent, (0, n.saveAs)(i, "avatar.zip");

                case 7:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }))), h(this, "render", function (r, n) {
          t._instance.world.tickOuter(n), e.draw(r);
        }), h(this, "draw", function (e) {
          t._instance.world.draw(e);
        }), h(this, "onKeyEvent", function (e) {
          "keydown" === e.type ? t._instance.engine.keyboard.onKeyDown(e) : t._instance.engine.keyboard.onKeyUp(e);
        }), h(this, "onTouchEvent", function (e) {
          e.type, t._instance.engine.touch(e);
        }), this.shaders = {
          fs: "\n  precision mediump float;\n\n  varying vec2 vTextureCoord;\n  varying vec3 vTransformedNormal;\n  varying vec4 vPosition;\n\n  varying highp vec3 vLighting;\n\n  uniform float useSampler;\n  uniform float useDiffuse;\n  uniform sampler2D uSampler;\n  uniform sampler2D uDiffuseMap;\n\n  uniform vec3 uDiffuse;\n  uniform vec3 uSpecular;\n  uniform float uSpecularExponent;\n\n  void main(void) {\n\n    if(useSampler == 1.0){\n      if(vLighting != vec3(0.0,0.0,0.0)){\n        highp vec4 texelColors = texture2D(uSampler, vTextureCoord);\n        gl_FragColor = vec4(texelColors.rgb * vLighting, texelColors.a);\n      }else{\n        highp vec4 texelColor = texture2D(uSampler, vTextureCoord);\n        gl_FragColor = vec4(texelColor.rgb, texelColor.a);\n      }\n    } else {\n      highp vec4 texelColors = texture2D(uDiffuseMap, vTextureCoord);\n      vec3 V = -normalize(vPosition.xyz);\n      vec3 L = normalize(vec3(1.0, 1.0, 1.0));\n      vec3 H = normalize(L + V);\n      vec3 N = normalize(vLighting);\n      vec3 color = uDiffuse * dot(N, L) + uSpecular * pow(dot(H, N), uSpecularExponent);\n      if(useDiffuse == 1.0){\n        if(texelColors != vec4(0.0,0.0,0.0,0.0)){\n          color = texelColors.rgb * color;\n        }\n      }\n\n      if(vLighting != vec3(0.0,0.0,0.0))\n        gl_FragColor = vec4(color * vLighting, 1.0);\n      else\n        gl_FragColor = vec4(color, 1.0);\n    }\n\n    if(gl_FragColor.a < 0.1)\n      discard;\n  }\n",
          vs: "\n  attribute vec3 aVertexPosition;\n  attribute vec3 aVertexNormal;\n  attribute vec2 aTextureCoord;\n  \n  uniform mat4 uMVMatrix;\n  uniform mat4 uPMatrix;\n  uniform mat3 uNormalMatrix;\n  \n  varying vec2 vTextureCoord;\n  varying vec3 vTransformedNormal;\n  varying vec4 vPosition;\n\n  varying highp vec3 vLighting;\n  \n  uniform vec3 u_scale;\n\n  void main(void) {\n\n    vec3 scaledPosition = aVertexPosition * u_scale;\n    vPosition = uMVMatrix * vec4(scaledPosition, 1.0);\n    gl_Position = uPMatrix * vPosition;\n\n    vTextureCoord = aTextureCoord;\n\n    highp vec3 ambientLight = vec3(0.8, 0.8, 0.8);\n    highp vec3 directionalLightColor = vec3(1, 1, 1);\n    highp vec3 directionalVector = normalize(vec3(1, 1, 0.75));\n\n    highp vec3 transformedNormal = uNormalMatrix * aVertexNormal;\n\n    highp float directional = max(dot(transformedNormal.xyz, directionalVector), 0.1);\n    vLighting = ambientLight + (directionalLightColor * directional);\n  }\n"
        }, t._instance || (t._instance = this), t._instance;
      });
    },
    5870: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return y;
        }
      });
      var n = r(8348),
          o = r(4180),
          i = r(7408),
          a = r(3569),
          s = r(9175);

      function c(t) {
        return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, c(t);
      }

      function u() {
        u = function u() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        s(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, s) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == c(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(h).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, s(b, "constructor", y), s(y, "constructor", d), d.displayName = s(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, s(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), s(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), s(b, a, "Generator"), s(b, o, function () {
          return this;
        }), s(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function l(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function f(t, e, r) {
        return f = h() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && p(o, r.prototype), o;
        }, f.apply(null, arguments);
      }

      function h() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function p(t, e) {
        return p = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, p(t, e);
      }

      function d(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var y = function () {
        function t(e) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.engine = e, this.templateLoaded = !1, this.drawOffset = new n.OW(0, 0, 0), this.hotspotOffset = new n.OW(0, 0, 0), this.animFrame = 0, this.fixed = !1, this.pos = new n.OW(0, 0, 0), this.scale = new n.OW(1, 1, 1), this.facing = o.N.Right, this.actionDict = {}, this.actionList = [], this.gender = null, this.speech = {}, this.portrait = null, this.onLoadActions = new i.Z(), this.getTexCoords = this.getTexCoords.bind(this), this.inventory = [], this.onTilesetOrTextureLoaded = this.onTilesetOrTextureLoaded.bind(this), this.blocking = !0, this.override = !1, this.voice = new SpeechSynthesisUtterance();
        }

        var e, r, c, h;
        return e = t, r = [{
          key: "update",
          value: function value(t) {
            Object.assign(this, t);
          }
        }, {
          key: "runWhenLoaded",
          value: function value(t) {
            this.loaded ? t() : this.onLoadActions.add(t);
          }
        }, {
          key: "onLoad",
          value: function value(t) {
            if (!this.loaded) if (this.src && this.sheetSize && this.tileSize && this.frames) {
              if (this.zone = t.zone, t.id && (this.id = t.id), t.pos && (0, n.t8)(t.pos, this.pos), t.facing && 0 !== t.facing && (this.facing = t.facing), t.zones && null !== t.zones && (this.zones = t.zones), t.onStep && "function" == typeof t.onStep) {
                var e = this.onStep.bind(this);

                this.onStep = function () {
                  t.onStep(), e();
                };
              }

              this.texture = this.engine.loadTexture(this.src), this.texture.runWhenLoaded(this.onTilesetOrTextureLoaded.bind(this)), this.vertexTexBuf = this.engine.createBuffer(this.getTexCoords(), this.engine.gl.DYNAMIC_DRAW, 2), this.enableSpeech && (this.speech = this.engine.loadSpeech(this.id, this.engine.mipmap), this.speech.runWhenLoaded(this.onTilesetOrTextureLoaded.bind(this)), this.speechTexBuf = this.engine.createBuffer(this.getSpeechBubbleTexture(), this.engine.gl.DYNAMIC_DRAW, 2)), this.portraitSrc && (this.portrait = this.engine.loadTexture(this.portraitSrc), this.portrait.runWhenLoaded(this.onTilesetOrTextureLoaded.bind(this))), this.zone.tileset.runWhenDefinitionLoaded(this.onTilesetDefinitionLoaded.bind(this));
            } else console.error("Invalid sprite definition");
          }
        }, {
          key: "onTilesetDefinitionLoaded",
          value: function value() {
            var t = this.zone.tileset.tileSize,
                e = [this.tileSize[0] / t, this.tileSize[1] / t],
                r = [[0, 0, 0], [e[0], 0, 0], [e[0], 0, e[1]], [0, 0, e[1]]],
                n = [[r[2], r[3], r[0]], [r[2], r[0], r[1]]].flat(3);
            this.vertexPosBuf = this.engine.createBuffer(n, this.engine.gl.STATIC_DRAW, 3), this.enableSpeech && (this.speechVerBuf = this.engine.createBuffer(this.getSpeechBubbleVertices(), this.engine.gl.STATIC_DRAW, 3)), this.zone.tileset.runWhenLoaded(this.onTilesetOrTextureLoaded.bind(this));
          }
        }, {
          key: "onTilesetOrTextureLoaded",
          value: function value() {
            !this || this.loaded || !this.zone.tileset.loaded || !this.texture.loaded || this.enableSpeech && this.speech && !this.speech.loaded || this.portrait && !this.portrait.loaded || (this.init(), this.enableSpeech && this.speech && this.speech.clearHud && (this.speech.clearHud(), this.speech.writeText(this.id), this.speech.loadImage()), this.loaded = !0, this.onLoadActions.run());
          }
        }, {
          key: "getTexCoords",
          value: function value() {
            var t,
                e = null !== (t = this.frames[o.N.spriteSequence(this.facing)]) && void 0 !== t ? t : this.frames.up,
                r = this.frames[o.N.spriteSequence(this.facing)].length,
                n = e[this.animFrame % r],
                i = this.sheetSize,
                a = this.tileSize,
                s = [(n[0] + a[0]) / i[0], n[1] / i[1]],
                c = [n[0] / i[0], (n[1] + a[1]) / i[1]],
                u = [s, [c[0], s[1]], c, [s[0], c[1]]];
            return [[u[0], u[1], u[2]], [u[0], u[2], u[3]]].flat(3);
          }
        }, {
          key: "getSpeechBubbleTexture",
          value: function value() {
            return [[1, 1], [0, 1], [0, 0], [1, 1], [0, 0], [1, 0]].flat(3);
          }
        }, {
          key: "getSpeechBubbleVertices",
          value: function value() {
            return [f(n.OW, [2, 0, 4]).toArray(), f(n.OW, [0, 0, 4]).toArray(), f(n.OW, [0, 0, 2]).toArray(), f(n.OW, [2, 0, 4]).toArray(), f(n.OW, [0, 0, 2]).toArray(), f(n.OW, [2, 0, 2]).toArray()].flat(3);
          }
        }, {
          key: "draw",
          value: function value() {
            this.loaded && (this.engine.mvPushMatrix(), (0, s.Iu)(this.engine.uViewMat, this.engine.uViewMat, this.drawOffset.toArray()), (0, s.Iu)(this.engine.uViewMat, this.engine.uViewMat, this.pos.toArray()), (0, s.U1)(this.engine.uViewMat, this.engine.uViewMat, this.engine.degToRad(this.engine.cameraAngle), [1, 0, 0]), this.engine.bindBuffer(this.vertexPosBuf, this.engine.shaderProgram.aVertexPosition), this.engine.bindBuffer(this.vertexTexBuf, this.engine.shaderProgram.aTextureCoord), this.texture.attach(), this.engine.shaderProgram.setMatrixUniforms(), this.engine.gl.depthFunc(this.engine.gl.ALWAYS), this.engine.gl.drawArrays(this.engine.gl.TRIANGLES, 0, this.vertexPosBuf.numItems), this.engine.gl.depthFunc(this.engine.gl.LESS), this.engine.mvPopMatrix(), this.enableSpeech && (this.engine.mvPushMatrix(), (0, s.Iu)(this.engine.uViewMat, this.engine.uViewMat, this.drawOffset.toArray()), (0, s.Iu)(this.engine.uViewMat, this.engine.uViewMat, this.pos.toArray()), (0, s.U1)(this.engine.uViewMat, this.engine.uViewMat, this.engine.degToRad(this.engine.cameraAngle), [1, 0, 0]), this.engine.bindBuffer(this.speechVerBuf, this.engine.shaderProgram.aVertexPosition), this.engine.bindBuffer(this.speechTexBuf, this.engine.shaderProgram.aTextureCoord), this.speech.attach(), this.engine.shaderProgram.setMatrixUniforms(), this.engine.gl.depthFunc(this.engine.gl.ALWAYS), this.engine.gl.drawArrays(this.engine.gl.TRIANGLES, 0, this.speechVerBuf.numItems), this.engine.gl.depthFunc(this.engine.gl.LESS), this.engine.mvPopMatrix()));
          }
        }, {
          key: "setFrame",
          value: function value(t) {
            this.animFrame = t, this.engine.updateBuffer(this.vertexTexBuf, this.getTexCoords());
          }
        }, {
          key: "setFacing",
          value: function value(t) {
            t && (this.facing = t), this.setFrame(this.animFrame);
          }
        }, {
          key: "addAction",
          value: function value(t) {
            this.actionDict[t.id] && this.removeAction(t.id), this.actionDict[t.id] = t, this.actionList.push(t);
          }
        }, {
          key: "removeAction",
          value: function value(t) {
            this.actionList = this.actionList.filter(function (e) {
              return e.id !== t;
            }), delete this.actionDict[t];
          }
        }, {
          key: "removeAllActions",
          value: function value() {
            this.actionList = [], this.actionDict = {};
          }
        }, {
          key: "tickOuter",
          value: function value(t) {
            var e = this;

            if (this.loaded) {
              this.actionList.sort(function (t, e) {
                var r = t.startTime - e.startTime;
                return r ? t.id > e.id ? 1 : -1 : r;
              });
              var r = [];
              this.actionList.forEach(function (e) {
                if (e.loaded && !(e.startTime > t)) try {
                  e.tick(t) && (r.push(e), e.onComplete());
                } catch (t) {
                  console.error(t), r.push(e);
                }
              }), r.forEach(function (t) {
                return e.removeAction(t.id);
              }), this.tick && this.tick(t);
            }
          }
        }, {
          key: "init",
          value: function value() {}
        }, {
          key: "loadRemote",
          value: (c = u().mark(function t(e) {
            var r;
            return u().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, fetch(e);

                  case 2:
                    if ((r = t.sent).ok) {
                      t.next = 5;
                      break;
                    }

                    throw new Error();

                  case 5:
                    this.processJson(r.json());

                  case 6:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), h = function h() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = c.apply(t, e);

              function i(t) {
                l(o, r, n, i, a, "next", t);
              }

              function a(t) {
                l(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function (t) {
            return h.apply(this, arguments);
          })
        }, {
          key: "processJson",
          value: function value(t) {
            this.update(t);
          }
        }, {
          key: "speak",
          value: function value(t) {
            var e,
                r,
                n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            !t && this.speech.clearHud ? this.speech.clearHud() : (o.speechOutput && (this.speechSynthesis(t), o.speechOutput = !1), this.textbox = this.engine.scrollText(this.id + ":> " + t, !0, {
              portrait: null !== (e = this.portrait) && void 0 !== e && e
            }), n && this.speech && (this.speech.scrollText(t, !1, {
              portrait: null !== (r = this.portrait) && void 0 !== r && r
            }), this.speech.loadImage()));
          }
        }, {
          key: "speechSynthesis",
          value: function value(t) {
            var e,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "en",
                n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
                i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
                a = this.voice,
                s = null !== (e = window.speechSynthesis.getVoices()) && void 0 !== e ? e : [];
            console.log(this, this.gender, s), a.voice = this.gender ? "male" == this.gender ? s[7] : s[28] : s[0], n && (a.rate = n), o && (a.volume = o), i && (a.pitch = i), a.text = t, a.lang = r, window.speechSynthesis.speak(a);
          }
        }, {
          key: "interact",
          value: function value(t, e) {
            return this.state, e && e(!0), null;
          }
        }, {
          key: "faceDir",
          value: function value(t) {
            return this.facing == t || t === o.N.None ? null : new a.aW(this.engine, "face", [t], this);
          }
        }, {
          key: "setGreeting",
          value: function value(t) {
            return this.speech.clearHud && this.speech.clearHud(), this.speech.writeText(t), this.speech.loadImage(), new a.aW(this.engine, "greeting", [t, {
              autoclose: !0
            }], this);
          }
        }], r && d(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();
    },
    3793: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return R;
        }
      });
      var n = r(4180),
          o = r(6185),
          i = r(7408),
          a = r(8348),
          s = r(3569);

      function c(t) {
        return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, c(t);
      }

      function u(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function l(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(r), !0).forEach(function (e) {
            f(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function f(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      function h(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      function p(t, e, r) {
        return p = d() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && y(o, r.prototype), o;
        }, p.apply(null, arguments);
      }

      function d() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function y(t, e) {
        return y = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, y(t, e);
      }

      function m() {
        m = function m() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function u(t, e, r, n) {
          var o = e && e.prototype instanceof h ? e : h,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === f) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = l(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === f) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function l(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = u;
        var f = {};

        function h() {}

        function p() {}

        function d() {}

        var y = {};
        s(y, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (y = g);
        var b = d.prototype = h.prototype = Object.create(y);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, s) {
            var u = l(t[o], t, i);

            if ("throw" !== u.type) {
              var f = u.arg,
                  h = f.value;
              return h && "object" == c(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(h).then(function (t) {
                f.value = t, a(f);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return f;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return f;
          }

          var n = l(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, f;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, f) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return p.prototype = d, s(b, "constructor", d), s(d, "constructor", p), p.displayName = s(d, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === p || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : (t.__proto__ = d, s(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), s(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(u(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), s(b, a, "Generator"), s(b, o, function () {
          return this;
        }), s(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, f) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), f;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), f;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), f;
          }
        }, t;
      }

      function v(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function g(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(t) {
              v(i, n, o, a, s, "next", t);
            }

            function s(t) {
              v(i, n, o, a, s, "throw", t);
            }

            a(void 0);
          });
        };
      }

      function b(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var w = function () {
        function t(e, r) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.sceneName = r.id, this.id = e, this.world = r, this.data = {}, this.spriteDict = {}, this.spriteList = [], this.objectDict = {}, this.objectList = [], this.scenes = [], this.lastKey = Date.now(), this.engine = r.engine, this.onLoadActions = new i.Z(), this.spriteLoader = new s.jf(r.engine), this.objectLoader = new s.Gq(r.engine), this.tsLoader = new s.e5(r.engine), this.audio = null, this.onTilesetDefinitionLoaded = this.onTilesetDefinitionLoaded.bind(this), this.onTilesetOrSpriteLoaded = this.onTilesetOrSpriteLoaded.bind(this), this.loadSprite = this.loadSprite.bind(this, this), this.loadObject = this.loadObject.bind(this, this), this.checkInput = this.checkInput.bind(this);
        }

        var e, c, u, f, d, y, v, w, O, _, x;

        return e = t, c = [{
          key: "loadRemote",
          value: (x = g(m().mark(function t() {
            var e,
                r,
                n = this;
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, fetch(o.Z.zoneRequestUrl(this.id));

                  case 2:
                    if (!(e = t.sent).ok) {
                      t.next = 31;
                      break;
                    }

                    return t.prev = 4, t.next = 7, e.json();

                  case 7:
                    return r = t.sent, this.bounds = r.bounds, this.size = [r.bounds[2] - r.bounds[0], r.bounds[3] - r.bounds[1]], this.cells = "function" == typeof r.cells ? r.cells(this.bounds, this) : r.cells, this.sprites = "function" == typeof r.sprites ? r.sprites(this.bounds, this) : r.sprites, t.next = 14, this.tsLoader.load(r.tileset, this.sceneName);

                  case 14:
                    if (this.tileset = t.sent, this.tileset.runWhenDefinitionLoaded(this.onTilesetDefinitionLoaded.bind(this)), this.tileset.runWhenLoaded(this.onTilesetOrSpriteLoaded.bind(this)), !r.sprites) {
                      t.next = 20;
                      break;
                    }

                    return t.next = 20, Promise.all(r.sprites.map(this.loadSprite.bind(this)));

                  case 20:
                    if (!r.objects) {
                      t.next = 23;
                      break;
                    }

                    return t.next = 23, Promise.all(r.objects.map(this.loadObject.bind(this)));

                  case 23:
                    this.spriteList.forEach(function (t) {
                      return t.runWhenLoaded(n.onTilesetOrSpriteLoaded.bind(n));
                    }), this.objectList.forEach(function (t) {
                      return t.runWhenLoaded(n.onTilesetOrSpriteLoaded.bind(n));
                    }), t.next = 31;
                    break;

                  case 27:
                    t.prev = 27, t.t0 = t.catch(4), console.error("Error parsing zone " + this.id), console.error(t.t0);

                  case 31:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this, [[4, 27]]);
          })), function () {
            return x.apply(this, arguments);
          })
        }, {
          key: "load",
          value: (_ = g(m().mark(function t() {
            var e, n;
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.prev = 0, e = r(3998)("./" + this.sceneName + "/maps/" + this.id + "/map.jsx").default, Object.assign(this, e), "function" == typeof this.cells && (this.cells = this.cells(this.bounds, this)), this.audioSrc && (this.audio = this.engine.audioLoader.load(this.audioSrc, !0)), this.size = [this.bounds[2] - this.bounds[0], this.bounds[3] - this.bounds[1]], t.next = 8, this.tsLoader.load(this.tileset, this.sceneName);

                  case 8:
                    return this.tileset = t.sent, this.tileset.runWhenDefinitionLoaded(this.onTilesetDefinitionLoaded.bind(this)), this.tileset.runWhenLoaded(this.onTilesetOrSpriteLoaded.bind(this)), "function" == typeof this.sprites && (this.sprites = this.sprites(this.bounds, this)), n = this, t.next = 15, Promise.all(n.sprites.map(n.loadSprite));

                  case 15:
                    return t.next = 17, Promise.all(n.objects.map(n.loadObject));

                  case 17:
                    n.spriteList.forEach(function (t) {
                      return t.runWhenLoaded(n.onTilesetOrSpriteLoaded);
                    }), n.objectList.forEach(function (t) {
                      return t.runWhenLoaded(n.onTilesetOrSpriteLoaded);
                    }), t.next = 25;
                    break;

                  case 21:
                    t.prev = 21, t.t0 = t.catch(0), console.error("Error parsing zone " + this.id), console.error(t.t0);

                  case 25:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this, [[0, 21]]);
          })), function () {
            return _.apply(this, arguments);
          })
        }, {
          key: "runWhenLoaded",
          value: function value(t) {
            this.loaded ? t() : this.onLoadActions.add(t);
          }
        }, {
          key: "onTilesetDefinitionLoaded",
          value: function value() {
            this.vertexPosBuf = [], this.vertexTexBuf = [], this.walkability = [];

            for (var t = 0, e = 0; t < this.size[1]; t++) {
              for (var r = [], o = [], i = 0; i < this.size[0]; i++, e++) {
                var a = this.cells[e];
                this.walkability[e] = n.N.All;

                for (var s = Math.floor(a.length / 3), c = 0; c < s; c++) {
                  var u = [this.bounds[0] + i, this.bounds[1] + t, a[3 * c + 2]];
                  this.walkability[e] &= this.tileset.getWalkability(a[3 * c]), r = r.concat(this.tileset.getTileVertices(a[3 * c], u)), o = o.concat(this.tileset.getTileTexCoords(a[3 * c], a[3 * c + 1]));
                }

                a.length == 3 * s + 1 && (this.walkability[e] = a[3 * s]);
              }

              this.vertexPosBuf[t] = this.engine.createBuffer(r, this.engine.gl.STATIC_DRAW, 3), this.vertexTexBuf[t] = this.engine.createBuffer(o, this.engine.gl.STATIC_DRAW, 2);
            }
          }
        }, {
          key: "onTilesetOrSpriteLoaded",
          value: function value() {
            var t = this;

            if (!this.loaded && this.tileset.loaded && this.spriteList.every(function (t) {
              return t.loaded;
            }) && this.objectList.every(function (t) {
              return t.loaded;
            })) {
              var e = this;
              this.scripts.forEach(function (r) {
                "load-scene" === r.id && t.runWhenLoaded(r.trigger.bind(e));
              }), this.loaded = !0, this.onLoadActions.run();
            }
          }
        }, {
          key: "loadObject",
          value: (O = g(m().mark(function t(e, r) {
            var n;
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (r.zone = e, this.objectDict[r.id] || e.objectDict[r.id]) {
                      t.next = 7;
                      break;
                    }

                    return t.next = 4, this.objectLoader.load(r, function (t) {
                      return t.onLoad(t);
                    });

                  case 4:
                    n = t.sent, this.objectDict[r.id] = n, this.objectList.push(n);

                  case 7:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function (t, e) {
            return O.apply(this, arguments);
          })
        }, {
          key: "loadSprite",
          value: (w = g(m().mark(function t(e, r) {
            var n;
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (r.zone = e, this.spriteDict[r.id] || e.spriteDict[r.id]) {
                      t.next = 7;
                      break;
                    }

                    return t.next = 4, this.spriteLoader.load(r.type, this.sceneName, function (t) {
                      return t.onLoad(r);
                    });

                  case 4:
                    n = t.sent, this.spriteDict[r.id] = n, this.spriteList.push(n);

                  case 7:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function (t, e) {
            return w.apply(this, arguments);
          })
        }, {
          key: "addSprite",
          value: function value(t) {
            t.zone = this, this.spriteDict[t.id] = t, this.spriteList.push(t);
          }
        }, {
          key: "removeSprite",
          value: function value(t) {
            this.spriteList = this.spriteList.filter(function (e) {
              if (e.id !== t) return !0;
              e.removeAllActions();
            }), delete this.spriteDict[t];
          }
        }, {
          key: "removeAllSprites",
          value: function value() {
            this.spriteList = [], this.spriteDict = {};
          }
        }, {
          key: "getSpriteById",
          value: function value(t) {
            return this.spriteDict[t];
          }
        }, {
          key: "addPortal",
          value: function value(t, e, r) {
            if (this.portals.length > 0 && 0 === this.getHeight(e, r)) {
              var n = this.portals.pop();
              n.pos = p(a.OW, [e, r, this.getHeight(e, r)]), t.push(n);
            } else if (this.portals.length > 0 && e * r % Math.abs(3) && 0 === this.getHeight(e, r)) {
              var o = this.portals.shift();
              o.pos = p(a.OW, [e, r, this.getHeight(e, r)]), t.push(o);
            }

            return t;
          }
        }, {
          key: "getHeight",
          value: function value(t, e) {
            if (!this.isInZone(t, e)) return console.error("Requesting height for [" + t + ", " + e + "] outside zone bounds"), 0;

            for (var r = Math.floor(t), n = Math.floor(e), o = [t - r, e - n], i = function i(t, e) {
              var r = [t[1][0] - t[0][0], t[1][1] - t[0][1]],
                  n = [t[2][0] - t[0][0], t[2][1] - t[0][1]],
                  o = 1 / (r[0] * n[1] - r[1] * n[0]),
                  i = [o * n[1], -o * n[0], -o * r[1], o * r[0]];
              return [r = (e[0] - t[0][0]) * i[0] + (e[1] - t[0][1]) * i[1], n = (e[0] - t[0][0]) * i[2] + (e[1] - t[0][1]) * i[3]];
            }, a = this.cells[(n - this.bounds[1]) * this.size[0] + r - this.bounds[0]], s = Math.floor(a.length / 3), c = 0; c < s; c++) {
              var u = this.tileset.getTileWalkPoly(a[3 * c]);
              if (u) for (var l = 0; l < u.length; l++) {
                var f = i(u[l], o),
                    h = f[0] + f[1];
                if (h <= 1) return a[3 * c + 2] + (1 - h) * u[l][0][2] + f[0] * u[l][1][2] + f[1] * u[l][2][2];
              }
            }

            return a[2];
          }
        }, {
          key: "drawRow",
          value: function value(t) {
            this.engine.bindBuffer(this.vertexPosBuf[t], this.engine.shaderProgram.aVertexPosition), this.engine.bindBuffer(this.vertexTexBuf[t], this.engine.shaderProgram.aTextureCoord), this.tileset.texture.attach(), this.engine.shaderProgram.setMatrixUniforms(), this.engine.gl.drawArrays(this.engine.gl.TRIANGLES, 0, this.vertexPosBuf[t].numItems);
          }
        }, {
          key: "draw",
          value: function value() {
            var t, e;

            if (this.loaded) {
              null === (t = this.spriteList) || void 0 === t || t.sort(function (t, e) {
                return t.pos.y - e.pos.y;
              }), null === (e = this.objectList) || void 0 === e || e.sort(function (t, e) {
                return t.pos.y - e.pos.y;
              }), this.engine.mvPushMatrix(), this.engine.setCamera();

              for (var r = 0, n = 0, o = 0; o < this.size[1]; o++) {
                for (this.drawRow(o); n < this.objectList.length && this.objectList[n].pos.y - this.bounds[1] <= o;) {
                  this.objectList[n++].draw();
                }

                for (; r < this.spriteList.length && this.spriteList[r].pos.y - this.bounds[1] <= o;) {
                  this.spriteList[r++].draw(this.engine);
                }
              }

              for (; n < this.objectList.length;) {
                this.objectList[n++].draw();
              }

              for (; r < this.spriteList.length;) {
                this.spriteList[r++].draw(this.engine);
              }

              this.engine.mvPopMatrix();
            }
          }
        }, {
          key: "tick",
          value: function value(t, e) {
            this.loaded && !e && (this.checkInput(t), this.spriteList.forEach(function () {
              var e = g(m().mark(function e(r) {
                return m().wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        return e.abrupt("return", r.tickOuter(t));

                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e);
              }));
              return function (t) {
                return e.apply(this, arguments);
              };
            }()));
          }
        }, {
          key: "checkInput",
          value: (v = g(m().mark(function t(e) {
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (!(e > this.lastKey + 100)) {
                      t.next = 11;
                      break;
                    }

                    this.engine.gamepad.checkInput(), this.lastKey = e, t.t0 = this.engine.keyboard.lastPressedKey("o"), t.next = "o" === t.t0 ? 6 : 11;
                    break;

                  case 6:
                    return console.log(this.audio), t.next = 9, this.moveSprite("monster", [7, 7, this.getHeight(7, 7)], !1);

                  case 9:
                    return this.audio && this.audio.playAudio(), t.abrupt("break", 11);

                  case 11:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function (t) {
            return v.apply(this, arguments);
          })
        }, {
          key: "isInZone",
          value: function value(t, e) {
            return t >= this.bounds[0] && e >= this.bounds[1] && t < this.bounds[2] && e < this.bounds[3];
          }
        }, {
          key: "isWalkable",
          value: function value(t, e, r) {
            if (!this.isInZone(t, e)) return null;

            for (var n in console.log("check walk"), this.spriteDict) {
              if (!this.spriteDict[n].walkable && this.spriteDict[n].pos.x === t && this.spriteDict[n].pos.y === e && !this.spriteDict[n].blocking && this.spriteDict[n].override) return !0;
              if (!this.spriteDict[n].walkable && this.spriteDict[n].pos.x === t && this.spriteDict[n].pos.y === e && this.spriteDict[n].blocking) return !1;
            }

            for (var o in this.objectDict) {
              if (!this.objectDict[o].walkable && this.within(t, this.objectDict[o].pos.x - this.objectDict[o].scale.x * (this.objectDict[o].size.x / 2), this.objectDict[o].pos.x) && this.within(e, this.objectDict[o].pos.y - this.objectDict[o].scale.y * (this.objectDict[o].size.y / 2), this.objectDict[o].pos.y) && !this.objectDict[o].blocking && this.objectDict[o].override) return !0;
              if (!this.objectDict[o].walkable && (this.objectDict[o].pos.x === t && this.objectDict[o].pos.y === e || this.within(t, this.objectDict[o].pos.x - this.objectDict[o].scale.x * (this.objectDict[o].size.x / 2), this.objectDict[o].pos.x, !0) && this.within(e, this.objectDict[o].pos.y - this.objectDict[o].scale.y * (this.objectDict[o].size.y / 2), this.objectDict[o].pos.y, !0)) && this.objectDict[o].blocking) return !1;
            }

            return 0 != (this.walkability[(e - this.bounds[1]) * this.size[0] + t - this.bounds[0]] & r);
          }
        }, {
          key: "within",
          value: function value(t, e, r) {
            var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            return !!(n && t >= e && t <= r) || !n && t > e && t < r;
          }
        }, {
          key: "triggerScript",
          value: function value(t) {
            var e = this;
            this.scripts.forEach(function (r) {
              r.id === t && e.runWhenLoaded(r.trigger.bind(e));
            });
          }
        }, {
          key: "moveSprite",
          value: (y = g(m().mark(function t(e, r) {
            var n,
                o = this,
                i = arguments;
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return n = i.length > 2 && void 0 !== i[2] && i[2], t.abrupt("return", new Promise(function (t, i) {
                      var a = o.getSpriteById(e);
                      a.addAction(new s.aW(o.engine, "patrol", [a.pos.toArray(), r, n ? 200 : 600, o], a, t));
                    }));

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          })), function (t, e) {
            return y.apply(this, arguments);
          })
        }, {
          key: "spriteDialogue",
          value: (d = g(m().mark(function t(e, r) {
            var n,
                o = this,
                i = arguments;
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return n = i.length > 2 && void 0 !== i[2] ? i[2] : {
                      autoclose: !0
                    }, t.abrupt("return", new Promise(function (t, i) {
                      var a = o.getSpriteById(e);
                      a.addAction(new s.aW(o.engine, "dialogue", [r, !1, n], a, t));
                    }));

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          })), function (t, e) {
            return d.apply(this, arguments);
          })
        }, {
          key: "runActions",
          value: (f = g(m().mark(function t(e) {
            var r;
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return r = this, t.next = 3, e.reduce(function () {
                      var t = g(m().mark(function t(e, n) {
                        return m().wrap(function (t) {
                          for (;;) {
                            switch (t.prev = t.next) {
                              case 0:
                                return t.next = 2, e.then(g(m().mark(function t() {
                                  return m().wrap(function (t) {
                                    for (;;) {
                                      switch (t.prev = t.next) {
                                        case 0:
                                          return t.abrupt("return", new Promise(function (t, e) {
                                            n || t();

                                            try {
                                              if (n.scope || (n.scope = r), n.sprite) {
                                                var o = n.scope.getSpriteById(n.sprite);

                                                if (o && n.action) {
                                                  var i = n.args,
                                                      a = i.pop();
                                                  o.addAction(new s.aW(r.engine, n.action, [].concat(function (t) {
                                                    if (Array.isArray(t)) return h(t);
                                                  }(u = i) || function (t) {
                                                    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                                                  }(u) || function (t, e) {
                                                    if (t) {
                                                      if ("string" == typeof t) return h(t, e);
                                                      var r = Object.prototype.toString.call(t).slice(8, -1);
                                                      return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? h(t, e) : void 0;
                                                    }
                                                  }(u) || function () {
                                                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                  }(), [l({}, a)]), o, function () {
                                                    return t(r);
                                                  }));
                                                }
                                              }

                                              if (n.trigger) {
                                                var c = n.scope.getSpriteById("avatar");
                                                c && n.trigger && c.addAction(new s.aW(r.engine, "script", [n.trigger, n.scope, function () {
                                                  return t(r);
                                                }], c));
                                              }
                                            } catch (t) {
                                              e(t);
                                            }

                                            var u;
                                          }));

                                        case 1:
                                        case "end":
                                          return t.stop();
                                      }
                                    }
                                  }, t);
                                }))).catch(function (t) {
                                  console.warn("err", t.message);
                                });

                              case 2:
                                return t.abrupt("return", t.sent);

                              case 3:
                              case "end":
                                return t.stop();
                            }
                          }
                        }, t);
                      }));
                      return function (e, r) {
                        return t.apply(this, arguments);
                      };
                    }(), Promise.resolve());

                  case 3:
                    return t.abrupt("return", t.sent);

                  case 4:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function (t) {
            return f.apply(this, arguments);
          })
        }, {
          key: "playScene",
          value: (u = g(m().mark(function t(e) {
            var r,
                n,
                o = arguments;
            return m().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    r = o.length > 1 && void 0 !== o[1] ? o[1] : null, n = this, r || (r = n.scenes), r.forEach(function () {
                      var t = g(m().mark(function t(o) {
                        return m().wrap(function (t) {
                          for (;;) {
                            switch (t.prev = t.next) {
                              case 0:
                                if (t.prev = 0, o.currentStep || (o.currentStep = 0), !(o.currentStep > r.length)) {
                                  t.next = 4;
                                  break;
                                }

                                return t.abrupt("return");

                              case 4:
                                if (o.id !== e) {
                                  t.next = 7;
                                  break;
                                }

                                return t.next = 7, n.runActions(o.actions);

                              case 7:
                                t.next = 12;
                                break;

                              case 9:
                                t.prev = 9, t.t0 = t.catch(0), console.error(t.t0);

                              case 12:
                              case "end":
                                return t.stop();
                            }
                          }
                        }, t, null, [[0, 9]]);
                      }));
                      return function (e) {
                        return t.apply(this, arguments);
                      };
                    }());

                  case 4:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function (t) {
            return u.apply(this, arguments);
          })
        }], c && b(e.prototype, c), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();

      function O(t) {
        return O = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, O(t);
      }

      function _(t) {
        return function (t) {
          if (Array.isArray(t)) return x(t);
        }(t) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return x(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? x(t, e) : void 0;
          }
        }(t) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function x(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      function L() {
        L = function L() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function c(t, e, r, n) {
          var o = e && e.prototype instanceof f ? e : f,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = w(a, r);

                  if (s) {
                    if (s === l) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = u(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function u(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = c;
        var l = {};

        function f() {}

        function h() {}

        function p() {}

        var d = {};
        s(d, o, function () {
          return this;
        });
        var y = Object.getPrototypeOf,
            m = y && y(y(A([])));
        m && m !== e && r.call(m, o) && (d = m);
        var v = p.prototype = f.prototype = Object.create(d);

        function g(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function b(t, e) {
          function n(o, i, a, s) {
            var c = u(t[o], t, i);

            if ("throw" !== c.type) {
              var l = c.arg,
                  f = l.value;
              return f && "object" == O(f) && r.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(f).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(c.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function w(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, w(t, e), "throw" === e.method)) return l;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return l;
          }

          var n = u(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
        }

        function _(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function x(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(_, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return h.prototype = p, s(v, "constructor", p), s(p, "constructor", h), h.displayName = s(p, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === h || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, p) : (t.__proto__ = p, s(t, a, "GeneratorFunction")), t.prototype = Object.create(v), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, g(b.prototype), s(b.prototype, i, function () {
          return this;
        }), t.AsyncIterator = b, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new b(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, g(v), s(v, a, "Generator"), s(v, o, function () {
          return this;
        }), s(v, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), x(r), l;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  x(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), l;
          }
        }, t;
      }

      function E(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function A(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var R = function () {
        function t(e, r) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.id = r, this.engine = e, this.zoneDict = {}, this.zoneList = [], this.eventList = [], this.eventDict = {}, this.lastKey = new Date().getTime(), this.isPaused = !0, this.afterTickActions = new i.Z(), this.sortZones = this.sortZones.bind(this), this.canWalk = this.canWalk.bind(this), this.pathFind = this.pathFind.bind(this), this.menuConfig = {
            start: {
              onOpen: function onOpen(t) {
                t.completed = !0;
              }
            }
          };
        }

        var e, r, o, a;
        return e = t, r = [{
          key: "runAfterTick",
          value: function value(t) {
            this.afterTickActions.add(t);
          }
        }, {
          key: "sortZones",
          value: function value() {
            this.zoneList.sort(function (t, e) {
              return t.bounds[1] - e.bounds[1];
            });
          }
        }, {
          key: "loadZone",
          value: (o = L().mark(function t(e) {
            var r,
                n,
                o = arguments;
            return L().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (r = o.length > 1 && void 0 !== o[1] && o[1], !this.zoneDict[e]) {
                      t.next = 3;
                      break;
                    }

                    return t.abrupt("return", this.zoneDict[e]);

                  case 3:
                    if (n = new w(e, this), !r) {
                      t.next = 9;
                      break;
                    }

                    return t.next = 7, n.loadRemote();

                  case 7:
                    t.next = 11;
                    break;

                  case 9:
                    return t.next = 11, n.load();

                  case 11:
                    return this.zoneList.map(function (t) {
                      return t.audio.pauseAudio();
                    }), n.audio && n.audio.playAudio(), this.zoneDict[e] = n, this.zoneList.push(n), n.runWhenLoaded(this.sortZones), t.abrupt("return", n);

                  case 17:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), a = function a() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var i = o.apply(t, e);

              function a(t) {
                E(i, r, n, a, s, "next", t);
              }

              function s(t) {
                E(i, r, n, a, s, "throw", t);
              }

              a(void 0);
            });
          }, function (t) {
            return a.apply(this, arguments);
          })
        }, {
          key: "removeZone",
          value: function value(t) {
            this.zoneList = this.zoneList.filter(function (e) {
              if (e.id !== t) return !0;
              e.audio.pauseAudio(), e.removeAllSprites();
            }), delete this.zoneDict[t];
          }
        }, {
          key: "removeAllZones",
          value: function value() {
            this.zoneList.map(function (t) {
              t.audio.pauseAudio(), t.removeAllSprites();
            }), this.zoneList = [], this.zoneDict = {};
          }
        }, {
          key: "tick",
          value: function value(t) {
            for (var e in this.zoneDict) {
              var r;
              null === (r = this.zoneDict[e]) || void 0 === r || r.tick(t, this.isPaused);
            }

            this.afterTickActions.run(t);
          }
        }, {
          key: "checkInput",
          value: function value(t) {
            if (t > this.lastKey + 200) {
              var e = this.engine.gamepad.checkInput();
              this.lastKey = t, this.engine.gamepad.keyPressed("start") && (e.start = 0), this.engine.gamepad.keyPressed("select") && (e.select = 0, this.engine.toggleFullscreen());
            }
          }
        }, {
          key: "startMenu",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ["start"];
            this.addEvent(new s.q1(this.engine, "menu", [null != t ? t : this.menuConfig, e, !1, {
              autoclose: !1,
              closeOnEnter: !0
            }], this));
          }
        }, {
          key: "addEvent",
          value: function value(t) {
            this.eventDict[t.id] && this.removeAction(t.id), this.eventDict[t.id] = t, this.eventList.push(t);
          }
        }, {
          key: "removeAction",
          value: function value(t) {
            this.eventList = this.eventList.filter(function (e) {
              return e.id !== t;
            }), delete this.eventDict[t];
          }
        }, {
          key: "removeAllActions",
          value: function value() {
            this.eventList = [], this.eventDict = {};
          }
        }, {
          key: "tickOuter",
          value: function value(t) {
            var e = this;
            this.checkInput(t), this.eventList.sort(function (t, e) {
              var r = t.startTime - e.startTime;
              return r ? t.id > e.id ? 1 : -1 : r;
            });
            var r = [];
            this.eventList.forEach(function (e) {
              !e.loaded || e.startTime > t || e.tick(t) && (r.push(e), e.onComplete());
            }), r.forEach(function (t) {
              return e.removeAction(t.id);
            }), this.tick && !this.isPaused && this.tick(t);
          }
        }, {
          key: "draw",
          value: function value() {
            for (var t in this.zoneDict) {
              this.zoneDict[t].draw(this.engine);
            }
          }
        }, {
          key: "zoneContaining",
          value: function value(t, e) {
            for (var r in this.zoneDict) {
              var n = this.zoneDict[r];
              if (n.loaded && n.isInZone(t, e)) return n;
            }

            return null;
          }
        }, {
          key: "pathFind",
          value: function value(t, e) {
            var r = [],
                n = [],
                o = !1,
                i = this,
                a = t[0],
                s = t[1];

            function c(t, r) {
              var a = JSON.stringify([t[0], t[1]]);
              return !o && (t[0] == e[0] && t[1] == e[1] ? (o = !0, i.canWalk(t, a, n) ? [o, [].concat(_(r), [e])] : [o, _(r)]) : !!i.canWalk(t, a, n) && (n.push(a), i.getNeighbours.apply(i, _(t)).sort(function (t, r) {
                return Math.min(Math.abs(e[0] - t[0]) - Math.abs(e[0] - r[0]), Math.abs(e[1] - t[1]) - Math.abs(e[1] - r[1]));
              }).map(function (e) {
                return c(e, [].concat(_(r), [[t[0], t[1], 600]]));
              }).filter(function (t) {
                return t;
              }).flat()));
            }

            return r = i.getNeighbours(a, s).sort(function (t, r) {
              return Math.min(Math.abs(e[0] - t[0]) - Math.abs(e[0] - r[0]), Math.abs(e[1] - t[1]) - Math.abs(e[1] - r[1]));
            }).map(function (e) {
              return c(e, [[t[0], t[1], 600]]);
            }).filter(function (t) {
              return t[0];
            }), console.log("pathing", i, i.getNeighbours(a, s), n, o, a, s, t, e, r), r.flat();
          }
        }, {
          key: "getNeighbours",
          value: function value(t, e) {
            var r = [t, e + 1, n.N.Up],
                o = [t, e - 1, n.N.Down];
            return [r, [t - 1, e, n.N.Left], [t + 1, e, n.N.Right], o];
          }
        }, {
          key: "canWalk",
          value: function value(t, e, r) {
            var o = this.zoneContaining.apply(this, _(t));
            return !(r.indexOf(e) >= 0 || !o || !o.isWalkable.apply(o, _(t)) || !o.isWalkable(t[0], t[1], n.N.reverse(t[2])));
          }
        }], r && A(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();
    },
    5830: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        init: function init(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.engine = this.world.engine, this.text = "", this.prompt = t, this.scrolling = e, this.line = 0, this.options = r, this.completed = !1, this.lastKey = new Date().getTime();
        },
        tick: function tick(t) {
          var e;
          if (this.loaded) return this.options && this.options.autoclose && (this.endTime = this.endTime ? this.endTime : null !== (e = this.options.endTime) && void 0 !== e ? e : new Date().getTime() + 1e4, t > this.endTime && (this.completed = !0)), this.checkInput(t), this.textbox = this.engine.scrollText(this.prompt + this.text, this.scrolling, this.options), this.completed;
        },
        checkInput: function checkInput(t) {
          if (t > this.lastKey + 100) {
            var e = !1;

            switch (this.engine.keyboard.lastPressedCode()) {
              case "Escape":
                this.completed = !0, e = !0;
                break;

              case "Backspace":
                var r = this.text.split("");
                r.pop(), this.text = r.join(""), this.lastKey = t, e = !0;
                break;

              case "Enter":
                this.engine.scrollText(this.text), this.completed = !0, e = !0;
            }

            if (!e) {
              var n = this.engine.keyboard.lastPressedKey();
              n && (this.lastKey = t, this.text += "" + n);
            }
          }
        }
      };
    },
    4726: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        init: function init(t, e) {
          var r = this,
              n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
              o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
            autoclose: !1,
            closeOnEnter: !1
          };
          this.engine = this.world.engine, this.text = "", this.prompt = "", this.scrolling = n, this.line = 0, this.options = o, this.completed = !1, this.lastKey = new Date().getTime(), this.listenerId = this.engine.gamepad.attachListener(this.hookListener()), this.touches = [], this.menuDict = null != t ? t : {}, this.activeMenus = null != e ? e : [], this.selectedMenu = {}, this.selectedMenuId = null, this.isTouched = !1, this.speechOutput = !1, this.quittable = !0, window.speechSynthesis.onvoiceschanged = function () {
            r.speechOutput = !0;
          };
        },
        tick: function tick(t) {
          var e,
              r = this;
          if (this.loaded) return this.options && this.options.autoclose && (this.endTime = this.endTime ? this.endTime : null !== (e = this.options.endTime) && void 0 !== e ? e : new Date().getTime() + 1e4, t > this.endTime && (this.completed = !0)), this.checkInput(t), Object.keys(this.menuDict).filter(function (t) {
            return r.activeMenus.includes(t);
          }).map(function (t) {
            var e = r.menuDict[t],
                n = e.colours;
            e.active && (n.background = "#555"), r.engine.drawButton(e.text, e.x, e.y, e.w, e.h, e.colours), e.prompt && (r.speechOutput && r.engine.speechSynthesis(e.prompt), r.textbox = r.engine.scrollText(e.prompt, r.scrolling, r.options));
          }), this.speechOutput = !1, this.completed && (this.unhookListener(), window.speechSynthesis.cancel()), this.completed;
        },
        unhookListener: function unhookListener() {
          this.engine.gamepad.removeListener(this.listenerId), this.listenerId = null;
        },
        hookListener: function hookListener() {
          var t = this;
          this.onOpen && this.onOpen(this);

          var e = function e(_e3) {
            var r = _e3.touches;

            if (t.isTouched = !0, t.touches = r, t.isTouched && t.touches.length > 0 && t.lastKey + 100 < new Date().getTime()) {
              var n = t.touches[0].x,
                  o = t.touches[0].y,
                  i = t;
              i.activeMenus.filter(function (t) {
                var e = i.menuDict[t];
                return n < e.x + e.w && n > e.x && o < e.y + e.h && o > e.y;
              }).map(function (e) {
                var r = i.menuDict[e];
                r.trigger && r.trigger(t), r.children && (i.activeMenus = r.children);
              });
            }
          },
              r = function r(e) {
            t.touches = e;
          },
              n = function n(e) {
            t.isTouched = !1, t.touches = e;
          };

          return {
            touchstart: e,
            touchmove: r,
            touchend: n,
            mousedown: e,
            mousemove: r,
            mouseup: n
          };
        },
        checkInput: function checkInput(t) {
          var e = this;
          if (t > this.lastKey + 100) switch (this.engine.keyboard.lastPressedCode()) {
            case "Escape":
              this.quittable && (this.completed = !0);
              break;

            case "Enter":
              Object.keys(this.menuDict).filter(function (t) {
                return e.activeMenus.includes(t);
              }).map(function (t) {
                var r = e.menuDict[t];
                r.onEnter && r.trigger(e);
              }), (this.quittable || this.options.closeOnEnter) && (this.completed = !0);
          }
        }
      };
    },
    4494: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function i(t, e) {
        return i = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, i(t, e);
      }

      function a(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function s(t) {
        return s = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, s(t);
      }

      r.d(e, {
        Z: function Z() {
          return c;
        }
      });

      var c = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && i(t, e);
        }(l, t);
        var e,
            r,
            n,
            c,
            u = (n = l, c = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = s(n);

          if (c) {
            var r = s(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return a(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).enableSpeech = !1, e.lastTime = 0, e.accumTime = 0, e.triggerTime = 400, e.frameTime = 250, e;
        }

        return e = l, (r = [{
          key: "init",
          value: function value() {
            this.triggerTime = 1e3 + Math.floor(5e3 * Math.random());
          }
        }, {
          key: "tick",
          value: function value(t) {
            0 != this.lastTime ? (this.accumTime += t - this.lastTime, this.accumTime < this.frameTime || 0 == this.animFrame && this.accumTime < this.triggerTime || (5 == this.animFrame ? (this.setFrame(0), this.triggerTime = 1e3 + Math.floor(4e3 * Math.random())) : (this.setFrame(this.animFrame + 1), this.accumTime = 0, this.lastTime = t))) : this.lastTime = t;
          }
        }]) && o(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), l;
      }(r(5870).Z);
    },
    2011: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return l;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function s(t, e) {
        return s = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, s(t, e);
      }

      function c(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function u(t) {
        return u = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, u(t);
      }

      var l = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && s(t, e);
        }(h, t);
        var e,
            r,
            i,
            l,
            f = (i = h, l = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = u(i);

          if (l) {
            var r = u(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return c(this, t);
        });

        function h(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, h), (e = f.call(this, t)).src = o.Z.artResourceUrl("room.gif"), e.sheetSize = [256, 256], e.tileSize = [48, 32], e.fixed = !0, e.frames = {
            up: [[0, 144], [48, 144], [0, 176], [48, 176]]
          }, e.drawOffset = new n.OW(0, 1.8, .001), e.hotspotOffset = new n.OW(.5, .5, 0), e.frameTime = 150, e;
        }

        return e = h, (r = [{
          key: "init",
          value: function value() {
            this.triggerTime = 1e3;
          }
        }]) && a(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), h;
      }(r(4494).Z);
    },
    9737: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return m;
        }
      });
      var n = r(8348),
          o = r(6185),
          i = r(9175);

      function a(t) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, a(t);
      }

      function s(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function c(t, e) {
        return c = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, c(t, e);
      }

      function u(t, e) {
        if (e && ("object" === a(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function l(t) {
        return l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, l(t);
      }

      function f(t) {
        return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, f(t);
      }

      function h(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function p(t, e) {
        return p = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, p(t, e);
      }

      function d(t, e) {
        if (e && ("object" === f(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function y(t) {
        return y = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, y(t);
      }

      var m = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && p(t, e);
        }(c, t);
        var e,
            r,
            i,
            a,
            s = (i = c, a = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = y(i);

          if (a) {
            var r = y(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return d(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).src = o.Z.artResourceUrl("sewer.gif"), e.sheetSize = [256, 256], e.tileSize = [16, 16], e.frames = {
            up: [[0, 144], [16, 144], [32, 144], [48, 144], [64, 144], [80, 144]]
          }, e.drawOffset = new n.OW(0, 1, .001), e.hotspotOffset = new n.OW(.5, .5, 0), e.frameTime = 150, e;
        }

        return e = c, (r = [{
          key: "init",
          value: function value() {
            this.triggerTime = 1e3 + 5e3 * Math.random();
          }
        }]) && h(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), c;
      }(function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && c(t, e);
        }(f, t);
        var e,
            r,
            n,
            o,
            a = (n = f, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = l(n);

          if (o) {
            var r = l(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return u(this, t);
        });

        function f(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), (e = a.call(this, t)).enableSpeech = !1, e.lastTime = 0, e.accumTime = 0, e.triggerTime = 400, e.frameTime = 250, e.blocking = !1, e;
        }

        return e = f, (r = [{
          key: "init",
          value: function value() {
            this.triggerTime = 2e3;
          }
        }, {
          key: "tick",
          value: function value(t) {
            0 != this.lastTime ? (this.accumTime += t - this.lastTime, this.accumTime < this.frameTime || 0 == this.animFrame && this.accumTime < this.triggerTime || (4 == this.animFrame ? (this.setFrame(0), this.triggerTime = 2e3 + Math.floor(4e3 * Math.random())) : (this.setFrame(this.animFrame + 1), this.accumTime = 0, this.lastTime = t))) : this.lastTime = t;
          }
        }, {
          key: "draw",
          value: function value(t) {
            this.loaded && (t.mvPushMatrix(), (0, i.Iu)(t.uViewMat, t.uViewMat, this.pos.toArray()), (0, i.Iu)(t.uViewMat, t.uViewMat, this.drawOffset.toArray()), (0, i.U1)(t.uViewMat, t.uViewMat, t.degToRad(90), [1, 0, 0]), t.bindBuffer(this.vertexPosBuf, t.shaderProgram.aVertexPosition), t.bindBuffer(this.vertexTexBuf, t.shaderProgram.aTextureCoord), this.texture.attach(), t.shaderProgram.setMatrixUniforms(), t.gl.drawArrays(t.gl.TRIANGLES, 0, this.vertexPosBuf.numItems), t.mvPopMatrix());
          }
        }]) && s(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(5870).Z));
    },
    5329: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return h;
        }
      });
      var n = r(8348),
          o = r(6185),
          i = r(5870),
          a = r(3569);

      function s(t) {
        return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, s(t);
      }

      function c(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function u(t, e) {
        return u = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, u(t, e);
      }

      function l(t, e) {
        if (e && ("object" === s(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function f(t) {
        return f = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, f(t);
      }

      var h = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && u(t, e);
        }(p, t);
        var e,
            r,
            i,
            s,
            h = (i = p, s = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = f(i);

          if (s) {
            var r = f(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return l(this, t);
        });

        function p(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, p), (e = h.call(this, t)).src = o.Z.artResourceUrl("room.gif"), e.sheetSize = [256, 256], e.tileSize = [16, 32], e.fixed = !0, e.frames = {
            up: [[48, 64], [48, 96]],
            right: [[48, 64], [48, 96]],
            left: [[48, 64], [48, 96]],
            down: [[48, 64], [48, 96]]
          }, e.drawOffset = new n.OW(0, 1.001, .001), e.hotspotOffset = new n.OW(.5, .5, 0), e.state = "closed", e;
        }

        return e = p, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.startTime = Date.now(), this.state) {
              case "closed":
                this.state = "open", this.blocking = !1, this.override = !0, r = new a.aW(this.engine, "animate", [600, 3, function () {
                  e(!0);
                }], this);
                break;

              case "open":
                this.state = "open", r = new a.aW(this.engine, "dialogue", ["Its already Open!.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }, {
          key: "onStep",
          value: function value(t) {
            var e = this.zone.world;
            return e.removeAllZones(), this.zones && this.zones.forEach(function (t) {
              return e.loadZone(t);
            }), null;
          }
        }]) && c(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), p;
      }(i.Z);
    },
    1924: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("room.gif"), e.sheetSize = [256, 256], e.tileSize = [48, 80], e.fixed = !0, e.frames = {
            up: [[160, 80]]
          }, e.drawOffset = new n.OW(0, 1.8, .001), e.hotspotOffset = new n.OW(.5, .5, 0), e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(5870).Z);
    },
    2811: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("trees.png"), e.sheetSize = [512, 512], e.tileSize = [96, 144], e.fixed = !0, e.frames = {
            up: [[96, 160]]
          }, e.drawOffset = new n.OW(-2.5, 2.15, -.85), e.hotspotOffset = new n.OW(.5, .5, 0), e.blocking = !0, e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(5870).Z);
    },
    9875: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("air-knight.gif"), e.portraitSrc = o.Z.artResourceUrl("air_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "intro", e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(7772).Z);
    },
    7772: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), (e = l.call(this, t)).bindCamera = !1, e.enableSpeech = !0, e.state = "intro", e;
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Buying stuff eh?!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this), void 0 !== window.ethereum && console.log("MetaMask is installed!");
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(5870).Z);
    },
    2304: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("darkness.gif"), e.portraitSrc = o.Z.artResourceUrl("dark_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "intro", e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(7772).Z);
    },
    512: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("earth-knight.gif"), e.portraitSrc = o.Z.artResourceUrl("earth_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "intro", e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(7772).Z);
    },
    6529: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("fire-knight.gif"), e.portraitSrc = o.Z.artResourceUrl("fire_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "intro", e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(7772).Z);
    },
    7967: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("water-knight.gif"), e.portraitSrc = o.Z.artResourceUrl("water_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "intro", e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(7772).Z);
    },
    6595: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return f;
        }
      }), r(6185);
      var n = r(5870),
          o = r(3569);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      function s(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function c(t, e) {
        return c = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, c(t, e);
      }

      function u(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function l(t) {
        return l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, l(t);
      }

      var f = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && c(t, e);
        }(h, t);
        var e,
            r,
            n,
            i,
            f = (n = h, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = l(n);

          if (i) {
            var r = l(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return u(this, t);
        });

        function h(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, h), (e = f.call(this, t)).bindCamera = !1, e.enableSpeech = !0, e.state = "closed", e.inventory = [], e.fixed = !0, e;
        }

        return e = h, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = this,
                n = null;

            switch (this.startTime = Date.now(), this.state) {
              case "closed":
                this.state = "open", n = new o.aW(this.engine, "animate", [600, 3, function () {
                  var n, o;
                  t.inventory && (n = t.inventory).push.apply(n, function (t) {
                    if (Array.isArray(t)) return a(t);
                  }(o = r.inventory) || function (t) {
                    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                  }(o) || function (t, e) {
                    if (t) {
                      if ("string" == typeof t) return a(t, e);
                      var r = Object.prototype.toString.call(t).slice(8, -1);
                      return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(t, e) : void 0;
                    }
                  }(o) || function () {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }()), e(!0);
                }], this);
                break;

              case "open":
                this.state = "open", n = new o.aW(this.engine, "dialogue", ["Empty.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return n && this.addAction(n), e && e(!1), n;
          }
        }]) && s(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), h;
      }(n.Z);
    },
    9096: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("chests.gif"), e.sheetSize = [256, 256], e.tileSize = [16, 24], e.drawOffset = new n.OW(0, 1, .2), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            down: [[48, 0], [48, 24], [48, 48], [48, 72]],
            right: [[112, 0], [112, 24], [112, 48], [112, 72]],
            up: [[48, 96], [48, 120], [48, 144], [48, 168]],
            left: [[176, 0], [176, 24], [176, 48], [176, 72]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "closed", e.inventory = [], e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(6595).Z);
    },
    9391: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("chests.gif"), e.sheetSize = [256, 256], e.tileSize = [16, 24], e.drawOffset = new n.OW(0, 1, .2), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            down: [[16, 0], [16, 24], [16, 48], [16, 72]],
            right: [[80, 0], [80, 24], [80, 48], [80, 72]],
            up: [[16, 96], [16, 120], [16, 144], [16, 168]],
            left: [[144, 0], [144, 24], [144, 48], [144, 72]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "closed", e.inventory = [], e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(6595).Z);
    },
    8790: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("chests.gif"), e.sheetSize = [256, 256], e.tileSize = [16, 24], e.drawOffset = new n.OW(0, 1, .2), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            down: [[32, 0], [32, 24], [32, 48], [32, 72]],
            right: [[96, 0], [96, 24], [96, 48], [96, 72]],
            up: [[32, 96], [32, 120], [32, 144], [32, 168]],
            left: [[160, 0], [160, 24], [160, 48], [160, 72]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "closed", e.inventory = [], e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(6595).Z);
    },
    1060: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      r(3569);

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("chests.gif"), e.sheetSize = [256, 256], e.tileSize = [16, 24], e.drawOffset = new n.OW(0, 1, .2), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            down: [[0, 0], [0, 24], [0, 48], [0, 72]],
            right: [[64, 0], [64, 24], [64, 48], [64, 72]],
            up: [[0, 96], [0, 120], [0, 144], [0, 168]],
            left: [[128, 0], [128, 24], [128, 48], [128, 72]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "closed", e.inventory = [], e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(6595).Z);
    },
    4180: function _(t, e, r) {
      "use strict";

      r.d(e, {
        N: function N() {
          return n;
        }
      });
      var n = {
        None: 0,
        Right: 1,
        Up: 2,
        Left: 4,
        Down: 8,
        All: 15,
        fromOffset: function fromOffset(t) {
          return t[0] > 0 ? n.Right : t[0] < 0 ? n.Left : t[1] > 0 ? n.Down : t[1] < 0 ? n.Up : 0;
        },
        toOffset: function toOffset(t) {
          switch (t) {
            case n.Right:
              return [1, 0];

            case n.Up:
              return [0, -1];

            case n.Left:
              return [-1, 0];

            case n.Down:
              return [0, 1];
          }

          return [0, 0];
        },
        reverse: function reverse(t) {
          switch (t) {
            case n.Right:
              return n.Left;

            case n.Up:
              return n.Down;

            case n.Left:
              return n.Right;

            case n.Down:
              return n.Up;
          }

          return n.None;
        },
        rotate: function rotate(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

          switch (t) {
            case n.Right:
              return e ? n.Top : n.Down;

            case n.Up:
              return e ? n.Left : n.Right;

            case n.Left:
              return e ? n.Down : n.Top;

            case n.Down:
              return e ? n.Right : n.Left;
          }

          return n.None;
        },
        spriteSequence: function spriteSequence(t) {
          switch (t) {
            case n.Right:
              return "right";

            case n.Up:
              return "up";

            case n.Left:
              return "left";

            case n.Down:
              return "down";
          }

          return "down";
        },
        objectSequence: function objectSequence(t) {
          switch (t) {
            case n.Right:
              return [0, 90, 0];

            case n.Up:
              return [0, 0, 0];

            case n.Left:
              return [0, -90, 0];

            case n.Down:
              return [0, 180, 0];
          }

          return [0, 0, 0];
        }
      };
    },
    1736: function _(t, e, r) {
      "use strict";

      r.d(e, {
        G4: function G4() {
          return p;
        },
        Kn: function Kn() {
          return d;
        },
        hy: function hy() {
          return m;
        }
      });
      var n = r(5565),
          o = r(8348),
          i = r(4180);

      function a(t) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, a(t);
      }

      function s() {
        s = function s() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, s, c) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == a(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function c(t, e, r) {
        return c = u() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && l(o, r.prototype), o;
        }, c.apply(null, arguments);
      }

      function u() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function l(t, e) {
        return l = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, l(t, e);
      }

      function f(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function h(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(t) {
              f(i, n, o, a, s, "next", t);
            }

            function s(t) {
              f(i, n, o, a, s, "throw", t);
            }

            a(void 0);
          });
        };
      }

      var p = "garden-tome";

      function d(t, e, r, n) {
        return y.apply(this, arguments);
      }

      function y() {
        return y = h(s().mark(function t(e, r, i, a) {
          var u, l;
          return s().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (u = e.engine.fetchStore(i)) {
                    t.next = 9;
                    break;
                  }

                  return u = {
                    gender: r,
                    position: c(o.OW, [8, 3, 0]),
                    selected: -2,
                    rain: !0,
                    snow: !1,
                    scenes: [],
                    sprites: [],
                    objects: []
                  }, Object.assign(u, a), e.engine.addStore(i, u), t.next = 7, e.playScene("welcome");

                case 7:
                  t.next = 22;
                  break;

                case 9:
                  return t.next = 11, Promise.all(u.sprites.filter(function (t) {
                    return t.id == u.selected;
                  }).map(e.loadSprite.bind(e)));

                case 11:
                  return t.next = 13, Promise.all(u.objects.filter(function (t) {
                    return t.id == u.selected;
                  }).map(e.loadObject.bind(e)));

                case 13:
                  return t.next = 15, Promise.all(u.npcs.filter(function (t) {
                    return t.id == u.selected;
                  }).map(function () {
                    var t = h(s().mark(function t(e) {
                      return s().wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }()));

                case 15:
                  return t.next = 17, Promise.all(u.triggers.filter(function (t) {
                    return t.id == u.selected;
                  }).map(function () {
                    var t = h(s().mark(function t(e) {
                      return s().wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }()));

                case 17:
                  return t.next = 19, Promise.all(u.scenes.filter(function (t) {
                    return t.id == u.selected;
                  }).map(function () {
                    var t = h(s().mark(function t(r) {
                      return s().wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                              return t.next = 2, e.playScene(r.id, u.scenes);

                            case 2:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }()));

                case 19:
                  return l = [{
                    id: "new-space" + Math.random(),
                    actions: [{
                      sprite: "avatar",
                      action: "dialogue",
                      args: [["Welcome traveler... I see you are exploring. Good. Please continue to look", "You have travelled into the number " + (n.store.pixos && n.store.pixos[i] ? n.store.pixos[i].selected : -2) + " room"], !1, {
                        autoclose: !0
                      }],
                      scope: e
                    }]
                  }], t.next = 22, e.playScene(l[0].id, l);

                case 22:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        })), y.apply(this, arguments);
      }

      function m(t, e) {
        return v.apply(this, arguments);
      }

      function v() {
        return (v = h(s().mark(function t(e, r) {
          var a, u, l;
          return s().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return l = void 0 !== (null === (a = n.store.pixos[r]) || void 0 === a ? void 0 : a.gender) ? n.store.pixos[r].gender : ["male", "female"][Math.floor(2 * Math.random() % 2)], t.next = 3, e.loadSprite.bind(self)({
                    id: "avatar",
                    type: "characters/" + l,
                    gender: l,
                    pos: void 0 !== (null === (u = n.store.pixos[r]) || void 0 === u ? void 0 : u.position) ? n.store.pixos[r].position : c(o.OW, [8, 8, e.getHeight(8, 8)]),
                    facing: i.N.Down
                  });

                case 3:
                  return t.abrupt("return", l);

                case 4:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }))).apply(this, arguments);
      }
    },
    3569: function _(t, e, r) {
      "use strict";

      r.d(e, {
        aW: function aW() {
          return F;
        },
        q1: function q1() {
          return I;
        },
        Gq: function Gq() {
          return j;
        },
        jf: function jf() {
          return R;
        },
        e5: function e5() {
          return h;
        }
      });
      var n = r(6185),
          o = r(7408);

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var a = function () {
        function t(e) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.engine = e, this.src = null, this.sheetSize = [0, 0], this.tileSize = 0, this.tiles = {}, this.loaded = !1, this.onLoadActions = new o.Z(), this.onDefinitionLoadActions = new o.Z(), this.onTextureLoaded = this.onTextureLoaded.bind(this);
        }

        var e, r;
        return e = t, (r = [{
          key: "runWhenLoaded",
          value: function value(t) {
            this.loaded ? t() : this.onLoadActions.add(t);
          }
        }, {
          key: "runWhenDefinitionLoaded",
          value: function value(t) {
            this.definitionLoaded ? t() : this.onDefinitionLoadActions.add(t);
          }
        }, {
          key: "onJsonLoaded",
          value: function value(t) {
            var e = this;
            Object.keys(t).map(function (r) {
              e[r] = t[r];
            }), this.definitionLoaded = !0, this.onDefinitionLoadActions.run(), this.texture = this.engine.loadTexture(this.src), this.texture.runWhenLoaded(this.onTextureLoaded), console.log("texture loaded", this.texture), this.bgColor && this.engine.gl.clearColor(this.bgColor[0] / 255, this.bgColor[1] / 255, this.bgColor[2] / 255, 1);
          }
        }, {
          key: "onTextureLoaded",
          value: function value() {
            this.loaded = !0, this.onLoadActions.run();
          }
        }, {
          key: "getTileVertices",
          value: function value(t, e) {
            return this.geometry[t].vertices.map(function (t) {
              return t.map(function (t) {
                return [t[0] + e[0], t[1] + e[1], t[2] + e[2]];
              });
            }).flat(3);
          }
        }, {
          key: "getTileTexCoords",
          value: function value(t, e) {
            var r = this.textures[e],
                n = [this.tileSize / this.sheetSize[0], this.tileSize / this.sheetSize[1]];
            return this.geometry[t].surfaces.map(function (t) {
              return t.map(function (t) {
                return [(t[0] + r[0]) * n[0], (t[1] + r[1]) * n[1]];
              });
            }).flat(3);
          }
        }, {
          key: "getWalkability",
          value: function value(t) {
            return this.geometry[t].type;
          }
        }, {
          key: "getTileWalkPoly",
          value: function value(t) {
            return this.geometry[t].walkPoly;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();

      function s(t) {
        return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, s(t);
      }

      function c() {
        c = function c() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, c) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == s(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, c);
              }, function (t) {
                n("throw", t, a, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, a, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function u(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function l(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(t) {
              u(i, n, o, a, s, "next", t);
            }

            function s(t) {
              u(i, n, o, a, s, "throw", t);
            }

            a(void 0);
          });
        };
      }

      function f(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var h = function () {
        function t(e) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.engine = e, this.tilesets = {};
        }

        var e, o, i, s;
        return e = t, o = [{
          key: "loadRemote",
          value: (s = l(c().mark(function t(e) {
            var r, o, i;
            return c().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (!(r = this.tilesets[e])) {
                      t.next = 3;
                      break;
                    }

                    return t.abrupt("return", r);

                  case 3:
                    return this.tilesets[e] = r = new a(this.engine), r.name = e, t.next = 7, fetch(n.Z.tilesetRequestUrl(e));

                  case 7:
                    if (!(o = t.sent).ok) {
                      t.next = 21;
                      break;
                    }

                    return t.prev = 9, t.next = 12, o.json();

                  case 12:
                    return i = t.sent, t.next = 15, r.onJsonLoaded(i);

                  case 15:
                    t.next = 21;
                    break;

                  case 17:
                    t.prev = 17, t.t0 = t.catch(9), console.error("Error parsing tileset '" + r.name + "' definition"), console.error(t.t0);

                  case 21:
                    return t.abrupt("return", this.tilesets[e]);

                  case 22:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this, [[9, 17]]);
          })), function (t) {
            return s.apply(this, arguments);
          })
        }, {
          key: "load",
          value: (i = l(c().mark(function t(e, n) {
            var o, i, s;
            return c().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (console.log("loading tileset - ", this, e, n), !(o = this.tilesets[e])) {
                      t.next = 4;
                      break;
                    }

                    return t.abrupt("return", o);

                  case 4:
                    return i = new a(this.engine), this.tilesets[e] = i, i.name = e, s = r(7092)("./" + e + "/tileset.jsx").default, console.log("loading .... - ", s, e, n), i.onJsonLoaded(s), t.abrupt("return", i);

                  case 11:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function (t, e) {
            return i.apply(this, arguments);
          })
        }], o && f(e.prototype, o), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }(),
          p = (r(5870), r(8348)),
          d = r(4180),
          y = r(9175),
          m = r(8352);

      function v(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      function g(t, e, r) {
        return g = b() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && w(o, r.prototype), o;
        }, g.apply(null, arguments);
      }

      function b() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function w(t, e) {
        return w = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, w(t, e);
      }

      function O(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var _ = function () {
        function t(e) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.engine = e, this.templateLoaded = !1, this.drawOffset = new p.OW(0, 0, 0), this.hotspotOffset = new p.OW(0, 0, 0), this.pos = new p.OW(0, 0, 0), this.size = new p.OW(1, 1, 1), this.scale = new p.OW(1, 1, 1), this.rotation = new p.OW(0, 0, 0), this.facing = d.N.Right, this.actionDict = {}, this.actionList = [], this.speech = {}, this.portrait = null, this.onLoadActions = new o.Z(), this.inventory = [], this.onTilesetOrTextureLoaded = this.onTilesetOrTextureLoaded.bind(this), this.blocking = !0, this.override = !1;
        }

        var e, r;
        return e = t, r = [{
          key: "update",
          value: function value(t) {
            Object.assign(this, t);
          }
        }, {
          key: "runWhenLoaded",
          value: function value(t) {
            this.loaded ? t() : this.onLoadActions.add(t);
          }
        }, {
          key: "onLoad",
          value: function value(t) {
            if (!this.loaded) {
              this.zone = t.zone, t.id && (this.id = t.id), t.pos && (0, p.t8)(t.pos, this.pos), t.rotation && (0, p.t8)(t.rotation, this.rotation), t.facing && 0 !== t.facing && (this.facing = t.facing), t.zones && null !== t.zones && (this.zones = t.zones);

              for (var e, r, n, o = t.mesh, i = null, a = null, s = null, c = 0; c < o.vertices.length; c += 3) {
                var u = o.vertices.slice(c, c + 3);
                (null == e || u[0] > e) && (e = u[0]), (null == i || u[0] < i) && (i = u[0]), (null == r || u[1] > r) && (r = u[1]), (null == a || u[1] < a) && (a = u[1]), (null == n || u[2] > n) && (n = u[2]), (null == s || u[2] < s) && (s = u[2]);
              }

              var l = new p.OW(e - i, n - s, r - a);
              this.size = l, this.scale = new p.OW(1 / Math.max(l.x, l.z), 1 / Math.max(l.x, l.z), 1 / Math.max(l.x, l.z)), t.useScale && (this.scale = t.useScale), this.drawOffset = new p.OW(.5, .5, 0), this.mesh = o, this.engine.objLoader.initMeshBuffers(this.engine.gl, this.mesh), this.enableSpeech && (this.speech = this.engine.loadSpeech(this.id, this.engine.mipmap), this.speech.runWhenLoaded(this.onTilesetOrTextureLoaded.bind(this)), this.speechTexBuf = this.engine.createBuffer(this.getSpeechBubbleTexture(), this.engine.gl.DYNAMIC_DRAW, 2)), this.portraitSrc && (this.portrait = this.engine.loadTexture(this.portraitSrc), this.portrait.runWhenLoaded(this.onTilesetOrTextureLoaded.bind(this))), this.zone.tileset.runWhenDefinitionLoaded(this.onTilesetDefinitionLoaded.bind(this));
            }
          }
        }, {
          key: "onTilesetDefinitionLoaded",
          value: function value() {
            this.zone.tileset.runWhenLoaded(this.onTilesetOrTextureLoaded.bind(this));
          }
        }, {
          key: "onTilesetOrTextureLoaded",
          value: function value() {
            !this || this.loaded || this.enableSpeech && this.speech && !this.speech.loaded || this.portrait && !this.portrait.loaded || (this.init(), this.enableSpeech && this.speech && this.speech.clearHud && (this.speech.clearHud(), this.speech.writeText(this.id), this.speech.loadImage()), this.loaded = !0, this.onLoadActions.run());
          }
        }, {
          key: "getSpeechBubbleTexture",
          value: function value() {
            return [[1, 1], [0, 1], [0, 0], [1, 1], [0, 0], [1, 0]].flat(3);
          }
        }, {
          key: "getSpeechBubbleVertices",
          value: function value() {
            return [g(p.OW, [2, 0, 4]).toArray(), g(p.OW, [0, 0, 4]).toArray(), g(p.OW, [0, 0, 2]).toArray(), g(p.OW, [2, 0, 4]).toArray(), g(p.OW, [0, 0, 2]).toArray(), g(p.OW, [2, 0, 2]).toArray()].flat(3);
          }
        }, {
          key: "attach",
          value: function value(t) {
            var e = this.engine.gl;
            e.activeTexture(e.TEXTURE0), e.bindTexture(e.TEXTURE_2D, t), e.uniform1i(this.engine.shaderProgram.diffuseMapUniform, 0);
          }
        }, {
          key: "drawTexturedObj",
          value: function value() {
            var t = this,
                e = this.engine,
                r = this.mesh;
            r.indicesPerMaterial.length >= 1 && Object.keys(r.materialsByIndex).length > 0 ? r.indicesPerMaterial.forEach(function (n, o) {
              var i, a;
              e.bindBuffer(r.vertexBuffer, e.shaderProgram.aVertexPosition), e.bindBuffer(r.textureBuffer, e.shaderProgram.aTextureCoord), e.bindBuffer(r.normalBuffer, e.shaderProgram.aVertexNormal), e.gl.uniform3fv(e.shaderProgram.uDiffuse, r.materialsByIndex[o].diffuse), e.gl.uniform1f(e.shaderProgram.uSpecularExponent, r.materialsByIndex[o].specularExponent), null !== (i = r.materialsByIndex[o]) && void 0 !== i && null !== (a = i.mapDiffuse) && void 0 !== a && a.glTexture && t.attach(r.materialsByIndex[o].mapDiffuse.glTexture), e.gl.uniform3fv(e.shaderProgram.uSpecular, r.materialsByIndex[o].specular), e.gl.uniform1f(e.shaderProgram.uSpecularExponent, r.materialsByIndex[o].specularExponent);
              var s = (0, m._buildBuffer)(e.gl, e.gl.ELEMENT_ARRAY_BUFFER, n, 1);
              e.gl.bindBuffer(e.gl.ELEMENT_ARRAY_BUFFER, s), e.shaderProgram.setMatrixUniforms(t.scale, 0), e.gl.drawElements(e.gl.TRIANGLES, s.numItems, e.gl.UNSIGNED_SHORT, 0);
            }) : (e.bindBuffer(r.vertexBuffer, e.shaderProgram.aVertexPosition), e.bindBuffer(r.normalBuffer, e.shaderProgram.aVertexNormal), e.bindBuffer(r.textureBuffer, e.shaderProgram.aTextureCoord), e.gl.bindBuffer(e.gl.ELEMENT_ARRAY_BUFFER, r.indexBuffer), e.gl.uniform3fv(e.shaderProgram.uDiffuse, [.6, .3, .6]), e.gl.uniform3fv(e.shaderProgram.uSpecular, [.1, .1, .2]), e.gl.uniform1f(e.shaderProgram.uSpecularExponent, 2), e.shaderProgram.setMatrixUniforms(this.scale, 0), e.gl.drawElements(e.gl.TRIANGLES, r.indexBuffer.numItems, e.gl.UNSIGNED_SHORT, 0));
          }
        }, {
          key: "drawObj",
          value: function value() {
            var t = this.engine,
                e = this.mesh;
            t.gl.disableVertexAttribArray(t.shaderProgram.aTextureCoord), t.bindBuffer(e.vertexBuffer, t.shaderProgram.aVertexPosition), t.bindBuffer(e.normalBuffer, t.shaderProgram.aVertexNormal), t.gl.bindBuffer(t.gl.ELEMENT_ARRAY_BUFFER, e.indexBuffer), t.shaderProgram.setMatrixUniforms(this.scale, 1), t.gl.drawElements(t.gl.TRIANGLES, e.indexBuffer.numItems, t.gl.UNSIGNED_SHORT, 0);
          }
        }, {
          key: "draw",
          value: function value() {
            if (this.loaded) {
              var t = this.engine,
                  e = this.mesh;

              if (t.gl.enableVertexAttribArray(t.shaderProgram.aVertexNormal), t.gl.enableVertexAttribArray(t.shaderProgram.aTextureCoord), t.mvPushMatrix(), (0, y.Iu)(this.engine.uViewMat, this.engine.uViewMat, this.drawOffset.toArray()), (0, y.Iu)(this.engine.uViewMat, this.engine.uViewMat, this.pos.toArray()), (0, y.U1)(this.engine.uViewMat, this.engine.uViewMat, this.engine.degToRad(90), [1, 0, 0]), this.rotation && this.rotation.toArray) {
                var r = Math.max.apply(Math, function (t) {
                  if (Array.isArray(t)) return v(t);
                }(n = this.rotation.toArray()) || function (t) {
                  if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                }(n) || function (t, e) {
                  if (t) {
                    if ("string" == typeof t) return v(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(t, e) : void 0;
                  }
                }(n) || function () {
                  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }());
                r > 0 && (0, y.U1)(this.engine.uViewMat, this.engine.uViewMat, this.engine.degToRad(r), [this.rotation.x / r, this.rotation.y / r, this.rotation.z / r]);
              }

              e.textures.length ? this.drawTexturedObj() : this.drawObj(), t.mvPopMatrix(), t.gl.enableVertexAttribArray(t.shaderProgram.aTextureCoord), t.gl.disableVertexAttribArray(t.shaderProgram.aVertexNormal);
            }

            var n;
          }
        }, {
          key: "setFacing",
          value: function value(t) {
            t && (this.facing = t), this.rotation = d.N.objectSequence(t);
          }
        }, {
          key: "addAction",
          value: function value(t) {
            this.actionDict[t.id] && this.removeAction(t.id), this.actionDict[t.id] = t, this.actionList.push(t);
          }
        }, {
          key: "removeAction",
          value: function value(t) {
            this.actionList = this.actionList.filter(function (e) {
              return e.id !== t;
            }), delete this.actionDict[t];
          }
        }, {
          key: "removeAllActions",
          value: function value() {
            this.actionList = [], this.actionDict = {};
          }
        }, {
          key: "tickOuter",
          value: function value(t) {
            var e = this;

            if (this.loaded) {
              this.actionList.sort(function (t, e) {
                var r = t.startTime - e.startTime;
                return r ? t.id > e.id ? 1 : -1 : r;
              });
              var r = [];
              this.actionList.forEach(function (e) {
                !e.loaded || e.startTime > t || e.tick(t) && (r.push(e), e.onComplete());
              }), r.forEach(function (t) {
                return e.removeAction(t.id);
              }), this.tick && this.tick(t);
            }
          }
        }, {
          key: "init",
          value: function value() {
            console.log("- sprite hook", this.id, this.pos);
          }
        }, {
          key: "speak",
          value: function value(t) {
            var e,
                r,
                n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            t ? (this.textbox = this.engine.scrollText(this.id + ":> " + t, !0, {
              portrait: null !== (e = this.portrait) && void 0 !== e && e
            }), n && this.speech && (this.speech.scrollText(t, !1, {
              portrait: null !== (r = this.portrait) && void 0 !== r && r
            }), this.speech.loadImage())) : this.speech.clearHud();
          }
        }, {
          key: "interact",
          value: function value(t, e) {
            return this.state, e && e(!0), null;
          }
        }, {
          key: "faceDir",
          value: function value(t) {
            return this.facing == t || t === d.N.None ? null : new F(this.engine, "face", [t], this);
          }
        }, {
          key: "setGreeting",
          value: function value(t) {
            return this.speech.clearHud && this.speech.clearHud(), this.speech.writeText(t), this.speech.loadImage(), new F(this.engine, "greeting", [t, {
              autoclose: !0
            }], this);
          }
        }], r && O(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();

      function x(t) {
        return x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, x(t);
      }

      function L() {
        L = function L() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function c(t, e, r, n) {
          var o = e && e.prototype instanceof f ? e : f,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = w(a, r);

                  if (s) {
                    if (s === l) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = u(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function u(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = c;
        var l = {};

        function f() {}

        function h() {}

        function p() {}

        var d = {};
        s(d, o, function () {
          return this;
        });
        var y = Object.getPrototypeOf,
            m = y && y(y(A([])));
        m && m !== e && r.call(m, o) && (d = m);
        var v = p.prototype = f.prototype = Object.create(d);

        function g(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function b(t, e) {
          function n(o, i, a, s) {
            var c = u(t[o], t, i);

            if ("throw" !== c.type) {
              var l = c.arg,
                  f = l.value;
              return f && "object" == x(f) && r.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(f).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(c.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function w(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, w(t, e), "throw" === e.method)) return l;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return l;
          }

          var n = u(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
        }

        function O(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function _(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(O, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return h.prototype = p, s(v, "constructor", p), s(p, "constructor", h), h.displayName = s(p, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === h || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, p) : (t.__proto__ = p, s(t, a, "GeneratorFunction")), t.prototype = Object.create(v), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, g(b.prototype), s(b.prototype, i, function () {
          return this;
        }), t.AsyncIterator = b, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new b(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, g(v), s(v, a, "Generator"), s(v, o, function () {
          return this;
        }), s(v, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), _(r), l;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;

                  _(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), l;
          }
        }, t;
      }

      function E(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function A(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var R = function () {
        function t(e) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.engine = e, this.definitions = [], this.instances = {};
        }

        var e, n, o, i;
        return e = t, n = [{
          key: "load",
          value: (o = L().mark(function t(e, n) {
            var o,
                i,
                a,
                s,
                c = arguments;
            return L().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return o = c[2], i = c[3], this.instances[e] || (this.instances[e] = []), console.log("loading sprite - ", e, n, "../../" + n + "/sprites/" + e + ".jsx"), a = r(9245)("./" + n + "/sprites/" + e + ".jsx").default, (s = new a(this.engine)).templateLoaded = !0, this.instances[e].forEach(function (t) {
                      t.afterLoad && t.afterLoad(t.instance);
                    }), i && i(s), o && (s.templateLoaded ? o(s) : this.instances[e].push({
                      instance: s,
                      afterLoad: o
                    })), t.abrupt("return", s);

                  case 11:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), i = function i() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var i = o.apply(t, e);

              function a(t) {
                E(i, r, n, a, s, "next", t);
              }

              function s(t) {
                E(i, r, n, a, s, "throw", t);
              }

              a(void 0);
            });
          }, function (t, e) {
            return i.apply(this, arguments);
          })
        }], n && A(e.prototype, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();

      function T(t) {
        return T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, T(t);
      }

      function P() {
        P = function P() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function c(t, e, r, n) {
          var o = e && e.prototype instanceof f ? e : f,
              i = Object.create(o.prototype),
              a = new x(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = w(a, r);

                  if (s) {
                    if (s === l) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = u(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function u(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = c;
        var l = {};

        function f() {}

        function h() {}

        function p() {}

        var d = {};
        s(d, o, function () {
          return this;
        });
        var y = Object.getPrototypeOf,
            m = y && y(y(L([])));
        m && m !== e && r.call(m, o) && (d = m);
        var v = p.prototype = f.prototype = Object.create(d);

        function g(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function b(t, e) {
          function n(o, i, a, s) {
            var c = u(t[o], t, i);

            if ("throw" !== c.type) {
              var l = c.arg,
                  f = l.value;
              return f && "object" == T(f) && r.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(f).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(c.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function w(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, w(t, e), "throw" === e.method)) return l;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return l;
          }

          var n = u(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
        }

        function O(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function _(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function x(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(O, this), this.reset(!0);
        }

        function L(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: E
          };
        }

        function E() {
          return {
            value: void 0,
            done: !0
          };
        }

        return h.prototype = p, s(v, "constructor", p), s(p, "constructor", h), h.displayName = s(p, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === h || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, p) : (t.__proto__ = p, s(t, a, "GeneratorFunction")), t.prototype = Object.create(v), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, g(b.prototype), s(b.prototype, i, function () {
          return this;
        }), t.AsyncIterator = b, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new b(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, g(v), s(v, a, "Generator"), s(v, o, function () {
          return this;
        }), s(v, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = L, x.prototype = {
          constructor: x,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), _(r), l;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;

                  _(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: L(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), l;
          }
        }, t;
      }

      function S(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function k(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var j = function () {
        function t(e) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.engine = e, this.definitions = [], this.instances = {};
        }

        var e, r, n, o;
        return e = t, r = [{
          key: "load",
          value: (n = P().mark(function t(e) {
            var r,
                n,
                o,
                i,
                a,
                s,
                c = arguments;
            return P().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return n = c[1], o = c[2], this.instances[e.id] || (this.instances[e.id] = []), (i = new _(this.engine)).update(e), a = {
                      obj: "pixos/models/".concat(i.type, ".obj"),
                      mtl: null !== (r = e.mtl) && void 0 !== r && r,
                      mtlTextureRoot: "/pixos/models",
                      downloadMtlTextures: !0,
                      enableWTextureCoord: !1,
                      name: i.id
                    }, t.next = 8, this.engine.objLoader.downloadModels(this.engine.gl, [a]);

                  case 8:
                    return s = t.sent, i.mesh = s[e.id], i.templateLoaded = !0, this.instances[i.id].forEach(function (t) {
                      t.afterLoad && t.afterLoad(t.instance);
                    }), o && o(i), n && (i.templateLoaded ? n(i) : this.instances[i.id].push({
                      instance: i,
                      afterLoad: n
                    })), i.loaded = !0, t.abrupt("return", i);

                  case 16:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), o = function o() {
            var t = this,
                e = arguments;
            return new Promise(function (r, o) {
              var i = n.apply(t, e);

              function a(t) {
                S(i, r, o, a, s, "next", t);
              }

              function s(t) {
                S(i, r, o, a, s, "throw", t);
              }

              a(void 0);
            });
          }, function (t) {
            return o.apply(this, arguments);
          })
        }], r && k(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();

      function Z(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var M = function () {
        function t(e, r, n) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.type = e, this.sprite = r, this.callback = n, this.time = new Date().getTime(), this.id = r.id + "-" + e + "-" + this.time;
        }

        var e, r;
        return e = t, (r = [{
          key: "configure",
          value: function value(t, e, r, n, o) {
            this.sprite = e, this.id = r, this.type = t, this.startTime = n, this.creationArgs = o;
          }
        }, {
          key: "onLoad",
          value: function value(t) {
            this.init.apply(this, t), this.loaded = !0;
          }
        }, {
          key: "serialize",
          value: function value() {
            return {
              id: this.id,
              time: this.startTime,
              zone: this.sprite.zone.id,
              sprite: this.sprite.id,
              type: this.type,
              args: this.creationArgs
            };
          }
        }, {
          key: "onComplete",
          value: function value() {
            return this.callback ? this.callback() : null;
          }
        }]) && Z(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();

      function C(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var F = function () {
        function t(e, r, n, o, i) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.engine = e, this.type = r, this.args = n, this.sprite = o, this.callback = i, this.instances = {}, this.definitions = [], this.assets = {};
          var a = new Date().getTime(),
              s = o.id + "-" + r + "-" + a;
          return this.load(r, function (t) {
            t.onLoad(n);
          }, function (t) {
            t.configure(r, o, s, a, n);
          });
        }

        var e, n;
        return e = t, n = [{
          key: "load",
          value: function value(t) {
            var e = arguments[1],
                n = arguments[2];
            this.instances[t] || (this.instances[t] = []);
            var o = new M(this.type, this.sprite, this.callback);
            return Object.assign(o, r(3333)("./" + t + ".jsx").default), o.templateLoaded = !0, this.instances[t].forEach(function (t) {
              t.afterLoad && t.afterLoad(t.instance);
            }), n && n(o), e && (o.templateLoaded ? e(o) : this.instances[t].push({
              instance: o,
              afterLoad: e
            })), o;
          }
        }], n && C(e.prototype, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();

      function W(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var B = function () {
        function t(e, r, n) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.type = e, this.world = r, this.callback = n, this.time = new Date().getTime(), this.id = r.id + "-" + e + "-" + this.time;
        }

        var e, r;
        return e = t, (r = [{
          key: "configure",
          value: function value(t, e, r, n, o) {
            this.world = e, this.id = r, this.type = t, this.startTime = n, this.creationArgs = o;
          }
        }, {
          key: "onLoad",
          value: function value(t) {
            this.init.apply(this, t), this.loaded = !0;
          }
        }, {
          key: "serialize",
          value: function value() {
            return {
              id: this.id,
              time: this.startTime,
              world: this.world.id,
              type: this.type,
              args: this.creationArgs
            };
          }
        }, {
          key: "onComplete",
          value: function value() {
            return this.callback ? this.callback() : null;
          }
        }]) && W(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();

      function N(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var I = function () {
        function t(e, r, n, o, i) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.engine = e, this.type = r, this.args = n, this.world = o, this.callback = i, this.instances = {}, this.definitions = [], this.assets = {};
          var a = new Date().getTime(),
              s = o.id + "-" + r + "-" + a;
          return this.load(r, function (t) {
            t.onLoad(n);
          }, function (t) {
            t.configure(r, o, s, a, n);
          });
        }

        var e, n;
        return e = t, n = [{
          key: "load",
          value: function value(t) {
            var e = arguments[1],
                n = arguments[2];
            this.instances[t] || (this.instances[t] = []);
            var o = new B(this.type, this.world, this.callback);
            return Object.assign(o, r(4472)("./" + t + ".jsx").default), o.templateLoaded = !0, this.instances[t].forEach(function (t) {
              t.afterLoad && t.afterLoad(t.instance);
            }), n && n(o), e && (o.templateLoaded ? e(o) : this.instances[t].push({
              instance: o,
              afterLoad: e
            })), o;
          }
        }], n && N(e.prototype, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();
    },
    9175: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        return function (t) {
          if (Array.isArray(t)) return t;
        }(t) || function (t, e) {
          var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

          if (null != r) {
            var n,
                o,
                i = [],
                a = !0,
                s = !1;

            try {
              for (r = r.call(t); !(a = (n = r.next()).done) && (i.push(n.value), !e || i.length !== e); a = !0) {
                ;
              }
            } catch (t) {
              s = !0, o = t;
            } finally {
              try {
                a || null == r.return || r.return();
              } finally {
                if (s) throw o;
              }
            }

            return i;
          }
        }(t, e) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return o(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(t, e) : void 0;
          }
        }(t, e) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function o(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      r.d(e, {
        Ez: function Ez() {
          return a;
        },
        G3: function G3() {
          return s;
        },
        Iu: function Iu() {
          return c;
        },
        U1: function U1() {
          return u;
        },
        Ue: function Ue() {
          return i;
        },
        XL: function XL() {
          return f;
        },
        t8: function t8() {
          return l;
        }
      });

      var i = function i() {
        var t = new Float32Array(16);
        return t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
      },
          a = function a() {
        var t = new Float32Array(9);
        return t[0] = 1, t[4] = 1, t[8] = 1, t;
      },
          s = function s(t, e, r, n) {
        var o = new Float32Array(16),
            i = 1 / Math.tan(t / 2);

        if (o[0] = i / e, o[1] = 0, o[2] = 0, o[3] = 0, o[4] = 0, o[5] = i, o[6] = 0, o[7] = 0, o[8] = 0, o[9] = 0, o[10] = -1, o[11] = -1, o[12] = 0, o[13] = 0, o[14] = -2 * r, o[15] = 0, null != n && n !== 1 / 0 && n !== r) {
          var a = 1 / (r - n);
          o[10] = (n + r) * a, o[14] = 2 * n * r * a;
        }

        return o;
      },
          c = function c(t, e, r) {
        var o = t,
            i = n(r, 3),
            a = i[0],
            s = i[1],
            c = i[2],
            u = n(e, 12),
            l = u[0],
            f = u[1],
            h = u[2],
            p = u[3],
            d = u[4],
            y = u[5],
            m = u[6],
            v = u[7],
            g = u[8],
            b = u[9],
            w = u[10],
            O = u[11];
        return t !== e && (o[0] = l, o[1] = f, o[2] = h, o[3] = p, o[4] = d, o[5] = y, o[6] = m, o[7] = v, o[8] = g, o[9] = b, o[10] = w, o[11] = O), o[12] = l * a + d * s + g * c + e[12], o[13] = f * a + y * s + b * c + e[13], o[14] = h * a + m * s + w * c + e[14], o[15] = p * a + v * s + O * c + e[15], o;
      },
          u = function u(t, e, r, o) {
        var i = t,
            a = n(o, 3),
            s = a[0],
            c = a[1],
            u = a[2],
            l = Math.hypot(s, c, u);
        if (l < 1e-6) throw new Error("Matrix4*4 rotate has wrong axis");
        s *= l = 1 / l, c *= l, u *= l;
        var f = Math.sin(r),
            h = Math.cos(r),
            p = 1 - h,
            d = n(e, 12),
            y = d[0],
            m = d[1],
            v = d[2],
            g = d[3],
            b = d[4],
            w = d[5],
            O = d[6],
            _ = d[7],
            x = d[8],
            L = d[9],
            E = d[10],
            A = d[11],
            R = s * s * p + h,
            T = c * s * p + u * f,
            P = u * s * p - c * f,
            S = s * c * p - u * f,
            k = c * c * p + h,
            j = u * c * p + s * f,
            Z = s * u * p + c * f,
            M = c * u * p - s * f,
            C = u * u * p + h;
        return i[0] = y * R + b * T + x * P, i[1] = m * R + w * T + L * P, i[2] = v * R + O * T + E * P, i[3] = g * R + _ * T + A * P, i[4] = y * S + b * k + x * j, i[5] = m * S + w * k + L * j, i[6] = v * S + O * k + E * j, i[7] = g * S + _ * k + A * j, i[8] = y * Z + b * M + x * C, i[9] = m * Z + w * M + L * C, i[10] = v * Z + O * M + E * C, i[11] = g * Z + _ * M + A * C, e !== t && (i[12] = e[12], i[13] = e[13], i[14] = e[14], i[15] = e[15]), i;
      };

      function l(t, e) {
        return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
      }

      function f(t, e) {
        var r = e[0],
            n = e[1],
            o = e[2],
            i = e[3],
            a = e[4],
            s = e[5],
            c = e[6],
            u = e[7],
            l = e[8],
            f = e[9],
            h = e[10],
            p = e[11],
            d = e[12],
            y = e[13],
            m = e[14],
            v = e[15],
            g = r * s - n * a,
            b = r * c - o * a,
            w = r * u - i * a,
            O = n * c - o * s,
            _ = n * u - i * s,
            x = o * u - i * c,
            L = l * y - f * d,
            E = l * m - h * d,
            A = l * v - p * d,
            R = f * m - h * y,
            T = f * v - p * y,
            P = h * v - p * m,
            S = g * P - b * T + w * R + O * A - _ * E + x * L;

        return S ? (S = 1 / S, t[0] = (s * P - c * T + u * R) * S, t[1] = (c * A - a * P - u * E) * S, t[2] = (a * T - s * A + u * L) * S, t[3] = (o * T - n * P - i * R) * S, t[4] = (r * P - o * A + i * E) * S, t[5] = (n * A - r * T - i * L) * S, t[6] = (y * x - m * _ + v * O) * S, t[7] = (m * w - d * x - v * b) * S, t[8] = (d * _ - y * w + v * g) * S, t) : null;
      }
    },
    8348: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      r.d(e, {
        OW: function OW() {
          return o;
        },
        t7: function t7() {
          return s;
        },
        t8: function t8() {
          return i;
        },
        tk: function tk() {
          return a;
        }
      });

      var o = function () {
        function t(e, r, n) {
          (function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, t), this.x = e, this.y = r, this.z = n;
        }

        return e = t, (r = [{
          key: "add",
          value: function value(e) {
            return new t(this.x + e.x, this.y + e.y, this.z + e.z);
          }
        }, {
          key: "sub",
          value: function value(e) {
            return new t(this.x - e.x, this.y - e.y, this.z - e.z);
          }
        }, {
          key: "mul",
          value: function value(e) {
            return new t(this.x * e, this.y * e, this.z * e);
          }
        }, {
          key: "length",
          value: function value() {
            return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
          }
        }, {
          key: "distance",
          value: function value(t) {
            return this.sub(t).length();
          }
        }, {
          key: "normal",
          value: function value() {
            if (0 === this.x && 0 === this.y && 0 === this.z) return new t(0, 0, 0);
            var e = this.length();
            return new t(this.x / e, this.y / e, this.z / e);
          }
        }, {
          key: "dot",
          value: function value(t) {
            return this.x * t.x + this.y * t.y + this.z * t.z;
          }
        }, {
          key: "toArray",
          value: function value() {
            return [this.x, this.y, this.z];
          }
        }, {
          key: "toString",
          value: function value() {
            return "( ".concat(this.x, ", ").concat(this.y, ", ").concat(this.z, " )");
          }
        }, {
          key: "negate",
          value: function value() {
            return new t(-1 * this.x, -1 * this.y, -1 * this.z);
          }
        }]) && n(e.prototype, r), o && n(e, o), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
        var e, r, o;
      }();

      function i(t, e) {
        e.x = t.x, e.y = t.y, e.z = t.z;
      }

      function a(t, e) {
        return e || (e = new o(-t.x, -t.y, -t.z)), e.x = -t.x, e.y = -t.y, e.z = -t.z, e;
      }

      function s(t, e, r, n) {
        return n || (n = t), n.x = t.x + r * (e.x - t.x), n.y = t.y + r * (e.y - t.y), n.z = t.z + r * (e.z - t.z), n;
      }
    },
    6185: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return n;
        }
      });
      var n = {
        tilesetRequestUrl: function tilesetRequestUrl(t) {
          return "/pixos/tilesets/" + t + "/tileset.json";
        },
        zoneRequestUrl: function zoneRequestUrl(t) {
          return "/pixos/maps/" + t + "/map.json";
        },
        artResourceUrl: function artResourceUrl(t) {
          return "/pixos/art/" + t;
        }
      };
    },
    9176: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return y;
        }
      });
      var n = r(1),
          o = r(3793);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a() {
        a = function a() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            s = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, a, s, c) {
            var u = f(t[o], t, a);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == i(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, s, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function s(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function c(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(t) {
              s(i, n, o, a, c, "next", t);
            }

            function c(t) {
              s(i, n, o, a, c, "throw", t);
            }

            a(void 0);
          });
        };
      }

      function u(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function l(t, e) {
        return l = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, l(t, e);
      }

      function f(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return h(t);
      }

      function h(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }

      function p(t) {
        return p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, p(t);
      }

      function d(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      var y = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && l(t, e);
        }(y, t);
        var e,
            r,
            i,
            s = (r = y, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = p(r);

          if (i) {
            var n = p(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return f(this, t);
        });

        function y() {
          var t;
          u(this, y);

          for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++) {
            r[i] = arguments[i];
          }

          return d(h(t = s.call.apply(s, [this].concat(r))), "init", function () {
            var e = c(a().mark(function e(r) {
              var i;
              return a().wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return n.Z._instance.engine = r, i = n.Z._instance.world = new o.Z(r, "scene"), e.next = 4, i.loadZone("room");

                    case 4:
                      i.zoneList.forEach(function (t) {
                        return t.runWhenLoaded(function () {
                          return console.log("loading...done");
                        });
                      }), i.startMenu({
                        start: {
                          text: "Start Game",
                          prompt: "Welcome to Pixos",
                          x: r.screenSize().width / 2 - 75,
                          y: r.screenSize().height / 2 - 50,
                          w: 150,
                          h: 75,
                          quittable: !1,
                          colours: {
                            top: "#333",
                            bottom: "#777",
                            background: "#999"
                          },
                          onOpen: function onOpen(e) {
                            t.isPaused = !0;
                          },
                          trigger: function trigger(t) {
                            console.log(t), t.world.zoneList.filter(function (t) {
                              return null != t.audio;
                            }).map(function (t) {
                              return t.audio.playAudio();
                            }), t.world.isPaused = !1, t.completed = !0;
                          }
                        }
                      });

                    case 6:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()), t;
        }

        return e = y, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(n.Z);
    },
    5253: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return o;
        }
      });
      var n = r(1927);
      var o = [n.Z.SLW_CORNER, n.Z.SLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.LW_LPIT, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.V_WALKWAY, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.RW_RPIT, n.Z.FLOOR, n.Z.FLOOR, n.Z.SRW_COLUMN, n.Z.SRW_CORNER].concat([n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.SLW_WATER_COLUMN, n.Z.WATER, n.Z.WATER, n.Z.S_STAIR, n.Z.WATER, n.Z.WATER, n.Z.SRW_WATER_COLUMN, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.SRW_CORNER, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.SW_SPIT, n.Z.SW_SPIT, n.Z.S_STAIRWALL, n.Z.SW_SPIT, n.Z.SW_SPIT, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.SLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.SRW_COLUMN, n.Z.SRW_CORNER, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.SRW_CORNER, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY]);
    },
    49: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return h;
        }
      });
      var n = r(8348),
          o = r(4180),
          i = r(1736);

      function a(t) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, a(t);
      }

      function s() {
        s = function s() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, s, c) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == a(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function c(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function u(t, e, r) {
        return u = l() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && f(o, r.prototype), o;
        }, u.apply(null, arguments);
      }

      function l() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function f(t, e) {
        return f = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, f(t, e);
      }

      var h = {
        bounds: [0, 10, 17, 19],
        tileset: "void",
        audioSrc: "/pixos/audio/dungeon-beat.mp3",
        cells: r(5253).default,
        sprites: [{
          id: "water",
          type: "npc/water-knight",
          pos: u(n.OW, [8, 13, 0]),
          facing: o.N.Up
        }, {
          id: "spurt8",
          type: "effects/lavaspurt",
          pos: u(n.OW, [7, 10, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt9",
          type: "effects/lavaspurt",
          pos: u(n.OW, [10, 10, -1.5]),
          facing: o.N.Up
        }],
        scripts: [{
          id: "load-scene",
          trigger: (p = s().mark(function t() {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, i.hy)(this, i.G4);

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), d = function d() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = p.apply(t, e);

              function i(t) {
                c(o, r, n, i, a, "next", t);
              }

              function a(t) {
                c(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function () {
            return d.apply(this, arguments);
          })
        }],
        scenes: [],
        objects: []
      };
      var p, d;
    },
    6268: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return o;
        }
      });
      var n = r(1927);
      var o = [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.NRW_CORNER, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY].concat([n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.NLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.NRW_COLUMN, n.Z.NRW_CORNER, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.NW_NPIT, n.Z.NW_NPIT, n.Z.N_STAIRWALL, n.Z.NW_NPIT, n.Z.NW_NPIT, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.NLW_WATER_COLUMN, n.Z.WATER, n.Z.WATER, n.Z.N_STAIR, n.Z.WATER, n.Z.WATER, n.Z.NRW_WATER_COLUMN, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.NRW_CORNER, n.Z.EMPTY], [n.Z.NLW_CORNER, n.Z.NLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.LW_LPIT, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.V_WALKWAY, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.RW_RPIT, n.Z.FLOOR, n.Z.FLOOR, n.Z.NRW_COLUMN, n.Z.NRW_CORNER], [n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.LW_LPIT, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.V_WALKWAY, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.RW_RPIT, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL], [n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.L_STAIRWALL, n.Z.L_STAIR, n.Z.H_WALKWAY, n.Z.H_WALKWAY, n.Z.C_WALKWAY, n.Z.H_WALKWAY, n.Z.H_WALKWAY, n.Z.R_STAIR, n.Z.R_STAIRWALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL], [n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.LW_LPIT, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.V_WALKWAY, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.RW_RPIT, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL]);
    },
    1689: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return f;
        }
      });
      var n = r(8348),
          o = r(4180);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a() {
        a = function a() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            s = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, a, s, c) {
            var u = f(t[o], t, a);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == i(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, s, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function s(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function c(t, e, r) {
        return c = u() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && l(o, r.prototype), o;
        }, c.apply(null, arguments);
      }

      function u() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function l(t, e) {
        return l = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, l(t, e);
      }

      r(1736);
      var f = {
        bounds: [0, 0, 17, 10],
        tileset: "void",
        cells: r(6268).default,
        sprites: [{
          id: "darkness",
          type: "npc/darkness",
          pos: c(n.OW, [10, 4, 0]),
          facing: o.N.Down
        }, {
          id: "air",
          type: "npc/air-knight",
          pos: c(n.OW, [8, 4, 0]),
          facing: o.N.Down
        }, {
          id: "fire",
          type: "npc/fire-knight",
          pos: c(n.OW, [2, 9, 0]),
          facing: o.N.Right
        }, {
          id: "earth",
          type: "npc/earth-knight",
          pos: c(n.OW, [14, 7, 0]),
          facing: o.N.Left
        }, {
          id: "door",
          type: "furniture/door",
          pos: c(n.OW, [2, 5, 0]),
          facing: o.N.Down,
          zones: ["mountain"]
        }, {
          id: "spurt1",
          type: "effects/lavaspurt",
          pos: c(n.OW, [10, 7, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt2",
          type: "effects/lavaspurt",
          pos: c(n.OW, [9, 6, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt3",
          type: "effects/lavaspurt",
          pos: c(n.OW, [10, 5, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt4",
          type: "effects/lavaspurt",
          pos: c(n.OW, [7, 6, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt5",
          type: "effects/lavaspurt",
          pos: c(n.OW, [6, 7, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt6",
          type: "effects/lavaspurt",
          pos: c(n.OW, [6, 9, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt7",
          type: "effects/lavaspurt",
          pos: c(n.OW, [9, 9, -1.5]),
          facing: o.N.Up
        }],
        scripts: [{
          id: "load-scene",
          trigger: (h = a().mark(function t() {
            return a().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    console.log("Triggered");

                  case 1:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }), p = function p() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = h.apply(t, e);

              function i(t) {
                s(o, r, n, i, a, "next", t);
              }

              function a(t) {
                s(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function () {
            return p.apply(this, arguments);
          })
        }],
        scenes: [],
        objects: []
      };
      var h, p;
    },
    7730: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return o;
        }
      });
      var n = r(1927);
      var o = [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY].concat([n.Z.EMPTY, n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.NRW_CORNER, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.NLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.NRW_COLUMN, n.Z.NRW_CORNER, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.SLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.SRW_COLUMN, n.Z.SRW_CORNER, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.SRW_CORNER, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY]);
    },
    5722: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return p;
        }
      });
      var n = r(8348),
          o = r(4180),
          i = r(1736);

      function a(t) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, a(t);
      }

      function s() {
        s = function s() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, s, c) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == a(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function c(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function u(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(t) {
              c(i, n, o, a, s, "next", t);
            }

            function s(t) {
              c(i, n, o, a, s, "throw", t);
            }

            a(void 0);
          });
        };
      }

      function l(t, e, r) {
        return l = f() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && h(o, r.prototype), o;
        }, l.apply(null, arguments);
      }

      function f() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function h(t, e) {
        return h = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, h(t, e);
      }

      var p = {
        bounds: [0, 0, 17, 19],
        tileset: "sewer",
        audioSrc: "/pixos/audio/calm-escape.mp3",
        cells: function cells(t, e) {
          var r = t[0],
              n = t[1],
              o = t[2] - r,
              a = t[3] - n;
          return new Array(a).fill(null).map(function (e, a) {
            return new Array(o).fill(null).map(function (e, o) {
              var s = (r + a) * (n + o) + Math.floor(a * Math.random()) - Math.floor(o * Math.random());
              return a == n || a == t[3] - 1 || o == r || o == t[2] - 1 ? T.EDGE : s % Math.abs(3 + (store.pixos && store.pixos[i.G4] ? store.pixos[i.G4].selected : 7)) != 0 ? T.FLOOR : s % Math.abs(7 + (store.pixos && store.pixos[i.G4] ? store.pixos[i.G4].selected : 7)) != 0 ? T.PILLAR : T.BLOCK;
            });
          }).filter(function (t) {
            return t;
          }).flat(1);
        },
        sprites: function sprites(t, e) {
          var r,
              a = null !== (r = e.defaultSprites) && void 0 !== r ? r : [],
              s = t[0],
              c = t[1],
              u = t[2] - s,
              f = t[3] - c,
              h = [{
            id: "door-l",
            type: "furniture/portal",
            facing: o.N.Down,
            onStep: function onStep() {
              store.pixos[i.G4].position = l(n.OW, [5, 3, 0]), store.pixos[i.G4].selected += 3;
            },
            zones: ["ice"]
          }, {
            id: "door-r",
            type: "furniture/portal",
            facing: o.N.Down,
            onStep: function onStep() {
              store.pixos[i.G4].position = l(n.OW, [8, 3, 0]), store.pixos[i.G4].selected += 7;
            },
            zones: ["jungle"]
          }];
          return new Array(f).fill(null).map(function (r, f) {
            return new Array(u).fill(null).map(function (r, u) {
              var p = (s + f) * (c + u) + Math.floor(f * Math.random()) - Math.floor(u * Math.random());
              if (f == c || f == t[3] - 1 || u == s || u == t[2] - 1) for (var d = 0; d < Math.floor(227 * (p + 1) % 9); d++) {
                a.push({
                  id: "plt-" + p + d,
                  type: "objects/plants/random",
                  pos: l(n.OW, [u, f, 2]),
                  facing: o.N.Down
                });
              }
              if (p % Math.abs(3 + (store.pixos && store.pixos[i.G4] ? store.pixos[i.G4].selected : 7)) != 0 && p % Math.abs(5 + (store.pixos && store.pixos[i.G4] ? store.pixos[i.G4].selected : 7)) == 0) if (h.length > 0 && p % Math.abs(22) && 0 === e.getHeight(u, f)) {
                var y = h.pop();
                y.pos = l(n.OW, [u, f, e.getHeight(u, f)]), Math.abs(a.push(y));
              } else if (h.length > 0 && p % Math.abs(33) && 0 === e.getHeight(u, f)) {
                var m = h.shift();
                m.pos = l(n.OW, [u, f, e.getHeight(u, f)]), Math.abs(a.push(m));
              }
              if (p % Math.abs(7 + (store.pixos && store.pixos[i.G4] ? store.pixos[i.G4].selected : 7)) != 0 && p % Math.abs(5 + (store.pixos && store.pixos[i.G4] ? store.pixos[i.G4].selected : 7)) == 0) for (var v = 0; v < Math.floor(227 * (p + 1) % 9); v++) {
                a.push({
                  id: "plt-" + p + v,
                  type: "objects/plants/random",
                  pos: l(n.OW, [u, f, e.getHeight(u, f)]),
                  facing: o.N.Down
                });
              }
              if (p % Math.abs(5 + (store.pixos && store.pixos[i.G4] ? store.pixos[i.G4].selected : 7)) == 0) for (var g = 0; g < Math.floor(227 * (p + 1) % 9); g++) {
                a.push({
                  id: "plt-" + p + g,
                  type: "objects/plants/random",
                  pos: l(n.OW, [u, f, e.getHeight(u, f)]),
                  facing: o.N.Down
                });
              }
            });
          }), a;
        },
        defaultSprites: [{
          id: "chest",
          type: "objects/chests/wood",
          pos: l(n.OW, [8, 14, 0]),
          facing: o.N.Down
        }, {
          id: "chestmetal",
          type: "objects/chests/metal",
          pos: l(n.OW, [9, 13, 0]),
          facing: o.N.Right
        }, {
          id: "chestred",
          type: "objects/chests/red",
          pos: l(n.OW, [9, 14, 0]),
          facing: o.N.Down
        }, {
          id: "chestblue",
          type: "objects/chests/blue",
          pos: l(n.OW, [7, 13, 0]),
          facing: o.N.Left
        }, {
          id: "door",
          type: "furniture/door",
          pos: l(n.OW, [9, 1, 0]),
          facing: o.N.Down,
          zones: ["dungeon-top", "dungeon-bottom"]
        }, {
          id: "tree",
          type: "furniture/tree",
          fixed: !0,
          pos: l(n.OW, [8, 13, 0]),
          facing: o.N.Up
        }, {
          id: "fireplace",
          type: "furniture/fireplace",
          fixed: !0,
          pos: l(n.OW, [11, 1, 0]),
          facing: o.N.Up
        }, {
          id: "fireplace",
          type: "effects/fireplace",
          fixed: !0,
          pos: l(n.OW, [11, 1, 0]),
          facing: o.N.Up
        }, {
          id: "darkness",
          type: "npc/darkness",
          pos: l(n.OW, [6, 5, 0]),
          facing: o.N.Down
        }, {
          id: "air",
          type: "npc/air-knight",
          pos: l(n.OW, [8, 2, 0]),
          facing: o.N.Down
        }, {
          id: "fire",
          type: "npc/fire-knight",
          pos: l(n.OW, [2, 8, 0]),
          facing: o.N.Right
        }, {
          id: "earth",
          type: "npc/earth-knight",
          pos: l(n.OW, [14, 8, 0]),
          facing: o.N.Left
        }],
        scenes: [{
          id: "strange-legend",
          actions: [{
            sprite: "air",
            action: "dialogue",
            args: [["Long ago, in a dungeon far far away", "The sewer was backing up, and well...everyone was losing their $%#t", "But one had a plan..."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            sprite: "air",
            action: "dialogue",
            args: [["But what was that plan?..."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            trigger: "custom",
            scope: void 0
          }]
        }],
        scripts: [{
          id: "load-scene",
          trigger: (m = u(s().mark(function t() {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, i.hy)(this, i.G4);

                  case 2:
                    return t.next = 4, this.playScene("strange-legend");

                  case 4:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function () {
            return m.apply(this, arguments);
          })
        }, {
          id: "custom",
          trigger: (y = u(s().mark(function t() {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, this.spriteDialogue("earth", ["Lets get in there!"]);

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function () {
            return y.apply(this, arguments);
          })
        }, {
          id: "clear-path",
          trigger: (d = u(s().mark(function t() {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, this.moveSprite("darkness", [8, 3, 0], !0);

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function () {
            return d.apply(this, arguments);
          })
        }],
        objects: [{
          id: "test-obj",
          type: "person",
          mtl: !1,
          useScale: l(n.OW, [.1, .1, .1]),
          pos: l(n.OW, [10, 15, 0])
        }, {
          id: "test-bed",
          type: "bed",
          mtl: !0,
          pos: l(n.OW, [14, 10, 0])
        }, {
          id: "test-" + Math.random(),
          type: "chair",
          mtl: !0,
          pos: l(n.OW, [12, 6, 0])
        }, {
          id: "test" + Math.random(),
          type: "cactus_short",
          mtl: !0,
          pos: l(n.OW, [11, 6, 0])
        }, {
          id: "test-robot",
          type: "robot",
          mtl: !1,
          pos: l(n.OW, [7, 7, 1]),
          rotation: l(n.OW, [0, 90, 0])
        }, {
          id: "test-cube",
          type: "die",
          mtl: !0,
          pos: l(n.OW, [6, 4, 1])
        }]
      };
      var d, y, m;
    },
    8030: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        main: {
          text: "Click Me",
          x: 100,
          y: 100,
          w: 150,
          h: 75,
          colours: {
            top: "#333",
            bottom: "#777",
            background: "#999"
          },
          children: ["sub", "nested"]
        },
        sub: {
          text: "Click Me Again",
          x: 110,
          y: 110,
          w: 150,
          h: 75,
          colours: {
            top: "#333",
            bottom: "#777",
            background: "#999"
          },
          children: ["main"]
        },
        nested: {
          text: "Click Me ONE MORE",
          x: 210,
          y: 110,
          w: 150,
          h: 75,
          colours: {
            top: "#333",
            bottom: "#777",
            background: "#999"
          },
          trigger: function trigger(t) {
            t.completed = !0;
          }
        }
      };
    },
    2090: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("player-2.gif"), e.portraitSrc = o.Z.artResourceUrl("witch_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.state = "intro", e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.bindCamera = !0, e.enableSpeech = !0, e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(6180).Z);
    },
    3764: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("player.gif"), e.portraitSrc = o.Z.artResourceUrl("hero_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.state = "intro", e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.bindCamera = !0, e.enableSpeech = !0, e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(6180).Z);
    },
    1493: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), s.call(this, t);
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(2011).Z);
    },
    6575: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), s.call(this, t);
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(5329).Z);
    },
    740: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), s.call(this, t);
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(1924).Z);
    },
    6301: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), s.call(this, t);
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(2811).Z);
    },
    9508: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return h;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i() {
        i = function i() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            a = n.iterator || "@@iterator",
            s = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, a, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, a) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(i, a, s, c) {
            var u = f(t[i], t, a);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == o(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var i;

          this._invoke = function (t, r) {
            function o() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[a];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  o = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return o.next = o;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, s, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, a, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function a(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function s(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function s(t) {
              a(i, n, o, s, c, "next", t);
            }

            function c(t) {
              a(i, n, o, s, c, "throw", t);
            }

            s(void 0);
          });
        };
      }

      function c(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function u(t, e) {
        return u = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, u(t, e);
      }

      function l(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function f(t) {
        return f = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, f(t);
      }

      var h = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && u(t, e);
        }(p, t);
        var e,
            r,
            o,
            a,
            h = (o = p, a = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = f(o);

          if (a) {
            var r = f(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return l(this, t);
        });

        function p(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, p), h.call(this, t);
        }

        return e = p, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Buying eh?!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this, s(i().mark(function t() {
                  var e, r, n, o;
                  return i().wrap(function (t) {
                    for (;;) {
                      switch (t.prev = t.next) {
                        case 0:
                          return t.next = 2, window.ethereum.request({
                            method: "eth_requestAccounts"
                          });

                        case 2:
                          e = t.sent[0], r = JSON.stringify({
                            domain: {
                              chainId: 1,
                              name: "Pixos",
                              verifyingContract: "0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC",
                              version: "1"
                            },
                            message: {
                              game: "Example",
                              contents: "Quest Item",
                              from: {
                                sprite: "air-knight",
                                wallet: "0xCD2a3d9F938E13CD947Ec05AbC7FE734Df8DD826"
                              },
                              to: {
                                sprite: "avatar",
                                wallet: e
                              }
                            },
                            primaryType: "Item",
                            types: {
                              EIP712Domain: [{
                                name: "name",
                                type: "string"
                              }, {
                                name: "version",
                                type: "string"
                              }, {
                                name: "chainId",
                                type: "uint256"
                              }, {
                                name: "verifyingContract",
                                type: "address"
                              }],
                              Item: [{
                                name: "game",
                                type: "string"
                              }, {
                                name: "contents",
                                type: "string"
                              }, {
                                name: "from",
                                type: "Person"
                              }, {
                                name: "to",
                                type: "Person"
                              }],
                              Person: [{
                                name: "sprite",
                                type: "string"
                              }, {
                                name: "wallet",
                                type: "address"
                              }]
                            }
                          }), o = [n = e, r], window.web3.currentProvider.sendAsync({
                            method: "eth_signTypedData_v4",
                            params: o,
                            from: n
                          }, function (t, e) {
                            if (t) return console.dir(t);
                            if (e.error && alert(e.error.message), e.error) return console.error("ERROR", e);
                            var o = window.sigUtil.recoverTypedSignature_v4({
                              data: JSON.parse(r),
                              sig: e.result
                            });
                            window.ethUtil.toChecksumAddress(o) === window.ethUtil.toChecksumAddress(n) ? alert("Successfully recovered signer as " + n) : alert("Failed to verify signer when comparing " + e + " to " + n);
                          });

                        case 8:
                        case "end":
                          return t.stop();
                      }
                    }
                  }, t);
                })));
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && c(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), p;
      }(r(9875).Z);
    },
    6463: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), l.call(this, t);
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Join me....!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I need a partner for squash.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Seriously - you swing?", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(2304).Z);
    },
    1350: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), l.call(this, t);
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Welcome!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(512).Z);
    },
    7238: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), l.call(this, t);
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Welcome!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(6529).Z);
    },
    6905: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), l.call(this, t);
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", [["I am the Water Knight!", "Here is my home.", "yo"], !1, {
                  autoclose: !1,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(7967).Z);
    },
    3188: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      }), r(3569);

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).enableSpeech = !1, e.inventory = [], e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(9096).Z);
    },
    9554: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      }), r(3569);

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).enableSpeech = !1, e.inventory = [], e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(9391).Z);
    },
    5999: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      }), r(3569);

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).enableSpeech = !1, e.inventory = [], e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(8790).Z);
    },
    9843: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      }), r(3569);

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).enableSpeech = !1, e.inventory = [{
            id: "sword",
            type: "object"
          }], e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(1060).Z);
    },
    4829: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return y;
        }
      });
      var n = r(1),
          o = r(3793);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a() {
        a = function a() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            s = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, a, s, c) {
            var u = f(t[o], t, a);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == i(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, s, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function s(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function c(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(t) {
              s(i, n, o, a, c, "next", t);
            }

            function c(t) {
              s(i, n, o, a, c, "throw", t);
            }

            a(void 0);
          });
        };
      }

      function u(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function l(t, e) {
        return l = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, l(t, e);
      }

      function f(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return h(t);
      }

      function h(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }

      function p(t) {
        return p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, p(t);
      }

      function d(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      var y = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && l(t, e);
        }(y, t);
        var e,
            r,
            i,
            s = (r = y, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = p(r);

          if (i) {
            var n = p(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return f(this, t);
        });

        function y() {
          var t;
          u(this, y);

          for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++) {
            r[i] = arguments[i];
          }

          return d(h(t = s.call.apply(s, [this].concat(r))), "init", function () {
            var e = c(a().mark(function e(r) {
              var i;
              return a().wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return n.Z._instance.engine = r, i = n.Z._instance.world = new o.Z(r, "peacefulGarden"), e.next = 4, i.loadZone("field");

                    case 4:
                      i.zoneList.forEach(function (t) {
                        return t.runWhenLoaded(function () {
                          return console.log("loading...done");
                        });
                      }), i.startMenu({
                        start: {
                          text: "Start Game",
                          prompt: "Welcome to the Peaceful Garden. Please feel free to discover its secrets",
                          x: r.screenSize().width / 2 - 75,
                          y: r.screenSize().height / 2 - 50,
                          w: 150,
                          h: 75,
                          quittable: !1,
                          colours: {
                            top: "#333",
                            bottom: "#777",
                            background: "#999"
                          },
                          onEnter: !0,
                          onOpen: function onOpen(e) {
                            t.isPaused = !0;
                          },
                          trigger: function trigger(t) {
                            console.log(t), t.world.zoneList.filter(function (t) {
                              return null != t.audio;
                            }).map(function (t) {
                              t.audio.playAudio();
                            }), t.world.isPaused = !1, t.completed = !0;
                          }
                        }
                      });

                    case 6:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()), t;
        }

        return e = y, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(n.Z);
    },
    7449: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return o;
        }
      });
      var n = r(1927);
      var o = [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.NRW_CORNER, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY].concat([n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.NLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.NRW_COLUMN, n.Z.NRW_CORNER, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.NW_NPIT, n.Z.NW_NPIT, n.Z.N_STAIRWALL, n.Z.NW_NPIT, n.Z.NW_NPIT, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.NLW_WATER_COLUMN, n.Z.WATER, n.Z.WATER, n.Z.N_STAIR, n.Z.WATER, n.Z.WATER, n.Z.NRW_WATER_COLUMN, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.NRW_CORNER, n.Z.EMPTY], [n.Z.NLW_CORNER, n.Z.NLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.LW_LPIT, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.V_WALKWAY, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.RW_RPIT, n.Z.FLOOR, n.Z.FLOOR, n.Z.NRW_COLUMN, n.Z.NRW_CORNER], [n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.LW_LPIT, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.V_WALKWAY, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.RW_RPIT, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL], [n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.L_STAIRWALL, n.Z.L_STAIR, n.Z.H_WALKWAY, n.Z.H_WALKWAY, n.Z.C_WALKWAY, n.Z.H_WALKWAY, n.Z.H_WALKWAY, n.Z.R_STAIR, n.Z.R_STAIRWALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL], [n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.LW_LPIT, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.V_WALKWAY, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.RW_RPIT, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL], [n.Z.SLW_CORNER, n.Z.SLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.LW_LPIT, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.V_WALKWAY, n.Z.WATER, n.Z.WATER, n.Z.WATER, n.Z.RW_RPIT, n.Z.FLOOR, n.Z.FLOOR, n.Z.SRW_COLUMN, n.Z.SRW_CORNER], [n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.SLW_WATER_COLUMN, n.Z.WATER, n.Z.WATER, n.Z.S_STAIR, n.Z.WATER, n.Z.WATER, n.Z.SRW_WATER_COLUMN, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.SRW_CORNER, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.SW_SPIT, n.Z.SW_SPIT, n.Z.S_STAIRWALL, n.Z.SW_SPIT, n.Z.SW_SPIT, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.SLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.SRW_COLUMN, n.Z.SRW_CORNER, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.SRW_CORNER, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY]);
    },
    5512: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return h;
        }
      });
      var n = r(8348),
          o = r(4180),
          i = r(1736);

      function a(t) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, a(t);
      }

      function s() {
        s = function s() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, s, c) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == a(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function c(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function u(t, e, r) {
        return u = l() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && f(o, r.prototype), o;
        }, u.apply(null, arguments);
      }

      function l() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function f(t, e) {
        return f = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, f(t, e);
      }

      var h = {
        bounds: [0, 0, 17, 19],
        tileset: "void",
        audioSrc: "/pixos/audio/dungeon-beat.mp3",
        cells: r(7449).default,
        sprites: [{
          id: "darkness",
          type: "npc/darkness",
          pos: u(n.OW, [10, 4, 0]),
          facing: o.N.Down
        }, {
          id: "water",
          type: "npc/water-knight",
          pos: u(n.OW, [8, 13, 0]),
          facing: o.N.Up
        }, {
          id: "air",
          type: "npc/air-knight",
          pos: u(n.OW, [8, 4, 0]),
          facing: o.N.Down
        }, {
          id: "fire",
          type: "npc/fire-knight",
          pos: u(n.OW, [2, 9, 0]),
          facing: o.N.Right
        }, {
          id: "earth",
          type: "npc/earth-knight",
          pos: u(n.OW, [14, 7, 0]),
          facing: o.N.Left
        }, {
          id: "door",
          type: "furniture/door",
          pos: u(n.OW, [2, 5, 0]),
          facing: o.N.Down,
          zones: ["sewer"]
        }, {
          id: "spurt1",
          type: "effects/lavaspurt",
          pos: u(n.OW, [10, 7, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt2",
          type: "effects/lavaspurt",
          pos: u(n.OW, [9, 6, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt3",
          type: "effects/lavaspurt",
          pos: u(n.OW, [10, 5, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt4",
          type: "effects/lavaspurt",
          pos: u(n.OW, [7, 6, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt5",
          type: "effects/lavaspurt",
          pos: u(n.OW, [6, 7, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt6",
          type: "effects/lavaspurt",
          pos: u(n.OW, [6, 9, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt7",
          type: "effects/lavaspurt",
          pos: u(n.OW, [9, 9, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt8",
          type: "effects/lavaspurt",
          pos: u(n.OW, [7, 10, -1.5]),
          facing: o.N.Up
        }, {
          id: "spurt9",
          type: "effects/lavaspurt",
          pos: u(n.OW, [10, 10, -1.5]),
          facing: o.N.Up
        }],
        scripts: [{
          id: "load-scene",
          trigger: (p = s().mark(function t() {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, i.hy)(this, i.G4);

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), d = function d() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = p.apply(t, e);

              function i(t) {
                c(o, r, n, i, a, "next", t);
              }

              function a(t) {
                c(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function () {
            return d.apply(this, arguments);
          })
        }],
        scenes: [],
        objects: []
      };
      var p, d;
    },
    5092: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return v;
        }
      });
      var n = r(5565),
          o = r(8348),
          i = r(4180),
          a = r(1736),
          s = r(9940);

      function c(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function u(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      var l = Object.assign({}, function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(r), !0).forEach(function (e) {
            u(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }({}, s.Z));

      function f(t) {
        return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, f(t);
      }

      function h() {
        h = function h() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function c(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === l) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = u(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function u(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = c;
        var l = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        s(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, s) {
            var c = u(t[o], t, i);

            if ("throw" !== c.type) {
              var l = c.arg,
                  h = l.value;
              return h && "object" == f(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(h).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(c.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return l;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return l;
          }

          var n = u(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, s(b, "constructor", y), s(y, "constructor", d), d.displayName = s(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, s(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), s(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), s(b, a, "Generator"), s(b, o, function () {
          return this;
        }), s(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), l;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), l;
          }
        }, t;
      }

      function p(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function d(t, e, r) {
        return d = y() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && m(o, r.prototype), o;
        }, d.apply(null, arguments);
      }

      function y() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function m(t, e) {
        return m = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, m(t, e);
      }

      var v = {
        bounds: [0, 0, 30, 50],
        tileset: "field",
        audioSrc: "/pixos/audio/calm-escape.mp3",
        portals: [{
          id: "door-l",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = d(o.OW, [5, 3, 0]), n.store.pixos[a.G4].selected += 3;
          },
          zones: ["mountain"]
        }, {
          id: "door-r",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = d(o.OW, [8, 3, 0]), n.store.pixos[a.G4].selected += 7;
          },
          zones: ["jungle"]
        }],
        cells: function cells(t, e) {
          var r = t[0],
              o = t[1],
              i = t[2] - r,
              s = t[3] - o;
          return new Array(s).fill(null).map(function (e, s) {
            return new Array(i).fill(null).map(function (e, i) {
              var c = (r + s) * (o + i) + Math.floor(s * Math.random()) - Math.floor(i * Math.random());
              return s == o || s == t[3] - 1 || i == r || i == t[2] - 1 ? l.EDGE : c % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? l.FLOOR : c % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? l.PILLAR : l.BLOCK;
            });
          }).filter(function (t) {
            return t;
          }).flat(1);
        },
        sprites: function sprites(t, e) {
          var r,
              s = null !== (r = e.defaultSprites) && void 0 !== r ? r : [],
              c = t[0],
              u = t[1],
              l = t[2] - c,
              f = t[3] - u;
          return new Array(f).fill(null).map(function (r, f) {
            return new Array(l).fill(null).map(function (r, l) {
              var h = (c + f) * (u + l) + Math.floor(f * Math.random()) - Math.floor(l * Math.random());
              if (f == u || f == t[3] - 1 || l == c || l == t[2] - 1) for (var p = 0; p < Math.floor(227 * (h + 1) % 9); p++) {
                s.push({
                  id: "plt-" + h + p,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, 2]),
                  facing: i.N.Down
                });
              }
              if (h % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0 && (s = e.addPortal(s, l, f)), h % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0) for (var y = 0; y < Math.floor(227 * (h + 1) % 9); y++) {
                s.push({
                  id: "plt-" + h + y,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, e.getHeight(l, f)]),
                  facing: i.N.Down
                });
              }
              if (h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0) for (var m = 0; m < Math.floor(227 * (h + 1) % 9); m++) {
                s.push({
                  id: "plt-" + h + m,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, e.getHeight(l, f)]),
                  facing: i.N.Down
                });
              }
            });
          }), s;
        },
        defaultSprites: [{
          id: "monster",
          type: "monsters/air_elemental",
          pos: d(o.OW, [10, 4, 0]),
          facing: i.N.Down
        }],
        scenes: [{
          id: "welcome",
          actions: [{
            sprite: "avatar",
            action: "dialogue",
            args: [["Welcome to the Peaceful Garden.", "May your anxieties melt away and your inner spirit find balance and a sense of calm.", "Feel free to take a look around and explore."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            trigger: "custom",
            scope: void 0
          }]
        }],
        scripts: [{
          id: "load-scene",
          trigger: (g = h().mark(function t() {
            var e;
            return h().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, a.hy)(this, a.G4);

                  case 2:
                    return e = t.sent, t.next = 5, (0, a.Kn)(this, e, a.G4, r(4570));

                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), b = function b() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = g.apply(t, e);

              function i(t) {
                p(o, r, n, i, a, "next", t);
              }

              function a(t) {
                p(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function () {
            return b.apply(this, arguments);
          })
        }],
        objects: [{
          id: "test" + Math.random(),
          type: "cactus_short",
          mtl: !0,
          pos: d(o.OW, [11, 6, 0])
        }]
      };
      var g, b;
    },
    7934: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return v;
        }
      });
      var n = r(5565),
          o = r(8348),
          i = r(4180),
          a = r(1736),
          s = r(9940);

      function c(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function u(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      var l = Object.assign({}, function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(r), !0).forEach(function (e) {
            u(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }({}, s.Z));

      function f(t) {
        return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, f(t);
      }

      function h() {
        h = function h() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function c(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === l) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = u(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function u(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = c;
        var l = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        s(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, s) {
            var c = u(t[o], t, i);

            if ("throw" !== c.type) {
              var l = c.arg,
                  h = l.value;
              return h && "object" == f(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(h).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(c.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return l;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return l;
          }

          var n = u(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, s(b, "constructor", y), s(y, "constructor", d), d.displayName = s(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, s(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), s(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), s(b, a, "Generator"), s(b, o, function () {
          return this;
        }), s(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), l;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), l;
          }
        }, t;
      }

      function p(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function d(t, e, r) {
        return d = y() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && m(o, r.prototype), o;
        }, d.apply(null, arguments);
      }

      function y() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function m(t, e) {
        return m = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, m(t, e);
      }

      var v = {
        bounds: [0, 0, 30, 50],
        tileset: "ice",
        audioSrc: "/pixos/audio/dawns-peak.mp3",
        portals: [{
          id: "door-l",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = d(o.OW, [5, 3, 0]), n.store.pixos[a.G4].selected += 3;
          },
          zones: ["mountain"]
        }, {
          id: "door-r",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = d(o.OW, [8, 3, 0]), n.store.pixos[a.G4].selected += 7;
          },
          zones: ["sewer"]
        }],
        cells: function cells(t, e) {
          var r = t[0],
              o = t[1],
              i = t[2] - r,
              s = t[3] - o;
          return new Array(s).fill(null).map(function (e, s) {
            return new Array(i).fill(null).map(function (e, i) {
              var c = (r + s) * (o + i) + Math.floor(s * Math.random()) - Math.floor(i * Math.random());
              return s == o || s == t[3] - 1 || i == r || i == t[2] - 1 ? l.EDGE : c % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? l.FLOOR : c % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? l.PILLAR : l.BLOCK;
            });
          }).filter(function (t) {
            return t;
          }).flat(1);
        },
        sprites: function sprites(t, e) {
          var r,
              o = null !== (r = e.defaultSprites) && void 0 !== r ? r : [],
              i = t[0],
              s = t[1],
              c = t[2] - i,
              u = t[3] - s;
          return new Array(u).fill(null).map(function (r, u) {
            return new Array(c).fill(null).map(function (r, c) {
              var l = (i + u) * (s + c) + Math.floor(u * Math.random()) - Math.floor(c * Math.random());
              u == s || u == t[3] - 1 || c == i || t[2], l % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && l % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0 && (o = e.addPortal(o, u, c));
            });
          }), o;
        },
        defaultSprites: [],
        scenes: [{
          id: "welcome",
          actions: [{
            sprite: "avatar",
            action: "dialogue",
            args: [["Welcome to the Peaceful Garden.", "May your anxieties melt away and your inner spirit find balance and a sense of calm.", "Feel free to take a look around and explore."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            trigger: "custom",
            scope: void 0
          }]
        }],
        scripts: [{
          id: "load-scene",
          trigger: (g = h().mark(function t() {
            var e;
            return h().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, a.hy)(this, a.G4);

                  case 2:
                    return e = t.sent, t.next = 5, (0, a.Kn)(this, e, a.G4, r(4570));

                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), b = function b() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = g.apply(t, e);

              function i(t) {
                p(o, r, n, i, a, "next", t);
              }

              function a(t) {
                p(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function () {
            return b.apply(this, arguments);
          })
        }],
        objects: [{
          id: "test" + Math.random(),
          type: "cactus_short",
          mtl: !0,
          pos: d(o.OW, [11, 6, 0])
        }]
      };
      var g, b;
    },
    817: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return v;
        }
      });
      var n = r(5565),
          o = r(8348),
          i = r(4180),
          a = r(1736),
          s = r(9940);

      function c(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function u(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      var l = Object.assign({}, function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(r), !0).forEach(function (e) {
            u(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }({}, s.Z));

      function f(t) {
        return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, f(t);
      }

      function h() {
        h = function h() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function c(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === l) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = u(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function u(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = c;
        var l = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        s(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, s) {
            var c = u(t[o], t, i);

            if ("throw" !== c.type) {
              var l = c.arg,
                  h = l.value;
              return h && "object" == f(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(h).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(c.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return l;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return l;
          }

          var n = u(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, s(b, "constructor", y), s(y, "constructor", d), d.displayName = s(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, s(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), s(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), s(b, a, "Generator"), s(b, o, function () {
          return this;
        }), s(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), l;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), l;
          }
        }, t;
      }

      function p(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function d(t, e, r) {
        return d = y() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && m(o, r.prototype), o;
        }, d.apply(null, arguments);
      }

      function y() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function m(t, e) {
        return m = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, m(t, e);
      }

      var v = {
        bounds: [0, 0, 30, 50],
        tileset: "jungle",
        audioSrc: "/pixos/audio/calm-escape.mp3",
        portals: [{
          id: "door-l",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = d(o.OW, [5, 3, 0]), n.store.pixos[a.G4].selected += 3;
          },
          zones: ["mountain"]
        }, {
          id: "door-r",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = d(o.OW, [8, 3, 0]), n.store.pixos[a.G4].selected += 7;
          },
          zones: ["field"]
        }],
        cells: function cells(t, e) {
          var r = t[0],
              o = t[1],
              i = t[2] - r,
              s = t[3] - o;
          return new Array(s).fill(null).map(function (e, s) {
            return new Array(i).fill(null).map(function (e, i) {
              var c = (r + s) * (o + i) + Math.floor(s * Math.random()) - Math.floor(i * Math.random());
              return s == o || s == t[3] - 1 || i == r || i == t[2] - 1 ? l.EDGE : c % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? l.FLOOR : c % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? l.PILLAR : l.BLOCK;
            });
          }).filter(function (t) {
            return t;
          }).flat(1);
        },
        sprites: function sprites(t, e) {
          var r,
              s = null !== (r = e.defaultSprites) && void 0 !== r ? r : [],
              c = t[0],
              u = t[1],
              l = t[2] - c,
              f = t[3] - u;
          return new Array(f).fill(null).map(function (r, f) {
            return new Array(l).fill(null).map(function (r, l) {
              var h = (c + f) * (u + l) + Math.floor(f * Math.random()) - Math.floor(l * Math.random());
              if (f == u || f == t[3] - 1 || l == c || l == t[2] - 1) for (var p = 0; p < Math.floor(227 * (h + 1) % 9); p++) {
                s.push({
                  id: "plt-" + h + p,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, 2]),
                  facing: i.N.Down
                });
              }
              if (h % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0 && (s = e.addPortal(s, l, f)), h % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0) for (var y = 0; y < Math.floor(227 * (h + 1) % 9); y++) {
                s.push({
                  id: "plt-" + h + y,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, e.getHeight(l, f)]),
                  facing: i.N.Down
                });
              }
              if (h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0) for (var m = 0; m < Math.floor(227 * (h + 1) % 9); m++) {
                s.push({
                  id: "plt-" + h + m,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, e.getHeight(l, f)]),
                  facing: i.N.Down
                });
              }
            });
          }), s;
        },
        defaultSprites: [],
        scenes: [{
          id: "welcome",
          actions: [{
            sprite: "avatar",
            action: "dialogue",
            args: [["Welcome to the Peaceful Garden.", "May your anxieties melt away and your inner spirit find balance and a sense of calm.", "Feel free to take a look around and explore."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            trigger: "custom",
            scope: void 0
          }]
        }],
        scripts: [{
          id: "load-scene",
          trigger: (g = h().mark(function t() {
            var e;
            return h().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, a.hy)(this, a.G4);

                  case 2:
                    return e = t.sent, t.next = 5, (0, a.Kn)(this, e, a.G4, r(4570));

                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), b = function b() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = g.apply(t, e);

              function i(t) {
                p(o, r, n, i, a, "next", t);
              }

              function a(t) {
                p(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function () {
            return b.apply(this, arguments);
          })
        }],
        objects: [{
          id: "test" + Math.random(),
          type: "cactus_short",
          mtl: !0,
          pos: d(o.OW, [11, 6, 0])
        }]
      };
      var g, b;
    },
    4605: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return v;
        }
      });
      var n = r(5565),
          o = r(8348),
          i = r(4180),
          a = r(1736),
          s = r(9940);

      function c(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function u(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      var l = Object.assign({}, function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(r), !0).forEach(function (e) {
            u(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }({}, s.Z));

      function f(t) {
        return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, f(t);
      }

      function h() {
        h = function h() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function c(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === l) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = u(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function u(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = c;
        var l = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        s(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, s) {
            var c = u(t[o], t, i);

            if ("throw" !== c.type) {
              var l = c.arg,
                  h = l.value;
              return h && "object" == f(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(h).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(c.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return l;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return l;
          }

          var n = u(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, s(b, "constructor", y), s(y, "constructor", d), d.displayName = s(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, s(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), s(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), s(b, a, "Generator"), s(b, o, function () {
          return this;
        }), s(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), l;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), l;
          }
        }, t;
      }

      function p(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function d(t, e, r) {
        return d = y() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && m(o, r.prototype), o;
        }, d.apply(null, arguments);
      }

      function y() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function m(t, e) {
        return m = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, m(t, e);
      }

      var v = {
        bounds: [0, 0, 30, 50],
        tileset: "mountain",
        audioSrc: "/pixos/audio/lonely-mountain.mp3",
        portals: [{
          id: "door-l",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = d(o.OW, [5, 3, 0]), n.store.pixos[a.G4].selected += 3;
          },
          zones: ["jungle"]
        }, {
          id: "door-r",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = d(o.OW, [8, 3, 0]), n.store.pixos[a.G4].selected += 7;
          },
          zones: ["ice"]
        }],
        cells: function cells(t, e) {
          var r = t[0],
              o = t[1],
              i = t[2] - r,
              s = t[3] - o;
          return new Array(s).fill(null).map(function (e, s) {
            return new Array(i).fill(null).map(function (e, i) {
              var c = (r + s) * (o + i) + Math.floor(s * Math.random()) - Math.floor(i * Math.random());
              return s == o || s == t[3] - 1 || i == r || i == t[2] - 1 ? l.EDGE : c % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? l.FLOOR : c % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? l.PILLAR : l.BLOCK;
            });
          }).filter(function (t) {
            return t;
          }).flat(1);
        },
        sprites: function sprites(t, e) {
          var r,
              s = null !== (r = e.defaultSprites) && void 0 !== r ? r : [],
              c = t[0],
              u = t[1],
              l = t[2] - c,
              f = t[3] - u;
          return new Array(f).fill(null).map(function (r, f) {
            return new Array(l).fill(null).map(function (r, l) {
              var h = (c + f) * (u + l) + Math.floor(f * Math.random()) - Math.floor(l * Math.random());
              if (f == u || f == t[3] - 1 || l == c || l == t[2] - 1) for (var p = 0; p < Math.floor(227 * (h + 1) % 9); p++) {
                s.push({
                  id: "plt-" + h + p,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, 2]),
                  facing: i.N.Down
                });
              }
              if (h % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0 && (s = e.addPortal(s, l, f)), h % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0) for (var y = 0; y < Math.floor(227 * (h + 1) % 9); y++) {
                s.push({
                  id: "plt-" + h + y,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, e.getHeight(l, f)]),
                  facing: i.N.Down
                });
              }
              if (h % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0) for (var m = 0; m < Math.floor(227 * (h + 1) % 9); m++) {
                s.push({
                  id: "plt-" + h + m,
                  type: "objects/plants/random",
                  pos: d(o.OW, [l, f, e.getHeight(l, f)]),
                  facing: i.N.Down
                });
              }
            });
          }), s;
        },
        defaultSprites: [],
        scenes: [{
          id: "welcome",
          actions: [{
            sprite: "avatar",
            action: "dialogue",
            args: [["Welcome to the Peaceful Garden.", "May your anxieties melt away and your inner spirit find balance and a sense of calm.", "Feel free to take a look around and explore."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            trigger: "custom",
            scope: void 0
          }]
        }],
        scripts: [{
          id: "load-scene",
          trigger: (g = h().mark(function t() {
            var e;
            return h().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, a.hy)(this, a.G4);

                  case 2:
                    return e = t.sent, t.next = 5, (0, a.Kn)(this, e, a.G4, r(4570));

                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), b = function b() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = g.apply(t, e);

              function i(t) {
                p(o, r, n, i, a, "next", t);
              }

              function a(t) {
                p(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function () {
            return b.apply(this, arguments);
          })
        }],
        objects: [{
          id: "test" + Math.random(),
          type: "cactus_short",
          mtl: !0,
          pos: d(o.OW, [11, 6, 0])
        }]
      };
      var g, b;
    },
    4837: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return o;
        }
      });
      var n = r(1927);
      var o = [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY].concat([n.Z.EMPTY, n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.N_WALL, n.Z.NRW_CORNER, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.NLW_CORNER, n.Z.NLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.NRW_COLUMN, n.Z.NRW_CORNER, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.L_WALL, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.R_WALL, n.Z.EMPTY], [n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.SLW_COLUMN, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.FLOOR, n.Z.SRW_COLUMN, n.Z.SRW_CORNER, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.SLW_CORNER, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.S_WALL, n.Z.SRW_CORNER, n.Z.EMPTY, n.Z.EMPTY], [n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY, n.Z.EMPTY]);
    },
    5397: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return p;
        }
      });
      var n = r(8348),
          o = r(4180),
          i = r(1736);

      function a(t) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, a(t);
      }

      function s() {
        s = function s() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, s, c) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == a(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, o, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function c(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function u(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(t) {
              c(i, n, o, a, s, "next", t);
            }

            function s(t) {
              c(i, n, o, a, s, "throw", t);
            }

            a(void 0);
          });
        };
      }

      function l(t, e, r) {
        return l = f() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && h(o, r.prototype), o;
        }, l.apply(null, arguments);
      }

      function f() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function h(t, e) {
        return h = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, h(t, e);
      }

      var p = {
        bounds: [0, 0, 17, 19],
        tileset: "sewer",
        audioSrc: "/pixos/audio/deep-unknown-beat.mp3",
        cells: r(4837).default,
        sprites: [{
          id: "chest",
          type: "objects/chests/wood",
          pos: l(n.OW, [8, 14, 0]),
          facing: o.N.Down
        }, {
          id: "chestmetal",
          type: "objects/chests/metal",
          pos: l(n.OW, [9, 13, 0]),
          facing: o.N.Right
        }, {
          id: "chestred",
          type: "objects/chests/red",
          pos: l(n.OW, [9, 14, 0]),
          facing: o.N.Down
        }, {
          id: "chestblue",
          type: "objects/chests/blue",
          pos: l(n.OW, [7, 13, 0]),
          facing: o.N.Left
        }, {
          id: "door",
          type: "furniture/door",
          pos: l(n.OW, [9, 1, 0]),
          facing: o.N.Down,
          zones: ["dungeon"]
        }, {
          id: "tree",
          type: "furniture/tree",
          fixed: !0,
          pos: l(n.OW, [8, 13, 0]),
          facing: o.N.Up
        }, {
          id: "fireplace",
          type: "furniture/fireplace",
          fixed: !0,
          pos: l(n.OW, [11, 1, 0]),
          facing: o.N.Up
        }, {
          id: "fireplace",
          type: "effects/fireplace",
          fixed: !0,
          pos: l(n.OW, [11, 1, 0]),
          facing: o.N.Up
        }, {
          id: "darkness",
          type: "npc/darkness",
          pos: l(n.OW, [6, 5, 0]),
          facing: o.N.Down
        }, {
          id: "air",
          type: "npc/air-knight",
          pos: l(n.OW, [8, 2, 0]),
          facing: o.N.Down
        }, {
          id: "fire",
          type: "npc/fire-knight",
          pos: l(n.OW, [2, 8, 0]),
          facing: o.N.Right
        }, {
          id: "earth",
          type: "npc/earth-knight",
          pos: l(n.OW, [14, 8, 0]),
          facing: o.N.Left
        }],
        scenes: [{
          id: "strange-legend",
          actions: [{
            sprite: "air",
            action: "dialogue",
            args: [["Long ago, in a dungeon far far away", "The sewer was backing up, and well...everyone was losing their $%#t", "But one had a plan..."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            sprite: "air",
            action: "dialogue",
            args: [["But what was that plan?..."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            trigger: "custom",
            scope: void 0
          }]
        }],
        scripts: [{
          id: "load-scene",
          trigger: (m = u(s().mark(function t() {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, i.hy)(this, i.G4);

                  case 2:
                    return t.next = 4, this.playScene("strange-legend");

                  case 4:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function () {
            return m.apply(this, arguments);
          })
        }, {
          id: "custom",
          trigger: (y = u(s().mark(function t() {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, this.spriteDialogue("earth", ["Lets get in there!"]);

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function () {
            return y.apply(this, arguments);
          })
        }, {
          id: "clear-path",
          trigger: (d = u(s().mark(function t() {
            return s().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, this.moveSprite("darkness", [8, 3, 0], !0);

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          })), function () {
            return d.apply(this, arguments);
          })
        }],
        objects: [{
          id: "test-obj",
          type: "person",
          mtl: !1,
          useScale: l(n.OW, [.1, .1, .1]),
          pos: l(n.OW, [10, 15, 0])
        }, {
          id: "test-bed",
          type: "bed",
          mtl: !0,
          pos: l(n.OW, [14, 10, 0])
        }, {
          id: "test-" + Math.random(),
          type: "chair",
          mtl: !0,
          pos: l(n.OW, [12, 6, 0])
        }, {
          id: "test" + Math.random(),
          type: "cactus_short",
          mtl: !0,
          pos: l(n.OW, [11, 6, 0])
        }, {
          id: "test-robot",
          type: "robot",
          mtl: !1,
          pos: l(n.OW, [7, 7, 1]),
          rotation: l(n.OW, [0, 90, 0])
        }, {
          id: "test-cube",
          type: "die",
          mtl: !0,
          pos: l(n.OW, [6, 4, 1])
        }]
      };
      var d, y, m;
    },
    7047: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return d;
        }
      });
      var n = r(5565),
          o = r(8348),
          i = r(4180),
          a = r(1736),
          s = r(1927);

      function c(t) {
        return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, c(t);
      }

      function u() {
        u = function u() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        s(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, s) {
            var u = f(t[o], t, i);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == c(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(h).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(u.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, s(b, "constructor", y), s(y, "constructor", d), d.displayName = s(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, s(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), s(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), s(b, a, "Generator"), s(b, o, function () {
          return this;
        }), s(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function l(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function f(t, e, r) {
        return f = h() ? Reflect.construct : function (t, e, r) {
          var n = [null];
          n.push.apply(n, e);
          var o = new (Function.bind.apply(t, n))();
          return r && p(o, r.prototype), o;
        }, f.apply(null, arguments);
      }

      function h() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function p(t, e) {
        return p = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, p(t, e);
      }

      var d = {
        bounds: [0, 0, 30, 50],
        tileset: "sewer",
        audioSrc: "/pixos/audio/sewer-beat.mp3",
        portals: [{
          id: "door-l",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = f(o.OW, [5, 3, 0]), n.store.pixos[a.G4].selected += 3;
          },
          zones: ["field"]
        }, {
          id: "door-r",
          type: "furniture/portal",
          facing: i.N.Down,
          onStep: function onStep() {
            n.store.pixos[a.G4].position = f(o.OW, [8, 3, 0]), n.store.pixos[a.G4].selected += 7;
          },
          zones: ["ice"]
        }],
        cells: function cells(t, e) {
          var r = t[0],
              o = t[1],
              i = t[2] - r,
              c = t[3] - o;
          return new Array(c).fill(null).map(function (e, c) {
            return new Array(i).fill(null).map(function (e, i) {
              var u = (r + c) * (o + i) + Math.floor(c * Math.random()) - Math.floor(i * Math.random());
              return c == o || c == t[3] - 1 || i == r || i == t[2] - 1 ? s.Z.PILLAR : u % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? s.Z.FLOOR : u % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 ? s.Z.EDGE : s.Z.BLOCK;
            });
          }).filter(function (t) {
            return t;
          }).flat(1);
        },
        sprites: function sprites(t, e) {
          var r,
              s = null !== (r = e.defaultSprites) && void 0 !== r ? r : [],
              c = t[0],
              u = t[1],
              l = t[2] - c,
              h = t[3] - u;
          return new Array(h).fill(null).map(function (r, h) {
            return new Array(l).fill(null).map(function (r, l) {
              var p = (c + h) * (u + l) + Math.floor(h * Math.random()) - Math.floor(l * Math.random());
              if (h == u || h == t[3] - 1 || l == c || l == t[2] - 1) for (var d = 0; d < Math.floor(227 * (p + 1) % 9); d++) {
                s.push({
                  id: "plt-" + p + d,
                  type: "objects/plants/random",
                  pos: f(o.OW, [l, h, 2]),
                  facing: i.N.Down
                });
              }
              if (p % Math.abs(3 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && p % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0 && (s = e.addPortal(s, l, h)), p % Math.abs(7 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) != 0 && p % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0) for (var y = 0; y < Math.floor(227 * (p + 1) % 9); y++) {
                s.push({
                  id: "plt-" + p + y,
                  type: "objects/plants/random",
                  pos: f(o.OW, [l, h, e.getHeight(l, h)]),
                  facing: i.N.Down
                });
              }
              if (p % Math.abs(5 + (n.store.pixos && n.store.pixos[a.G4] ? n.store.pixos[a.G4].selected : 7)) == 0) for (var m = 0; m < Math.floor(227 * (p + 1) % 9); m++) {
                s.push({
                  id: "plt-" + p + m,
                  type: "objects/plants/random",
                  pos: f(o.OW, [l, h, e.getHeight(l, h)]),
                  facing: i.N.Down
                });
              }
            });
          }), s;
        },
        defaultSprites: [],
        scenes: [{
          id: "welcome",
          actions: [{
            sprite: "avatar",
            action: "dialogue",
            args: [["Welcome to the Peaceful Garden.", "May your anxieties melt away and your inner spirit find balance and a sense of calm.", "Feel free to take a look around and explore."], !1, {
              autoclose: !0
            }],
            scope: void 0
          }, {
            trigger: "custom",
            scope: void 0
          }]
        }],
        scripts: [{
          id: "load-scene",
          trigger: (y = u().mark(function t() {
            var e;
            return u().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, (0, a.hy)(this, a.G4);

                  case 2:
                    return e = t.sent, t.next = 5, (0, a.Kn)(this, e, a.G4, r(4570));

                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }), m = function m() {
            var t = this,
                e = arguments;
            return new Promise(function (r, n) {
              var o = y.apply(t, e);

              function i(t) {
                l(o, r, n, i, a, "next", t);
              }

              function a(t) {
                l(o, r, n, i, a, "throw", t);
              }

              i(void 0);
            });
          }, function () {
            return m.apply(this, arguments);
          })
        }],
        objects: [{
          id: "test" + Math.random(),
          type: "cactus_short",
          mtl: !0,
          pos: f(o.OW, [11, 6, 0])
        }]
      };
      var y, m;
    },
    5412: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return n;
        }
      });
      var n = {
        main: {
          text: "Click Me",
          x: 100,
          y: 100,
          w: 150,
          h: 75,
          colours: {
            top: "#333",
            bottom: "#777",
            background: "#999"
          },
          children: ["sub", "nested"]
        },
        sub: {
          text: "Click Me Again",
          x: 110,
          y: 110,
          w: 150,
          h: 75,
          colours: {
            top: "#333",
            bottom: "#777",
            background: "#999"
          },
          children: ["main"]
        },
        nested: {
          text: "Click Me ONE MORE",
          x: 210,
          y: 110,
          w: 150,
          h: 75,
          colours: {
            top: "#333",
            bottom: "#777",
            background: "#999"
          },
          trigger: function trigger(t) {
            t.completed = !0;
          }
        }
      };
    },
    1785: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("player-2.gif"), e.portraitSrc = o.Z.artResourceUrl("witch_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.state = "intro", e.gender = "female", e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.bindCamera = !0, e.enableSpeech = !0, e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(6180).Z);
    },
    298: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("player.gif"), e.portraitSrc = o.Z.artResourceUrl("hero_portrait.gif"), e.sheetSize = [128, 256], e.tileSize = [24, 32], e.state = "intro", e.gender = "male", e.frames = {
            up: [[0, 0], [24, 0], [48, 0], [24, 0]],
            right: [[0, 32], [24, 32], [48, 32], [24, 32]],
            down: [[0, 64], [24, 64], [48, 64], [24, 64]],
            left: [[0, 96], [24, 96], [48, 96], [24, 96]]
          }, e.drawOffset = new n.OW(-.25, 1, .125), e.hotspotOffset = new n.OW(.5, .5, 0), e.bindCamera = !0, e.enableSpeech = !0, e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(6180).Z);
    },
    9863: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), s.call(this, t);
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(2011).Z);
    },
    5876: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(9737),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(u, t);
        var e,
            r,
            n,
            i = (r = u, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (n) {
            var o = c(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function u(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), (e = i.call(this, t)).src = o.Z.artResourceUrl("tileset.png"), e.sheetSize = [512, 512], e.tileSize = [16, 16], e.frames = {
            up: [[0, 416], [16, 416], [32, 416], [48, 416], [64, 416], [80, 416]]
          }, e;
        }

        return e = u, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(n.Z);
    },
    3771: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(9737),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(u, t);
        var e,
            r,
            n,
            i = (r = u, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (n) {
            var o = c(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function u(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), (e = i.call(this, t)).src = o.Z.artResourceUrl("tileset.png"), e.sheetSize = [512, 512], e.tileSize = [16, 16], e.frames = {
            up: [[0, 448], [16, 448], [32, 448], [48, 448], [64, 448], [80, 448]]
          }, e;
        }

        return e = u, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(n.Z);
    },
    7634: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).fixed = !0, e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(5329).Z);
    },
    1803: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), s.call(this, t);
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(1924).Z);
    },
    6823: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return m;
        }
      });
      var n = r(8348),
          o = r(6185),
          i = r(4494),
          a = r(3569);

      function s(t) {
        return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, s(t);
      }

      function c(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function u(t, e) {
        return u = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, u(t, e);
      }

      function l(t, e) {
        if (e && ("object" === s(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function f(t) {
        return f = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, f(t);
      }

      function h(t) {
        return h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, h(t);
      }

      function p(t, e) {
        return p = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, p(t, e);
      }

      function d(t, e) {
        if (e && ("object" === h(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function y(t) {
        return y = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, y(t);
      }

      var m = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && p(t, e);
        }(i, t);
        var e,
            r,
            n,
            o = (r = i, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = y(r);

          if (n) {
            var o = y(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return d(this, t);
        });

        function i(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, i), o.call(this, t);
        }

        return e = i, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && u(t, e);
        }(p, t);
        var e,
            r,
            i,
            s,
            h = (i = p, s = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = f(i);

          if (s) {
            var r = f(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return l(this, t);
        });

        function p(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, p), (e = h.call(this, t)).src = o.Z.artResourceUrl("room.png"), e.sheetSize = [256, 256], e.tileSize = [16, 32], e.frames = {
            up: [[0, 210], [18, 210], [36, 210], [54, 210]],
            left: [[0, 210], [18, 210], [36, 210], [54, 210]],
            right: [[0, 210], [18, 210], [36, 210], [54, 210]],
            down: [[0, 210], [18, 210], [36, 210], [54, 210]]
          }, e.drawOffset = new n.OW(0, 1.001, .001), e.hotspotOffset = new n.OW(.5, .5, 0), e.frameTime = 150, e.state = "closed", e;
        }

        return e = p, (r = [{
          key: "init",
          value: function value() {
            this.triggerTime = 1e3;
          }
        }, {
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.startTime = Date.now(), this.state) {
              case "closed":
                this.state = "open", this.blocking = !1, this.override = !0, this.frames = {
                  up: [[96, 210], [114, 210], [132, 210], [150, 210]],
                  right: [[96, 210], [114, 210], [132, 210], [150, 210]],
                  left: [[96, 210], [114, 210], [132, 210], [150, 210]],
                  down: [[96, 210], [114, 210], [132, 210], [150, 210]]
                }, r = new a.aW(this.engine, "dialogue", ["The portal is Open.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "open":
                this.state = "closed", this.blocking = !0, this.override = !1, r = new a.aW(this.engine, "dialogue", ["The portal is Closed.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this), this.frames = {
                  up: [[0, 210], [18, 210], [36, 210], [54, 210]],
                  left: [[0, 210], [18, 210], [36, 210], [54, 210]],
                  right: [[0, 210], [18, 210], [36, 210], [54, 210]],
                  down: [[0, 210], [18, 210], [36, 210], [54, 210]]
                };
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }, {
          key: "onStep",
          value: function value(t) {
            var e = this.zone.world;
            return e.removeAllZones(), this.zones && this.zones.forEach(function (t) {
              return e.loadZone(t);
            }), null;
          }
        }]) && c(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), p;
      }(i.Z));
    },
    4416: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), s.call(this, t);
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(2811).Z);
    },
    9986: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return g;
        }
      });
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(l, t);
        var e,
            r,
            i,
            u = (r = l, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (i) {
            var n = c(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function l(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, l), (e = u.call(this, t)).src = o.Z.artResourceUrl("elementals-2.gif"), e.sheetSize = [64, 128], e.tileSize = [16, 18], e.drawOffset = new n.OW(0, 1, .2), e.hotspotOffset = new n.OW(.5, .5, 0), e.frames = {
            up: [[0, 0], [16, 0], [32, 0], [48, 0]],
            right: [[0, 18], [16, 18], [32, 18], [16, 18]],
            down: [[0, 36], [16, 36], [32, 36], [16, 36]],
            left: [[48, 0], [48, 18], [48, 36], [48, 18]]
          }, e.bindCamera = !1, e.enableSpeech = !0, e.state = "intro", e;
        }

        return e = l, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(5870).Z),
          l = r(3569);

      function f(t) {
        return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, f(t);
      }

      function h() {
        h = function h() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            o = n.iterator || "@@iterator",
            i = n.asyncIterator || "@@asyncIterator",
            a = n.toStringTag || "@@toStringTag";

        function s(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, r) {
            return t[e] = r;
          };
        }

        function c(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === l) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = u(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function u(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = c;
        var l = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        s(m, o, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, o) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(o, i, a, s) {
            var c = u(t[o], t, i);

            if ("throw" !== c.type) {
              var l = c.arg,
                  h = l.value;
              return h && "object" == f(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, a, s);
              }, function (t) {
                n("throw", t, a, s);
              }) : e.resolve(h).then(function (t) {
                l.value = t, a(l);
              }, function (t) {
                return n("throw", t, a, s);
              });
            }

            s(c.arg);
          }

          var o;

          this._invoke = function (t, r) {
            function i() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return o = o ? o.then(i, i) : i();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return l;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return l;
          }

          var n = u(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  i = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, s(b, "constructor", y), s(y, "constructor", d), d.displayName = s(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, s(t, a, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), s(O.prototype, i, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), s(b, a, "Generator"), s(b, o, function () {
          return this;
        }), s(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), l;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), l;
          }
        }, t;
      }

      function p(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function d(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function y(t, e) {
        return y = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, y(t, e);
      }

      function m(t, e) {
        if (e && ("object" === f(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function v(t) {
        return v = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, v(t);
      }

      var g = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && y(t, e);
        }(c, t);
        var e,
            r,
            n,
            o,
            i,
            a,
            s = (i = c, a = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = v(i);

          if (a) {
            var r = v(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return m(this, t);
        });

        function c(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), s.call(this, t);
        }

        return e = c, r = [{
          key: "interact",
          value: (n = h().mark(function t(e, r) {
            return h().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.prev = 0, t.next = 3, this.zone.moveSprite(this.id, [10, 11, this.zone.getHeight(10, 11)], !1);

                  case 3:
                    r && r(!0), t.next = 9;
                    break;

                  case 6:
                    t.prev = 6, t.t0 = t.catch(0), console.log("error", t.t0);

                  case 9:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this, [[0, 6]]);
          }), o = function o() {
            var t = this,
                e = arguments;
            return new Promise(function (r, o) {
              var i = n.apply(t, e);

              function a(t) {
                p(i, r, o, a, s, "next", t);
              }

              function s(t) {
                p(i, r, o, a, s, "throw", t);
              }

              a(void 0);
            });
          }, function (t, e) {
            return o.apply(this, arguments);
          })
        }, {
          key: "init",
          value: function value() {
            var t = new l.aW(this.engine, "patrol", [this.pos.toArray(), [7, 7, this.zone.getHeight(7, 7)], 200, this.zone], this, function (t) {
              console.log("sssss", t);
            });
            console.log("----\x3eHERE", t), this.addAction(t);
          }
        }], r && d(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), c;
      }(u);
    },
    7588: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return h;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i() {
        i = function i() {
          return t;
        };

        var t = {},
            e = Object.prototype,
            r = e.hasOwnProperty,
            n = "function" == typeof Symbol ? Symbol : {},
            a = n.iterator || "@@iterator",
            s = n.asyncIterator || "@@asyncIterator",
            c = n.toStringTag || "@@toStringTag";

        function u(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }

        try {
          u({}, "");
        } catch (t) {
          u = function u(t, e, r) {
            return t[e] = r;
          };
        }

        function l(t, e, r, n) {
          var o = e && e.prototype instanceof p ? e : p,
              i = Object.create(o.prototype),
              a = new E(n || []);
          return i._invoke = function (t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n) throw new Error("Generator is already running");

              if ("completed" === n) {
                if ("throw" === o) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (r.method = o, r.arg = i;;) {
                var a = r.delegate;

                if (a) {
                  var s = _(a, r);

                  if (s) {
                    if (s === h) continue;
                    return s;
                  }
                }

                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw n = "completed", r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var c = f(t, e, r);

                if ("normal" === c.type) {
                  if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
                  return {
                    value: c.arg,
                    done: r.done
                  };
                }

                "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
              }
            };
          }(t, r, a), i;
        }

        function f(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        t.wrap = l;
        var h = {};

        function p() {}

        function d() {}

        function y() {}

        var m = {};
        u(m, a, function () {
          return this;
        });
        var v = Object.getPrototypeOf,
            g = v && v(v(A([])));
        g && g !== e && r.call(g, a) && (m = g);
        var b = y.prototype = p.prototype = Object.create(m);

        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }

        function O(t, e) {
          function n(i, a, s, c) {
            var u = f(t[i], t, a);

            if ("throw" !== u.type) {
              var l = u.arg,
                  h = l.value;
              return h && "object" == o(h) && r.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                n("next", t, s, c);
              }, function (t) {
                n("throw", t, s, c);
              }) : e.resolve(h).then(function (t) {
                l.value = t, s(l);
              }, function (t) {
                return n("throw", t, s, c);
              });
            }

            c(u.arg);
          }

          var i;

          this._invoke = function (t, r) {
            function o() {
              return new e(function (e, o) {
                n(t, r, e, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          };
        }

        function _(t, e) {
          var r = t.iterator[e.method];

          if (void 0 === r) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return h;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return h;
          }

          var n = f(r, t.iterator, e.arg);
          if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, h;
          var o = n.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
        }

        function x(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function L(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function E(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(x, this), this.reset(!0);
        }

        function A(t) {
          if (t) {
            var e = t[a];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var n = -1,
                  o = function e() {
                for (; ++n < t.length;) {
                  if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                }

                return e.value = void 0, e.done = !0, e;
              };

              return o.next = o;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return d.prototype = y, u(b, "constructor", y), u(y, "constructor", d), d.displayName = u(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, u(t, c, "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, w(O.prototype), u(O.prototype, s, function () {
          return this;
        }), t.AsyncIterator = O, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new O(l(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, w(b), u(b, c, "Generator"), u(b, a, function () {
          return this;
        }), u(b, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, t.values = A, E.prototype = {
          constructor: E,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function n(r, n) {
              return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  a = i.completion;
              if ("root" === i.tryLoc) return n("end");

              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                    c = r.call(i, "finallyLoc");

                if (s && c) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];

              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), h;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  L(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: A(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), h;
          }
        }, t;
      }

      function a(t, e, r, n, o, i, a) {
        try {
          var s = t[i](a),
              c = s.value;
        } catch (t) {
          return void r(t);
        }

        s.done ? e(c) : Promise.resolve(c).then(n, o);
      }

      function s(t) {
        return function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function s(t) {
              a(i, n, o, s, c, "next", t);
            }

            function c(t) {
              a(i, n, o, s, c, "throw", t);
            }

            s(void 0);
          });
        };
      }

      function c(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function u(t, e) {
        return u = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, u(t, e);
      }

      function l(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function f(t) {
        return f = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, f(t);
      }

      var h = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && u(t, e);
        }(p, t);
        var e,
            r,
            o,
            a,
            h = (o = p, a = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = f(o);

          if (a) {
            var r = f(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return l(this, t);
        });

        function p(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, p), h.call(this, t);
        }

        return e = p, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Buying eh?!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this, s(i().mark(function t() {
                  var e, r, n, o;
                  return i().wrap(function (t) {
                    for (;;) {
                      switch (t.prev = t.next) {
                        case 0:
                          return t.next = 2, window.ethereum.request({
                            method: "eth_requestAccounts"
                          });

                        case 2:
                          e = t.sent[0], r = JSON.stringify({
                            domain: {
                              chainId: 1,
                              name: "Pixos",
                              verifyingContract: "0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC",
                              version: "1"
                            },
                            message: {
                              game: "Example",
                              contents: "Quest Item",
                              from: {
                                sprite: "air-knight",
                                wallet: "0xCD2a3d9F938E13CD947Ec05AbC7FE734Df8DD826"
                              },
                              to: {
                                sprite: "avatar",
                                wallet: e
                              }
                            },
                            primaryType: "Item",
                            types: {
                              EIP712Domain: [{
                                name: "name",
                                type: "string"
                              }, {
                                name: "version",
                                type: "string"
                              }, {
                                name: "chainId",
                                type: "uint256"
                              }, {
                                name: "verifyingContract",
                                type: "address"
                              }],
                              Item: [{
                                name: "game",
                                type: "string"
                              }, {
                                name: "contents",
                                type: "string"
                              }, {
                                name: "from",
                                type: "Person"
                              }, {
                                name: "to",
                                type: "Person"
                              }],
                              Person: [{
                                name: "sprite",
                                type: "string"
                              }, {
                                name: "wallet",
                                type: "address"
                              }]
                            }
                          }), o = [n = e, r], window.web3.currentProvider.sendAsync({
                            method: "eth_signTypedData_v4",
                            params: o,
                            from: n
                          }, function (t, e) {
                            if (t) return console.dir(t);
                            if (e.error && alert(e.error.message), e.error) return console.error("ERROR", e);
                            var o = window.sigUtil.recoverTypedSignature_v4({
                              data: JSON.parse(r),
                              sig: e.result
                            });
                            window.ethUtil.toChecksumAddress(o) === window.ethUtil.toChecksumAddress(n) ? alert("Successfully recovered signer as " + n) : alert("Failed to verify signer when comparing " + e + " to " + n);
                          });

                        case 8:
                        case "end":
                          return t.stop();
                      }
                    }
                  }, t);
                })));
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && c(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), p;
      }(r(9875).Z);
    },
    5349: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), l.call(this, t);
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Join me....!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I need a partner for squash.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Seriously - you swing?", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(2304).Z);
    },
    5798: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), l.call(this, t);
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Welcome!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(512).Z);
    },
    7884: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), l.call(this, t);
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Welcome!", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(6529).Z);
    },
    4806: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return u;
        }
      });
      var n = r(3569);

      function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, o(t);
      }

      function i(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var u = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(f, t);
        var e,
            r,
            o,
            u,
            l = (o = f, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(o);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function f(t) {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), l.call(this, t);
        }

        return e = f, (r = [{
          key: "interact",
          value: function value(t, e) {
            var r = null;

            switch (this.state) {
              case "intro":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", [["I am the Water Knight!", "Here is my home.", "yo"], !1, {
                  autoclose: !1,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop":
                this.state = "loop2", r = new n.aW(this.engine, "dialogue", ["I heard about a strange legend once.", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
                break;

              case "loop2":
                this.state = "loop", r = new n.aW(this.engine, "dialogue", ["Sorry, I don't remember the story at the moment", !1, {
                  autoclose: !0,
                  onClose: function onClose() {
                    return e(!0);
                  }
                }], this);
            }

            return r && this.addAction(r), e && e(!1), r;
          }
        }]) && i(e.prototype, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r(7967).Z);
    },
    7477: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      }), r(3569);

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).enableSpeech = !1, e.inventory = [], e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(9096).Z);
    },
    1285: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      }), r(3569);

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).enableSpeech = !1, e.inventory = [], e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(9391).Z);
    },
    1642: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      }), r(3569);

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).enableSpeech = !1, e.inventory = [], e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(8790).Z);
    },
    5016: function _(t, e, r) {
      "use strict";

      function n(t) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, n(t);
      }

      function o(t, e) {
        return o = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, o(t, e);
      }

      function i(t, e) {
        if (e && ("object" === n(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function a(t) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, a(t);
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      }), r(3569);

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && o(t, e);
        }(c, t);
        var e,
            r,
            n,
            s = (r = c, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = a(r);

          if (n) {
            var o = a(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = s.call(this, t)).enableSpeech = !1, e.inventory = [{
            id: "sword",
            type: "object"
          }], e;
        }

        return e = c, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(1060).Z);
    },
    3081: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return v;
        }
      }), r(3569);
      var n = r(8348),
          o = r(6185);

      function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, i(t);
      }

      function a(t, e) {
        return a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, a(t, e);
      }

      function s(t, e) {
        if (e && ("object" === i(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      function u(t) {
        return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, u(t);
      }

      function l(t, e) {
        return l = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, l(t, e);
      }

      function f(t, e) {
        if (e && ("object" === u(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function h(t) {
        return h = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, h(t);
      }

      function p(t) {
        return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, p(t);
      }

      function d(t, e) {
        return d = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, d(t, e);
      }

      function y(t, e) {
        if (e && ("object" === p(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function m(t) {
        return m = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, m(t);
      }

      var v = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && d(t, e);
        }(i, t);
        var e,
            r,
            n,
            o = (r = i, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = m(r);

          if (n) {
            var o = m(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return y(this, t);
        });

        function i(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (e = o.call(this, t)).enableSpeech = !1, e.inventory = [], e;
        }

        return e = i, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && l(t, e);
        }(s, t);
        var e,
            r,
            i,
            a = (r = s, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = h(r);

          if (i) {
            var n = h(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return f(this, t);
        });

        function s(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, s), (e = a.call(this, t)).src = o.Z.artResourceUrl("plants.png"), e.sheetSize = [1024, 32], e.tileSize = [12, 24], e.selectedPlant = [Math.floor(30 * Math.random() % 30 * 12), 0], e.drawOffset = new n.OW(.25 * Math.random(), .5 + .1 * Math.random(), -.2), e.hotspotOffset = new n.OW(0, 0, 0), e.frames = {
            down: [e.selectedPlant],
            right: [e.selectedPlant],
            up: [e.selectedPlant],
            left: [e.selectedPlant]
          }, e.bindCamera = !1, e.enableSpeech = !1, e;
        }

        return e = s, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && a(t, e);
        }(i, t);
        var e,
            r,
            n,
            o = (r = i, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(r);

          if (n) {
            var o = c(this).constructor;
            t = Reflect.construct(e, arguments, o);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function i(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (e = o.call(this, t)).bindCamera = !1, e.enableSpeech = !0, e.state = "closed", e.blocking = !1, e.fixed = !0, e;
        }

        return e = i, Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(r(5870).Z)));
    },
    9940: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return n;
        }
      });
      var n = {
        FLOOR: ["FLAT_ALL", "FLOOR", 0],
        WATER: ["FLAT_NONE", "WATER", -1.5],
        EMPTY: ["FLAT_ALL", "EMPTY", 2],
        N_STAIR: ["FLAT_ALL", "FLOOR_V", -1, "WALL_R", "WATER_WALL", -1, "WALL_L", "WATER_WALL", -1, "STAIR_T", "STAIR", -1],
        N_STAIRWALL: ["FLAT_ALL", "FLOOR_B", 0, "WALL_T", "WALL_WATER", 0, 15],
        S_STAIR: ["FLAT_ALL", "FLOOR_V", -1, "WALL_R", "WATER_WALL", -1, "WALL_L", "WATER_WALL", -1, "STAIR_B", "STAIR", -1],
        S_STAIRWALL: ["FLAT_ALL", "FLOOR_T", 0, "WALL_B", "WALL", 0, 15],
        L_STAIR: ["FLAT_ALL", "FLOOR_H", -1, "WALL_T", "WATER_WALL", -1, "WALL_B", "WATER_WALL", -1, "STAIR_L", "STAIR", -1],
        L_STAIRWALL: ["FLAT_ALL", "FLOOR_R", 0, "WALL_L", "WALL_WATER", 0, 15],
        R_STAIR: ["FLAT_ALL", "FLOOR_H", -1, "WALL_T", "WATER_WALL", -1, "WALL_B", "WATER_WALL", -1, "STAIR_R", "STAIR", -1],
        R_STAIRWALL: ["FLAT_ALL", "FLOOR_L", 0, "WALL_R", "WALL_WATER", 0, 15],
        N_WALL: ["WALL_T", "WALL", 2, "FLAT_ALL", "EMPTY_B", 2],
        S_WALL: ["WALL_B", "WALL", 2, "FLAT_ALL", "EMPTY_T", 2],
        L_WALL: ["WALL_L", "WALL", 2, "FLAT_ALL", "EMPTY_R", 2],
        R_WALL: ["WALL_R", "WALL", 2, "FLAT_ALL", "EMPTY_L", 2],
        EDGE: ["WALL_R", "WALL", 2, "WALL_B", "WALL", 2, "WALL_L", "WALL", 2, "WALL_T", "WALL", 2, "FLAT_ALL", "FLOOR", 2],
        PILLAR: ["WALL_R", "WALL", 2, "WALL_B", "WALL", 2, "WALL_L", "WALL", 2, "WALL_T", "WALL", 2, "FLAT_ALL", "EMPTY", 2],
        BLOCK: ["WALL_R", "WALL", 1, "WALL_B", "WALL", 1, "WALL_L", "WALL", 1, "WALL_T", "WALL", 1, "FLAT_ALL", "EMPTY", 1],
        NLW_CORNER: ["FLAT_ALL", "EMPTY_CTL", 2],
        NRW_CORNER: ["FLAT_ALL", "EMPTY_CTR", 2],
        SLW_CORNER: ["FLAT_ALL", "EMPTY_CBL", 2],
        SRW_CORNER: ["FLAT_ALL", "EMPTY_CBR", 2],
        NLW_COLUMN: ["WALL_T", "WALL", 2, "WALL_L", "WALL", 2, "FLAT_NONE", "EMPTY_BR", 2],
        NRW_COLUMN: ["WALL_R", "WALL", 2, "WALL_T", "WALL", 2, "FLAT_NONE", "EMPTY_BL", 2],
        SLW_COLUMN: ["WALL_L", "WALL", 2, "WALL_B", "WALL", 2, "FLAT_NONE", "EMPTY_TR", 2],
        SRW_COLUMN: ["WALL_R", "WALL", 2, "WALL_B", "WALL", 2, "FLAT_NONE", "EMPTY_TL", 2],
        NRW_WATER_COLUMN: ["WALL_R", "WALL", 2, "WALL_R", "WALL_WATER", 0, "WALL_T", "WALL", 2, "WALL_T", "WALL_WATER", 0, "FLAT_ALL", "EMPTY_BL", 2],
        NLW_WATER_COLUMN: ["WALL_T", "WALL", 2, "WALL_L", "WALL", 2, "FLAT_ALL", "EMPTY_BR", 2, "WALL_L", "WALL_WATER", 0, "WALL_T", "WALL_WATER", 0],
        SLW_WATER_COLUMN: ["WALL_L", "WALL", 2, "WALL_B", "WALL", 2, "FLAT_ALL", "EMPTY_TR", 2, "WALL_L", "WALL_WATER", 0, "WALL_B", "WALL_WATER", 0],
        SRW_WATER_COLUMN: ["WALL_R", "WALL", 2, "WALL_R", "WALL_WATER", 0, "WALL_B", "WALL", 2, "WALL_B", "WALL_WATER", 0, "FLAT_ALL", "EMPTY_TL", 2],
        NW_NPIT: ["FLAT_ALL", "FLOOR_B", 0, "WALL_T", "WALL_WATER", 0],
        LW_LPIT: ["FLAT_ALL", "FLOOR_R", 0, "WALL_L", "WALL_WATER", 0],
        RW_RPIT: ["FLAT_ALL", "FLOOR_L", 0, "WALL_R", "WALL_WATER", 0],
        SW_SPIT: ["FLAT_ALL", "FLOOR_T", 0, "WALL_B", "WALL_WATER", 0],
        C_WALKWAY: ["FLAT_ALL", "FLOOR_C", -1],
        V_WALKWAY: ["FLAT_ALL", "FLOOR_V", -1, "WALL_R", "WATER_WALL", -1, "WALL_L", "WATER_WALL", -1],
        H_WALKWAY: ["FLAT_ALL", "FLOOR_H", -1, "WALL_T", "WATER_WALL", -1, "WALL_B", "WATER_WALL", -1]
      };
    },
    8046: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return i;
        }
      });
      var n = r(6185);

      var o = {
        FLAT_ALL: {
          vertices: [[[0, 1, 0], [1, 1, 0], [1, 0, 0]], [[0, 1, 0], [1, 0, 0], [0, 0, 0]]],
          surfaces: [[[0, 1], [1, 1], [1, 0]], [[0, 1], [1, 0], [0, 0]]],
          type: parseInt("1111", 2)
        },
        FLAT_NONE: {
          vertices: [[[0, 1, 0], [1, 1, 0], [1, 0, 0]], [[0, 1, 0], [1, 0, 0], [0, 0, 0]]],
          surfaces: [[[0, 1], [1, 1], [1, 0]], [[0, 1], [1, 0], [0, 0]]],
          type: parseInt("0000", 2)
        },
        STAIR_R: {
          vertices: [[[.25, 0, .25], [.25, 1, .25], [.5, 1, .25]], [[.25, 0, .25], [.5, 1, .25], [.5, 0, .25]], [[.5, 0, .5], [.5, 1, .5], [.75, 1, .5]], [[.5, 0, .5], [.75, 1, .5], [.75, 0, .5]], [[.75, 0, .75], [.75, 1, .75], [1, 1, .75]], [[.75, 0, .75], [1, 1, .75], [1, 0, .75]], [[.25, 0, 0], [.25, 1, 0], [.25, 1, .25]], [[.25, 0, 0], [.25, 1, .25], [.25, 0, .25]], [[.5, 0, .25], [.5, 1, .25], [.5, 1, .5]], [[.5, 0, .25], [.5, 1, .5], [.5, 0, .5]], [[.75, 0, .5], [.75, 1, .5], [.75, 1, .75]], [[.75, 0, .5], [.75, 1, .75], [.75, 0, .75]], [[1, 0, .75], [1, 1, .75], [1, 1, 1]], [[1, 0, .75], [1, 1, 1], [1, 0, 1]], [[0, 0, 0], [1, 0, 0], [1, 0, 1]], [[0, 0, 0], [1, 0, 1], [0, 0, 1]], [[0, 1, 0], [1, 1, 0], [1, 1, 1]], [[0, 1, 0], [1, 1, 1], [0, 1, 1]]],
          surfaces: [[[0, .75], [1, .75], [1, .5]], [[0, .75], [1, .5], [0, .5]], [[0, .5], [1, .5], [1, .25]], [[0, .5], [1, .25], [0, .25]], [[0, .25], [1, .25], [1, 0]], [[0, .25], [1, 0], [0, 0]], [[0, 2], [1, 2], [1, 1.75]], [[0, 2], [1, 1.75], [0, 1.75]], [[0, 1.75], [1, 1.75], [1, 1.5]], [[0, 1.75], [1, 1.5], [0, 1.5]], [[0, 1.5], [1, 1.5], [1, 1.25]], [[0, 1.5], [1, 1.25], [0, 1.25]], [[0, 1.25], [1, 1.25], [1, 1]], [[0, 1.25], [1, 1], [0, 1]], [[-1, 2], [0, 2], [0, 1]], [[-1, 2], [0, 1], [-1, 1]], [[-1, 2], [0, 2], [0, 1]], [[-1, 2], [0, 1], [-1, 1]]],
          walkPoly: [[[0, 1, 0], [1, 1, 1], [1, 0, 1]], [[0, 1, 0], [1, 0, 1], [0, 0, 0]]],
          type: parseInt("0101", 2)
        },
        STAIR_T: {
          vertices: [[[0, .75, .25], [1, .75, .25], [1, .5, .25]], [[0, .75, .25], [1, .5, .25], [0, .5, .25]], [[0, .5, .5], [1, .5, .5], [1, .25, .5]], [[0, .5, .5], [1, .25, .5], [0, .25, .5]], [[0, .25, .75], [1, .25, .75], [1, 0, .75]], [[0, .25, .75], [1, 0, .75], [0, 0, .75]], [[0, .75, 0], [1, .75, 0], [1, .75, .25]], [[0, .75, 0], [1, .75, .25], [0, .75, .25]], [[0, .5, .25], [1, .5, .25], [1, .5, .5]], [[0, .5, .25], [1, .5, .5], [0, .5, .5]], [[0, .25, .5], [1, .25, .5], [1, .25, .75]], [[0, .25, .5], [1, .25, .75], [0, .25, .75]], [[0, 0, .75], [1, 0, .75], [1, 0, 1]], [[0, 0, .75], [1, 0, 1], [0, 0, 1]], [[0, 1, 0], [0, 0, 0], [0, 0, 1]], [[0, 1, 0], [0, 0, 1], [0, 1, 1]], [[1, 1, 0], [1, 0, 0], [1, 0, 1]], [[1, 1, 0], [1, 0, 1], [1, 1, 1]]],
          surfaces: [[[0, .75], [1, .75], [1, .5]], [[0, .75], [1, .5], [0, .5]], [[0, .5], [1, .5], [1, .25]], [[0, .5], [1, .25], [0, .25]], [[0, .25], [1, .25], [1, 0]], [[0, .25], [1, 0], [0, 0]], [[0, 2], [1, 2], [1, 1.75]], [[0, 2], [1, 1.75], [0, 1.75]], [[0, 1.75], [1, 1.75], [1, 1.5]], [[0, 1.75], [1, 1.5], [0, 1.5]], [[0, 1.5], [1, 1.5], [1, 1.25]], [[0, 1.5], [1, 1.25], [0, 1.25]], [[0, 1.25], [1, 1.25], [1, 1]], [[0, 1.25], [1, 1], [0, 1]], [[-1, 2], [0, 2], [0, 1]], [[-1, 2], [0, 1], [-1, 1]], [[-1, 2], [0, 2], [0, 1]], [[-1, 2], [0, 1], [-1, 1]]],
          walkPoly: [[[0, 1, 0], [1, 1, 0], [1, 0, 1]], [[0, 1, 0], [1, 0, 1], [0, 0, 1]]],
          type: parseInt("1010", 2)
        },
        STAIR_L: {
          vertices: [[[.75, 1, .25], [.75, 0, .25], [.5, 0, .25]], [[.75, 1, .25], [.5, 0, .25], [.5, 1, .25]], [[.5, 1, .5], [.5, 0, .5], [.25, 0, .5]], [[.5, 1, .5], [.25, 0, .5], [.25, 1, .5]], [[.25, 1, .75], [.25, 0, .75], [0, 0, .75]], [[.25, 1, .75], [0, 0, .75], [0, 1, .75]], [[.75, 1, 0], [.75, 0, 0], [.75, 0, .25]], [[.75, 1, 0], [.75, 0, .25], [.75, 1, .25]], [[.5, 1, .25], [.5, 0, .25], [.5, 0, .5]], [[.5, 1, .25], [.5, 0, .5], [.5, 1, .5]], [[.25, 1, .5], [.25, 0, .5], [.25, 0, .75]], [[.25, 1, .5], [.25, 0, .75], [.25, 1, .75]], [[0, 1, .75], [0, 0, .75], [0, 0, 1]], [[0, 1, .75], [0, 0, 1], [0, 1, 1]], [[1, 1, 0], [0, 1, 0], [0, 1, 1]], [[1, 1, 0], [0, 1, 1], [1, 1, 1]], [[1, 0, 0], [0, 0, 0], [0, 0, 1]], [[1, 0, 0], [0, 0, 1], [1, 0, 1]]],
          surfaces: [[[0, .75], [1, .75], [1, .5]], [[0, .75], [1, .5], [0, .5]], [[0, .5], [1, .5], [1, .25]], [[0, .5], [1, .25], [0, .25]], [[0, .25], [1, .25], [1, 0]], [[0, .25], [1, 0], [0, 0]], [[0, 2], [1, 2], [1, 1.75]], [[0, 2], [1, 1.75], [0, 1.75]], [[0, 1.75], [1, 1.75], [1, 1.5]], [[0, 1.75], [1, 1.5], [0, 1.5]], [[0, 1.5], [1, 1.5], [1, 1.25]], [[0, 1.5], [1, 1.25], [0, 1.25]], [[0, 1.25], [1, 1.25], [1, 1]], [[0, 1.25], [1, 1], [0, 1]], [[-1, 2], [0, 2], [0, 1]], [[-1, 2], [0, 1], [-1, 1]], [[-1, 2], [0, 2], [0, 1]], [[-1, 2], [0, 1], [-1, 1]]],
          walkPoly: [[[0, 1, 1], [1, 1, 0], [1, 0, 0]], [[0, 1, 1], [1, 0, 0], [0, 0, 1]]],
          type: parseInt("0101", 2)
        },
        STAIR_B: {
          vertices: [[[1, .25, .25], [0, .25, .25], [0, .5, .25]], [[1, .25, .25], [0, .5, .25], [1, .5, .25]], [[1, .5, .5], [0, .5, .5], [0, .75, .5]], [[1, .5, .5], [0, .75, .5], [1, .75, .5]], [[1, .75, .75], [0, .75, .75], [0, 1, .75]], [[1, .75, .75], [0, 1, .75], [1, 1, .75]], [[1, .25, 0], [0, .25, 0], [0, .25, .25]], [[1, .25, 0], [0, .25, .25], [1, .25, .25]], [[1, .5, .25], [0, .5, .25], [0, .5, .5]], [[1, .5, .25], [0, .5, .5], [1, .5, .5]], [[1, .75, .5], [0, .75, .5], [0, .75, .75]], [[1, .75, .5], [0, .75, .75], [1, .75, .75]], [[1, 1, .75], [0, 1, .75], [0, 1, 1]], [[1, 1, .75], [0, 1, 1], [1, 1, 1]], [[1, 0, 0], [1, 1, 0], [1, 1, 1]], [[1, 0, 0], [1, 1, 1], [1, 0, 1]], [[0, 0, 0], [0, 1, 0], [0, 1, 1]], [[0, 0, 0], [0, 1, 1], [0, 0, 1]]],
          surfaces: [[[0, .75], [1, .75], [1, .5]], [[0, .75], [1, .5], [0, .5]], [[0, .5], [1, .5], [1, .25]], [[0, .5], [1, .25], [0, .25]], [[0, .25], [1, .25], [1, 0]], [[0, .25], [1, 0], [0, 0]], [[0, 2], [1, 2], [1, 1.75]], [[0, 2], [1, 1.75], [0, 1.75]], [[0, 1.75], [1, 1.75], [1, 1.5]], [[0, 1.75], [1, 1.5], [0, 1.5]], [[0, 1.5], [1, 1.5], [1, 1.25]], [[0, 1.5], [1, 1.25], [0, 1.25]], [[0, 1.25], [1, 1.25], [1, 1]], [[0, 1.25], [1, 1], [0, 1]], [[-1, 2], [0, 2], [0, 1]], [[-1, 2], [0, 1], [-1, 1]], [[-1, 2], [0, 2], [0, 1]], [[-1, 2], [0, 1], [-1, 1]]],
          walkPoly: [[[0, 1, 1], [1, 1, 1], [1, 0, 0]], [[0, 1, 1], [1, 0, 0], [0, 0, 0]]],
          type: parseInt("1010", 2)
        },
        WALL_R: {
          vertices: [[[0, 0, -2], [0, 1, -2], [0, 1, 0]], [[0, 0, -2], [0, 1, 0], [0, 0, 0]]],
          surfaces: [[[0, 2], [1, 2], [1, 0]], [[0, 2], [1, 0], [0, 0]]],
          type: parseInt("1011", 2)
        },
        WALL_T: {
          vertices: [[[0, 1, -2], [1, 1, -2], [1, 1, 0]], [[0, 1, -2], [1, 1, 0], [0, 1, 0]]],
          surfaces: [[[0, 2], [1, 2], [1, 0]], [[0, 2], [1, 0], [0, 0]]],
          type: parseInt("0111", 2)
        },
        WALL_L: {
          vertices: [[[1, 1, -2], [1, 0, -2], [1, 0, 0]], [[1, 1, -2], [1, 0, 0], [1, 1, 0]]],
          surfaces: [[[0, 2], [1, 2], [1, 0]], [[0, 2], [1, 0], [0, 0]]],
          type: parseInt("1110", 2)
        },
        WALL_B: {
          vertices: [[[1, 0, -2], [0, 0, -2], [0, 0, 0]], [[1, 0, -2], [0, 0, 0], [1, 0, 0]]],
          surfaces: [[[0, 2], [1, 2], [1, 0]], [[0, 2], [1, 0], [0, 0]]],
          type: parseInt("1101", 2)
        }
      },
          i = function i(t, e) {
        return {
          name: "default",
          src: n.Z.artResourceUrl("tileset.png"),
          sheetSize: [512, 512],
          sheetOffsetX: t,
          sheetOffsetY: e,
          tileSize: 16,
          bgColor: [32, 62, 88],
          textures: {
            FLOOR: [1 + t, 1],
            FLOOR_BR: [2 + t, 2],
            FLOOR_R: [2 + t, 1],
            FLOOR_TR: [2 + t, 0],
            FLOOR_T: [1 + t, 0],
            FLOOR_TL: [0 + t, 0],
            FLOOR_L: [0 + t, 1],
            FLOOR_BL: [0 + t, 2],
            FLOOR_B: [1 + t, 2],
            FLOOR_CBR: [1 + t, 1],
            FLOOR_CTR: [1 + t, 1],
            FLOOR_CTL: [1 + t, 1],
            FLOOR_CBL: [1 + t, 1],
            FLOOR_V: [0 + t, 3],
            FLOOR_H: [1 + t, 3],
            FLOOR_C: [0 + t, 4],
            STAIR: [2 + t, 3],
            WALL: [1 + t, 5],
            WATER: [0, 23 + e],
            WALL_WATER: [1 + t, 5 + 2 * e],
            WATER_WALL: [1 + t, 5 + 2 * e],
            EMPTY: [2 + t, 5],
            EMPTY_BR: [2 + t, 2],
            EMPTY_R: [2 + t, 1],
            EMPTY_TR: [2 + t, 0],
            EMPTY_T: [1 + t, 0],
            EMPTY_TL: [0 + t, 0],
            EMPTY_L: [0 + t, 1],
            EMPTY_BL: [0 + t, 2],
            EMPTY_B: [1 + t, 2],
            EMPTY_CBR: [1 + t, 1],
            EMPTY_CTR: [1 + t, 1],
            EMPTY_CTL: [1 + t, 1],
            EMPTY_CBL: [1 + t, 1]
          },
          geometry: {
            FLAT_ALL: o.FLAT_ALL,
            FLAT_NONE: o.FLAT_NONE,
            STAIR_R: o.STAIR_R,
            STAIR_T: o.STAIR_T,
            STAIR_L: o.STAIR_L,
            STAIR_B: o.STAIR_B,
            WALL_R: o.WALL_R,
            WALL_T: o.WALL_T,
            WALL_L: o.WALL_L,
            WALL_B: o.WALL_B
          }
        };
      };
    },
    6382: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function o(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? n(Object(r), !0).forEach(function (e) {
            i(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function i(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });
      var a = (0, r(8046).default)(6, 0);
      var s = o(o({}, a), {}, {
        name: "field",
        bgColor: [32, 88, 62],
        textures: o({}, a.textures),
        geometry: o({}, a.geometry)
      });
    },
    6841: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function o(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? n(Object(r), !0).forEach(function (e) {
            i(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function i(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });
      var a = (0, r(8046).default)(12, 4);
      var s = o(o({}, a), {}, {
        name: "ice",
        bgColor: [32, 62, 88],
        textures: o({}, a.textures),
        geometry: o({}, a.geometry)
      });
    },
    826: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function o(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? n(Object(r), !0).forEach(function (e) {
            i(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function i(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });
      var a = (0, r(8046).default)(9, 0);
      var s = o(o({}, a), {}, {
        name: "jungle",
        bgColor: [32, 88, 62],
        textures: o({}, a.textures),
        geometry: o({}, a.geometry)
      });
    },
    9663: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function o(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? n(Object(r), !0).forEach(function (e) {
            i(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function i(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });
      var a = (0, r(8046).default)(15, 0);
      var s = o(o({}, a), {}, {
        name: "jungle",
        bgColor: [32, 88, 62],
        textures: o({}, a.textures),
        geometry: o({}, a.geometry)
      });
    },
    1927: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return a;
        }
      });
      var n = r(9940);

      function o(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function i(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      var a = Object.assign({}, function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? o(Object(r), !0).forEach(function (e) {
            i(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }({}, n.Z));
    },
    2155: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function o(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? n(Object(r), !0).forEach(function (e) {
            i(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function i(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });
      var a = (0, r(8046).default)(0, 0);
      var s = o(o({}, a), {}, {
        name: "sewer",
        bgColor: [0, 0, 0],
        textures: o({}, a.textures),
        geometry: o({}, a.geometry)
      });
    },
    6321: function _(t, e, r) {
      "use strict";

      function n(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function o(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? n(Object(r), !0).forEach(function (e) {
            i(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function i(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      r.r(e), r.d(e, {
        default: function _default() {
          return s;
        }
      });
      var a = (0, r(8046).default)(3, 3);
      var s = o(o({}, a), {}, {
        name: "void",
        bgColor: [0, 0, 0],
        textures: o({}, a.textures),
        geometry: o({}, a.geometry)
      });
    },
    9742: function _(t, e) {
      "use strict";

      e.byteLength = function (t) {
        var e = c(t),
            r = e[0],
            n = e[1];
        return 3 * (r + n) / 4 - n;
      }, e.toByteArray = function (t) {
        var e,
            r,
            i = c(t),
            a = i[0],
            s = i[1],
            u = new o(function (t, e, r) {
          return 3 * (e + r) / 4 - r;
        }(0, a, s)),
            l = 0,
            f = s > 0 ? a - 4 : a;

        for (r = 0; r < f; r += 4) {
          e = n[t.charCodeAt(r)] << 18 | n[t.charCodeAt(r + 1)] << 12 | n[t.charCodeAt(r + 2)] << 6 | n[t.charCodeAt(r + 3)], u[l++] = e >> 16 & 255, u[l++] = e >> 8 & 255, u[l++] = 255 & e;
        }

        return 2 === s && (e = n[t.charCodeAt(r)] << 2 | n[t.charCodeAt(r + 1)] >> 4, u[l++] = 255 & e), 1 === s && (e = n[t.charCodeAt(r)] << 10 | n[t.charCodeAt(r + 1)] << 4 | n[t.charCodeAt(r + 2)] >> 2, u[l++] = e >> 8 & 255, u[l++] = 255 & e), u;
      }, e.fromByteArray = function (t) {
        for (var e, n = t.length, o = n % 3, i = [], a = 16383, s = 0, c = n - o; s < c; s += a) {
          i.push(u(t, s, s + a > c ? c : s + a));
        }

        return 1 === o ? (e = t[n - 1], i.push(r[e >> 2] + r[e << 4 & 63] + "==")) : 2 === o && (e = (t[n - 2] << 8) + t[n - 1], i.push(r[e >> 10] + r[e >> 4 & 63] + r[e << 2 & 63] + "=")), i.join("");
      };

      for (var r = [], n = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, s = i.length; a < s; ++a) {
        r[a] = i[a], n[i.charCodeAt(a)] = a;
      }

      function c(t) {
        var e = t.length;
        if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var r = t.indexOf("=");
        return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
      }

      function u(t, e, n) {
        for (var o, i, a = [], s = e; s < n; s += 3) {
          o = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(r[(i = o) >> 18 & 63] + r[i >> 12 & 63] + r[i >> 6 & 63] + r[63 & i]);
        }

        return a.join("");
      }

      n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
    },
    8764: function _(t, e, r) {
      "use strict";

      var n = r(9742),
          o = r(645),
          i = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
      e.Buffer = c, e.SlowBuffer = function (t) {
        return +t != t && (t = 0), c.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50;
      var a = 2147483647;

      function s(t) {
        if (t > a) throw new RangeError('The value "' + t + '" is invalid for option "size"');
        var e = new Uint8Array(t);
        return Object.setPrototypeOf(e, c.prototype), e;
      }

      function c(t, e, r) {
        if ("number" == typeof t) {
          if ("string" == typeof e) throw new TypeError('The "string" argument must be of type string. Received type number');
          return f(t);
        }

        return u(t, e, r);
      }

      function u(t, e, r) {
        if ("string" == typeof t) return function (t, e) {
          if ("string" == typeof e && "" !== e || (e = "utf8"), !c.isEncoding(e)) throw new TypeError("Unknown encoding: " + e);
          var r = 0 | y(t, e);
          var n = s(r);
          var o = n.write(t, e);
          return o !== r && (n = n.slice(0, o)), n;
        }(t, e);
        if (ArrayBuffer.isView(t)) return function (t) {
          if (q(t, Uint8Array)) {
            var _e4 = new Uint8Array(t);

            return p(_e4.buffer, _e4.byteOffset, _e4.byteLength);
          }

          return h(t);
        }(t);
        if (null == t) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t);
        if (q(t, ArrayBuffer) || t && q(t.buffer, ArrayBuffer)) return p(t, e, r);
        if ("undefined" != typeof SharedArrayBuffer && (q(t, SharedArrayBuffer) || t && q(t.buffer, SharedArrayBuffer))) return p(t, e, r);
        if ("number" == typeof t) throw new TypeError('The "value" argument must not be of type number. Received type number');
        var n = t.valueOf && t.valueOf();
        if (null != n && n !== t) return c.from(n, e, r);

        var o = function (t) {
          if (c.isBuffer(t)) {
            var _e5 = 0 | d(t.length),
                _r2 = s(_e5);

            return 0 === _r2.length || t.copy(_r2, 0, 0, _e5), _r2;
          }

          return void 0 !== t.length ? "number" != typeof t.length || $(t.length) ? s(0) : h(t) : "Buffer" === t.type && Array.isArray(t.data) ? h(t.data) : void 0;
        }(t);

        if (o) return o;
        if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof t[Symbol.toPrimitive]) return c.from(t[Symbol.toPrimitive]("string"), e, r);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t);
      }

      function l(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be of type number');
        if (t < 0) throw new RangeError('The value "' + t + '" is invalid for option "size"');
      }

      function f(t) {
        return l(t), s(t < 0 ? 0 : 0 | d(t));
      }

      function h(t) {
        var e = t.length < 0 ? 0 : 0 | d(t.length),
            r = s(e);

        for (var _n2 = 0; _n2 < e; _n2 += 1) {
          r[_n2] = 255 & t[_n2];
        }

        return r;
      }

      function p(t, e, r) {
        if (e < 0 || t.byteLength < e) throw new RangeError('"offset" is outside of buffer bounds');
        if (t.byteLength < e + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
        var n;
        return n = void 0 === e && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, e) : new Uint8Array(t, e, r), Object.setPrototypeOf(n, c.prototype), n;
      }

      function d(t) {
        if (t >= a) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
        return 0 | t;
      }

      function y(t, e) {
        if (c.isBuffer(t)) return t.length;
        if (ArrayBuffer.isView(t) || q(t, ArrayBuffer)) return t.byteLength;
        if ("string" != typeof t) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof t);
        var r = t.length,
            n = arguments.length > 2 && !0 === arguments[2];
        if (!n && 0 === r) return 0;
        var o = !1;

        for (;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
              return K(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return H(t).length;

            default:
              if (o) return n ? -1 : K(t).length;
              e = ("" + e).toLowerCase(), o = !0;
          }
        }
      }

      function m(t, e, r) {
        var n = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (e >>>= 0)) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return S(this, e, r);

            case "utf8":
            case "utf-8":
              return A(this, e, r);

            case "ascii":
              return T(this, e, r);

            case "latin1":
            case "binary":
              return P(this, e, r);

            case "base64":
              return E(this, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return k(this, e, r);

            default:
              if (n) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), n = !0;
          }
        }
      }

      function v(t, e, r) {
        var n = t[e];
        t[e] = t[r], t[r] = n;
      }

      function g(t, e, r, n, o) {
        if (0 === t.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), $(r = +r) && (r = o ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
          if (o) return -1;
          r = t.length - 1;
        } else if (r < 0) {
          if (!o) return -1;
          r = 0;
        }

        if ("string" == typeof e && (e = c.from(e, n)), c.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, r, n, o);
        if ("number" == typeof e) return e &= 255, "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : b(t, [e], r, n, o);
        throw new TypeError("val must be string, number or Buffer");
      }

      function b(t, e, r, n, o) {
        var i,
            a = 1,
            s = t.length,
            c = e.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (t.length < 2 || e.length < 2) return -1;
          a = 2, s /= 2, c /= 2, r /= 2;
        }

        function u(t, e) {
          return 1 === a ? t[e] : t.readUInt16BE(e * a);
        }

        if (o) {
          var _n3 = -1;

          for (i = r; i < s; i++) {
            if (u(t, i) === u(e, -1 === _n3 ? 0 : i - _n3)) {
              if (-1 === _n3 && (_n3 = i), i - _n3 + 1 === c) return _n3 * a;
            } else -1 !== _n3 && (i -= i - _n3), _n3 = -1;
          }
        } else for (r + c > s && (r = s - c), i = r; i >= 0; i--) {
          var _r3 = !0;

          for (var _n4 = 0; _n4 < c; _n4++) {
            if (u(t, i + _n4) !== u(e, _n4)) {
              _r3 = !1;
              break;
            }
          }

          if (_r3) return i;
        }

        return -1;
      }

      function w(t, e, r, n) {
        r = Number(r) || 0;
        var o = t.length - r;
        n ? (n = Number(n)) > o && (n = o) : n = o;
        var i = e.length;
        var a;

        for (n > i / 2 && (n = i / 2), a = 0; a < n; ++a) {
          var _n5 = parseInt(e.substr(2 * a, 2), 16);

          if ($(_n5)) return a;
          t[r + a] = _n5;
        }

        return a;
      }

      function O(t, e, r, n) {
        return V(K(e, t.length - r), t, r, n);
      }

      function _(t, e, r, n) {
        return V(function (t) {
          var e = [];

          for (var _r4 = 0; _r4 < t.length; ++_r4) {
            e.push(255 & t.charCodeAt(_r4));
          }

          return e;
        }(e), t, r, n);
      }

      function x(t, e, r, n) {
        return V(H(e), t, r, n);
      }

      function L(t, e, r, n) {
        return V(function (t, e) {
          var r, n, o;
          var i = [];

          for (var _a = 0; _a < t.length && !((e -= 2) < 0); ++_a) {
            r = t.charCodeAt(_a), n = r >> 8, o = r % 256, i.push(o), i.push(n);
          }

          return i;
        }(e, t.length - r), t, r, n);
      }

      function E(t, e, r) {
        return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
      }

      function A(t, e, r) {
        r = Math.min(t.length, r);
        var n = [];
        var o = e;

        for (; o < r;) {
          var _e6 = t[o];

          var _i = null,
              _a2 = _e6 > 239 ? 4 : _e6 > 223 ? 3 : _e6 > 191 ? 2 : 1;

          if (o + _a2 <= r) {
            var _r5 = void 0,
                _n6 = void 0,
                _s = void 0,
                _c = void 0;

            switch (_a2) {
              case 1:
                _e6 < 128 && (_i = _e6);
                break;

              case 2:
                _r5 = t[o + 1], 128 == (192 & _r5) && (_c = (31 & _e6) << 6 | 63 & _r5, _c > 127 && (_i = _c));
                break;

              case 3:
                _r5 = t[o + 1], _n6 = t[o + 2], 128 == (192 & _r5) && 128 == (192 & _n6) && (_c = (15 & _e6) << 12 | (63 & _r5) << 6 | 63 & _n6, _c > 2047 && (_c < 55296 || _c > 57343) && (_i = _c));
                break;

              case 4:
                _r5 = t[o + 1], _n6 = t[o + 2], _s = t[o + 3], 128 == (192 & _r5) && 128 == (192 & _n6) && 128 == (192 & _s) && (_c = (15 & _e6) << 18 | (63 & _r5) << 12 | (63 & _n6) << 6 | 63 & _s, _c > 65535 && _c < 1114112 && (_i = _c));
            }
          }

          null === _i ? (_i = 65533, _a2 = 1) : _i > 65535 && (_i -= 65536, n.push(_i >>> 10 & 1023 | 55296), _i = 56320 | 1023 & _i), n.push(_i), o += _a2;
        }

        return function (t) {
          var e = t.length;
          if (e <= R) return String.fromCharCode.apply(String, t);
          var r = "",
              n = 0;

          for (; n < e;) {
            r += String.fromCharCode.apply(String, t.slice(n, n += R));
          }

          return r;
        }(n);
      }

      e.kMaxLength = a, c.TYPED_ARRAY_SUPPORT = function () {
        try {
          var _t2 = new Uint8Array(1),
              _e7 = {
            foo: function foo() {
              return 42;
            }
          };

          return Object.setPrototypeOf(_e7, Uint8Array.prototype), Object.setPrototypeOf(_t2, _e7), 42 === _t2.foo();
        } catch (t) {
          return !1;
        }
      }(), c.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(c.prototype, "parent", {
        enumerable: !0,
        get: function get() {
          if (c.isBuffer(this)) return this.buffer;
        }
      }), Object.defineProperty(c.prototype, "offset", {
        enumerable: !0,
        get: function get() {
          if (c.isBuffer(this)) return this.byteOffset;
        }
      }), c.poolSize = 8192, c.from = function (t, e, r) {
        return u(t, e, r);
      }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array), c.alloc = function (t, e, r) {
        return function (t, e, r) {
          return l(t), t <= 0 ? s(t) : void 0 !== e ? "string" == typeof r ? s(t).fill(e, r) : s(t).fill(e) : s(t);
        }(t, e, r);
      }, c.allocUnsafe = function (t) {
        return f(t);
      }, c.allocUnsafeSlow = function (t) {
        return f(t);
      }, c.isBuffer = function (t) {
        return null != t && !0 === t._isBuffer && t !== c.prototype;
      }, c.compare = function (t, e) {
        if (q(t, Uint8Array) && (t = c.from(t, t.offset, t.byteLength)), q(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), !c.isBuffer(t) || !c.isBuffer(e)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (t === e) return 0;
        var r = t.length,
            n = e.length;

        for (var _o = 0, _i2 = Math.min(r, n); _o < _i2; ++_o) {
          if (t[_o] !== e[_o]) {
            r = t[_o], n = e[_o];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, c.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, c.concat = function (t, e) {
        if (!Array.isArray(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return c.alloc(0);
        var r;
        if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
          e += t[r].length;
        }
        var n = c.allocUnsafe(e);
        var o = 0;

        for (r = 0; r < t.length; ++r) {
          var _e8 = t[r];
          if (q(_e8, Uint8Array)) o + _e8.length > n.length ? (c.isBuffer(_e8) || (_e8 = c.from(_e8)), _e8.copy(n, o)) : Uint8Array.prototype.set.call(n, _e8, o);else {
            if (!c.isBuffer(_e8)) throw new TypeError('"list" argument must be an Array of Buffers');

            _e8.copy(n, o);
          }
          o += _e8.length;
        }

        return n;
      }, c.byteLength = y, c.prototype._isBuffer = !0, c.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var _e9 = 0; _e9 < t; _e9 += 2) {
          v(this, _e9, _e9 + 1);
        }

        return this;
      }, c.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var _e10 = 0; _e10 < t; _e10 += 4) {
          v(this, _e10, _e10 + 3), v(this, _e10 + 1, _e10 + 2);
        }

        return this;
      }, c.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var _e11 = 0; _e11 < t; _e11 += 8) {
          v(this, _e11, _e11 + 7), v(this, _e11 + 1, _e11 + 6), v(this, _e11 + 2, _e11 + 5), v(this, _e11 + 3, _e11 + 4);
        }

        return this;
      }, c.prototype.toString = function () {
        var t = this.length;
        return 0 === t ? "" : 0 === arguments.length ? A(this, 0, t) : m.apply(this, arguments);
      }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function (t) {
        if (!c.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === c.compare(this, t);
      }, c.prototype.inspect = function () {
        var t = "";
        var r = e.INSPECT_MAX_BYTES;
        return t = this.toString("hex", 0, r).replace(/(.{2})/g, "$1 ").trim(), this.length > r && (t += " ... "), "<Buffer " + t + ">";
      }, i && (c.prototype[i] = c.prototype.inspect), c.prototype.compare = function (t, e, r, n, o) {
        if (q(t, Uint8Array) && (t = c.from(t, t.offset, t.byteLength)), !c.isBuffer(t)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof t);
        if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), e < 0 || r > t.length || n < 0 || o > this.length) throw new RangeError("out of range index");
        if (n >= o && e >= r) return 0;
        if (n >= o) return -1;
        if (e >= r) return 1;
        if (this === t) return 0;
        var i = (o >>>= 0) - (n >>>= 0),
            a = (r >>>= 0) - (e >>>= 0);
        var s = Math.min(i, a),
            u = this.slice(n, o),
            l = t.slice(e, r);

        for (var _t3 = 0; _t3 < s; ++_t3) {
          if (u[_t3] !== l[_t3]) {
            i = u[_t3], a = l[_t3];
            break;
          }
        }

        return i < a ? -1 : a < i ? 1 : 0;
      }, c.prototype.includes = function (t, e, r) {
        return -1 !== this.indexOf(t, e, r);
      }, c.prototype.indexOf = function (t, e, r) {
        return g(this, t, e, r, !0);
      }, c.prototype.lastIndexOf = function (t, e, r) {
        return g(this, t, e, r, !1);
      }, c.prototype.write = function (t, e, r, n) {
        if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var o = this.length - e;
        if ((void 0 === r || r > o) && (r = o), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");
        var i = !1;

        for (;;) {
          switch (n) {
            case "hex":
              return w(this, t, e, r);

            case "utf8":
            case "utf-8":
              return O(this, t, e, r);

            case "ascii":
            case "latin1":
            case "binary":
              return _(this, t, e, r);

            case "base64":
              return x(this, t, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return L(this, t, e, r);

            default:
              if (i) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), i = !0;
          }
        }
      }, c.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var R = 4096;

      function T(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var _o2 = e; _o2 < r; ++_o2) {
          n += String.fromCharCode(127 & t[_o2]);
        }

        return n;
      }

      function P(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var _o3 = e; _o3 < r; ++_o3) {
          n += String.fromCharCode(t[_o3]);
        }

        return n;
      }

      function S(t, e, r) {
        var n = t.length;
        (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);
        var o = "";

        for (var _n7 = e; _n7 < r; ++_n7) {
          o += X[t[_n7]];
        }

        return o;
      }

      function k(t, e, r) {
        var n = t.slice(e, r);
        var o = "";

        for (var _t4 = 0; _t4 < n.length - 1; _t4 += 2) {
          o += String.fromCharCode(n[_t4] + 256 * n[_t4 + 1]);
        }

        return o;
      }

      function j(t, e, r) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function Z(t, e, r, n, o, i) {
        if (!c.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > o || e < i) throw new RangeError('"value" argument is out of bounds');
        if (r + n > t.length) throw new RangeError("Index out of range");
      }

      function M(t, e, r, n, o) {
        Y(e, n, o, t, r, 7);
        var i = Number(e & BigInt(4294967295));
        t[r++] = i, i >>= 8, t[r++] = i, i >>= 8, t[r++] = i, i >>= 8, t[r++] = i;
        var a = Number(e >> BigInt(32) & BigInt(4294967295));
        return t[r++] = a, a >>= 8, t[r++] = a, a >>= 8, t[r++] = a, a >>= 8, t[r++] = a, r;
      }

      function C(t, e, r, n, o) {
        Y(e, n, o, t, r, 7);
        var i = Number(e & BigInt(4294967295));
        t[r + 7] = i, i >>= 8, t[r + 6] = i, i >>= 8, t[r + 5] = i, i >>= 8, t[r + 4] = i;
        var a = Number(e >> BigInt(32) & BigInt(4294967295));
        return t[r + 3] = a, a >>= 8, t[r + 2] = a, a >>= 8, t[r + 1] = a, a >>= 8, t[r] = a, r + 8;
      }

      function F(t, e, r, n, o, i) {
        if (r + n > t.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function W(t, e, r, n, i) {
        return e = +e, r >>>= 0, i || F(t, 0, r, 4), o.write(t, e, r, n, 23, 4), r + 4;
      }

      function B(t, e, r, n, i) {
        return e = +e, r >>>= 0, i || F(t, 0, r, 8), o.write(t, e, r, n, 52, 8), r + 8;
      }

      c.prototype.slice = function (t, e) {
        var r = this.length;
        (t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), (e = void 0 === e ? r : ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), e < t && (e = t);
        var n = this.subarray(t, e);
        return Object.setPrototypeOf(n, c.prototype), n;
      }, c.prototype.readUintLE = c.prototype.readUIntLE = function (t, e, r) {
        t >>>= 0, e >>>= 0, r || j(t, e, this.length);
        var n = this[t],
            o = 1,
            i = 0;

        for (; ++i < e && (o *= 256);) {
          n += this[t + i] * o;
        }

        return n;
      }, c.prototype.readUintBE = c.prototype.readUIntBE = function (t, e, r) {
        t >>>= 0, e >>>= 0, r || j(t, e, this.length);
        var n = this[t + --e],
            o = 1;

        for (; e > 0 && (o *= 256);) {
          n += this[t + --e] * o;
        }

        return n;
      }, c.prototype.readUint8 = c.prototype.readUInt8 = function (t, e) {
        return t >>>= 0, e || j(t, 1, this.length), this[t];
      }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function (t, e) {
        return t >>>= 0, e || j(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function (t, e) {
        return t >>>= 0, e || j(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function (t, e) {
        return t >>>= 0, e || j(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function (t, e) {
        return t >>>= 0, e || j(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, c.prototype.readBigUInt64LE = J(function (t) {
        z(t >>>= 0, "offset");
        var e = this[t],
            r = this[t + 7];
        void 0 !== e && void 0 !== r || U(t, this.length - 8);
        var n = e + 256 * this[++t] + 65536 * this[++t] + this[++t] * Math.pow(2, 24),
            o = this[++t] + 256 * this[++t] + 65536 * this[++t] + r * Math.pow(2, 24);
        return BigInt(n) + (BigInt(o) << BigInt(32));
      }), c.prototype.readBigUInt64BE = J(function (t) {
        z(t >>>= 0, "offset");
        var e = this[t],
            r = this[t + 7];
        void 0 !== e && void 0 !== r || U(t, this.length - 8);
        var n = e * Math.pow(2, 24) + 65536 * this[++t] + 256 * this[++t] + this[++t],
            o = this[++t] * Math.pow(2, 24) + 65536 * this[++t] + 256 * this[++t] + r;
        return (BigInt(n) << BigInt(32)) + BigInt(o);
      }), c.prototype.readIntLE = function (t, e, r) {
        t >>>= 0, e >>>= 0, r || j(t, e, this.length);
        var n = this[t],
            o = 1,
            i = 0;

        for (; ++i < e && (o *= 256);) {
          n += this[t + i] * o;
        }

        return o *= 128, n >= o && (n -= Math.pow(2, 8 * e)), n;
      }, c.prototype.readIntBE = function (t, e, r) {
        t >>>= 0, e >>>= 0, r || j(t, e, this.length);
        var n = e,
            o = 1,
            i = this[t + --n];

        for (; n > 0 && (o *= 256);) {
          i += this[t + --n] * o;
        }

        return o *= 128, i >= o && (i -= Math.pow(2, 8 * e)), i;
      }, c.prototype.readInt8 = function (t, e) {
        return t >>>= 0, e || j(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, c.prototype.readInt16LE = function (t, e) {
        t >>>= 0, e || j(t, 2, this.length);
        var r = this[t] | this[t + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, c.prototype.readInt16BE = function (t, e) {
        t >>>= 0, e || j(t, 2, this.length);
        var r = this[t + 1] | this[t] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, c.prototype.readInt32LE = function (t, e) {
        return t >>>= 0, e || j(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, c.prototype.readInt32BE = function (t, e) {
        return t >>>= 0, e || j(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, c.prototype.readBigInt64LE = J(function (t) {
        z(t >>>= 0, "offset");
        var e = this[t],
            r = this[t + 7];
        void 0 !== e && void 0 !== r || U(t, this.length - 8);
        var n = this[t + 4] + 256 * this[t + 5] + 65536 * this[t + 6] + (r << 24);
        return (BigInt(n) << BigInt(32)) + BigInt(e + 256 * this[++t] + 65536 * this[++t] + this[++t] * Math.pow(2, 24));
      }), c.prototype.readBigInt64BE = J(function (t) {
        z(t >>>= 0, "offset");
        var e = this[t],
            r = this[t + 7];
        void 0 !== e && void 0 !== r || U(t, this.length - 8);
        var n = (e << 24) + 65536 * this[++t] + 256 * this[++t] + this[++t];
        return (BigInt(n) << BigInt(32)) + BigInt(this[++t] * Math.pow(2, 24) + 65536 * this[++t] + 256 * this[++t] + r);
      }), c.prototype.readFloatLE = function (t, e) {
        return t >>>= 0, e || j(t, 4, this.length), o.read(this, t, !0, 23, 4);
      }, c.prototype.readFloatBE = function (t, e) {
        return t >>>= 0, e || j(t, 4, this.length), o.read(this, t, !1, 23, 4);
      }, c.prototype.readDoubleLE = function (t, e) {
        return t >>>= 0, e || j(t, 8, this.length), o.read(this, t, !0, 52, 8);
      }, c.prototype.readDoubleBE = function (t, e) {
        return t >>>= 0, e || j(t, 8, this.length), o.read(this, t, !1, 52, 8);
      }, c.prototype.writeUintLE = c.prototype.writeUIntLE = function (t, e, r, n) {
        t = +t, e >>>= 0, r >>>= 0, n || Z(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var o = 1,
            i = 0;

        for (this[e] = 255 & t; ++i < r && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + r;
      }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function (t, e, r, n) {
        t = +t, e >>>= 0, r >>>= 0, n || Z(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var o = r - 1,
            i = 1;

        for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + r;
      }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 1, 255, 0), this[e] = 255 & t, e + 1;
      }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 2, 65535, 0), this[e] = 255 & t, this[e + 1] = t >>> 8, e + 2;
      }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 2, 65535, 0), this[e] = t >>> 8, this[e + 1] = 255 & t, e + 2;
      }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 4, 4294967295, 0), this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t, e + 4;
      }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 4, 4294967295, 0), this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t, e + 4;
      }, c.prototype.writeBigUInt64LE = J(function (t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return M(this, t, e, BigInt(0), BigInt("0xffffffffffffffff"));
      }), c.prototype.writeBigUInt64BE = J(function (t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return C(this, t, e, BigInt(0), BigInt("0xffffffffffffffff"));
      }), c.prototype.writeIntLE = function (t, e, r, n) {
        if (t = +t, e >>>= 0, !n) {
          var _n8 = Math.pow(2, 8 * r - 1);

          Z(this, t, e, r, _n8 - 1, -_n8);
        }

        var o = 0,
            i = 1,
            a = 0;

        for (this[e] = 255 & t; ++o < r && (i *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), this[e + o] = (t / i >> 0) - a & 255;
        }

        return e + r;
      }, c.prototype.writeIntBE = function (t, e, r, n) {
        if (t = +t, e >>>= 0, !n) {
          var _n9 = Math.pow(2, 8 * r - 1);

          Z(this, t, e, r, _n9 - 1, -_n9);
        }

        var o = r - 1,
            i = 1,
            a = 0;

        for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), this[e + o] = (t / i >> 0) - a & 255;
        }

        return e + r;
      }, c.prototype.writeInt8 = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 1, 127, -128), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, c.prototype.writeInt16LE = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 2, 32767, -32768), this[e] = 255 & t, this[e + 1] = t >>> 8, e + 2;
      }, c.prototype.writeInt16BE = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 2, 32767, -32768), this[e] = t >>> 8, this[e + 1] = 255 & t, e + 2;
      }, c.prototype.writeInt32LE = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 4, 2147483647, -2147483648), this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24, e + 4;
      }, c.prototype.writeInt32BE = function (t, e, r) {
        return t = +t, e >>>= 0, r || Z(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t, e + 4;
      }, c.prototype.writeBigInt64LE = J(function (t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return M(this, t, e, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      }), c.prototype.writeBigInt64BE = J(function (t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return C(this, t, e, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      }), c.prototype.writeFloatLE = function (t, e, r) {
        return W(this, t, e, !0, r);
      }, c.prototype.writeFloatBE = function (t, e, r) {
        return W(this, t, e, !1, r);
      }, c.prototype.writeDoubleLE = function (t, e, r) {
        return B(this, t, e, !0, r);
      }, c.prototype.writeDoubleBE = function (t, e, r) {
        return B(this, t, e, !1, r);
      }, c.prototype.copy = function (t, e, r, n) {
        if (!c.isBuffer(t)) throw new TypeError("argument should be a Buffer");
        if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
        var o = n - r;
        return this === t && "function" == typeof Uint8Array.prototype.copyWithin ? this.copyWithin(e, r, n) : Uint8Array.prototype.set.call(t, this.subarray(r, n), e), o;
      }, c.prototype.fill = function (t, e, r, n) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !c.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);

          if (1 === t.length) {
            var _e12 = t.charCodeAt(0);

            ("utf8" === n && _e12 < 128 || "latin1" === n) && (t = _e12);
          }
        } else "number" == typeof t ? t &= 255 : "boolean" == typeof t && (t = Number(t));

        if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
        if (r <= e) return this;
        var o;
        if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
          this[o] = t;
        } else {
          var _i3 = c.isBuffer(t) ? t : c.from(t, n),
              _a3 = _i3.length;

          if (0 === _a3) throw new TypeError('The value "' + t + '" is invalid for argument "value"');

          for (o = 0; o < r - e; ++o) {
            this[o + e] = _i3[o % _a3];
          }
        }
        return this;
      };
      var N = {};

      function I(t, e, r) {
        N[t] = /*#__PURE__*/function (_r6) {
          _inherits(_class, _r6);

          var _super = _createSuper(_class);

          function _class() {
            var _this;

            _classCallCheck(this, _class);

            _this = _super.call(this), Object.defineProperty(_assertThisInitialized(_this), "message", {
              value: e.apply(_assertThisInitialized(_this), arguments),
              writable: !0,
              configurable: !0
            }), _this.name = "".concat(_this.name, " [").concat(t, "]"), _this.stack, delete _this.name;
            return _this;
          }

          _createClass(_class, [{
            key: "code",
            get: function get() {
              return t;
            },
            set: function set(t) {
              Object.defineProperty(this, "code", {
                configurable: !0,
                enumerable: !0,
                value: t,
                writable: !0
              });
            }
          }, {
            key: "toString",
            value: function toString() {
              return "".concat(this.name, " [").concat(t, "]: ").concat(this.message);
            }
          }]);

          return _class;
        }(r);
      }

      function D(t) {
        var e = "",
            r = t.length;
        var n = "-" === t[0] ? 1 : 0;

        for (; r >= n + 4; r -= 3) {
          e = "_".concat(t.slice(r - 3, r)).concat(e);
        }

        return "".concat(t.slice(0, r)).concat(e);
      }

      function Y(t, e, r, n, o, i) {
        if (t > r || t < e) {
          var _n10 = "bigint" == typeof e ? "n" : "";

          var _o4;

          throw _o4 = i > 3 ? 0 === e || e === BigInt(0) ? ">= 0".concat(_n10, " and < 2").concat(_n10, " ** ").concat(8 * (i + 1)).concat(_n10) : ">= -(2".concat(_n10, " ** ").concat(8 * (i + 1) - 1).concat(_n10, ") and < 2 ** ").concat(8 * (i + 1) - 1).concat(_n10) : ">= ".concat(e).concat(_n10, " and <= ").concat(r).concat(_n10), new N.ERR_OUT_OF_RANGE("value", _o4, t);
        }

        !function (t, e, r) {
          z(e, "offset"), void 0 !== t[e] && void 0 !== t[e + r] || U(e, t.length - (r + 1));
        }(n, o, i);
      }

      function z(t, e) {
        if ("number" != typeof t) throw new N.ERR_INVALID_ARG_TYPE(e, "number", t);
      }

      function U(t, e, r) {
        if (Math.floor(t) !== t) throw z(t, r), new N.ERR_OUT_OF_RANGE(r || "offset", "an integer", t);
        if (e < 0) throw new N.ERR_BUFFER_OUT_OF_BOUNDS();
        throw new N.ERR_OUT_OF_RANGE(r || "offset", ">= ".concat(r ? 1 : 0, " and <= ").concat(e), t);
      }

      I("ERR_BUFFER_OUT_OF_BOUNDS", function (t) {
        return t ? "".concat(t, " is outside of buffer bounds") : "Attempt to access memory outside buffer bounds";
      }, RangeError), I("ERR_INVALID_ARG_TYPE", function (t, e) {
        return "The \"".concat(t, "\" argument must be of type number. Received type ").concat(typeof e);
      }, TypeError), I("ERR_OUT_OF_RANGE", function (t, e, r) {
        var n = "The value of \"".concat(t, "\" is out of range."),
            o = r;
        return Number.isInteger(r) && Math.abs(r) > Math.pow(2, 32) ? o = D(String(r)) : "bigint" == typeof r && (o = String(r), (r > Math.pow(BigInt(2), BigInt(32)) || r < -Math.pow(BigInt(2), BigInt(32))) && (o = D(o)), o += "n"), n += " It must be ".concat(e, ". Received ").concat(o), n;
      }, RangeError);
      var G = /[^+/0-9A-Za-z-_]/g;

      function K(t, e) {
        var r;
        e = e || 1 / 0;
        var n = t.length;
        var o = null;
        var i = [];

        for (var _a4 = 0; _a4 < n; ++_a4) {
          if (r = t.charCodeAt(_a4), r > 55295 && r < 57344) {
            if (!o) {
              if (r > 56319) {
                (e -= 3) > -1 && i.push(239, 191, 189);
                continue;
              }

              if (_a4 + 1 === n) {
                (e -= 3) > -1 && i.push(239, 191, 189);
                continue;
              }

              o = r;
              continue;
            }

            if (r < 56320) {
              (e -= 3) > -1 && i.push(239, 191, 189), o = r;
              continue;
            }

            r = 65536 + (o - 55296 << 10 | r - 56320);
          } else o && (e -= 3) > -1 && i.push(239, 191, 189);

          if (o = null, r < 128) {
            if ((e -= 1) < 0) break;
            i.push(r);
          } else if (r < 2048) {
            if ((e -= 2) < 0) break;
            i.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((e -= 3) < 0) break;
            i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return i;
      }

      function H(t) {
        return n.toByteArray(function (t) {
          if ((t = (t = t.split("=")[0]).trim().replace(G, "")).length < 2) return "";

          for (; t.length % 4 != 0;) {
            t += "=";
          }

          return t;
        }(t));
      }

      function V(t, e, r, n) {
        var o;

        for (o = 0; o < n && !(o + r >= e.length || o >= t.length); ++o) {
          e[o + r] = t[o];
        }

        return o;
      }

      function q(t, e) {
        return t instanceof e || null != t && null != t.constructor && null != t.constructor.name && t.constructor.name === e.name;
      }

      function $(t) {
        return t != t;
      }

      var X = function () {
        var t = "0123456789abcdef",
            e = new Array(256);

        for (var _r7 = 0; _r7 < 16; ++_r7) {
          var _n11 = 16 * _r7;

          for (var _o5 = 0; _o5 < 16; ++_o5) {
            e[_n11 + _o5] = t[_r7] + t[_o5];
          }
        }

        return e;
      }();

      function J(t) {
        return "undefined" == typeof BigInt ? Q : t;
      }

      function Q() {
        throw new Error("BigInt not supported");
      }
    },
    4913: function _(t, e, r) {
      "use strict";

      r.d(e, {
        Z: function Z() {
          return s;
        }
      });
      var n = r(7537),
          o = r.n(n),
          i = r(3645),
          a = r.n(i)()(o());
      a.push([t.id, "/*                                                 *** ----------------------------------------------- **\n**             Calliope - Site Generator   \t       **\n** ----------------------------------------------- **\n**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **\n**                                                 **\n**    Any unauthorized distribution or transfer    **\n**       of this work is strictly prohibited.      **\n**                                                 **\n**               All Rights Reserved.              **\n** ----------------------------------------------- **\n\\*                                                 */\n.pixos {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 16px;\n  width: 100%;\n  text-shadow: #3f3f3f 2px 2px 0px;\n  position: relative;\n  /* padding: 2.5em; */\n  align-items: center;\n  align-content: center;\n}\n\n.renderSurface {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.materialSelector {\n  background: rgba(0, 0, 0, 0.6);\n  margin: auto;\n  position: relative;\n}\n.materialSelector tr {\n  height: 70px;\n}\n.materialSelector td {\n  background-position: 0px 0px;\n  cursor: pointer;\n  margin: 0;\n  opacity: 0.3;\n  padding: 0;\n  width: 70px;\n}\n.materialSelector td:hover {\n  opacity: 0.8;\n}\n\n.nickname {\n  color: #ffffff;\n  cursor: default;\n  left: 42%;\n  position: absolute;\n  top: 40%;\n  width: 300px;\n}\n.nickname input {\n  background: none;\n  border-bottom: 1px solid #888888;\n  border: none;\n  color: white;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 24px;\n  outline: none;\n  width: 100%;\n}\n\n.joininfo {\n  color: #ffffff;\n  cursor: default;\n  font-size: 24px;\n  position: absolute;\n  text-align: center;\n  top: 42%;\n  width: 99%;\n}\n\n.chatbox {\n  background: rgba(0, 0, 0, 0.6);\n  bottom: 55px;\n  color: white;\n  cursor: default;\n  height: 195px;\n  left: 20px;\n  overflow: hidden;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  width: 600px;\n}\n\n.chatbox_text {\n  bottom: 8px;\n  position: absolute;\n  text-shadow: none;\n}\n\n.chatbox_entry {\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  bottom: 18px;\n  color: white;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 16px;\n  height: 30px;\n  left: 20px;\n  outline: none;\n  padding-bottom: 2px;\n  padding-left: 10px;\n  position: absolute;\n  width: 610px;\n}\n\nhtml {\n  height: 100%;\n}\n\n.pixos-body {\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  background: linear-gradient(to bottom, #202020, #111119);\n}\n\n.rain {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.snow {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.rain.back-row {\n  z-index: 1;\n  bottom: 60px;\n  opacity: 0.5;\n}\n.snow.back-row {\n  z-index: 1;\n  bottom: 60px;\n  opacity: 0.8;\n}\n\nbody.back-row-toggle .rain.back-row .snow.back-row {\n  display: block;\n}\n\n.drop {\n  position: absolute;\n  bottom: 100%;\n  width: 15px;\n  height: 120px;\n  pointer-events: none;\n  animation: drop 0.5s linear infinite;\n}\n\n.flake {\n  position: absolute;\n  bottom: 100%;\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n  animation: snow 2.5s linear infinite;\n}\n\n@keyframes drop {\n  0% {\n    transform: translateY(0vh);\n  }\n  75% {\n    transform: translateY(90vh);\n  }\n  100% {\n    transform: translateY(90vh);\n  }\n}\n\n@keyframes snow {\n  0% {\n    transform: translateY(0vh);\n  }\n  70% {\n    transform: translateY(50vh);\n  }\n  85% {\n    transform: translateY(85vh);\n  }\n  75% {\n    transform: translateY(75vh);\n  }\n  100% {\n    transform: translateY(95vh);\n    transform: translateX(30vw);\n  }\n}\n\n.stem {\n  width: 1px;\n  height: 60%;\n  margin-left: 7px;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.25));\n  animation: stem 0.5s linear infinite;\n}\n\n@keyframes stem {\n  0% {\n    opacity: 1;\n  }\n  65% {\n    opacity: 1;\n  }\n  75% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.splat {\n  width: 15px;\n  height: 10px;\n  border-top: 2px dotted rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  opacity: 1;\n  transform: scale(0);\n  animation: splat 0.5s linear infinite;\n}\n\nbody.splat-toggle .splat {\n  display: block;\n}\n\n@keyframes splat {\n  0% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  80% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  90% {\n    opacity: 0.5;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.5);\n  }\n}\n\n.toggles {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 3;\n}\n\n.toggle {\n  position: absolute;\n  left: 20px;\n  width: 50px;\n  height: 50px;\n  line-height: 51px;\n  box-sizing: border-box;\n  text-align: center;\n  font-family: sans-serif;\n  font-size: 10px;\n  font-weight: bold;\n  background-color: rgba(255, 255, 255, 0.2);\n  color: rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.toggle:hover {\n  background-color: rgba(255, 255, 255, 0.25);\n}\n\n.toggle:active {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.toggle.active {\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.splat-toggle {\n  top: 20px;\n}\n\n.back-row-toggle {\n  top: 90px;\n  line-height: 12px;\n  padding-top: 14px;\n}\n\n.single-toggle {\n  top: 160px;\n}\n\nbody.single-toggle .drop {\n  display: none;\n}\n\nbody.single-toggle .drop:nth-child(10) {\n  display: block;\n}\n", "", {
        version: 3,
        sources: ["webpack://./pixos/less/pixos.css"],
        names: [],
        mappings: "AAAA;;;;;;;;;;oDAUoD;AACpD;EACE,yCAAyC;EACzC,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,yFAAyF;EACzF,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB",
        sourcesContent: ["/*                                                 *** ----------------------------------------------- **\n**             Calliope - Site Generator   \t       **\n** ----------------------------------------------- **\n**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **\n**                                                 **\n**    Any unauthorized distribution or transfer    **\n**       of this work is strictly prohibited.      **\n**                                                 **\n**               All Rights Reserved.              **\n** ----------------------------------------------- **\n\\*                                                 */\n.pixos {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 16px;\n  width: 100%;\n  text-shadow: #3f3f3f 2px 2px 0px;\n  position: relative;\n  /* padding: 2.5em; */\n  align-items: center;\n  align-content: center;\n}\n\n.renderSurface {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.materialSelector {\n  background: rgba(0, 0, 0, 0.6);\n  margin: auto;\n  position: relative;\n}\n.materialSelector tr {\n  height: 70px;\n}\n.materialSelector td {\n  background-position: 0px 0px;\n  cursor: pointer;\n  margin: 0;\n  opacity: 0.3;\n  padding: 0;\n  width: 70px;\n}\n.materialSelector td:hover {\n  opacity: 0.8;\n}\n\n.nickname {\n  color: #ffffff;\n  cursor: default;\n  left: 42%;\n  position: absolute;\n  top: 40%;\n  width: 300px;\n}\n.nickname input {\n  background: none;\n  border-bottom: 1px solid #888888;\n  border: none;\n  color: white;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 24px;\n  outline: none;\n  width: 100%;\n}\n\n.joininfo {\n  color: #ffffff;\n  cursor: default;\n  font-size: 24px;\n  position: absolute;\n  text-align: center;\n  top: 42%;\n  width: 99%;\n}\n\n.chatbox {\n  background: rgba(0, 0, 0, 0.6);\n  bottom: 55px;\n  color: white;\n  cursor: default;\n  height: 195px;\n  left: 20px;\n  overflow: hidden;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  width: 600px;\n}\n\n.chatbox_text {\n  bottom: 8px;\n  position: absolute;\n  text-shadow: none;\n}\n\n.chatbox_entry {\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  bottom: 18px;\n  color: white;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 16px;\n  height: 30px;\n  left: 20px;\n  outline: none;\n  padding-bottom: 2px;\n  padding-left: 10px;\n  position: absolute;\n  width: 610px;\n}\n\nhtml {\n  height: 100%;\n}\n\n.pixos-body {\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  background: linear-gradient(to bottom, #202020, #111119);\n}\n\n.rain {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.snow {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.rain.back-row {\n  z-index: 1;\n  bottom: 60px;\n  opacity: 0.5;\n}\n.snow.back-row {\n  z-index: 1;\n  bottom: 60px;\n  opacity: 0.8;\n}\n\nbody.back-row-toggle .rain.back-row .snow.back-row {\n  display: block;\n}\n\n.drop {\n  position: absolute;\n  bottom: 100%;\n  width: 15px;\n  height: 120px;\n  pointer-events: none;\n  animation: drop 0.5s linear infinite;\n}\n\n.flake {\n  position: absolute;\n  bottom: 100%;\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n  animation: snow 2.5s linear infinite;\n}\n\n@keyframes drop {\n  0% {\n    transform: translateY(0vh);\n  }\n  75% {\n    transform: translateY(90vh);\n  }\n  100% {\n    transform: translateY(90vh);\n  }\n}\n\n@keyframes snow {\n  0% {\n    transform: translateY(0vh);\n  }\n  70% {\n    transform: translateY(50vh);\n  }\n  85% {\n    transform: translateY(85vh);\n  }\n  75% {\n    transform: translateY(75vh);\n  }\n  100% {\n    transform: translateY(95vh);\n    transform: translateX(30vw);\n  }\n}\n\n.stem {\n  width: 1px;\n  height: 60%;\n  margin-left: 7px;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.25));\n  animation: stem 0.5s linear infinite;\n}\n\n@keyframes stem {\n  0% {\n    opacity: 1;\n  }\n  65% {\n    opacity: 1;\n  }\n  75% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.splat {\n  width: 15px;\n  height: 10px;\n  border-top: 2px dotted rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  opacity: 1;\n  transform: scale(0);\n  animation: splat 0.5s linear infinite;\n}\n\nbody.splat-toggle .splat {\n  display: block;\n}\n\n@keyframes splat {\n  0% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  80% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  90% {\n    opacity: 0.5;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.5);\n  }\n}\n\n.toggles {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 3;\n}\n\n.toggle {\n  position: absolute;\n  left: 20px;\n  width: 50px;\n  height: 50px;\n  line-height: 51px;\n  box-sizing: border-box;\n  text-align: center;\n  font-family: sans-serif;\n  font-size: 10px;\n  font-weight: bold;\n  background-color: rgba(255, 255, 255, 0.2);\n  color: rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.toggle:hover {\n  background-color: rgba(255, 255, 255, 0.25);\n}\n\n.toggle:active {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.toggle.active {\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.splat-toggle {\n  top: 20px;\n}\n\n.back-row-toggle {\n  top: 90px;\n  line-height: 12px;\n  padding-top: 14px;\n}\n\n.single-toggle {\n  top: 160px;\n}\n\nbody.single-toggle .drop {\n  display: none;\n}\n\nbody.single-toggle .drop:nth-child(10) {\n  display: block;\n}\n"],
        sourceRoot: ""
      }]);
      var s = a;
    },
    3645: function _(t) {
      "use strict";

      t.exports = function (t) {
        var e = [];
        return e.toString = function () {
          return this.map(function (e) {
            var r = "",
                n = void 0 !== e[5];
            return e[4] && (r += "@supports (".concat(e[4], ") {")), e[2] && (r += "@media ".concat(e[2], " {")), n && (r += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), r += t(e), n && (r += "}"), e[2] && (r += "}"), e[4] && (r += "}"), r;
          }).join("");
        }, e.i = function (t, r, n, o, i) {
          "string" == typeof t && (t = [[null, t, void 0]]);
          var a = {};
          if (n) for (var s = 0; s < this.length; s++) {
            var c = this[s][0];
            null != c && (a[c] = !0);
          }

          for (var u = 0; u < t.length; u++) {
            var l = [].concat(t[u]);
            n && a[l[0]] || (void 0 !== i && (void 0 === l[5] || (l[1] = "@layer".concat(l[5].length > 0 ? " ".concat(l[5]) : "", " {").concat(l[1], "}")), l[5] = i), r && (l[2] ? (l[1] = "@media ".concat(l[2], " {").concat(l[1], "}"), l[2] = r) : l[2] = r), o && (l[4] ? (l[1] = "@supports (".concat(l[4], ") {").concat(l[1], "}"), l[4] = o) : l[4] = "".concat(o)), e.push(l));
          }
        }, e;
      };
    },
    7537: function _(t) {
      "use strict";

      t.exports = function (t) {
        var e = t[1],
            r = t[3];
        if (!r) return e;

        if ("function" == typeof btoa) {
          var n = btoa(unescape(encodeURIComponent(JSON.stringify(r)))),
              o = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(n),
              i = "/*# ".concat(o, " */"),
              a = r.sources.map(function (t) {
            return "/*# sourceURL=".concat(r.sourceRoot || "").concat(t, " */");
          });
          return [e].concat(a).concat([i]).join("\n");
        }

        return [e].join("\n");
      };
    },
    3162: function _(t, e, r) {
      var n;
      void 0 === (n = function () {
        "use strict";

        function e(t, e, r) {
          var n = new XMLHttpRequest();
          n.open("GET", t), n.responseType = "blob", n.onload = function () {
            s(n.response, e, r);
          }, n.onerror = function () {
            console.error("could not download file");
          }, n.send();
        }

        function n(t) {
          var e = new XMLHttpRequest();
          e.open("HEAD", t, !1);

          try {
            e.send();
          } catch (t) {}

          return 200 <= e.status && 299 >= e.status;
        }

        function o(t) {
          try {
            t.dispatchEvent(new MouseEvent("click"));
          } catch (r) {
            var e = document.createEvent("MouseEvents");
            e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
          }
        }

        var i = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof r.g && r.g.global === r.g ? r.g : void 0,
            a = i.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent),
            s = i.saveAs || ("object" != typeof window || window !== i ? function () {} : "download" in HTMLAnchorElement.prototype && !a ? function (t, r, a) {
          var s = i.URL || i.webkitURL,
              c = document.createElement("a");
          r = r || t.name || "download", c.download = r, c.rel = "noopener", "string" == typeof t ? (c.href = t, c.origin === location.origin ? o(c) : n(c.href) ? e(t, r, a) : o(c, c.target = "_blank")) : (c.href = s.createObjectURL(t), setTimeout(function () {
            s.revokeObjectURL(c.href);
          }, 4e4), setTimeout(function () {
            o(c);
          }, 0));
        } : "msSaveOrOpenBlob" in navigator ? function (t, r, i) {
          if (r = r || t.name || "download", "string" != typeof t) navigator.msSaveOrOpenBlob(function (t, e) {
            return void 0 === e ? e = {
              autoBom: !1
            } : "object" != typeof e && (console.warn("Deprecated: Expected third argument to be a object"), e = {
              autoBom: !e
            }), e.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob(["\uFEFF", t], {
              type: t.type
            }) : t;
          }(t, i), r);else if (n(t)) e(t, r, i);else {
            var a = document.createElement("a");
            a.href = t, a.target = "_blank", setTimeout(function () {
              o(a);
            });
          }
        } : function (t, r, n, o) {
          if ((o = o || open("", "_blank")) && (o.document.title = o.document.body.innerText = "downloading..."), "string" == typeof t) return e(t, r, n);
          var s = "application/octet-stream" === t.type,
              c = /constructor/i.test(i.HTMLElement) || i.safari,
              u = /CriOS\/[\d]+/.test(navigator.userAgent);

          if ((u || s && c || a) && "undefined" != typeof FileReader) {
            var l = new FileReader();
            l.onloadend = function () {
              var t = l.result;
              t = u ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), o ? o.location.href = t : location = t, o = null;
            }, l.readAsDataURL(t);
          } else {
            var f = i.URL || i.webkitURL,
                h = f.createObjectURL(t);
            o ? o.location = h : location.href = h, o = null, setTimeout(function () {
              f.revokeObjectURL(h);
            }, 4e4);
          }
        });
        i.saveAs = s.saveAs = s, t.exports = s;
      }.apply(e, [])) || (t.exports = n);
    },
    8679: function _(t, e, r) {
      "use strict";

      var n = r(9864),
          o = {
        childContextTypes: !0,
        contextType: !0,
        contextTypes: !0,
        defaultProps: !0,
        displayName: !0,
        getDefaultProps: !0,
        getDerivedStateFromError: !0,
        getDerivedStateFromProps: !0,
        mixins: !0,
        propTypes: !0,
        type: !0
      },
          i = {
        name: !0,
        length: !0,
        prototype: !0,
        caller: !0,
        callee: !0,
        arguments: !0,
        arity: !0
      },
          a = {
        $$typeof: !0,
        compare: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0,
        type: !0
      },
          s = {};

      function c(t) {
        return n.isMemo(t) ? a : s[t.$$typeof] || o;
      }

      s[n.ForwardRef] = {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
      }, s[n.Memo] = a;
      var u = Object.defineProperty,
          l = Object.getOwnPropertyNames,
          f = Object.getOwnPropertySymbols,
          h = Object.getOwnPropertyDescriptor,
          p = Object.getPrototypeOf,
          d = Object.prototype;

      t.exports = function t(e, r, n) {
        if ("string" != typeof r) {
          if (d) {
            var o = p(r);
            o && o !== d && t(e, o, n);
          }

          var a = l(r);
          f && (a = a.concat(f(r)));

          for (var s = c(e), y = c(r), m = 0; m < a.length; ++m) {
            var v = a[m];

            if (!(i[v] || n && n[v] || y && y[v] || s && s[v])) {
              var g = h(r, v);

              try {
                u(e, v, g);
              } catch (t) {}
            }
          }
        }

        return e;
      };
    },
    645: function _(t, e) {
      e.read = function (t, e, r, n, o) {
        var i,
            a,
            s = 8 * o - n - 1,
            c = (1 << s) - 1,
            u = c >> 1,
            l = -7,
            f = r ? o - 1 : 0,
            h = r ? -1 : 1,
            p = t[e + f];

        for (f += h, i = p & (1 << -l) - 1, p >>= -l, l += s; l > 0; i = 256 * i + t[e + f], f += h, l -= 8) {
          ;
        }

        for (a = i & (1 << -l) - 1, i >>= -l, l += n; l > 0; a = 256 * a + t[e + f], f += h, l -= 8) {
          ;
        }

        if (0 === i) i = 1 - u;else {
          if (i === c) return a ? NaN : 1 / 0 * (p ? -1 : 1);
          a += Math.pow(2, n), i -= u;
        }
        return (p ? -1 : 1) * a * Math.pow(2, i - n);
      }, e.write = function (t, e, r, n, o, i) {
        var a,
            s,
            c,
            u = 8 * i - o - 1,
            l = (1 << u) - 1,
            f = l >> 1,
            h = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            p = n ? 0 : i - 1,
            d = n ? 1 : -1,
            y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

        for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = l) : (a = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -a)) < 1 && (a--, c *= 2), (e += a + f >= 1 ? h / c : h * Math.pow(2, 1 - f)) * c >= 2 && (a++, c /= 2), a + f >= l ? (s = 0, a = l) : a + f >= 1 ? (s = (e * c - 1) * Math.pow(2, o), a += f) : (s = e * Math.pow(2, f - 1) * Math.pow(2, o), a = 0)); o >= 8; t[r + p] = 255 & s, p += d, s /= 256, o -= 8) {
          ;
        }

        for (a = a << o | s, u += o; u > 0; t[r + p] = 255 & a, p += d, a /= 256, u -= 8) {
          ;
        }

        t[r + p - d] |= 128 * y;
      };
    },
    5733: function _(t, e, r) {
      var n = r(8764).Buffer;

      t.exports = function t(e, r, n) {
        function o(a, s) {
          if (!r[a]) {
            if (!e[a]) {
              if (i) return i(a, !0);
              var c = new Error("Cannot find module '" + a + "'");
              throw c.code = "MODULE_NOT_FOUND", c;
            }

            var u = r[a] = {
              exports: {}
            };
            e[a][0].call(u.exports, function (t) {
              return o(e[a][1][t] || t);
            }, u, u.exports, t, e, r, n);
          }

          return r[a].exports;
        }

        for (var i = void 0, a = 0; a < n.length; a++) {
          o(n[a]);
        }

        return o;
      }({
        1: [function (t, e, r) {
          "use strict";

          var n = t("./utils"),
              o = t("./support"),
              i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          r.encode = function (t) {
            for (var e, r, o, a, s, c, u, l = [], f = 0, h = t.length, p = h, d = "string" !== n.getTypeOf(t); f < t.length;) {
              p = h - f, o = d ? (e = t[f++], r = f < h ? t[f++] : 0, f < h ? t[f++] : 0) : (e = t.charCodeAt(f++), r = f < h ? t.charCodeAt(f++) : 0, f < h ? t.charCodeAt(f++) : 0), a = e >> 2, s = (3 & e) << 4 | r >> 4, c = 1 < p ? (15 & r) << 2 | o >> 6 : 64, u = 2 < p ? 63 & o : 64, l.push(i.charAt(a) + i.charAt(s) + i.charAt(c) + i.charAt(u));
            }

            return l.join("");
          }, r.decode = function (t) {
            var e,
                r,
                n,
                a,
                s,
                c,
                u = 0,
                l = 0,
                f = "data:";
            if (t.substr(0, f.length) === f) throw new Error("Invalid base64 input, it looks like a data url.");
            var h,
                p = 3 * (t = t.replace(/[^A-Za-z0-9\+\/\=]/g, "")).length / 4;
            if (t.charAt(t.length - 1) === i.charAt(64) && p--, t.charAt(t.length - 2) === i.charAt(64) && p--, p % 1 != 0) throw new Error("Invalid base64 input, bad content length.");

            for (h = o.uint8array ? new Uint8Array(0 | p) : new Array(0 | p); u < t.length;) {
              e = i.indexOf(t.charAt(u++)) << 2 | (a = i.indexOf(t.charAt(u++))) >> 4, r = (15 & a) << 4 | (s = i.indexOf(t.charAt(u++))) >> 2, n = (3 & s) << 6 | (c = i.indexOf(t.charAt(u++))), h[l++] = e, 64 !== s && (h[l++] = r), 64 !== c && (h[l++] = n);
            }

            return h;
          };
        }, {
          "./support": 30,
          "./utils": 32
        }],
        2: [function (t, e, r) {
          "use strict";

          var n = t("./external"),
              o = t("./stream/DataWorker"),
              i = t("./stream/Crc32Probe"),
              a = t("./stream/DataLengthProbe");

          function s(t, e, r, n, o) {
            this.compressedSize = t, this.uncompressedSize = e, this.crc32 = r, this.compression = n, this.compressedContent = o;
          }

          s.prototype = {
            getContentWorker: function getContentWorker() {
              var t = new o(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),
                  e = this;
              return t.on("end", function () {
                if (this.streamInfo.data_length !== e.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
              }), t;
            },
            getCompressedWorker: function getCompressedWorker() {
              return new o(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
            }
          }, s.createWorkerFrom = function (t, e, r) {
            return t.pipe(new i()).pipe(new a("uncompressedSize")).pipe(e.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", e);
          }, e.exports = s;
        }, {
          "./external": 6,
          "./stream/Crc32Probe": 25,
          "./stream/DataLengthProbe": 26,
          "./stream/DataWorker": 27
        }],
        3: [function (t, e, r) {
          "use strict";

          var n = t("./stream/GenericWorker");
          r.STORE = {
            magic: "\0\0",
            compressWorker: function compressWorker(t) {
              return new n("STORE compression");
            },
            uncompressWorker: function uncompressWorker() {
              return new n("STORE decompression");
            }
          }, r.DEFLATE = t("./flate");
        }, {
          "./flate": 7,
          "./stream/GenericWorker": 28
        }],
        4: [function (t, e, r) {
          "use strict";

          var n = t("./utils"),
              o = function () {
            for (var t, e = [], r = 0; r < 256; r++) {
              t = r;

              for (var n = 0; n < 8; n++) {
                t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
              }

              e[r] = t;
            }

            return e;
          }();

          e.exports = function (t, e) {
            return void 0 !== t && t.length ? "string" !== n.getTypeOf(t) ? function (t, e, r, n) {
              var i = o,
                  a = 0 + r;
              t ^= -1;

              for (var s = 0; s < a; s++) {
                t = t >>> 8 ^ i[255 & (t ^ e[s])];
              }

              return -1 ^ t;
            }(0 | e, t, t.length) : function (t, e, r, n) {
              var i = o,
                  a = 0 + r;
              t ^= -1;

              for (var s = 0; s < a; s++) {
                t = t >>> 8 ^ i[255 & (t ^ e.charCodeAt(s))];
              }

              return -1 ^ t;
            }(0 | e, t, t.length) : 0;
          };
        }, {
          "./utils": 32
        }],
        5: [function (t, e, r) {
          "use strict";

          r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
        }, {}],
        6: [function (t, e, r) {
          "use strict";

          var n;
          n = "undefined" != typeof Promise ? Promise : t("lie"), e.exports = {
            Promise: n
          };
        }, {
          lie: 37
        }],
        7: [function (t, e, r) {
          "use strict";

          var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array,
              o = t("pako"),
              i = t("./utils"),
              a = t("./stream/GenericWorker"),
              s = n ? "uint8array" : "array";

          function c(t, e) {
            a.call(this, "FlateWorker/" + t), this._pako = null, this._pakoAction = t, this._pakoOptions = e, this.meta = {};
          }

          r.magic = "\b\0", i.inherits(c, a), c.prototype.processChunk = function (t) {
            this.meta = t.meta, null === this._pako && this._createPako(), this._pako.push(i.transformTo(s, t.data), !1);
          }, c.prototype.flush = function () {
            a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
          }, c.prototype.cleanUp = function () {
            a.prototype.cleanUp.call(this), this._pako = null;
          }, c.prototype._createPako = function () {
            this._pako = new o[this._pakoAction]({
              raw: !0,
              level: this._pakoOptions.level || -1
            });
            var t = this;

            this._pako.onData = function (e) {
              t.push({
                data: e,
                meta: t.meta
              });
            };
          }, r.compressWorker = function (t) {
            return new c("Deflate", t);
          }, r.uncompressWorker = function () {
            return new c("Inflate", {});
          };
        }, {
          "./stream/GenericWorker": 28,
          "./utils": 32,
          pako: 38
        }],
        8: [function (t, e, r) {
          "use strict";

          function n(t, e) {
            var r,
                n = "";

            for (r = 0; r < e; r++) {
              n += String.fromCharCode(255 & t), t >>>= 8;
            }

            return n;
          }

          function o(t, e, r, o, a, l) {
            var f,
                h,
                p = t.file,
                d = t.compression,
                y = l !== s.utf8encode,
                m = i.transformTo("string", l(p.name)),
                v = i.transformTo("string", s.utf8encode(p.name)),
                g = p.comment,
                b = i.transformTo("string", l(g)),
                w = i.transformTo("string", s.utf8encode(g)),
                O = v.length !== p.name.length,
                _ = w.length !== g.length,
                x = "",
                L = "",
                E = "",
                A = p.dir,
                R = p.date,
                T = {
              crc32: 0,
              compressedSize: 0,
              uncompressedSize: 0
            };

            e && !r || (T.crc32 = t.crc32, T.compressedSize = t.compressedSize, T.uncompressedSize = t.uncompressedSize);
            var P = 0;
            e && (P |= 8), y || !O && !_ || (P |= 2048);
            var S = 0,
                k = 0;
            A && (S |= 16), "UNIX" === a ? (k = 798, S |= function (t, e) {
              var r = t;
              return t || (r = e ? 16893 : 33204), (65535 & r) << 16;
            }(p.unixPermissions, A)) : (k = 20, S |= function (t) {
              return 63 & (t || 0);
            }(p.dosPermissions)), f = R.getUTCHours(), f <<= 6, f |= R.getUTCMinutes(), f <<= 5, f |= R.getUTCSeconds() / 2, h = R.getUTCFullYear() - 1980, h <<= 4, h |= R.getUTCMonth() + 1, h <<= 5, h |= R.getUTCDate(), O && (L = n(1, 1) + n(c(m), 4) + v, x += "up" + n(L.length, 2) + L), _ && (E = n(1, 1) + n(c(b), 4) + w, x += "uc" + n(E.length, 2) + E);
            var j = "";
            return j += "\n\0", j += n(P, 2), j += d.magic, j += n(f, 2), j += n(h, 2), j += n(T.crc32, 4), j += n(T.compressedSize, 4), j += n(T.uncompressedSize, 4), j += n(m.length, 2), j += n(x.length, 2), {
              fileRecord: u.LOCAL_FILE_HEADER + j + m + x,
              dirRecord: u.CENTRAL_FILE_HEADER + n(k, 2) + j + n(b.length, 2) + "\0\0\0\0" + n(S, 4) + n(o, 4) + m + x + b
            };
          }

          var i = t("../utils"),
              a = t("../stream/GenericWorker"),
              s = t("../utf8"),
              c = t("../crc32"),
              u = t("../signature");

          function l(t, e, r, n) {
            a.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = e, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = t, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
          }

          i.inherits(l, a), l.prototype.push = function (t) {
            var e = t.meta.percent || 0,
                r = this.entriesCount,
                n = this._sources.length;
            this.accumulate ? this.contentBuffer.push(t) : (this.bytesWritten += t.data.length, a.prototype.push.call(this, {
              data: t.data,
              meta: {
                currentFile: this.currentFile,
                percent: r ? (e + 100 * (r - n - 1)) / r : 100
              }
            }));
          }, l.prototype.openedSource = function (t) {
            this.currentSourceOffset = this.bytesWritten, this.currentFile = t.file.name;
            var e = this.streamFiles && !t.file.dir;

            if (e) {
              var r = o(t, e, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
              this.push({
                data: r.fileRecord,
                meta: {
                  percent: 0
                }
              });
            } else this.accumulate = !0;
          }, l.prototype.closedSource = function (t) {
            this.accumulate = !1;
            var e = this.streamFiles && !t.file.dir,
                r = o(t, e, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
            if (this.dirRecords.push(r.dirRecord), e) this.push({
              data: function (t) {
                return u.DATA_DESCRIPTOR + n(t.crc32, 4) + n(t.compressedSize, 4) + n(t.uncompressedSize, 4);
              }(t),
              meta: {
                percent: 100
              }
            });else for (this.push({
              data: r.fileRecord,
              meta: {
                percent: 0
              }
            }); this.contentBuffer.length;) {
              this.push(this.contentBuffer.shift());
            }
            this.currentFile = null;
          }, l.prototype.flush = function () {
            for (var t = this.bytesWritten, e = 0; e < this.dirRecords.length; e++) {
              this.push({
                data: this.dirRecords[e],
                meta: {
                  percent: 100
                }
              });
            }

            var r = this.bytesWritten - t,
                o = function (t, e, r, o, a) {
              var s = i.transformTo("string", a(o));
              return u.CENTRAL_DIRECTORY_END + "\0\0\0\0" + n(t, 2) + n(t, 2) + n(e, 4) + n(r, 4) + n(s.length, 2) + s;
            }(this.dirRecords.length, r, t, this.zipComment, this.encodeFileName);

            this.push({
              data: o,
              meta: {
                percent: 100
              }
            });
          }, l.prototype.prepareNextSource = function () {
            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
          }, l.prototype.registerPrevious = function (t) {
            this._sources.push(t);

            var e = this;
            return t.on("data", function (t) {
              e.processChunk(t);
            }), t.on("end", function () {
              e.closedSource(e.previous.streamInfo), e._sources.length ? e.prepareNextSource() : e.end();
            }), t.on("error", function (t) {
              e.error(t);
            }), this;
          }, l.prototype.resume = function () {
            return !!a.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
          }, l.prototype.error = function (t) {
            var e = this._sources;
            if (!a.prototype.error.call(this, t)) return !1;

            for (var r = 0; r < e.length; r++) {
              try {
                e[r].error(t);
              } catch (t) {}
            }

            return !0;
          }, l.prototype.lock = function () {
            a.prototype.lock.call(this);

            for (var t = this._sources, e = 0; e < t.length; e++) {
              t[e].lock();
            }
          }, e.exports = l;
        }, {
          "../crc32": 4,
          "../signature": 23,
          "../stream/GenericWorker": 28,
          "../utf8": 31,
          "../utils": 32
        }],
        9: [function (t, e, r) {
          "use strict";

          var n = t("../compressions"),
              o = t("./ZipFileWorker");

          r.generateWorker = function (t, e, r) {
            var i = new o(e.streamFiles, r, e.platform, e.encodeFileName),
                a = 0;

            try {
              t.forEach(function (t, r) {
                a++;

                var o = function (t, e) {
                  var r = t || e,
                      o = n[r];
                  if (!o) throw new Error(r + " is not a valid compression method !");
                  return o;
                }(r.options.compression, e.compression),
                    s = r.options.compressionOptions || e.compressionOptions || {},
                    c = r.dir,
                    u = r.date;

                r._compressWorker(o, s).withStreamInfo("file", {
                  name: t,
                  dir: c,
                  date: u,
                  comment: r.comment || "",
                  unixPermissions: r.unixPermissions,
                  dosPermissions: r.dosPermissions
                }).pipe(i);
              }), i.entriesCount = a;
            } catch (t) {
              i.error(t);
            }

            return i;
          };
        }, {
          "../compressions": 3,
          "./ZipFileWorker": 8
        }],
        10: [function (t, e, r) {
          "use strict";

          function n() {
            if (!(this instanceof n)) return new n();
            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
            this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function () {
              var t = new n();

              for (var e in this) {
                "function" != typeof this[e] && (t[e] = this[e]);
              }

              return t;
            };
          }

          (n.prototype = t("./object")).loadAsync = t("./load"), n.support = t("./support"), n.defaults = t("./defaults"), n.version = "3.7.1", n.loadAsync = function (t, e) {
            return new n().loadAsync(t, e);
          }, n.external = t("./external"), e.exports = n;
        }, {
          "./defaults": 5,
          "./external": 6,
          "./load": 11,
          "./object": 15,
          "./support": 30
        }],
        11: [function (t, e, r) {
          "use strict";

          var n = t("./utils"),
              o = t("./external"),
              i = t("./utf8"),
              a = t("./zipEntries"),
              s = t("./stream/Crc32Probe"),
              c = t("./nodejsUtils");

          function u(t) {
            return new o.Promise(function (e, r) {
              var n = t.decompressed.getContentWorker().pipe(new s());
              n.on("error", function (t) {
                r(t);
              }).on("end", function () {
                n.streamInfo.crc32 !== t.decompressed.crc32 ? r(new Error("Corrupted zip : CRC32 mismatch")) : e();
              }).resume();
            });
          }

          e.exports = function (t, e) {
            var r = this;
            return e = n.extend(e || {}, {
              base64: !1,
              checkCRC32: !1,
              optimizedBinaryString: !1,
              createFolders: !1,
              decodeFileName: i.utf8decode
            }), c.isNode && c.isStream(t) ? o.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : n.prepareContent("the loaded zip file", t, !0, e.optimizedBinaryString, e.base64).then(function (t) {
              var r = new a(e);
              return r.load(t), r;
            }).then(function (t) {
              var r = [o.Promise.resolve(t)],
                  n = t.files;
              if (e.checkCRC32) for (var i = 0; i < n.length; i++) {
                r.push(u(n[i]));
              }
              return o.Promise.all(r);
            }).then(function (t) {
              for (var n = t.shift(), o = n.files, i = 0; i < o.length; i++) {
                var a = o[i];
                r.file(a.fileNameStr, a.decompressed, {
                  binary: !0,
                  optimizedBinaryString: !0,
                  date: a.date,
                  dir: a.dir,
                  comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                  unixPermissions: a.unixPermissions,
                  dosPermissions: a.dosPermissions,
                  createFolders: e.createFolders
                });
              }

              return n.zipComment.length && (r.comment = n.zipComment), r;
            });
          };
        }, {
          "./external": 6,
          "./nodejsUtils": 14,
          "./stream/Crc32Probe": 25,
          "./utf8": 31,
          "./utils": 32,
          "./zipEntries": 33
        }],
        12: [function (t, e, r) {
          "use strict";

          var n = t("../utils"),
              o = t("../stream/GenericWorker");

          function i(t, e) {
            o.call(this, "Nodejs stream input adapter for " + t), this._upstreamEnded = !1, this._bindStream(e);
          }

          n.inherits(i, o), i.prototype._bindStream = function (t) {
            var e = this;
            (this._stream = t).pause(), t.on("data", function (t) {
              e.push({
                data: t,
                meta: {
                  percent: 0
                }
              });
            }).on("error", function (t) {
              e.isPaused ? this.generatedError = t : e.error(t);
            }).on("end", function () {
              e.isPaused ? e._upstreamEnded = !0 : e.end();
            });
          }, i.prototype.pause = function () {
            return !!o.prototype.pause.call(this) && (this._stream.pause(), !0);
          }, i.prototype.resume = function () {
            return !!o.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
          }, e.exports = i;
        }, {
          "../stream/GenericWorker": 28,
          "../utils": 32
        }],
        13: [function (t, e, r) {
          "use strict";

          var n = t("readable-stream").Readable;

          function o(t, e, r) {
            n.call(this, e), this._helper = t;
            var o = this;
            t.on("data", function (t, e) {
              o.push(t) || o._helper.pause(), r && r(e);
            }).on("error", function (t) {
              o.emit("error", t);
            }).on("end", function () {
              o.push(null);
            });
          }

          t("../utils").inherits(o, n), o.prototype._read = function () {
            this._helper.resume();
          }, e.exports = o;
        }, {
          "../utils": 32,
          "readable-stream": 16
        }],
        14: [function (t, e, r) {
          "use strict";

          e.exports = {
            isNode: void 0 !== n,
            newBufferFrom: function newBufferFrom(t, e) {
              if (n.from && n.from !== Uint8Array.from) return n.from(t, e);
              if ("number" == typeof t) throw new Error('The "data" argument must not be a number');
              return new n(t, e);
            },
            allocBuffer: function allocBuffer(t) {
              if (n.alloc) return n.alloc(t);
              var e = new n(t);
              return e.fill(0), e;
            },
            isBuffer: function isBuffer(t) {
              return n.isBuffer(t);
            },
            isStream: function isStream(t) {
              return t && "function" == typeof t.on && "function" == typeof t.pause && "function" == typeof t.resume;
            }
          };
        }, {}],
        15: [function (t, e, r) {
          "use strict";

          function n(t, e, r) {
            var n,
                o = i.getTypeOf(e),
                s = i.extend(r || {}, c);
            s.date = s.date || new Date(), null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (t = y(t)), s.createFolders && (n = d(t)) && m.call(this, n, !0);
            var f = "string" === o && !1 === s.binary && !1 === s.base64;
            r && void 0 !== r.binary || (s.binary = !f), (e instanceof u && 0 === e.uncompressedSize || s.dir || !e || 0 === e.length) && (s.base64 = !1, s.binary = !0, e = "", s.compression = "STORE", o = "string");
            var v;
            v = e instanceof u || e instanceof a ? e : h.isNode && h.isStream(e) ? new p(t, e) : i.prepareContent(t, e, s.binary, s.optimizedBinaryString, s.base64);
            var g = new l(t, v, s);
            this.files[t] = g;
          }

          var o = t("./utf8"),
              i = t("./utils"),
              a = t("./stream/GenericWorker"),
              s = t("./stream/StreamHelper"),
              c = t("./defaults"),
              u = t("./compressedObject"),
              l = t("./zipObject"),
              f = t("./generate"),
              h = t("./nodejsUtils"),
              p = t("./nodejs/NodejsStreamInputAdapter"),
              d = function d(t) {
            "/" === t.slice(-1) && (t = t.substring(0, t.length - 1));
            var e = t.lastIndexOf("/");
            return 0 < e ? t.substring(0, e) : "";
          },
              y = function y(t) {
            return "/" !== t.slice(-1) && (t += "/"), t;
          },
              m = function m(t, e) {
            return e = void 0 !== e ? e : c.createFolders, t = y(t), this.files[t] || n.call(this, t, null, {
              dir: !0,
              createFolders: e
            }), this.files[t];
          };

          function v(t) {
            return "[object RegExp]" === Object.prototype.toString.call(t);
          }

          var g = {
            load: function load() {
              throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
            },
            forEach: function forEach(t) {
              var e, r, n;

              for (e in this.files) {
                n = this.files[e], (r = e.slice(this.root.length, e.length)) && e.slice(0, this.root.length) === this.root && t(r, n);
              }
            },
            filter: function filter(t) {
              var e = [];
              return this.forEach(function (r, n) {
                t(r, n) && e.push(n);
              }), e;
            },
            file: function file(t, e, r) {
              if (1 !== arguments.length) return t = this.root + t, n.call(this, t, e, r), this;

              if (v(t)) {
                var o = t;
                return this.filter(function (t, e) {
                  return !e.dir && o.test(t);
                });
              }

              var i = this.files[this.root + t];
              return i && !i.dir ? i : null;
            },
            folder: function folder(t) {
              if (!t) return this;
              if (v(t)) return this.filter(function (e, r) {
                return r.dir && t.test(e);
              });
              var e = this.root + t,
                  r = m.call(this, e),
                  n = this.clone();
              return n.root = r.name, n;
            },
            remove: function remove(t) {
              t = this.root + t;
              var e = this.files[t];
              if (e || ("/" !== t.slice(-1) && (t += "/"), e = this.files[t]), e && !e.dir) delete this.files[t];else for (var r = this.filter(function (e, r) {
                return r.name.slice(0, t.length) === t;
              }), n = 0; n < r.length; n++) {
                delete this.files[r[n].name];
              }
              return this;
            },
            generate: function generate(t) {
              throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
            },
            generateInternalStream: function generateInternalStream(t) {
              var e,
                  r = {};

              try {
                if ((r = i.extend(t || {}, {
                  streamFiles: !1,
                  compression: "STORE",
                  compressionOptions: null,
                  type: "",
                  platform: "DOS",
                  comment: null,
                  mimeType: "application/zip",
                  encodeFileName: o.utf8encode
                })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                i.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                var n = r.comment || this.comment || "";
                e = f.generateWorker(this, r, n);
              } catch (t) {
                (e = new a("error")).error(t);
              }

              return new s(e, r.type || "string", r.mimeType);
            },
            generateAsync: function generateAsync(t, e) {
              return this.generateInternalStream(t).accumulate(e);
            },
            generateNodeStream: function generateNodeStream(t, e) {
              return (t = t || {}).type || (t.type = "nodebuffer"), this.generateInternalStream(t).toNodejsStream(e);
            }
          };
          e.exports = g;
        }, {
          "./compressedObject": 2,
          "./defaults": 5,
          "./generate": 9,
          "./nodejs/NodejsStreamInputAdapter": 12,
          "./nodejsUtils": 14,
          "./stream/GenericWorker": 28,
          "./stream/StreamHelper": 29,
          "./utf8": 31,
          "./utils": 32,
          "./zipObject": 35
        }],
        16: [function (t, e, r) {
          e.exports = t("stream");
        }, {
          stream: void 0
        }],
        17: [function (t, e, r) {
          "use strict";

          var n = t("./DataReader");

          function o(t) {
            n.call(this, t);

            for (var e = 0; e < this.data.length; e++) {
              t[e] = 255 & t[e];
            }
          }

          t("../utils").inherits(o, n), o.prototype.byteAt = function (t) {
            return this.data[this.zero + t];
          }, o.prototype.lastIndexOfSignature = function (t) {
            for (var e = t.charCodeAt(0), r = t.charCodeAt(1), n = t.charCodeAt(2), o = t.charCodeAt(3), i = this.length - 4; 0 <= i; --i) {
              if (this.data[i] === e && this.data[i + 1] === r && this.data[i + 2] === n && this.data[i + 3] === o) return i - this.zero;
            }

            return -1;
          }, o.prototype.readAndCheckSignature = function (t) {
            var e = t.charCodeAt(0),
                r = t.charCodeAt(1),
                n = t.charCodeAt(2),
                o = t.charCodeAt(3),
                i = this.readData(4);
            return e === i[0] && r === i[1] && n === i[2] && o === i[3];
          }, o.prototype.readData = function (t) {
            if (this.checkOffset(t), 0 === t) return [];
            var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
            return this.index += t, e;
          }, e.exports = o;
        }, {
          "../utils": 32,
          "./DataReader": 18
        }],
        18: [function (t, e, r) {
          "use strict";

          var n = t("../utils");

          function o(t) {
            this.data = t, this.length = t.length, this.index = 0, this.zero = 0;
          }

          o.prototype = {
            checkOffset: function checkOffset(t) {
              this.checkIndex(this.index + t);
            },
            checkIndex: function checkIndex(t) {
              if (this.length < this.zero + t || t < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + t + "). Corrupted zip ?");
            },
            setIndex: function setIndex(t) {
              this.checkIndex(t), this.index = t;
            },
            skip: function skip(t) {
              this.setIndex(this.index + t);
            },
            byteAt: function byteAt(t) {},
            readInt: function readInt(t) {
              var e,
                  r = 0;

              for (this.checkOffset(t), e = this.index + t - 1; e >= this.index; e--) {
                r = (r << 8) + this.byteAt(e);
              }

              return this.index += t, r;
            },
            readString: function readString(t) {
              return n.transformTo("string", this.readData(t));
            },
            readData: function readData(t) {},
            lastIndexOfSignature: function lastIndexOfSignature(t) {},
            readAndCheckSignature: function readAndCheckSignature(t) {},
            readDate: function readDate() {
              var t = this.readInt(4);
              return new Date(Date.UTC(1980 + (t >> 25 & 127), (t >> 21 & 15) - 1, t >> 16 & 31, t >> 11 & 31, t >> 5 & 63, (31 & t) << 1));
            }
          }, e.exports = o;
        }, {
          "../utils": 32
        }],
        19: [function (t, e, r) {
          "use strict";

          var n = t("./Uint8ArrayReader");

          function o(t) {
            n.call(this, t);
          }

          t("../utils").inherits(o, n), o.prototype.readData = function (t) {
            this.checkOffset(t);
            var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
            return this.index += t, e;
          }, e.exports = o;
        }, {
          "../utils": 32,
          "./Uint8ArrayReader": 21
        }],
        20: [function (t, e, r) {
          "use strict";

          var n = t("./DataReader");

          function o(t) {
            n.call(this, t);
          }

          t("../utils").inherits(o, n), o.prototype.byteAt = function (t) {
            return this.data.charCodeAt(this.zero + t);
          }, o.prototype.lastIndexOfSignature = function (t) {
            return this.data.lastIndexOf(t) - this.zero;
          }, o.prototype.readAndCheckSignature = function (t) {
            return t === this.readData(4);
          }, o.prototype.readData = function (t) {
            this.checkOffset(t);
            var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
            return this.index += t, e;
          }, e.exports = o;
        }, {
          "../utils": 32,
          "./DataReader": 18
        }],
        21: [function (t, e, r) {
          "use strict";

          var n = t("./ArrayReader");

          function o(t) {
            n.call(this, t);
          }

          t("../utils").inherits(o, n), o.prototype.readData = function (t) {
            if (this.checkOffset(t), 0 === t) return new Uint8Array(0);
            var e = this.data.subarray(this.zero + this.index, this.zero + this.index + t);
            return this.index += t, e;
          }, e.exports = o;
        }, {
          "../utils": 32,
          "./ArrayReader": 17
        }],
        22: [function (t, e, r) {
          "use strict";

          var n = t("../utils"),
              o = t("../support"),
              i = t("./ArrayReader"),
              a = t("./StringReader"),
              s = t("./NodeBufferReader"),
              c = t("./Uint8ArrayReader");

          e.exports = function (t) {
            var e = n.getTypeOf(t);
            return n.checkSupport(e), "string" !== e || o.uint8array ? "nodebuffer" === e ? new s(t) : o.uint8array ? new c(n.transformTo("uint8array", t)) : new i(n.transformTo("array", t)) : new a(t);
          };
        }, {
          "../support": 30,
          "../utils": 32,
          "./ArrayReader": 17,
          "./NodeBufferReader": 19,
          "./StringReader": 20,
          "./Uint8ArrayReader": 21
        }],
        23: [function (t, e, r) {
          "use strict";

          r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
        }, {}],
        24: [function (t, e, r) {
          "use strict";

          var n = t("./GenericWorker"),
              o = t("../utils");

          function i(t) {
            n.call(this, "ConvertWorker to " + t), this.destType = t;
          }

          o.inherits(i, n), i.prototype.processChunk = function (t) {
            this.push({
              data: o.transformTo(this.destType, t.data),
              meta: t.meta
            });
          }, e.exports = i;
        }, {
          "../utils": 32,
          "./GenericWorker": 28
        }],
        25: [function (t, e, r) {
          "use strict";

          var n = t("./GenericWorker"),
              o = t("../crc32");

          function i() {
            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
          }

          t("../utils").inherits(i, n), i.prototype.processChunk = function (t) {
            this.streamInfo.crc32 = o(t.data, this.streamInfo.crc32 || 0), this.push(t);
          }, e.exports = i;
        }, {
          "../crc32": 4,
          "../utils": 32,
          "./GenericWorker": 28
        }],
        26: [function (t, e, r) {
          "use strict";

          var n = t("../utils"),
              o = t("./GenericWorker");

          function i(t) {
            o.call(this, "DataLengthProbe for " + t), this.propName = t, this.withStreamInfo(t, 0);
          }

          n.inherits(i, o), i.prototype.processChunk = function (t) {
            if (t) {
              var e = this.streamInfo[this.propName] || 0;
              this.streamInfo[this.propName] = e + t.data.length;
            }

            o.prototype.processChunk.call(this, t);
          }, e.exports = i;
        }, {
          "../utils": 32,
          "./GenericWorker": 28
        }],
        27: [function (t, e, r) {
          "use strict";

          var n = t("../utils"),
              o = t("./GenericWorker");

          function i(t) {
            o.call(this, "DataWorker");
            var e = this;
            this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, t.then(function (t) {
              e.dataIsReady = !0, e.data = t, e.max = t && t.length || 0, e.type = n.getTypeOf(t), e.isPaused || e._tickAndRepeat();
            }, function (t) {
              e.error(t);
            });
          }

          n.inherits(i, o), i.prototype.cleanUp = function () {
            o.prototype.cleanUp.call(this), this.data = null;
          }, i.prototype.resume = function () {
            return !!o.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
          }, i.prototype._tickAndRepeat = function () {
            this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
          }, i.prototype._tick = function () {
            if (this.isPaused || this.isFinished) return !1;
            var t = null,
                e = Math.min(this.max, this.index + 16384);
            if (this.index >= this.max) return this.end();

            switch (this.type) {
              case "string":
                t = this.data.substring(this.index, e);
                break;

              case "uint8array":
                t = this.data.subarray(this.index, e);
                break;

              case "array":
              case "nodebuffer":
                t = this.data.slice(this.index, e);
            }

            return this.index = e, this.push({
              data: t,
              meta: {
                percent: this.max ? this.index / this.max * 100 : 0
              }
            });
          }, e.exports = i;
        }, {
          "../utils": 32,
          "./GenericWorker": 28
        }],
        28: [function (t, e, r) {
          "use strict";

          function n(t) {
            this.name = t || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
              data: [],
              end: [],
              error: []
            }, this.previous = null;
          }

          n.prototype = {
            push: function push(t) {
              this.emit("data", t);
            },
            end: function end() {
              if (this.isFinished) return !1;
              this.flush();

              try {
                this.emit("end"), this.cleanUp(), this.isFinished = !0;
              } catch (t) {
                this.emit("error", t);
              }

              return !0;
            },
            error: function error(t) {
              return !this.isFinished && (this.isPaused ? this.generatedError = t : (this.isFinished = !0, this.emit("error", t), this.previous && this.previous.error(t), this.cleanUp()), !0);
            },
            on: function on(t, e) {
              return this._listeners[t].push(e), this;
            },
            cleanUp: function cleanUp() {
              this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
            },
            emit: function emit(t, e) {
              if (this._listeners[t]) for (var r = 0; r < this._listeners[t].length; r++) {
                this._listeners[t][r].call(this, e);
              }
            },
            pipe: function pipe(t) {
              return t.registerPrevious(this);
            },
            registerPrevious: function registerPrevious(t) {
              if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
              this.streamInfo = t.streamInfo, this.mergeStreamInfo(), this.previous = t;
              var e = this;
              return t.on("data", function (t) {
                e.processChunk(t);
              }), t.on("end", function () {
                e.end();
              }), t.on("error", function (t) {
                e.error(t);
              }), this;
            },
            pause: function pause() {
              return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
            },
            resume: function resume() {
              if (!this.isPaused || this.isFinished) return !1;
              var t = this.isPaused = !1;
              return this.generatedError && (this.error(this.generatedError), t = !0), this.previous && this.previous.resume(), !t;
            },
            flush: function flush() {},
            processChunk: function processChunk(t) {
              this.push(t);
            },
            withStreamInfo: function withStreamInfo(t, e) {
              return this.extraStreamInfo[t] = e, this.mergeStreamInfo(), this;
            },
            mergeStreamInfo: function mergeStreamInfo() {
              for (var t in this.extraStreamInfo) {
                this.extraStreamInfo.hasOwnProperty(t) && (this.streamInfo[t] = this.extraStreamInfo[t]);
              }
            },
            lock: function lock() {
              if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
              this.isLocked = !0, this.previous && this.previous.lock();
            },
            toString: function toString() {
              var t = "Worker " + this.name;
              return this.previous ? this.previous + " -> " + t : t;
            }
          }, e.exports = n;
        }, {}],
        29: [function (t, e, r) {
          "use strict";

          var o = t("../utils"),
              i = t("./ConvertWorker"),
              a = t("./GenericWorker"),
              s = t("../base64"),
              c = t("../support"),
              u = t("../external"),
              l = null;
          if (c.nodestream) try {
            l = t("../nodejs/NodejsStreamOutputAdapter");
          } catch (t) {}

          function f(t, e, r) {
            var n = e;

            switch (e) {
              case "blob":
              case "arraybuffer":
                n = "uint8array";
                break;

              case "base64":
                n = "string";
            }

            try {
              this._internalType = n, this._outputType = e, this._mimeType = r, o.checkSupport(n), this._worker = t.pipe(new i(n)), t.lock();
            } catch (t) {
              this._worker = new a("error"), this._worker.error(t);
            }
          }

          f.prototype = {
            accumulate: function accumulate(t) {
              return function (t, e) {
                return new u.Promise(function (r, i) {
                  var a = [],
                      c = t._internalType,
                      u = t._outputType,
                      l = t._mimeType;
                  t.on("data", function (t, r) {
                    a.push(t), e && e(r);
                  }).on("error", function (t) {
                    a = [], i(t);
                  }).on("end", function () {
                    try {
                      var t = function (t, e, r) {
                        switch (t) {
                          case "blob":
                            return o.newBlob(o.transformTo("arraybuffer", e), r);

                          case "base64":
                            return s.encode(e);

                          default:
                            return o.transformTo(t, e);
                        }
                      }(u, function (t, e) {
                        var r,
                            o = 0,
                            i = null,
                            a = 0;

                        for (r = 0; r < e.length; r++) {
                          a += e[r].length;
                        }

                        switch (t) {
                          case "string":
                            return e.join("");

                          case "array":
                            return Array.prototype.concat.apply([], e);

                          case "uint8array":
                            for (i = new Uint8Array(a), r = 0; r < e.length; r++) {
                              i.set(e[r], o), o += e[r].length;
                            }

                            return i;

                          case "nodebuffer":
                            return n.concat(e);

                          default:
                            throw new Error("concat : unsupported type '" + t + "'");
                        }
                      }(c, a), l);

                      r(t);
                    } catch (t) {
                      i(t);
                    }

                    a = [];
                  }).resume();
                });
              }(this, t);
            },
            on: function on(t, e) {
              var r = this;
              return "data" === t ? this._worker.on(t, function (t) {
                e.call(r, t.data, t.meta);
              }) : this._worker.on(t, function () {
                o.delay(e, arguments, r);
              }), this;
            },
            resume: function resume() {
              return o.delay(this._worker.resume, [], this._worker), this;
            },
            pause: function pause() {
              return this._worker.pause(), this;
            },
            toNodejsStream: function toNodejsStream(t) {
              if (o.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
              return new l(this, {
                objectMode: "nodebuffer" !== this._outputType
              }, t);
            }
          }, e.exports = f;
        }, {
          "../base64": 1,
          "../external": 6,
          "../nodejs/NodejsStreamOutputAdapter": 13,
          "../support": 30,
          "../utils": 32,
          "./ConvertWorker": 24,
          "./GenericWorker": 28
        }],
        30: [function (t, e, r) {
          "use strict";

          if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = void 0 !== n, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;else {
            var o = new ArrayBuffer(0);

            try {
              r.blob = 0 === new Blob([o], {
                type: "application/zip"
              }).size;
            } catch (t) {
              try {
                var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                i.append(o), r.blob = 0 === i.getBlob("application/zip").size;
              } catch (t) {
                r.blob = !1;
              }
            }
          }

          try {
            r.nodestream = !!t("readable-stream").Readable;
          } catch (t) {
            r.nodestream = !1;
          }
        }, {
          "readable-stream": 16
        }],
        31: [function (t, e, r) {
          "use strict";

          for (var n = t("./utils"), o = t("./support"), i = t("./nodejsUtils"), a = t("./stream/GenericWorker"), s = new Array(256), c = 0; c < 256; c++) {
            s[c] = 252 <= c ? 6 : 248 <= c ? 5 : 240 <= c ? 4 : 224 <= c ? 3 : 192 <= c ? 2 : 1;
          }

          function u() {
            a.call(this, "utf-8 decode"), this.leftOver = null;
          }

          function l() {
            a.call(this, "utf-8 encode");
          }

          s[254] = s[254] = 1, r.utf8encode = function (t) {
            return o.nodebuffer ? i.newBufferFrom(t, "utf-8") : function (t) {
              var e,
                  r,
                  n,
                  i,
                  a,
                  s = t.length,
                  c = 0;

              for (i = 0; i < s; i++) {
                55296 == (64512 & (r = t.charCodeAt(i))) && i + 1 < s && 56320 == (64512 & (n = t.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), c += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
              }

              for (e = o.uint8array ? new Uint8Array(c) : new Array(c), i = a = 0; a < c; i++) {
                55296 == (64512 & (r = t.charCodeAt(i))) && i + 1 < s && 56320 == (64512 & (n = t.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? e[a++] = r : (r < 2048 ? e[a++] = 192 | r >>> 6 : (r < 65536 ? e[a++] = 224 | r >>> 12 : (e[a++] = 240 | r >>> 18, e[a++] = 128 | r >>> 12 & 63), e[a++] = 128 | r >>> 6 & 63), e[a++] = 128 | 63 & r);
              }

              return e;
            }(t);
          }, r.utf8decode = function (t) {
            return o.nodebuffer ? n.transformTo("nodebuffer", t).toString("utf-8") : function (t) {
              var e,
                  r,
                  o,
                  i,
                  a = t.length,
                  c = new Array(2 * a);

              for (e = r = 0; e < a;) {
                if ((o = t[e++]) < 128) c[r++] = o;else if (4 < (i = s[o])) c[r++] = 65533, e += i - 1;else {
                  for (o &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && e < a;) {
                    o = o << 6 | 63 & t[e++], i--;
                  }

                  1 < i ? c[r++] = 65533 : o < 65536 ? c[r++] = o : (o -= 65536, c[r++] = 55296 | o >> 10 & 1023, c[r++] = 56320 | 1023 & o);
                }
              }

              return c.length !== r && (c.subarray ? c = c.subarray(0, r) : c.length = r), n.applyFromCharCode(c);
            }(t = n.transformTo(o.uint8array ? "uint8array" : "array", t));
          }, n.inherits(u, a), u.prototype.processChunk = function (t) {
            var e = n.transformTo(o.uint8array ? "uint8array" : "array", t.data);

            if (this.leftOver && this.leftOver.length) {
              if (o.uint8array) {
                var i = e;
                (e = new Uint8Array(i.length + this.leftOver.length)).set(this.leftOver, 0), e.set(i, this.leftOver.length);
              } else e = this.leftOver.concat(e);

              this.leftOver = null;
            }

            var a = function (t, e) {
              var r;

              for ((e = e || t.length) > t.length && (e = t.length), r = e - 1; 0 <= r && 128 == (192 & t[r]);) {
                r--;
              }

              return r < 0 || 0 === r ? e : r + s[t[r]] > e ? r : e;
            }(e),
                c = e;

            a !== e.length && (o.uint8array ? (c = e.subarray(0, a), this.leftOver = e.subarray(a, e.length)) : (c = e.slice(0, a), this.leftOver = e.slice(a, e.length))), this.push({
              data: r.utf8decode(c),
              meta: t.meta
            });
          }, u.prototype.flush = function () {
            this.leftOver && this.leftOver.length && (this.push({
              data: r.utf8decode(this.leftOver),
              meta: {}
            }), this.leftOver = null);
          }, r.Utf8DecodeWorker = u, n.inherits(l, a), l.prototype.processChunk = function (t) {
            this.push({
              data: r.utf8encode(t.data),
              meta: t.meta
            });
          }, r.Utf8EncodeWorker = l;
        }, {
          "./nodejsUtils": 14,
          "./stream/GenericWorker": 28,
          "./support": 30,
          "./utils": 32
        }],
        32: [function (t, e, r) {
          "use strict";

          var n = t("./support"),
              o = t("./base64"),
              i = t("./nodejsUtils"),
              a = t("set-immediate-shim"),
              s = t("./external");

          function c(t) {
            return t;
          }

          function u(t, e) {
            for (var r = 0; r < t.length; ++r) {
              e[r] = 255 & t.charCodeAt(r);
            }

            return e;
          }

          r.newBlob = function (t, e) {
            r.checkSupport("blob");

            try {
              return new Blob([t], {
                type: e
              });
            } catch (r) {
              try {
                var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                return n.append(t), n.getBlob(e);
              } catch (t) {
                throw new Error("Bug : can't construct the Blob.");
              }
            }
          };

          var l = {
            stringifyByChunk: function stringifyByChunk(t, e, r) {
              var n = [],
                  o = 0,
                  i = t.length;
              if (i <= r) return String.fromCharCode.apply(null, t);

              for (; o < i;) {
                "array" === e || "nodebuffer" === e ? n.push(String.fromCharCode.apply(null, t.slice(o, Math.min(o + r, i)))) : n.push(String.fromCharCode.apply(null, t.subarray(o, Math.min(o + r, i)))), o += r;
              }

              return n.join("");
            },
            stringifyByChar: function stringifyByChar(t) {
              for (var e = "", r = 0; r < t.length; r++) {
                e += String.fromCharCode(t[r]);
              }

              return e;
            },
            applyCanBeUsed: {
              uint8array: function () {
                try {
                  return n.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                } catch (t) {
                  return !1;
                }
              }(),
              nodebuffer: function () {
                try {
                  return n.nodebuffer && 1 === String.fromCharCode.apply(null, i.allocBuffer(1)).length;
                } catch (t) {
                  return !1;
                }
              }()
            }
          };

          function f(t) {
            var e = 65536,
                n = r.getTypeOf(t),
                o = !0;
            if ("uint8array" === n ? o = l.applyCanBeUsed.uint8array : "nodebuffer" === n && (o = l.applyCanBeUsed.nodebuffer), o) for (; 1 < e;) {
              try {
                return l.stringifyByChunk(t, n, e);
              } catch (t) {
                e = Math.floor(e / 2);
              }
            }
            return l.stringifyByChar(t);
          }

          function h(t, e) {
            for (var r = 0; r < t.length; r++) {
              e[r] = t[r];
            }

            return e;
          }

          r.applyFromCharCode = f;
          var p = {};
          p.string = {
            string: c,
            array: function array(t) {
              return u(t, new Array(t.length));
            },
            arraybuffer: function arraybuffer(t) {
              return p.string.uint8array(t).buffer;
            },
            uint8array: function uint8array(t) {
              return u(t, new Uint8Array(t.length));
            },
            nodebuffer: function nodebuffer(t) {
              return u(t, i.allocBuffer(t.length));
            }
          }, p.array = {
            string: f,
            array: c,
            arraybuffer: function arraybuffer(t) {
              return new Uint8Array(t).buffer;
            },
            uint8array: function uint8array(t) {
              return new Uint8Array(t);
            },
            nodebuffer: function nodebuffer(t) {
              return i.newBufferFrom(t);
            }
          }, p.arraybuffer = {
            string: function string(t) {
              return f(new Uint8Array(t));
            },
            array: function array(t) {
              return h(new Uint8Array(t), new Array(t.byteLength));
            },
            arraybuffer: c,
            uint8array: function uint8array(t) {
              return new Uint8Array(t);
            },
            nodebuffer: function nodebuffer(t) {
              return i.newBufferFrom(new Uint8Array(t));
            }
          }, p.uint8array = {
            string: f,
            array: function array(t) {
              return h(t, new Array(t.length));
            },
            arraybuffer: function arraybuffer(t) {
              return t.buffer;
            },
            uint8array: c,
            nodebuffer: function nodebuffer(t) {
              return i.newBufferFrom(t);
            }
          }, p.nodebuffer = {
            string: f,
            array: function array(t) {
              return h(t, new Array(t.length));
            },
            arraybuffer: function arraybuffer(t) {
              return p.nodebuffer.uint8array(t).buffer;
            },
            uint8array: function uint8array(t) {
              return h(t, new Uint8Array(t.length));
            },
            nodebuffer: c
          }, r.transformTo = function (t, e) {
            if (e = e || "", !t) return e;
            r.checkSupport(t);
            var n = r.getTypeOf(e);
            return p[n][t](e);
          }, r.getTypeOf = function (t) {
            return "string" == typeof t ? "string" : "[object Array]" === Object.prototype.toString.call(t) ? "array" : n.nodebuffer && i.isBuffer(t) ? "nodebuffer" : n.uint8array && t instanceof Uint8Array ? "uint8array" : n.arraybuffer && t instanceof ArrayBuffer ? "arraybuffer" : void 0;
          }, r.checkSupport = function (t) {
            if (!n[t.toLowerCase()]) throw new Error(t + " is not supported by this platform");
          }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function (t) {
            var e,
                r,
                n = "";

            for (r = 0; r < (t || "").length; r++) {
              n += "\\x" + ((e = t.charCodeAt(r)) < 16 ? "0" : "") + e.toString(16).toUpperCase();
            }

            return n;
          }, r.delay = function (t, e, r) {
            a(function () {
              t.apply(r || null, e || []);
            });
          }, r.inherits = function (t, e) {
            function r() {}

            r.prototype = e.prototype, t.prototype = new r();
          }, r.extend = function () {
            var t,
                e,
                r = {};

            for (t = 0; t < arguments.length; t++) {
              for (e in arguments[t]) {
                arguments[t].hasOwnProperty(e) && void 0 === r[e] && (r[e] = arguments[t][e]);
              }
            }

            return r;
          }, r.prepareContent = function (t, e, i, a, c) {
            return s.Promise.resolve(e).then(function (t) {
              return n.blob && (t instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(t))) && "undefined" != typeof FileReader ? new s.Promise(function (e, r) {
                var n = new FileReader();
                n.onload = function (t) {
                  e(t.target.result);
                }, n.onerror = function (t) {
                  r(t.target.error);
                }, n.readAsArrayBuffer(t);
              }) : t;
            }).then(function (e) {
              var l = r.getTypeOf(e);
              return l ? ("arraybuffer" === l ? e = r.transformTo("uint8array", e) : "string" === l && (c ? e = o.decode(e) : i && !0 !== a && (e = function (t) {
                return u(t, n.uint8array ? new Uint8Array(t.length) : new Array(t.length));
              }(e))), e) : s.Promise.reject(new Error("Can't read the data of '" + t + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
            });
          };
        }, {
          "./base64": 1,
          "./external": 6,
          "./nodejsUtils": 14,
          "./support": 30,
          "set-immediate-shim": 54
        }],
        33: [function (t, e, r) {
          "use strict";

          var n = t("./reader/readerFor"),
              o = t("./utils"),
              i = t("./signature"),
              a = t("./zipEntry"),
              s = (t("./utf8"), t("./support"));

          function c(t) {
            this.files = [], this.loadOptions = t;
          }

          c.prototype = {
            checkSignature: function checkSignature(t) {
              if (!this.reader.readAndCheckSignature(t)) {
                this.reader.index -= 4;
                var e = this.reader.readString(4);
                throw new Error("Corrupted zip or bug: unexpected signature (" + o.pretty(e) + ", expected " + o.pretty(t) + ")");
              }
            },
            isSignature: function isSignature(t, e) {
              var r = this.reader.index;
              this.reader.setIndex(t);
              var n = this.reader.readString(4) === e;
              return this.reader.setIndex(r), n;
            },
            readBlockEndOfCentral: function readBlockEndOfCentral() {
              this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
              var t = this.reader.readData(this.zipCommentLength),
                  e = s.uint8array ? "uint8array" : "array",
                  r = o.transformTo(e, t);
              this.zipComment = this.loadOptions.decodeFileName(r);
            },
            readBlockZip64EndOfCentral: function readBlockZip64EndOfCentral() {
              this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};

              for (var t, e, r, n = this.zip64EndOfCentralSize - 44; 0 < n;) {
                t = this.reader.readInt(2), e = this.reader.readInt(4), r = this.reader.readData(e), this.zip64ExtensibleData[t] = {
                  id: t,
                  length: e,
                  value: r
                };
              }
            },
            readBlockZip64EndOfCentralLocator: function readBlockZip64EndOfCentralLocator() {
              if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
            },
            readLocalFiles: function readLocalFiles() {
              var t, e;

              for (t = 0; t < this.files.length; t++) {
                e = this.files[t], this.reader.setIndex(e.localHeaderOffset), this.checkSignature(i.LOCAL_FILE_HEADER), e.readLocalPart(this.reader), e.handleUTF8(), e.processAttributes();
              }
            },
            readCentralDir: function readCentralDir() {
              var t;

              for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(i.CENTRAL_FILE_HEADER);) {
                (t = new a({
                  zip64: this.zip64
                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(t);
              }

              if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            },
            readEndOfCentral: function readEndOfCentral() {
              var t = this.reader.lastIndexOfSignature(i.CENTRAL_DIRECTORY_END);
              if (t < 0) throw this.isSignature(0, i.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
              this.reader.setIndex(t);
              var e = t;

              if (this.checkSignature(i.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === o.MAX_VALUE_16BITS || this.diskWithCentralDirStart === o.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === o.MAX_VALUE_16BITS || this.centralDirRecords === o.MAX_VALUE_16BITS || this.centralDirSize === o.MAX_VALUE_32BITS || this.centralDirOffset === o.MAX_VALUE_32BITS) {
                if (this.zip64 = !0, (t = this.reader.lastIndexOfSignature(i.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                if (this.reader.setIndex(t), this.checkSignature(i.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, i.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(i.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(i.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
              }

              var r = this.centralDirOffset + this.centralDirSize;
              this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
              var n = e - r;
              if (0 < n) this.isSignature(e, i.CENTRAL_FILE_HEADER) || (this.reader.zero = n);else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
            },
            prepareReader: function prepareReader(t) {
              this.reader = n(t);
            },
            load: function load(t) {
              this.prepareReader(t), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
            }
          }, e.exports = c;
        }, {
          "./reader/readerFor": 22,
          "./signature": 23,
          "./support": 30,
          "./utf8": 31,
          "./utils": 32,
          "./zipEntry": 34
        }],
        34: [function (t, e, r) {
          "use strict";

          var n = t("./reader/readerFor"),
              o = t("./utils"),
              i = t("./compressedObject"),
              a = t("./crc32"),
              s = t("./utf8"),
              c = t("./compressions"),
              u = t("./support");

          function l(t, e) {
            this.options = t, this.loadOptions = e;
          }

          l.prototype = {
            isEncrypted: function isEncrypted() {
              return 1 == (1 & this.bitFlag);
            },
            useUTF8: function useUTF8() {
              return 2048 == (2048 & this.bitFlag);
            },
            readLocalPart: function readLocalPart(t) {
              var e, r;
              if (t.skip(22), this.fileNameLength = t.readInt(2), r = t.readInt(2), this.fileName = t.readData(this.fileNameLength), t.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
              if (null === (e = function (t) {
                for (var e in c) {
                  if (c.hasOwnProperty(e) && c[e].magic === t) return c[e];
                }

                return null;
              }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + o.pretty(this.compressionMethod) + " unknown (inner file : " + o.transformTo("string", this.fileName) + ")");
              this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, e, t.readData(this.compressedSize));
            },
            readCentralPart: function readCentralPart(t) {
              this.versionMadeBy = t.readInt(2), t.skip(2), this.bitFlag = t.readInt(2), this.compressionMethod = t.readString(2), this.date = t.readDate(), this.crc32 = t.readInt(4), this.compressedSize = t.readInt(4), this.uncompressedSize = t.readInt(4);
              var e = t.readInt(2);
              if (this.extraFieldsLength = t.readInt(2), this.fileCommentLength = t.readInt(2), this.diskNumberStart = t.readInt(2), this.internalFileAttributes = t.readInt(2), this.externalFileAttributes = t.readInt(4), this.localHeaderOffset = t.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
              t.skip(e), this.readExtraFields(t), this.parseZIP64ExtraField(t), this.fileComment = t.readData(this.fileCommentLength);
            },
            processAttributes: function processAttributes() {
              this.unixPermissions = null, this.dosPermissions = null;
              var t = this.versionMadeBy >> 8;
              this.dir = !!(16 & this.externalFileAttributes), 0 == t && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == t && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
            },
            parseZIP64ExtraField: function parseZIP64ExtraField(t) {
              if (this.extraFields[1]) {
                var e = n(this.extraFields[1].value);
                this.uncompressedSize === o.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === o.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === o.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === o.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
              }
            },
            readExtraFields: function readExtraFields(t) {
              var e,
                  r,
                  n,
                  o = t.index + this.extraFieldsLength;

              for (this.extraFields || (this.extraFields = {}); t.index + 4 < o;) {
                e = t.readInt(2), r = t.readInt(2), n = t.readData(r), this.extraFields[e] = {
                  id: e,
                  length: r,
                  value: n
                };
              }

              t.setIndex(o);
            },
            handleUTF8: function handleUTF8() {
              var t = u.uint8array ? "uint8array" : "array";
              if (this.useUTF8()) this.fileNameStr = s.utf8decode(this.fileName), this.fileCommentStr = s.utf8decode(this.fileComment);else {
                var e = this.findExtraFieldUnicodePath();
                if (null !== e) this.fileNameStr = e;else {
                  var r = o.transformTo(t, this.fileName);
                  this.fileNameStr = this.loadOptions.decodeFileName(r);
                }
                var n = this.findExtraFieldUnicodeComment();
                if (null !== n) this.fileCommentStr = n;else {
                  var i = o.transformTo(t, this.fileComment);
                  this.fileCommentStr = this.loadOptions.decodeFileName(i);
                }
              }
            },
            findExtraFieldUnicodePath: function findExtraFieldUnicodePath() {
              var t = this.extraFields[28789];

              if (t) {
                var e = n(t.value);
                return 1 !== e.readInt(1) || a(this.fileName) !== e.readInt(4) ? null : s.utf8decode(e.readData(t.length - 5));
              }

              return null;
            },
            findExtraFieldUnicodeComment: function findExtraFieldUnicodeComment() {
              var t = this.extraFields[25461];

              if (t) {
                var e = n(t.value);
                return 1 !== e.readInt(1) || a(this.fileComment) !== e.readInt(4) ? null : s.utf8decode(e.readData(t.length - 5));
              }

              return null;
            }
          }, e.exports = l;
        }, {
          "./compressedObject": 2,
          "./compressions": 3,
          "./crc32": 4,
          "./reader/readerFor": 22,
          "./support": 30,
          "./utf8": 31,
          "./utils": 32
        }],
        35: [function (t, e, r) {
          "use strict";

          function n(t, e, r) {
            this.name = t, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = e, this._dataBinary = r.binary, this.options = {
              compression: r.compression,
              compressionOptions: r.compressionOptions
            };
          }

          var o = t("./stream/StreamHelper"),
              i = t("./stream/DataWorker"),
              a = t("./utf8"),
              s = t("./compressedObject"),
              c = t("./stream/GenericWorker");
          n.prototype = {
            internalStream: function internalStream(t) {
              var e = null,
                  r = "string";

              try {
                if (!t) throw new Error("No output type specified.");
                var n = "string" === (r = t.toLowerCase()) || "text" === r;
                "binarystring" !== r && "text" !== r || (r = "string"), e = this._decompressWorker();
                var i = !this._dataBinary;
                i && !n && (e = e.pipe(new a.Utf8EncodeWorker())), !i && n && (e = e.pipe(new a.Utf8DecodeWorker()));
              } catch (t) {
                (e = new c("error")).error(t);
              }

              return new o(e, r, "");
            },
            async: function async(t, e) {
              return this.internalStream(t).accumulate(e);
            },
            nodeStream: function nodeStream(t, e) {
              return this.internalStream(t || "nodebuffer").toNodejsStream(e);
            },
            _compressWorker: function _compressWorker(t, e) {
              if (this._data instanceof s && this._data.compression.magic === t.magic) return this._data.getCompressedWorker();

              var r = this._decompressWorker();

              return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker())), s.createWorkerFrom(r, t, e);
            },
            _decompressWorker: function _decompressWorker() {
              return this._data instanceof s ? this._data.getContentWorker() : this._data instanceof c ? this._data : new i(this._data);
            }
          };

          for (var u = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], l = function l() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, f = 0; f < u.length; f++) {
            n.prototype[u[f]] = l;
          }

          e.exports = n;
        }, {
          "./compressedObject": 2,
          "./stream/DataWorker": 27,
          "./stream/GenericWorker": 28,
          "./stream/StreamHelper": 29,
          "./utf8": 31
        }],
        36: [function (t, e, n) {
          (function (t) {
            "use strict";

            var r,
                n,
                o = t.MutationObserver || t.WebKitMutationObserver;

            if (o) {
              var i = 0,
                  a = new o(l),
                  s = t.document.createTextNode("");
              a.observe(s, {
                characterData: !0
              }), r = function r() {
                s.data = i = ++i % 2;
              };
            } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function () {
              var e = t.document.createElement("script");
              e.onreadystatechange = function () {
                l(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
              }, t.document.documentElement.appendChild(e);
            } : function () {
              setTimeout(l, 0);
            };else {
              var c = new t.MessageChannel();
              c.port1.onmessage = l, r = function r() {
                c.port2.postMessage(0);
              };
            }

            var u = [];

            function l() {
              var t, e;
              n = !0;

              for (var r = u.length; r;) {
                for (e = u, u = [], t = -1; ++t < r;) {
                  e[t]();
                }

                r = u.length;
              }

              n = !1;
            }

            e.exports = function (t) {
              1 !== u.push(t) || n || r();
            };
          }).call(this, void 0 !== r.g ? r.g : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}],
        37: [function (t, e, r) {
          "use strict";

          var n = t("immediate");

          function o() {}

          var i = {},
              a = ["REJECTED"],
              s = ["FULFILLED"],
              c = ["PENDING"];

          function u(t) {
            if ("function" != typeof t) throw new TypeError("resolver must be a function");
            this.state = c, this.queue = [], this.outcome = void 0, t !== o && p(this, t);
          }

          function l(t, e, r) {
            this.promise = t, "function" == typeof e && (this.onFulfilled = e, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
          }

          function f(t, e, r) {
            n(function () {
              var n;

              try {
                n = e(r);
              } catch (n) {
                return i.reject(t, n);
              }

              n === t ? i.reject(t, new TypeError("Cannot resolve promise with itself")) : i.resolve(t, n);
            });
          }

          function h(t) {
            var e = t && t.then;
            if (t && ("object" == typeof t || "function" == typeof t) && "function" == typeof e) return function () {
              e.apply(t, arguments);
            };
          }

          function p(t, e) {
            var r = !1;

            function n(e) {
              r || (r = !0, i.reject(t, e));
            }

            function o(e) {
              r || (r = !0, i.resolve(t, e));
            }

            var a = d(function () {
              e(o, n);
            });
            "error" === a.status && n(a.value);
          }

          function d(t, e) {
            var r = {};

            try {
              r.value = t(e), r.status = "success";
            } catch (t) {
              r.status = "error", r.value = t;
            }

            return r;
          }

          (e.exports = u).prototype.finally = function (t) {
            if ("function" != typeof t) return this;
            var e = this.constructor;
            return this.then(function (r) {
              return e.resolve(t()).then(function () {
                return r;
              });
            }, function (r) {
              return e.resolve(t()).then(function () {
                throw r;
              });
            });
          }, u.prototype.catch = function (t) {
            return this.then(null, t);
          }, u.prototype.then = function (t, e) {
            if ("function" != typeof t && this.state === s || "function" != typeof e && this.state === a) return this;
            var r = new this.constructor(o);
            return this.state !== c ? f(r, this.state === s ? t : e, this.outcome) : this.queue.push(new l(r, t, e)), r;
          }, l.prototype.callFulfilled = function (t) {
            i.resolve(this.promise, t);
          }, l.prototype.otherCallFulfilled = function (t) {
            f(this.promise, this.onFulfilled, t);
          }, l.prototype.callRejected = function (t) {
            i.reject(this.promise, t);
          }, l.prototype.otherCallRejected = function (t) {
            f(this.promise, this.onRejected, t);
          }, i.resolve = function (t, e) {
            var r = d(h, e);
            if ("error" === r.status) return i.reject(t, r.value);
            var n = r.value;
            if (n) p(t, n);else {
              t.state = s, t.outcome = e;

              for (var o = -1, a = t.queue.length; ++o < a;) {
                t.queue[o].callFulfilled(e);
              }
            }
            return t;
          }, i.reject = function (t, e) {
            t.state = a, t.outcome = e;

            for (var r = -1, n = t.queue.length; ++r < n;) {
              t.queue[r].callRejected(e);
            }

            return t;
          }, u.resolve = function (t) {
            return t instanceof this ? t : i.resolve(new this(o), t);
          }, u.reject = function (t) {
            var e = new this(o);
            return i.reject(e, t);
          }, u.all = function (t) {
            var e = this;
            if ("[object Array]" !== Object.prototype.toString.call(t)) return this.reject(new TypeError("must be an array"));
            var r = t.length,
                n = !1;
            if (!r) return this.resolve([]);

            for (var a = new Array(r), s = 0, c = -1, u = new this(o); ++c < r;) {
              l(t[c], c);
            }

            return u;

            function l(t, o) {
              e.resolve(t).then(function (t) {
                a[o] = t, ++s !== r || n || (n = !0, i.resolve(u, a));
              }, function (t) {
                n || (n = !0, i.reject(u, t));
              });
            }
          }, u.race = function (t) {
            if ("[object Array]" !== Object.prototype.toString.call(t)) return this.reject(new TypeError("must be an array"));
            var e = t.length,
                r = !1;
            if (!e) return this.resolve([]);

            for (var n, a = -1, s = new this(o); ++a < e;) {
              n = t[a], this.resolve(n).then(function (t) {
                r || (r = !0, i.resolve(s, t));
              }, function (t) {
                r || (r = !0, i.reject(s, t));
              });
            }

            return s;
          };
        }, {
          immediate: 36
        }],
        38: [function (t, e, r) {
          "use strict";

          var n = {};
          (0, t("./lib/utils/common").assign)(n, t("./lib/deflate"), t("./lib/inflate"), t("./lib/zlib/constants")), e.exports = n;
        }, {
          "./lib/deflate": 39,
          "./lib/inflate": 40,
          "./lib/utils/common": 41,
          "./lib/zlib/constants": 44
        }],
        39: [function (t, e, r) {
          "use strict";

          var n = t("./zlib/deflate"),
              o = t("./utils/common"),
              i = t("./utils/strings"),
              a = t("./zlib/messages"),
              s = t("./zlib/zstream"),
              c = Object.prototype.toString;

          function u(t) {
            if (!(this instanceof u)) return new u(t);
            this.options = o.assign({
              level: -1,
              method: 8,
              chunkSize: 16384,
              windowBits: 15,
              memLevel: 8,
              strategy: 0,
              to: ""
            }, t || {});
            var e = this.options;
            e.raw && 0 < e.windowBits ? e.windowBits = -e.windowBits : e.gzip && 0 < e.windowBits && e.windowBits < 16 && (e.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
            var r = n.deflateInit2(this.strm, e.level, e.method, e.windowBits, e.memLevel, e.strategy);
            if (0 !== r) throw new Error(a[r]);

            if (e.header && n.deflateSetHeader(this.strm, e.header), e.dictionary) {
              var l;
              if (l = "string" == typeof e.dictionary ? i.string2buf(e.dictionary) : "[object ArrayBuffer]" === c.call(e.dictionary) ? new Uint8Array(e.dictionary) : e.dictionary, 0 !== (r = n.deflateSetDictionary(this.strm, l))) throw new Error(a[r]);
              this._dict_set = !0;
            }
          }

          function l(t, e) {
            var r = new u(e);
            if (r.push(t, !0), r.err) throw r.msg || a[r.err];
            return r.result;
          }

          u.prototype.push = function (t, e) {
            var r,
                a,
                s = this.strm,
                u = this.options.chunkSize;
            if (this.ended) return !1;
            a = e === ~~e ? e : !0 === e ? 4 : 0, "string" == typeof t ? s.input = i.string2buf(t) : "[object ArrayBuffer]" === c.call(t) ? s.input = new Uint8Array(t) : s.input = t, s.next_in = 0, s.avail_in = s.input.length;

            do {
              if (0 === s.avail_out && (s.output = new o.Buf8(u), s.next_out = 0, s.avail_out = u), 1 !== (r = n.deflate(s, a)) && 0 !== r) return this.onEnd(r), !(this.ended = !0);
              0 !== s.avail_out && (0 !== s.avail_in || 4 !== a && 2 !== a) || ("string" === this.options.to ? this.onData(i.buf2binstring(o.shrinkBuf(s.output, s.next_out))) : this.onData(o.shrinkBuf(s.output, s.next_out)));
            } while ((0 < s.avail_in || 0 === s.avail_out) && 1 !== r);

            return 4 === a ? (r = n.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r) : 2 !== a || (this.onEnd(0), !(s.avail_out = 0));
          }, u.prototype.onData = function (t) {
            this.chunks.push(t);
          }, u.prototype.onEnd = function (t) {
            0 === t && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
          }, r.Deflate = u, r.deflate = l, r.deflateRaw = function (t, e) {
            return (e = e || {}).raw = !0, l(t, e);
          }, r.gzip = function (t, e) {
            return (e = e || {}).gzip = !0, l(t, e);
          };
        }, {
          "./utils/common": 41,
          "./utils/strings": 42,
          "./zlib/deflate": 46,
          "./zlib/messages": 51,
          "./zlib/zstream": 53
        }],
        40: [function (t, e, r) {
          "use strict";

          var n = t("./zlib/inflate"),
              o = t("./utils/common"),
              i = t("./utils/strings"),
              a = t("./zlib/constants"),
              s = t("./zlib/messages"),
              c = t("./zlib/zstream"),
              u = t("./zlib/gzheader"),
              l = Object.prototype.toString;

          function f(t) {
            if (!(this instanceof f)) return new f(t);
            this.options = o.assign({
              chunkSize: 16384,
              windowBits: 0,
              to: ""
            }, t || {});
            var e = this.options;
            e.raw && 0 <= e.windowBits && e.windowBits < 16 && (e.windowBits = -e.windowBits, 0 === e.windowBits && (e.windowBits = -15)), !(0 <= e.windowBits && e.windowBits < 16) || t && t.windowBits || (e.windowBits += 32), 15 < e.windowBits && e.windowBits < 48 && 0 == (15 & e.windowBits) && (e.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new c(), this.strm.avail_out = 0;
            var r = n.inflateInit2(this.strm, e.windowBits);
            if (r !== a.Z_OK) throw new Error(s[r]);
            this.header = new u(), n.inflateGetHeader(this.strm, this.header);
          }

          function h(t, e) {
            var r = new f(e);
            if (r.push(t, !0), r.err) throw r.msg || s[r.err];
            return r.result;
          }

          f.prototype.push = function (t, e) {
            var r,
                s,
                c,
                u,
                f,
                h,
                p = this.strm,
                d = this.options.chunkSize,
                y = this.options.dictionary,
                m = !1;
            if (this.ended) return !1;
            s = e === ~~e ? e : !0 === e ? a.Z_FINISH : a.Z_NO_FLUSH, "string" == typeof t ? p.input = i.binstring2buf(t) : "[object ArrayBuffer]" === l.call(t) ? p.input = new Uint8Array(t) : p.input = t, p.next_in = 0, p.avail_in = p.input.length;

            do {
              if (0 === p.avail_out && (p.output = new o.Buf8(d), p.next_out = 0, p.avail_out = d), (r = n.inflate(p, a.Z_NO_FLUSH)) === a.Z_NEED_DICT && y && (h = "string" == typeof y ? i.string2buf(y) : "[object ArrayBuffer]" === l.call(y) ? new Uint8Array(y) : y, r = n.inflateSetDictionary(this.strm, h)), r === a.Z_BUF_ERROR && !0 === m && (r = a.Z_OK, m = !1), r !== a.Z_STREAM_END && r !== a.Z_OK) return this.onEnd(r), !(this.ended = !0);
              p.next_out && (0 !== p.avail_out && r !== a.Z_STREAM_END && (0 !== p.avail_in || s !== a.Z_FINISH && s !== a.Z_SYNC_FLUSH) || ("string" === this.options.to ? (c = i.utf8border(p.output, p.next_out), u = p.next_out - c, f = i.buf2string(p.output, c), p.next_out = u, p.avail_out = d - u, u && o.arraySet(p.output, p.output, c, u, 0), this.onData(f)) : this.onData(o.shrinkBuf(p.output, p.next_out)))), 0 === p.avail_in && 0 === p.avail_out && (m = !0);
            } while ((0 < p.avail_in || 0 === p.avail_out) && r !== a.Z_STREAM_END);

            return r === a.Z_STREAM_END && (s = a.Z_FINISH), s === a.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === a.Z_OK) : s !== a.Z_SYNC_FLUSH || (this.onEnd(a.Z_OK), !(p.avail_out = 0));
          }, f.prototype.onData = function (t) {
            this.chunks.push(t);
          }, f.prototype.onEnd = function (t) {
            t === a.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
          }, r.Inflate = f, r.inflate = h, r.inflateRaw = function (t, e) {
            return (e = e || {}).raw = !0, h(t, e);
          }, r.ungzip = h;
        }, {
          "./utils/common": 41,
          "./utils/strings": 42,
          "./zlib/constants": 44,
          "./zlib/gzheader": 47,
          "./zlib/inflate": 49,
          "./zlib/messages": 51,
          "./zlib/zstream": 53
        }],
        41: [function (t, e, r) {
          "use strict";

          var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
          r.assign = function (t) {
            for (var e = Array.prototype.slice.call(arguments, 1); e.length;) {
              var r = e.shift();

              if (r) {
                if ("object" != typeof r) throw new TypeError(r + "must be non-object");

                for (var n in r) {
                  r.hasOwnProperty(n) && (t[n] = r[n]);
                }
              }
            }

            return t;
          }, r.shrinkBuf = function (t, e) {
            return t.length === e ? t : t.subarray ? t.subarray(0, e) : (t.length = e, t);
          };
          var o = {
            arraySet: function arraySet(t, e, r, n, o) {
              if (e.subarray && t.subarray) t.set(e.subarray(r, r + n), o);else for (var i = 0; i < n; i++) {
                t[o + i] = e[r + i];
              }
            },
            flattenChunks: function flattenChunks(t) {
              var e, r, n, o, i, a;

              for (e = n = 0, r = t.length; e < r; e++) {
                n += t[e].length;
              }

              for (a = new Uint8Array(n), e = o = 0, r = t.length; e < r; e++) {
                i = t[e], a.set(i, o), o += i.length;
              }

              return a;
            }
          },
              i = {
            arraySet: function arraySet(t, e, r, n, o) {
              for (var i = 0; i < n; i++) {
                t[o + i] = e[r + i];
              }
            },
            flattenChunks: function flattenChunks(t) {
              return [].concat.apply([], t);
            }
          };
          r.setTyped = function (t) {
            t ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, o)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, i));
          }, r.setTyped(n);
        }, {}],
        42: [function (t, e, r) {
          "use strict";

          var n = t("./common"),
              o = !0,
              i = !0;

          try {
            String.fromCharCode.apply(null, [0]);
          } catch (t) {
            o = !1;
          }

          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (t) {
            i = !1;
          }

          for (var a = new n.Buf8(256), s = 0; s < 256; s++) {
            a[s] = 252 <= s ? 6 : 248 <= s ? 5 : 240 <= s ? 4 : 224 <= s ? 3 : 192 <= s ? 2 : 1;
          }

          function c(t, e) {
            if (e < 65537 && (t.subarray && i || !t.subarray && o)) return String.fromCharCode.apply(null, n.shrinkBuf(t, e));

            for (var r = "", a = 0; a < e; a++) {
              r += String.fromCharCode(t[a]);
            }

            return r;
          }

          a[254] = a[254] = 1, r.string2buf = function (t) {
            var e,
                r,
                o,
                i,
                a,
                s = t.length,
                c = 0;

            for (i = 0; i < s; i++) {
              55296 == (64512 & (r = t.charCodeAt(i))) && i + 1 < s && 56320 == (64512 & (o = t.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (o - 56320), i++), c += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
            }

            for (e = new n.Buf8(c), i = a = 0; a < c; i++) {
              55296 == (64512 & (r = t.charCodeAt(i))) && i + 1 < s && 56320 == (64512 & (o = t.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (o - 56320), i++), r < 128 ? e[a++] = r : (r < 2048 ? e[a++] = 192 | r >>> 6 : (r < 65536 ? e[a++] = 224 | r >>> 12 : (e[a++] = 240 | r >>> 18, e[a++] = 128 | r >>> 12 & 63), e[a++] = 128 | r >>> 6 & 63), e[a++] = 128 | 63 & r);
            }

            return e;
          }, r.buf2binstring = function (t) {
            return c(t, t.length);
          }, r.binstring2buf = function (t) {
            for (var e = new n.Buf8(t.length), r = 0, o = e.length; r < o; r++) {
              e[r] = t.charCodeAt(r);
            }

            return e;
          }, r.buf2string = function (t, e) {
            var r,
                n,
                o,
                i,
                s = e || t.length,
                u = new Array(2 * s);

            for (r = n = 0; r < s;) {
              if ((o = t[r++]) < 128) u[n++] = o;else if (4 < (i = a[o])) u[n++] = 65533, r += i - 1;else {
                for (o &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && r < s;) {
                  o = o << 6 | 63 & t[r++], i--;
                }

                1 < i ? u[n++] = 65533 : o < 65536 ? u[n++] = o : (o -= 65536, u[n++] = 55296 | o >> 10 & 1023, u[n++] = 56320 | 1023 & o);
              }
            }

            return c(u, n);
          }, r.utf8border = function (t, e) {
            var r;

            for ((e = e || t.length) > t.length && (e = t.length), r = e - 1; 0 <= r && 128 == (192 & t[r]);) {
              r--;
            }

            return r < 0 || 0 === r ? e : r + a[t[r]] > e ? r : e;
          };
        }, {
          "./common": 41
        }],
        43: [function (t, e, r) {
          "use strict";

          e.exports = function (t, e, r, n) {
            for (var o = 65535 & t | 0, i = t >>> 16 & 65535 | 0, a = 0; 0 !== r;) {
              for (r -= a = 2e3 < r ? 2e3 : r; i = i + (o = o + e[n++] | 0) | 0, --a;) {
                ;
              }

              o %= 65521, i %= 65521;
            }

            return o | i << 16 | 0;
          };
        }, {}],
        44: [function (t, e, r) {
          "use strict";

          e.exports = {
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_BUF_ERROR: -5,
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            Z_BINARY: 0,
            Z_TEXT: 1,
            Z_UNKNOWN: 2,
            Z_DEFLATED: 8
          };
        }, {}],
        45: [function (t, e, r) {
          "use strict";

          var n = function () {
            for (var t, e = [], r = 0; r < 256; r++) {
              t = r;

              for (var n = 0; n < 8; n++) {
                t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
              }

              e[r] = t;
            }

            return e;
          }();

          e.exports = function (t, e, r, o) {
            var i = n,
                a = o + r;
            t ^= -1;

            for (var s = o; s < a; s++) {
              t = t >>> 8 ^ i[255 & (t ^ e[s])];
            }

            return -1 ^ t;
          };
        }, {}],
        46: [function (t, e, r) {
          "use strict";

          var n,
              o = t("../utils/common"),
              i = t("./trees"),
              a = t("./adler32"),
              s = t("./crc32"),
              c = t("./messages"),
              u = -2,
              l = 258,
              f = 262,
              h = 113;

          function p(t, e) {
            return t.msg = c[e], e;
          }

          function d(t) {
            return (t << 1) - (4 < t ? 9 : 0);
          }

          function y(t) {
            for (var e = t.length; 0 <= --e;) {
              t[e] = 0;
            }
          }

          function m(t) {
            var e = t.state,
                r = e.pending;
            r > t.avail_out && (r = t.avail_out), 0 !== r && (o.arraySet(t.output, e.pending_buf, e.pending_out, r, t.next_out), t.next_out += r, e.pending_out += r, t.total_out += r, t.avail_out -= r, e.pending -= r, 0 === e.pending && (e.pending_out = 0));
          }

          function v(t, e) {
            i._tr_flush_block(t, 0 <= t.block_start ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, m(t.strm);
          }

          function g(t, e) {
            t.pending_buf[t.pending++] = e;
          }

          function b(t, e) {
            t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = 255 & e;
          }

          function w(t, e) {
            var r,
                n,
                o = t.max_chain_length,
                i = t.strstart,
                a = t.prev_length,
                s = t.nice_match,
                c = t.strstart > t.w_size - f ? t.strstart - (t.w_size - f) : 0,
                u = t.window,
                h = t.w_mask,
                p = t.prev,
                d = t.strstart + l,
                y = u[i + a - 1],
                m = u[i + a];
            t.prev_length >= t.good_match && (o >>= 2), s > t.lookahead && (s = t.lookahead);

            do {
              if (u[(r = e) + a] === m && u[r + a - 1] === y && u[r] === u[i] && u[++r] === u[i + 1]) {
                i += 2, r++;

                do {} while (u[++i] === u[++r] && u[++i] === u[++r] && u[++i] === u[++r] && u[++i] === u[++r] && u[++i] === u[++r] && u[++i] === u[++r] && u[++i] === u[++r] && u[++i] === u[++r] && i < d);

                if (n = l - (d - i), i = d - l, a < n) {
                  if (t.match_start = e, s <= (a = n)) break;
                  y = u[i + a - 1], m = u[i + a];
                }
              }
            } while ((e = p[e & h]) > c && 0 != --o);

            return a <= t.lookahead ? a : t.lookahead;
          }

          function O(t) {
            var e,
                r,
                n,
                i,
                c,
                u,
                l,
                h,
                p,
                d,
                y = t.w_size;

            do {
              if (i = t.window_size - t.lookahead - t.strstart, t.strstart >= y + (y - f)) {
                for (o.arraySet(t.window, t.window, y, y, 0), t.match_start -= y, t.strstart -= y, t.block_start -= y, e = r = t.hash_size; n = t.head[--e], t.head[e] = y <= n ? n - y : 0, --r;) {
                  ;
                }

                for (e = r = y; n = t.prev[--e], t.prev[e] = y <= n ? n - y : 0, --r;) {
                  ;
                }

                i += y;
              }

              if (0 === t.strm.avail_in) break;
              if (u = t.strm, l = t.window, h = t.strstart + t.lookahead, d = void 0, (p = i) < (d = u.avail_in) && (d = p), r = 0 === d ? 0 : (u.avail_in -= d, o.arraySet(l, u.input, u.next_in, d, h), 1 === u.state.wrap ? u.adler = a(u.adler, l, d, h) : 2 === u.state.wrap && (u.adler = s(u.adler, l, d, h)), u.next_in += d, u.total_in += d, d), t.lookahead += r, t.lookahead + t.insert >= 3) for (c = t.strstart - t.insert, t.ins_h = t.window[c], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[c + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[c + 3 - 1]) & t.hash_mask, t.prev[c & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = c, c++, t.insert--, !(t.lookahead + t.insert < 3));) {
                ;
              }
            } while (t.lookahead < f && 0 !== t.strm.avail_in);
          }

          function _(t, e) {
            for (var r, n;;) {
              if (t.lookahead < f) {
                if (O(t), t.lookahead < f && 0 === e) return 1;
                if (0 === t.lookahead) break;
              }

              if (r = 0, t.lookahead >= 3 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), 0 !== r && t.strstart - r <= t.w_size - f && (t.match_length = w(t, r)), t.match_length >= 3) {
                if (n = i._tr_tally(t, t.strstart - t.match_start, t.match_length - 3), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= 3) {
                  for (t.match_length--; t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart, 0 != --t.match_length;) {
                    ;
                  }

                  t.strstart++;
                } else t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
              } else n = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
              if (n && (v(t, !1), 0 === t.strm.avail_out)) return 1;
            }

            return t.insert = t.strstart < 2 ? t.strstart : 2, 4 === e ? (v(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (v(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
          }

          function x(t, e) {
            for (var r, n, o;;) {
              if (t.lookahead < f) {
                if (O(t), t.lookahead < f && 0 === e) return 1;
                if (0 === t.lookahead) break;
              }

              if (r = 0, t.lookahead >= 3 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = 2, 0 !== r && t.prev_length < t.max_lazy_match && t.strstart - r <= t.w_size - f && (t.match_length = w(t, r), t.match_length <= 5 && (1 === t.strategy || 3 === t.match_length && 4096 < t.strstart - t.match_start) && (t.match_length = 2)), t.prev_length >= 3 && t.match_length <= t.prev_length) {
                for (o = t.strstart + t.lookahead - 3, n = i._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - 3), t.lookahead -= t.prev_length - 1, t.prev_length -= 2; ++t.strstart <= o && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), 0 != --t.prev_length;) {
                  ;
                }

                if (t.match_available = 0, t.match_length = 2, t.strstart++, n && (v(t, !1), 0 === t.strm.avail_out)) return 1;
              } else if (t.match_available) {
                if ((n = i._tr_tally(t, 0, t.window[t.strstart - 1])) && v(t, !1), t.strstart++, t.lookahead--, 0 === t.strm.avail_out) return 1;
              } else t.match_available = 1, t.strstart++, t.lookahead--;
            }

            return t.match_available && (n = i._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < 2 ? t.strstart : 2, 4 === e ? (v(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (v(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
          }

          function L(t, e, r, n, o) {
            this.good_length = t, this.max_lazy = e, this.nice_length = r, this.max_chain = n, this.func = o;
          }

          function E() {
            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new o.Buf16(1146), this.dyn_dtree = new o.Buf16(122), this.bl_tree = new o.Buf16(78), y(this.dyn_ltree), y(this.dyn_dtree), y(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new o.Buf16(16), this.heap = new o.Buf16(573), y(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new o.Buf16(573), y(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
          }

          function A(t) {
            var e;
            return t && t.state ? (t.total_in = t.total_out = 0, t.data_type = 2, (e = t.state).pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? 42 : h, t.adler = 2 === e.wrap ? 0 : 1, e.last_flush = 0, i._tr_init(e), 0) : p(t, u);
          }

          function R(t) {
            var e = A(t);
            return 0 === e && function (t) {
              t.window_size = 2 * t.w_size, y(t.head), t.max_lazy_match = n[t.level].max_lazy, t.good_match = n[t.level].good_length, t.nice_match = n[t.level].nice_length, t.max_chain_length = n[t.level].max_chain, t.strstart = 0, t.block_start = 0, t.lookahead = 0, t.insert = 0, t.match_length = t.prev_length = 2, t.match_available = 0, t.ins_h = 0;
            }(t.state), e;
          }

          function T(t, e, r, n, i, a) {
            if (!t) return u;
            var s = 1;
            if (-1 === e && (e = 6), n < 0 ? (s = 0, n = -n) : 15 < n && (s = 2, n -= 16), i < 1 || 9 < i || 8 !== r || n < 8 || 15 < n || e < 0 || 9 < e || a < 0 || 4 < a) return p(t, u);
            8 === n && (n = 9);
            var c = new E();
            return (t.state = c).strm = t, c.wrap = s, c.gzhead = null, c.w_bits = n, c.w_size = 1 << c.w_bits, c.w_mask = c.w_size - 1, c.hash_bits = i + 7, c.hash_size = 1 << c.hash_bits, c.hash_mask = c.hash_size - 1, c.hash_shift = ~~((c.hash_bits + 3 - 1) / 3), c.window = new o.Buf8(2 * c.w_size), c.head = new o.Buf16(c.hash_size), c.prev = new o.Buf16(c.w_size), c.lit_bufsize = 1 << i + 6, c.pending_buf_size = 4 * c.lit_bufsize, c.pending_buf = new o.Buf8(c.pending_buf_size), c.d_buf = 1 * c.lit_bufsize, c.l_buf = 3 * c.lit_bufsize, c.level = e, c.strategy = a, c.method = r, R(t);
          }

          n = [new L(0, 0, 0, 0, function (t, e) {
            var r = 65535;

            for (r > t.pending_buf_size - 5 && (r = t.pending_buf_size - 5);;) {
              if (t.lookahead <= 1) {
                if (O(t), 0 === t.lookahead && 0 === e) return 1;
                if (0 === t.lookahead) break;
              }

              t.strstart += t.lookahead, t.lookahead = 0;
              var n = t.block_start + r;
              if ((0 === t.strstart || t.strstart >= n) && (t.lookahead = t.strstart - n, t.strstart = n, v(t, !1), 0 === t.strm.avail_out)) return 1;
              if (t.strstart - t.block_start >= t.w_size - f && (v(t, !1), 0 === t.strm.avail_out)) return 1;
            }

            return t.insert = 0, 4 === e ? (v(t, !0), 0 === t.strm.avail_out ? 3 : 4) : (t.strstart > t.block_start && (v(t, !1), t.strm.avail_out), 1);
          }), new L(4, 4, 8, 4, _), new L(4, 5, 16, 8, _), new L(4, 6, 32, 32, _), new L(4, 4, 16, 16, x), new L(8, 16, 32, 32, x), new L(8, 16, 128, 128, x), new L(8, 32, 128, 256, x), new L(32, 128, 258, 1024, x), new L(32, 258, 258, 4096, x)], r.deflateInit = function (t, e) {
            return T(t, e, 8, 15, 8, 0);
          }, r.deflateInit2 = T, r.deflateReset = R, r.deflateResetKeep = A, r.deflateSetHeader = function (t, e) {
            return t && t.state ? 2 !== t.state.wrap ? u : (t.state.gzhead = e, 0) : u;
          }, r.deflate = function (t, e) {
            var r, o, a, c;
            if (!t || !t.state || 5 < e || e < 0) return t ? p(t, u) : u;
            if (o = t.state, !t.output || !t.input && 0 !== t.avail_in || 666 === o.status && 4 !== e) return p(t, 0 === t.avail_out ? -5 : u);
            if (o.strm = t, r = o.last_flush, o.last_flush = e, 42 === o.status) if (2 === o.wrap) t.adler = 0, g(o, 31), g(o, 139), g(o, 8), o.gzhead ? (g(o, (o.gzhead.text ? 1 : 0) + (o.gzhead.hcrc ? 2 : 0) + (o.gzhead.extra ? 4 : 0) + (o.gzhead.name ? 8 : 0) + (o.gzhead.comment ? 16 : 0)), g(o, 255 & o.gzhead.time), g(o, o.gzhead.time >> 8 & 255), g(o, o.gzhead.time >> 16 & 255), g(o, o.gzhead.time >> 24 & 255), g(o, 9 === o.level ? 2 : 2 <= o.strategy || o.level < 2 ? 4 : 0), g(o, 255 & o.gzhead.os), o.gzhead.extra && o.gzhead.extra.length && (g(o, 255 & o.gzhead.extra.length), g(o, o.gzhead.extra.length >> 8 & 255)), o.gzhead.hcrc && (t.adler = s(t.adler, o.pending_buf, o.pending, 0)), o.gzindex = 0, o.status = 69) : (g(o, 0), g(o, 0), g(o, 0), g(o, 0), g(o, 0), g(o, 9 === o.level ? 2 : 2 <= o.strategy || o.level < 2 ? 4 : 0), g(o, 3), o.status = h);else {
              var f = 8 + (o.w_bits - 8 << 4) << 8;
              f |= (2 <= o.strategy || o.level < 2 ? 0 : o.level < 6 ? 1 : 6 === o.level ? 2 : 3) << 6, 0 !== o.strstart && (f |= 32), f += 31 - f % 31, o.status = h, b(o, f), 0 !== o.strstart && (b(o, t.adler >>> 16), b(o, 65535 & t.adler)), t.adler = 1;
            }
            if (69 === o.status) if (o.gzhead.extra) {
              for (a = o.pending; o.gzindex < (65535 & o.gzhead.extra.length) && (o.pending !== o.pending_buf_size || (o.gzhead.hcrc && o.pending > a && (t.adler = s(t.adler, o.pending_buf, o.pending - a, a)), m(t), a = o.pending, o.pending !== o.pending_buf_size));) {
                g(o, 255 & o.gzhead.extra[o.gzindex]), o.gzindex++;
              }

              o.gzhead.hcrc && o.pending > a && (t.adler = s(t.adler, o.pending_buf, o.pending - a, a)), o.gzindex === o.gzhead.extra.length && (o.gzindex = 0, o.status = 73);
            } else o.status = 73;
            if (73 === o.status) if (o.gzhead.name) {
              a = o.pending;

              do {
                if (o.pending === o.pending_buf_size && (o.gzhead.hcrc && o.pending > a && (t.adler = s(t.adler, o.pending_buf, o.pending - a, a)), m(t), a = o.pending, o.pending === o.pending_buf_size)) {
                  c = 1;
                  break;
                }

                c = o.gzindex < o.gzhead.name.length ? 255 & o.gzhead.name.charCodeAt(o.gzindex++) : 0, g(o, c);
              } while (0 !== c);

              o.gzhead.hcrc && o.pending > a && (t.adler = s(t.adler, o.pending_buf, o.pending - a, a)), 0 === c && (o.gzindex = 0, o.status = 91);
            } else o.status = 91;
            if (91 === o.status) if (o.gzhead.comment) {
              a = o.pending;

              do {
                if (o.pending === o.pending_buf_size && (o.gzhead.hcrc && o.pending > a && (t.adler = s(t.adler, o.pending_buf, o.pending - a, a)), m(t), a = o.pending, o.pending === o.pending_buf_size)) {
                  c = 1;
                  break;
                }

                c = o.gzindex < o.gzhead.comment.length ? 255 & o.gzhead.comment.charCodeAt(o.gzindex++) : 0, g(o, c);
              } while (0 !== c);

              o.gzhead.hcrc && o.pending > a && (t.adler = s(t.adler, o.pending_buf, o.pending - a, a)), 0 === c && (o.status = 103);
            } else o.status = 103;

            if (103 === o.status && (o.gzhead.hcrc ? (o.pending + 2 > o.pending_buf_size && m(t), o.pending + 2 <= o.pending_buf_size && (g(o, 255 & t.adler), g(o, t.adler >> 8 & 255), t.adler = 0, o.status = h)) : o.status = h), 0 !== o.pending) {
              if (m(t), 0 === t.avail_out) return o.last_flush = -1, 0;
            } else if (0 === t.avail_in && d(e) <= d(r) && 4 !== e) return p(t, -5);

            if (666 === o.status && 0 !== t.avail_in) return p(t, -5);

            if (0 !== t.avail_in || 0 !== o.lookahead || 0 !== e && 666 !== o.status) {
              var w = 2 === o.strategy ? function (t, e) {
                for (var r;;) {
                  if (0 === t.lookahead && (O(t), 0 === t.lookahead)) {
                    if (0 === e) return 1;
                    break;
                  }

                  if (t.match_length = 0, r = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, r && (v(t, !1), 0 === t.strm.avail_out)) return 1;
                }

                return t.insert = 0, 4 === e ? (v(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (v(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
              }(o, e) : 3 === o.strategy ? function (t, e) {
                for (var r, n, o, a, s = t.window;;) {
                  if (t.lookahead <= l) {
                    if (O(t), t.lookahead <= l && 0 === e) return 1;
                    if (0 === t.lookahead) break;
                  }

                  if (t.match_length = 0, t.lookahead >= 3 && 0 < t.strstart && (n = s[o = t.strstart - 1]) === s[++o] && n === s[++o] && n === s[++o]) {
                    a = t.strstart + l;

                    do {} while (n === s[++o] && n === s[++o] && n === s[++o] && n === s[++o] && n === s[++o] && n === s[++o] && n === s[++o] && n === s[++o] && o < a);

                    t.match_length = l - (a - o), t.match_length > t.lookahead && (t.match_length = t.lookahead);
                  }

                  if (t.match_length >= 3 ? (r = i._tr_tally(t, 1, t.match_length - 3), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (r = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), r && (v(t, !1), 0 === t.strm.avail_out)) return 1;
                }

                return t.insert = 0, 4 === e ? (v(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (v(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
              }(o, e) : n[o.level].func(o, e);
              if (3 !== w && 4 !== w || (o.status = 666), 1 === w || 3 === w) return 0 === t.avail_out && (o.last_flush = -1), 0;
              if (2 === w && (1 === e ? i._tr_align(o) : 5 !== e && (i._tr_stored_block(o, 0, 0, !1), 3 === e && (y(o.head), 0 === o.lookahead && (o.strstart = 0, o.block_start = 0, o.insert = 0))), m(t), 0 === t.avail_out)) return o.last_flush = -1, 0;
            }

            return 4 !== e ? 0 : o.wrap <= 0 ? 1 : (2 === o.wrap ? (g(o, 255 & t.adler), g(o, t.adler >> 8 & 255), g(o, t.adler >> 16 & 255), g(o, t.adler >> 24 & 255), g(o, 255 & t.total_in), g(o, t.total_in >> 8 & 255), g(o, t.total_in >> 16 & 255), g(o, t.total_in >> 24 & 255)) : (b(o, t.adler >>> 16), b(o, 65535 & t.adler)), m(t), 0 < o.wrap && (o.wrap = -o.wrap), 0 !== o.pending ? 0 : 1);
          }, r.deflateEnd = function (t) {
            var e;
            return t && t.state ? 42 !== (e = t.state.status) && 69 !== e && 73 !== e && 91 !== e && 103 !== e && e !== h && 666 !== e ? p(t, u) : (t.state = null, e === h ? p(t, -3) : 0) : u;
          }, r.deflateSetDictionary = function (t, e) {
            var r,
                n,
                i,
                s,
                c,
                l,
                f,
                h,
                p = e.length;
            if (!t || !t.state) return u;
            if (2 === (s = (r = t.state).wrap) || 1 === s && 42 !== r.status || r.lookahead) return u;

            for (1 === s && (t.adler = a(t.adler, e, p, 0)), r.wrap = 0, p >= r.w_size && (0 === s && (y(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), h = new o.Buf8(r.w_size), o.arraySet(h, e, p - r.w_size, r.w_size, 0), e = h, p = r.w_size), c = t.avail_in, l = t.next_in, f = t.input, t.avail_in = p, t.next_in = 0, t.input = e, O(r); r.lookahead >= 3;) {
              for (n = r.strstart, i = r.lookahead - 2; r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;) {
                ;
              }

              r.strstart = n, r.lookahead = 2, O(r);
            }

            return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, t.next_in = l, t.input = f, t.avail_in = c, r.wrap = s, 0;
          }, r.deflateInfo = "pako deflate (from Nodeca project)";
        }, {
          "../utils/common": 41,
          "./adler32": 43,
          "./crc32": 45,
          "./messages": 51,
          "./trees": 52
        }],
        47: [function (t, e, r) {
          "use strict";

          e.exports = function () {
            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
          };
        }, {}],
        48: [function (t, e, r) {
          "use strict";

          e.exports = function (t, e) {
            var r, n, o, i, a, s, c, u, l, f, h, p, d, y, m, v, g, b, w, O, _, x, L, E, A;

            r = t.state, n = t.next_in, E = t.input, o = n + (t.avail_in - 5), i = t.next_out, A = t.output, a = i - (e - t.avail_out), s = i + (t.avail_out - 257), c = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, h = r.window, p = r.hold, d = r.bits, y = r.lencode, m = r.distcode, v = (1 << r.lenbits) - 1, g = (1 << r.distbits) - 1;

            t: do {
              d < 15 && (p += E[n++] << d, d += 8, p += E[n++] << d, d += 8), b = y[p & v];

              e: for (;;) {
                if (p >>>= w = b >>> 24, d -= w, 0 == (w = b >>> 16 & 255)) A[i++] = 65535 & b;else {
                  if (!(16 & w)) {
                    if (0 == (64 & w)) {
                      b = y[(65535 & b) + (p & (1 << w) - 1)];
                      continue e;
                    }

                    if (32 & w) {
                      r.mode = 12;
                      break t;
                    }

                    t.msg = "invalid literal/length code", r.mode = 30;
                    break t;
                  }

                  O = 65535 & b, (w &= 15) && (d < w && (p += E[n++] << d, d += 8), O += p & (1 << w) - 1, p >>>= w, d -= w), d < 15 && (p += E[n++] << d, d += 8, p += E[n++] << d, d += 8), b = m[p & g];

                  r: for (;;) {
                    if (p >>>= w = b >>> 24, d -= w, !(16 & (w = b >>> 16 & 255))) {
                      if (0 == (64 & w)) {
                        b = m[(65535 & b) + (p & (1 << w) - 1)];
                        continue r;
                      }

                      t.msg = "invalid distance code", r.mode = 30;
                      break t;
                    }

                    if (_ = 65535 & b, d < (w &= 15) && (p += E[n++] << d, (d += 8) < w && (p += E[n++] << d, d += 8)), c < (_ += p & (1 << w) - 1)) {
                      t.msg = "invalid distance too far back", r.mode = 30;
                      break t;
                    }

                    if (p >>>= w, d -= w, (w = i - a) < _) {
                      if (l < (w = _ - w) && r.sane) {
                        t.msg = "invalid distance too far back", r.mode = 30;
                        break t;
                      }

                      if (L = h, (x = 0) === f) {
                        if (x += u - w, w < O) {
                          for (O -= w; A[i++] = h[x++], --w;) {
                            ;
                          }

                          x = i - _, L = A;
                        }
                      } else if (f < w) {
                        if (x += u + f - w, (w -= f) < O) {
                          for (O -= w; A[i++] = h[x++], --w;) {
                            ;
                          }

                          if (x = 0, f < O) {
                            for (O -= w = f; A[i++] = h[x++], --w;) {
                              ;
                            }

                            x = i - _, L = A;
                          }
                        }
                      } else if (x += f - w, w < O) {
                        for (O -= w; A[i++] = h[x++], --w;) {
                          ;
                        }

                        x = i - _, L = A;
                      }

                      for (; 2 < O;) {
                        A[i++] = L[x++], A[i++] = L[x++], A[i++] = L[x++], O -= 3;
                      }

                      O && (A[i++] = L[x++], 1 < O && (A[i++] = L[x++]));
                    } else {
                      for (x = i - _; A[i++] = A[x++], A[i++] = A[x++], A[i++] = A[x++], 2 < (O -= 3);) {
                        ;
                      }

                      O && (A[i++] = A[x++], 1 < O && (A[i++] = A[x++]));
                    }

                    break;
                  }
                }
                break;
              }
            } while (n < o && i < s);

            n -= O = d >> 3, p &= (1 << (d -= O << 3)) - 1, t.next_in = n, t.next_out = i, t.avail_in = n < o ? o - n + 5 : 5 - (n - o), t.avail_out = i < s ? s - i + 257 : 257 - (i - s), r.hold = p, r.bits = d;
          };
        }, {}],
        49: [function (t, e, r) {
          "use strict";

          var n = t("../utils/common"),
              o = t("./adler32"),
              i = t("./crc32"),
              a = t("./inffast"),
              s = t("./inftrees"),
              c = -2;

          function u(t) {
            return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((65280 & t) << 8) + ((255 & t) << 24);
          }

          function l() {
            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
          }

          function f(t) {
            var e;
            return t && t.state ? (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = 1 & e.wrap), e.mode = 1, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new n.Buf32(852), e.distcode = e.distdyn = new n.Buf32(592), e.sane = 1, e.back = -1, 0) : c;
          }

          function h(t) {
            var e;
            return t && t.state ? ((e = t.state).wsize = 0, e.whave = 0, e.wnext = 0, f(t)) : c;
          }

          function p(t, e) {
            var r, n;
            return t && t.state ? (n = t.state, e < 0 ? (r = 0, e = -e) : (r = 1 + (e >> 4), e < 48 && (e &= 15)), e && (e < 8 || 15 < e) ? c : (null !== n.window && n.wbits !== e && (n.window = null), n.wrap = r, n.wbits = e, h(t))) : c;
          }

          function d(t, e) {
            var r, n;
            return t ? (n = new l(), (t.state = n).window = null, 0 !== (r = p(t, e)) && (t.state = null), r) : c;
          }

          var y,
              m,
              v = !0;

          function g(t) {
            if (v) {
              var e;

              for (y = new n.Buf32(512), m = new n.Buf32(32), e = 0; e < 144;) {
                t.lens[e++] = 8;
              }

              for (; e < 256;) {
                t.lens[e++] = 9;
              }

              for (; e < 280;) {
                t.lens[e++] = 7;
              }

              for (; e < 288;) {
                t.lens[e++] = 8;
              }

              for (s(1, t.lens, 0, 288, y, 0, t.work, {
                bits: 9
              }), e = 0; e < 32;) {
                t.lens[e++] = 5;
              }

              s(2, t.lens, 0, 32, m, 0, t.work, {
                bits: 5
              }), v = !1;
            }

            t.lencode = y, t.lenbits = 9, t.distcode = m, t.distbits = 5;
          }

          function b(t, e, r, o) {
            var i,
                a = t.state;
            return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new n.Buf8(a.wsize)), o >= a.wsize ? (n.arraySet(a.window, e, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (o < (i = a.wsize - a.wnext) && (i = o), n.arraySet(a.window, e, r - o, i, a.wnext), (o -= i) ? (n.arraySet(a.window, e, r - o, o, 0), a.wnext = o, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
          }

          r.inflateReset = h, r.inflateReset2 = p, r.inflateResetKeep = f, r.inflateInit = function (t) {
            return d(t, 15);
          }, r.inflateInit2 = d, r.inflate = function (t, e) {
            var r,
                l,
                f,
                h,
                p,
                d,
                y,
                m,
                v,
                w,
                O,
                _,
                x,
                L,
                E,
                A,
                R,
                T,
                P,
                S,
                k,
                j,
                Z,
                M,
                C = 0,
                F = new n.Buf8(4),
                W = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

            if (!t || !t.state || !t.output || !t.input && 0 !== t.avail_in) return c;
            12 === (r = t.state).mode && (r.mode = 13), p = t.next_out, f = t.output, y = t.avail_out, h = t.next_in, l = t.input, d = t.avail_in, m = r.hold, v = r.bits, w = d, O = y, j = 0;

            t: for (;;) {
              switch (r.mode) {
                case 1:
                  if (0 === r.wrap) {
                    r.mode = 13;
                    break;
                  }

                  for (; v < 16;) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  if (2 & r.wrap && 35615 === m) {
                    F[r.check = 0] = 255 & m, F[1] = m >>> 8 & 255, r.check = i(r.check, F, 2, 0), v = m = 0, r.mode = 2;
                    break;
                  }

                  if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & m) << 8) + (m >> 8)) % 31) {
                    t.msg = "incorrect header check", r.mode = 30;
                    break;
                  }

                  if (8 != (15 & m)) {
                    t.msg = "unknown compression method", r.mode = 30;
                    break;
                  }

                  if (v -= 4, k = 8 + (15 & (m >>>= 4)), 0 === r.wbits) r.wbits = k;else if (k > r.wbits) {
                    t.msg = "invalid window size", r.mode = 30;
                    break;
                  }
                  r.dmax = 1 << k, t.adler = r.check = 1, r.mode = 512 & m ? 10 : 12, v = m = 0;
                  break;

                case 2:
                  for (; v < 16;) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  if (r.flags = m, 8 != (255 & r.flags)) {
                    t.msg = "unknown compression method", r.mode = 30;
                    break;
                  }

                  if (57344 & r.flags) {
                    t.msg = "unknown header flags set", r.mode = 30;
                    break;
                  }

                  r.head && (r.head.text = m >> 8 & 1), 512 & r.flags && (F[0] = 255 & m, F[1] = m >>> 8 & 255, r.check = i(r.check, F, 2, 0)), v = m = 0, r.mode = 3;

                case 3:
                  for (; v < 32;) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  r.head && (r.head.time = m), 512 & r.flags && (F[0] = 255 & m, F[1] = m >>> 8 & 255, F[2] = m >>> 16 & 255, F[3] = m >>> 24 & 255, r.check = i(r.check, F, 4, 0)), v = m = 0, r.mode = 4;

                case 4:
                  for (; v < 16;) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  r.head && (r.head.xflags = 255 & m, r.head.os = m >> 8), 512 & r.flags && (F[0] = 255 & m, F[1] = m >>> 8 & 255, r.check = i(r.check, F, 2, 0)), v = m = 0, r.mode = 5;

                case 5:
                  if (1024 & r.flags) {
                    for (; v < 16;) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    r.length = m, r.head && (r.head.extra_len = m), 512 & r.flags && (F[0] = 255 & m, F[1] = m >>> 8 & 255, r.check = i(r.check, F, 2, 0)), v = m = 0;
                  } else r.head && (r.head.extra = null);

                  r.mode = 6;

                case 6:
                  if (1024 & r.flags && (d < (_ = r.length) && (_ = d), _ && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, l, h, _, k)), 512 & r.flags && (r.check = i(r.check, l, _, h)), d -= _, h += _, r.length -= _), r.length)) break t;
                  r.length = 0, r.mode = 7;

                case 7:
                  if (2048 & r.flags) {
                    if (0 === d) break t;

                    for (_ = 0; k = l[h + _++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && _ < d;) {
                      ;
                    }

                    if (512 & r.flags && (r.check = i(r.check, l, _, h)), d -= _, h += _, k) break t;
                  } else r.head && (r.head.name = null);

                  r.length = 0, r.mode = 8;

                case 8:
                  if (4096 & r.flags) {
                    if (0 === d) break t;

                    for (_ = 0; k = l[h + _++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && _ < d;) {
                      ;
                    }

                    if (512 & r.flags && (r.check = i(r.check, l, _, h)), d -= _, h += _, k) break t;
                  } else r.head && (r.head.comment = null);

                  r.mode = 9;

                case 9:
                  if (512 & r.flags) {
                    for (; v < 16;) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    if (m !== (65535 & r.check)) {
                      t.msg = "header crc mismatch", r.mode = 30;
                      break;
                    }

                    v = m = 0;
                  }

                  r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), t.adler = r.check = 0, r.mode = 12;
                  break;

                case 10:
                  for (; v < 32;) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  t.adler = r.check = u(m), v = m = 0, r.mode = 11;

                case 11:
                  if (0 === r.havedict) return t.next_out = p, t.avail_out = y, t.next_in = h, t.avail_in = d, r.hold = m, r.bits = v, 2;
                  t.adler = r.check = 1, r.mode = 12;

                case 12:
                  if (5 === e || 6 === e) break t;

                case 13:
                  if (r.last) {
                    m >>>= 7 & v, v -= 7 & v, r.mode = 27;
                    break;
                  }

                  for (; v < 3;) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  switch (r.last = 1 & m, v -= 1, 3 & (m >>>= 1)) {
                    case 0:
                      r.mode = 14;
                      break;

                    case 1:
                      if (g(r), r.mode = 20, 6 !== e) break;
                      m >>>= 2, v -= 2;
                      break t;

                    case 2:
                      r.mode = 17;
                      break;

                    case 3:
                      t.msg = "invalid block type", r.mode = 30;
                  }

                  m >>>= 2, v -= 2;
                  break;

                case 14:
                  for (m >>>= 7 & v, v -= 7 & v; v < 32;) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  if ((65535 & m) != (m >>> 16 ^ 65535)) {
                    t.msg = "invalid stored block lengths", r.mode = 30;
                    break;
                  }

                  if (r.length = 65535 & m, v = m = 0, r.mode = 15, 6 === e) break t;

                case 15:
                  r.mode = 16;

                case 16:
                  if (_ = r.length) {
                    if (d < _ && (_ = d), y < _ && (_ = y), 0 === _) break t;
                    n.arraySet(f, l, h, _, p), d -= _, h += _, y -= _, p += _, r.length -= _;
                    break;
                  }

                  r.mode = 12;
                  break;

                case 17:
                  for (; v < 14;) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  if (r.nlen = 257 + (31 & m), m >>>= 5, v -= 5, r.ndist = 1 + (31 & m), m >>>= 5, v -= 5, r.ncode = 4 + (15 & m), m >>>= 4, v -= 4, 286 < r.nlen || 30 < r.ndist) {
                    t.msg = "too many length or distance symbols", r.mode = 30;
                    break;
                  }

                  r.have = 0, r.mode = 18;

                case 18:
                  for (; r.have < r.ncode;) {
                    for (; v < 3;) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    r.lens[W[r.have++]] = 7 & m, m >>>= 3, v -= 3;
                  }

                  for (; r.have < 19;) {
                    r.lens[W[r.have++]] = 0;
                  }

                  if (r.lencode = r.lendyn, r.lenbits = 7, Z = {
                    bits: r.lenbits
                  }, j = s(0, r.lens, 0, 19, r.lencode, 0, r.work, Z), r.lenbits = Z.bits, j) {
                    t.msg = "invalid code lengths set", r.mode = 30;
                    break;
                  }

                  r.have = 0, r.mode = 19;

                case 19:
                  for (; r.have < r.nlen + r.ndist;) {
                    for (; A = (C = r.lencode[m & (1 << r.lenbits) - 1]) >>> 16 & 255, R = 65535 & C, !((E = C >>> 24) <= v);) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    if (R < 16) m >>>= E, v -= E, r.lens[r.have++] = R;else {
                      if (16 === R) {
                        for (M = E + 2; v < M;) {
                          if (0 === d) break t;
                          d--, m += l[h++] << v, v += 8;
                        }

                        if (m >>>= E, v -= E, 0 === r.have) {
                          t.msg = "invalid bit length repeat", r.mode = 30;
                          break;
                        }

                        k = r.lens[r.have - 1], _ = 3 + (3 & m), m >>>= 2, v -= 2;
                      } else if (17 === R) {
                        for (M = E + 3; v < M;) {
                          if (0 === d) break t;
                          d--, m += l[h++] << v, v += 8;
                        }

                        v -= E, k = 0, _ = 3 + (7 & (m >>>= E)), m >>>= 3, v -= 3;
                      } else {
                        for (M = E + 7; v < M;) {
                          if (0 === d) break t;
                          d--, m += l[h++] << v, v += 8;
                        }

                        v -= E, k = 0, _ = 11 + (127 & (m >>>= E)), m >>>= 7, v -= 7;
                      }

                      if (r.have + _ > r.nlen + r.ndist) {
                        t.msg = "invalid bit length repeat", r.mode = 30;
                        break;
                      }

                      for (; _--;) {
                        r.lens[r.have++] = k;
                      }
                    }
                  }

                  if (30 === r.mode) break;

                  if (0 === r.lens[256]) {
                    t.msg = "invalid code -- missing end-of-block", r.mode = 30;
                    break;
                  }

                  if (r.lenbits = 9, Z = {
                    bits: r.lenbits
                  }, j = s(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, Z), r.lenbits = Z.bits, j) {
                    t.msg = "invalid literal/lengths set", r.mode = 30;
                    break;
                  }

                  if (r.distbits = 6, r.distcode = r.distdyn, Z = {
                    bits: r.distbits
                  }, j = s(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, Z), r.distbits = Z.bits, j) {
                    t.msg = "invalid distances set", r.mode = 30;
                    break;
                  }

                  if (r.mode = 20, 6 === e) break t;

                case 20:
                  r.mode = 21;

                case 21:
                  if (6 <= d && 258 <= y) {
                    t.next_out = p, t.avail_out = y, t.next_in = h, t.avail_in = d, r.hold = m, r.bits = v, a(t, O), p = t.next_out, f = t.output, y = t.avail_out, h = t.next_in, l = t.input, d = t.avail_in, m = r.hold, v = r.bits, 12 === r.mode && (r.back = -1);
                    break;
                  }

                  for (r.back = 0; A = (C = r.lencode[m & (1 << r.lenbits) - 1]) >>> 16 & 255, R = 65535 & C, !((E = C >>> 24) <= v);) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  if (A && 0 == (240 & A)) {
                    for (T = E, P = A, S = R; A = (C = r.lencode[S + ((m & (1 << T + P) - 1) >> T)]) >>> 16 & 255, R = 65535 & C, !(T + (E = C >>> 24) <= v);) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    m >>>= T, v -= T, r.back += T;
                  }

                  if (m >>>= E, v -= E, r.back += E, r.length = R, 0 === A) {
                    r.mode = 26;
                    break;
                  }

                  if (32 & A) {
                    r.back = -1, r.mode = 12;
                    break;
                  }

                  if (64 & A) {
                    t.msg = "invalid literal/length code", r.mode = 30;
                    break;
                  }

                  r.extra = 15 & A, r.mode = 22;

                case 22:
                  if (r.extra) {
                    for (M = r.extra; v < M;) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    r.length += m & (1 << r.extra) - 1, m >>>= r.extra, v -= r.extra, r.back += r.extra;
                  }

                  r.was = r.length, r.mode = 23;

                case 23:
                  for (; A = (C = r.distcode[m & (1 << r.distbits) - 1]) >>> 16 & 255, R = 65535 & C, !((E = C >>> 24) <= v);) {
                    if (0 === d) break t;
                    d--, m += l[h++] << v, v += 8;
                  }

                  if (0 == (240 & A)) {
                    for (T = E, P = A, S = R; A = (C = r.distcode[S + ((m & (1 << T + P) - 1) >> T)]) >>> 16 & 255, R = 65535 & C, !(T + (E = C >>> 24) <= v);) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    m >>>= T, v -= T, r.back += T;
                  }

                  if (m >>>= E, v -= E, r.back += E, 64 & A) {
                    t.msg = "invalid distance code", r.mode = 30;
                    break;
                  }

                  r.offset = R, r.extra = 15 & A, r.mode = 24;

                case 24:
                  if (r.extra) {
                    for (M = r.extra; v < M;) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    r.offset += m & (1 << r.extra) - 1, m >>>= r.extra, v -= r.extra, r.back += r.extra;
                  }

                  if (r.offset > r.dmax) {
                    t.msg = "invalid distance too far back", r.mode = 30;
                    break;
                  }

                  r.mode = 25;

                case 25:
                  if (0 === y) break t;

                  if (_ = O - y, r.offset > _) {
                    if ((_ = r.offset - _) > r.whave && r.sane) {
                      t.msg = "invalid distance too far back", r.mode = 30;
                      break;
                    }

                    x = _ > r.wnext ? (_ -= r.wnext, r.wsize - _) : r.wnext - _, _ > r.length && (_ = r.length), L = r.window;
                  } else L = f, x = p - r.offset, _ = r.length;

                  for (y < _ && (_ = y), y -= _, r.length -= _; f[p++] = L[x++], --_;) {
                    ;
                  }

                  0 === r.length && (r.mode = 21);
                  break;

                case 26:
                  if (0 === y) break t;
                  f[p++] = r.length, y--, r.mode = 21;
                  break;

                case 27:
                  if (r.wrap) {
                    for (; v < 32;) {
                      if (0 === d) break t;
                      d--, m |= l[h++] << v, v += 8;
                    }

                    if (O -= y, t.total_out += O, r.total += O, O && (t.adler = r.check = r.flags ? i(r.check, f, O, p - O) : o(r.check, f, O, p - O)), O = y, (r.flags ? m : u(m)) !== r.check) {
                      t.msg = "incorrect data check", r.mode = 30;
                      break;
                    }

                    v = m = 0;
                  }

                  r.mode = 28;

                case 28:
                  if (r.wrap && r.flags) {
                    for (; v < 32;) {
                      if (0 === d) break t;
                      d--, m += l[h++] << v, v += 8;
                    }

                    if (m !== (4294967295 & r.total)) {
                      t.msg = "incorrect length check", r.mode = 30;
                      break;
                    }

                    v = m = 0;
                  }

                  r.mode = 29;

                case 29:
                  j = 1;
                  break t;

                case 30:
                  j = -3;
                  break t;

                case 31:
                  return -4;

                default:
                  return c;
              }
            }

            return t.next_out = p, t.avail_out = y, t.next_in = h, t.avail_in = d, r.hold = m, r.bits = v, (r.wsize || O !== t.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== e)) && b(t, t.output, t.next_out, O - t.avail_out) ? (r.mode = 31, -4) : (w -= t.avail_in, O -= t.avail_out, t.total_in += w, t.total_out += O, r.total += O, r.wrap && O && (t.adler = r.check = r.flags ? i(r.check, f, O, t.next_out - O) : o(r.check, f, O, t.next_out - O)), t.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == w && 0 === O || 4 === e) && 0 === j && (j = -5), j);
          }, r.inflateEnd = function (t) {
            if (!t || !t.state) return c;
            var e = t.state;
            return e.window && (e.window = null), t.state = null, 0;
          }, r.inflateGetHeader = function (t, e) {
            var r;
            return t && t.state ? 0 == (2 & (r = t.state).wrap) ? c : ((r.head = e).done = !1, 0) : c;
          }, r.inflateSetDictionary = function (t, e) {
            var r,
                n = e.length;
            return t && t.state ? 0 !== (r = t.state).wrap && 11 !== r.mode ? c : 11 === r.mode && o(1, e, n, 0) !== r.check ? -3 : b(t, e, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : c;
          }, r.inflateInfo = "pako inflate (from Nodeca project)";
        }, {
          "../utils/common": 41,
          "./adler32": 43,
          "./crc32": 45,
          "./inffast": 48,
          "./inftrees": 50
        }],
        50: [function (t, e, r) {
          "use strict";

          var n = t("../utils/common"),
              o = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
              i = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
              a = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
              s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

          e.exports = function (t, e, r, c, u, l, f, h) {
            var p,
                d,
                y,
                m,
                v,
                g,
                b,
                w,
                O,
                _ = h.bits,
                x = 0,
                L = 0,
                E = 0,
                A = 0,
                R = 0,
                T = 0,
                P = 0,
                S = 0,
                k = 0,
                j = 0,
                Z = null,
                M = 0,
                C = new n.Buf16(16),
                F = new n.Buf16(16),
                W = null,
                B = 0;

            for (x = 0; x <= 15; x++) {
              C[x] = 0;
            }

            for (L = 0; L < c; L++) {
              C[e[r + L]]++;
            }

            for (R = _, A = 15; 1 <= A && 0 === C[A]; A--) {
              ;
            }

            if (A < R && (R = A), 0 === A) return u[l++] = 20971520, u[l++] = 20971520, h.bits = 1, 0;

            for (E = 1; E < A && 0 === C[E]; E++) {
              ;
            }

            for (R < E && (R = E), x = S = 1; x <= 15; x++) {
              if (S <<= 1, (S -= C[x]) < 0) return -1;
            }

            if (0 < S && (0 === t || 1 !== A)) return -1;

            for (F[1] = 0, x = 1; x < 15; x++) {
              F[x + 1] = F[x] + C[x];
            }

            for (L = 0; L < c; L++) {
              0 !== e[r + L] && (f[F[e[r + L]]++] = L);
            }

            if (g = 0 === t ? (Z = W = f, 19) : 1 === t ? (Z = o, M -= 257, W = i, B -= 257, 256) : (Z = a, W = s, -1), x = E, v = l, P = L = j = 0, y = -1, m = (k = 1 << (T = R)) - 1, 1 === t && 852 < k || 2 === t && 592 < k) return 1;

            for (;;) {
              for (b = x - P, O = f[L] < g ? (w = 0, f[L]) : f[L] > g ? (w = W[B + f[L]], Z[M + f[L]]) : (w = 96, 0), p = 1 << x - P, E = d = 1 << T; u[v + (j >> P) + (d -= p)] = b << 24 | w << 16 | O | 0, 0 !== d;) {
                ;
              }

              for (p = 1 << x - 1; j & p;) {
                p >>= 1;
              }

              if (0 !== p ? (j &= p - 1, j += p) : j = 0, L++, 0 == --C[x]) {
                if (x === A) break;
                x = e[r + f[L]];
              }

              if (R < x && (j & m) !== y) {
                for (0 === P && (P = R), v += E, S = 1 << (T = x - P); T + P < A && !((S -= C[T + P]) <= 0);) {
                  T++, S <<= 1;
                }

                if (k += 1 << T, 1 === t && 852 < k || 2 === t && 592 < k) return 1;
                u[y = j & m] = R << 24 | T << 16 | v - l | 0;
              }
            }

            return 0 !== j && (u[v + j] = x - P << 24 | 64 << 16 | 0), h.bits = R, 0;
          };
        }, {
          "../utils/common": 41
        }],
        51: [function (t, e, r) {
          "use strict";

          e.exports = {
            2: "need dictionary",
            1: "stream end",
            0: "",
            "-1": "file error",
            "-2": "stream error",
            "-3": "data error",
            "-4": "insufficient memory",
            "-5": "buffer error",
            "-6": "incompatible version"
          };
        }, {}],
        52: [function (t, e, r) {
          "use strict";

          var n = t("../utils/common");

          function o(t) {
            for (var e = t.length; 0 <= --e;) {
              t[e] = 0;
            }
          }

          var i = 256,
              a = 286,
              s = 30,
              c = 15,
              u = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
              l = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
              f = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
              h = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
              p = new Array(576);
          o(p);
          var d = new Array(60);
          o(d);
          var y = new Array(512);
          o(y);
          var m = new Array(256);
          o(m);
          var v = new Array(29);
          o(v);
          var g,
              b,
              w,
              O = new Array(s);

          function _(t, e, r, n, o) {
            this.static_tree = t, this.extra_bits = e, this.extra_base = r, this.elems = n, this.max_length = o, this.has_stree = t && t.length;
          }

          function x(t, e) {
            this.dyn_tree = t, this.max_code = 0, this.stat_desc = e;
          }

          function L(t) {
            return t < 256 ? y[t] : y[256 + (t >>> 7)];
          }

          function E(t, e) {
            t.pending_buf[t.pending++] = 255 & e, t.pending_buf[t.pending++] = e >>> 8 & 255;
          }

          function A(t, e, r) {
            t.bi_valid > 16 - r ? (t.bi_buf |= e << t.bi_valid & 65535, E(t, t.bi_buf), t.bi_buf = e >> 16 - t.bi_valid, t.bi_valid += r - 16) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += r);
          }

          function R(t, e, r) {
            A(t, r[2 * e], r[2 * e + 1]);
          }

          function T(t, e) {
            for (var r = 0; r |= 1 & t, t >>>= 1, r <<= 1, 0 < --e;) {
              ;
            }

            return r >>> 1;
          }

          function P(t, e, r) {
            var n,
                o,
                i = new Array(16),
                a = 0;

            for (n = 1; n <= c; n++) {
              i[n] = a = a + r[n - 1] << 1;
            }

            for (o = 0; o <= e; o++) {
              var s = t[2 * o + 1];
              0 !== s && (t[2 * o] = T(i[s]++, s));
            }
          }

          function S(t) {
            var e;

            for (e = 0; e < a; e++) {
              t.dyn_ltree[2 * e] = 0;
            }

            for (e = 0; e < s; e++) {
              t.dyn_dtree[2 * e] = 0;
            }

            for (e = 0; e < 19; e++) {
              t.bl_tree[2 * e] = 0;
            }

            t.dyn_ltree[512] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0;
          }

          function k(t) {
            8 < t.bi_valid ? E(t, t.bi_buf) : 0 < t.bi_valid && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
          }

          function j(t, e, r, n) {
            var o = 2 * e,
                i = 2 * r;
            return t[o] < t[i] || t[o] === t[i] && n[e] <= n[r];
          }

          function Z(t, e, r) {
            for (var n = t.heap[r], o = r << 1; o <= t.heap_len && (o < t.heap_len && j(e, t.heap[o + 1], t.heap[o], t.depth) && o++, !j(e, n, t.heap[o], t.depth));) {
              t.heap[r] = t.heap[o], r = o, o <<= 1;
            }

            t.heap[r] = n;
          }

          function M(t, e, r) {
            var n,
                o,
                a,
                s,
                c = 0;
            if (0 !== t.last_lit) for (; n = t.pending_buf[t.d_buf + 2 * c] << 8 | t.pending_buf[t.d_buf + 2 * c + 1], o = t.pending_buf[t.l_buf + c], c++, 0 === n ? R(t, o, e) : (R(t, (a = m[o]) + i + 1, e), 0 !== (s = u[a]) && A(t, o -= v[a], s), R(t, a = L(--n), r), 0 !== (s = l[a]) && A(t, n -= O[a], s)), c < t.last_lit;) {
              ;
            }
            R(t, 256, e);
          }

          function C(t, e) {
            var r,
                n,
                o,
                i = e.dyn_tree,
                a = e.stat_desc.static_tree,
                s = e.stat_desc.has_stree,
                u = e.stat_desc.elems,
                l = -1;

            for (t.heap_len = 0, t.heap_max = 573, r = 0; r < u; r++) {
              0 !== i[2 * r] ? (t.heap[++t.heap_len] = l = r, t.depth[r] = 0) : i[2 * r + 1] = 0;
            }

            for (; t.heap_len < 2;) {
              i[2 * (o = t.heap[++t.heap_len] = l < 2 ? ++l : 0)] = 1, t.depth[o] = 0, t.opt_len--, s && (t.static_len -= a[2 * o + 1]);
            }

            for (e.max_code = l, r = t.heap_len >> 1; 1 <= r; r--) {
              Z(t, i, r);
            }

            for (o = u; r = t.heap[1], t.heap[1] = t.heap[t.heap_len--], Z(t, i, 1), n = t.heap[1], t.heap[--t.heap_max] = r, t.heap[--t.heap_max] = n, i[2 * o] = i[2 * r] + i[2 * n], t.depth[o] = (t.depth[r] >= t.depth[n] ? t.depth[r] : t.depth[n]) + 1, i[2 * r + 1] = i[2 * n + 1] = o, t.heap[1] = o++, Z(t, i, 1), 2 <= t.heap_len;) {
              ;
            }

            t.heap[--t.heap_max] = t.heap[1], function (t, e) {
              var r,
                  n,
                  o,
                  i,
                  a,
                  s,
                  u = e.dyn_tree,
                  l = e.max_code,
                  f = e.stat_desc.static_tree,
                  h = e.stat_desc.has_stree,
                  p = e.stat_desc.extra_bits,
                  d = e.stat_desc.extra_base,
                  y = e.stat_desc.max_length,
                  m = 0;

              for (i = 0; i <= c; i++) {
                t.bl_count[i] = 0;
              }

              for (u[2 * t.heap[t.heap_max] + 1] = 0, r = t.heap_max + 1; r < 573; r++) {
                y < (i = u[2 * u[2 * (n = t.heap[r]) + 1] + 1] + 1) && (i = y, m++), u[2 * n + 1] = i, l < n || (t.bl_count[i]++, a = 0, d <= n && (a = p[n - d]), s = u[2 * n], t.opt_len += s * (i + a), h && (t.static_len += s * (f[2 * n + 1] + a)));
              }

              if (0 !== m) {
                do {
                  for (i = y - 1; 0 === t.bl_count[i];) {
                    i--;
                  }

                  t.bl_count[i]--, t.bl_count[i + 1] += 2, t.bl_count[y]--, m -= 2;
                } while (0 < m);

                for (i = y; 0 !== i; i--) {
                  for (n = t.bl_count[i]; 0 !== n;) {
                    l < (o = t.heap[--r]) || (u[2 * o + 1] !== i && (t.opt_len += (i - u[2 * o + 1]) * u[2 * o], u[2 * o + 1] = i), n--);
                  }
                }
              }
            }(t, e), P(i, l, t.bl_count);
          }

          function F(t, e, r) {
            var n,
                o,
                i = -1,
                a = e[1],
                s = 0,
                c = 7,
                u = 4;

            for (0 === a && (c = 138, u = 3), e[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++) {
              o = a, a = e[2 * (n + 1) + 1], ++s < c && o === a || (s < u ? t.bl_tree[2 * o] += s : 0 !== o ? (o !== i && t.bl_tree[2 * o]++, t.bl_tree[32]++) : s <= 10 ? t.bl_tree[34]++ : t.bl_tree[36]++, i = o, u = (s = 0) === a ? (c = 138, 3) : o === a ? (c = 6, 3) : (c = 7, 4));
            }
          }

          function W(t, e, r) {
            var n,
                o,
                i = -1,
                a = e[1],
                s = 0,
                c = 7,
                u = 4;

            for (0 === a && (c = 138, u = 3), n = 0; n <= r; n++) {
              if (o = a, a = e[2 * (n + 1) + 1], !(++s < c && o === a)) {
                if (s < u) for (; R(t, o, t.bl_tree), 0 != --s;) {
                  ;
                } else 0 !== o ? (o !== i && (R(t, o, t.bl_tree), s--), R(t, 16, t.bl_tree), A(t, s - 3, 2)) : s <= 10 ? (R(t, 17, t.bl_tree), A(t, s - 3, 3)) : (R(t, 18, t.bl_tree), A(t, s - 11, 7));
                i = o, u = (s = 0) === a ? (c = 138, 3) : o === a ? (c = 6, 3) : (c = 7, 4);
              }
            }
          }

          o(O);
          var B = !1;

          function N(t, e, r, o) {
            A(t, 0 + (o ? 1 : 0), 3), function (t, e, r, o) {
              k(t), E(t, r), E(t, ~r), n.arraySet(t.pending_buf, t.window, e, r, t.pending), t.pending += r;
            }(t, e, r);
          }

          r._tr_init = function (t) {
            B || (function () {
              var t,
                  e,
                  r,
                  n,
                  o,
                  i = new Array(16);

              for (n = r = 0; n < 28; n++) {
                for (v[n] = r, t = 0; t < 1 << u[n]; t++) {
                  m[r++] = n;
                }
              }

              for (m[r - 1] = n, n = o = 0; n < 16; n++) {
                for (O[n] = o, t = 0; t < 1 << l[n]; t++) {
                  y[o++] = n;
                }
              }

              for (o >>= 7; n < s; n++) {
                for (O[n] = o << 7, t = 0; t < 1 << l[n] - 7; t++) {
                  y[256 + o++] = n;
                }
              }

              for (e = 0; e <= c; e++) {
                i[e] = 0;
              }

              for (t = 0; t <= 143;) {
                p[2 * t + 1] = 8, t++, i[8]++;
              }

              for (; t <= 255;) {
                p[2 * t + 1] = 9, t++, i[9]++;
              }

              for (; t <= 279;) {
                p[2 * t + 1] = 7, t++, i[7]++;
              }

              for (; t <= 287;) {
                p[2 * t + 1] = 8, t++, i[8]++;
              }

              for (P(p, 287, i), t = 0; t < s; t++) {
                d[2 * t + 1] = 5, d[2 * t] = T(t, 5);
              }

              g = new _(p, u, 257, a, c), b = new _(d, l, 0, s, c), w = new _(new Array(0), f, 0, 19, 7);
            }(), B = !0), t.l_desc = new x(t.dyn_ltree, g), t.d_desc = new x(t.dyn_dtree, b), t.bl_desc = new x(t.bl_tree, w), t.bi_buf = 0, t.bi_valid = 0, S(t);
          }, r._tr_stored_block = N, r._tr_flush_block = function (t, e, r, n) {
            var o,
                a,
                s = 0;
            0 < t.level ? (2 === t.strm.data_type && (t.strm.data_type = function (t) {
              var e,
                  r = 4093624447;

              for (e = 0; e <= 31; e++, r >>>= 1) {
                if (1 & r && 0 !== t.dyn_ltree[2 * e]) return 0;
              }

              if (0 !== t.dyn_ltree[18] || 0 !== t.dyn_ltree[20] || 0 !== t.dyn_ltree[26]) return 1;

              for (e = 32; e < i; e++) {
                if (0 !== t.dyn_ltree[2 * e]) return 1;
              }

              return 0;
            }(t)), C(t, t.l_desc), C(t, t.d_desc), s = function (t) {
              var e;

              for (F(t, t.dyn_ltree, t.l_desc.max_code), F(t, t.dyn_dtree, t.d_desc.max_code), C(t, t.bl_desc), e = 18; 3 <= e && 0 === t.bl_tree[2 * h[e] + 1]; e--) {
                ;
              }

              return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
            }(t), o = t.opt_len + 3 + 7 >>> 3, (a = t.static_len + 3 + 7 >>> 3) <= o && (o = a)) : o = a = r + 5, r + 4 <= o && -1 !== e ? N(t, e, r, n) : 4 === t.strategy || a === o ? (A(t, 2 + (n ? 1 : 0), 3), M(t, p, d)) : (A(t, 4 + (n ? 1 : 0), 3), function (t, e, r, n) {
              var o;

              for (A(t, e - 257, 5), A(t, r - 1, 5), A(t, n - 4, 4), o = 0; o < n; o++) {
                A(t, t.bl_tree[2 * h[o] + 1], 3);
              }

              W(t, t.dyn_ltree, e - 1), W(t, t.dyn_dtree, r - 1);
            }(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, s + 1), M(t, t.dyn_ltree, t.dyn_dtree)), S(t), n && k(t);
          }, r._tr_tally = function (t, e, r) {
            return t.pending_buf[t.d_buf + 2 * t.last_lit] = e >>> 8 & 255, t.pending_buf[t.d_buf + 2 * t.last_lit + 1] = 255 & e, t.pending_buf[t.l_buf + t.last_lit] = 255 & r, t.last_lit++, 0 === e ? t.dyn_ltree[2 * r]++ : (t.matches++, e--, t.dyn_ltree[2 * (m[r] + i + 1)]++, t.dyn_dtree[2 * L(e)]++), t.last_lit === t.lit_bufsize - 1;
          }, r._tr_align = function (t) {
            A(t, 2, 3), R(t, 256, p), function (t) {
              16 === t.bi_valid ? (E(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : 8 <= t.bi_valid && (t.pending_buf[t.pending++] = 255 & t.bi_buf, t.bi_buf >>= 8, t.bi_valid -= 8);
            }(t);
          };
        }, {
          "../utils/common": 41
        }],
        53: [function (t, e, r) {
          "use strict";

          e.exports = function () {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          };
        }, {}],
        54: [function (t, e, r) {
          "use strict";

          e.exports = "function" == typeof setImmediate ? setImmediate : function () {
            var t = [].slice.apply(arguments);
            t.splice(1, 0, 0), setTimeout.apply(null, t);
          };
        }, {}]
      }, {}, [10])(10);
    },
    2703: function _(t, e, r) {
      "use strict";

      var n = r(414);

      function o() {}

      function i() {}

      i.resetWarningCache = o, t.exports = function () {
        function t(t, e, r, o, i, a) {
          if (a !== n) {
            var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw s.name = "Invariant Violation", s;
          }
        }

        function e() {
          return t;
        }

        t.isRequired = t;
        var r = {
          array: t,
          bool: t,
          func: t,
          number: t,
          object: t,
          string: t,
          symbol: t,
          any: t,
          arrayOf: e,
          element: t,
          elementType: t,
          instanceOf: e,
          node: t,
          objectOf: e,
          oneOf: e,
          oneOfType: e,
          shape: e,
          exact: e,
          checkPropTypes: i,
          resetWarningCache: o
        };
        return r.PropTypes = r, r;
      };
    },
    5697: function _(t, e, r) {
      t.exports = r(2703)();
    },
    414: function _(t) {
      "use strict";

      t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    9921: function _(t, e) {
      "use strict";

      var r = "function" == typeof Symbol && Symbol.for,
          n = r ? Symbol.for("react.element") : 60103,
          o = r ? Symbol.for("react.portal") : 60106,
          i = r ? Symbol.for("react.fragment") : 60107,
          a = r ? Symbol.for("react.strict_mode") : 60108,
          s = r ? Symbol.for("react.profiler") : 60114,
          c = r ? Symbol.for("react.provider") : 60109,
          u = r ? Symbol.for("react.context") : 60110,
          l = r ? Symbol.for("react.async_mode") : 60111,
          f = r ? Symbol.for("react.concurrent_mode") : 60111,
          h = r ? Symbol.for("react.forward_ref") : 60112,
          p = r ? Symbol.for("react.suspense") : 60113,
          d = r ? Symbol.for("react.suspense_list") : 60120,
          y = r ? Symbol.for("react.memo") : 60115,
          m = r ? Symbol.for("react.lazy") : 60116,
          v = r ? Symbol.for("react.block") : 60121,
          g = r ? Symbol.for("react.fundamental") : 60117,
          b = r ? Symbol.for("react.responder") : 60118,
          w = r ? Symbol.for("react.scope") : 60119;

      function O(t) {
        if ("object" == typeof t && null !== t) {
          var e = t.$$typeof;

          switch (e) {
            case n:
              switch (t = t.type) {
                case l:
                case f:
                case i:
                case s:
                case a:
                case p:
                  return t;

                default:
                  switch (t = t && t.$$typeof) {
                    case u:
                    case h:
                    case m:
                    case y:
                    case c:
                      return t;

                    default:
                      return e;
                  }

              }

            case o:
              return e;
          }
        }
      }

      function _(t) {
        return O(t) === f;
      }

      e.AsyncMode = l, e.ConcurrentMode = f, e.ContextConsumer = u, e.ContextProvider = c, e.Element = n, e.ForwardRef = h, e.Fragment = i, e.Lazy = m, e.Memo = y, e.Portal = o, e.Profiler = s, e.StrictMode = a, e.Suspense = p, e.isAsyncMode = function (t) {
        return _(t) || O(t) === l;
      }, e.isConcurrentMode = _, e.isContextConsumer = function (t) {
        return O(t) === u;
      }, e.isContextProvider = function (t) {
        return O(t) === c;
      }, e.isElement = function (t) {
        return "object" == typeof t && null !== t && t.$$typeof === n;
      }, e.isForwardRef = function (t) {
        return O(t) === h;
      }, e.isFragment = function (t) {
        return O(t) === i;
      }, e.isLazy = function (t) {
        return O(t) === m;
      }, e.isMemo = function (t) {
        return O(t) === y;
      }, e.isPortal = function (t) {
        return O(t) === o;
      }, e.isProfiler = function (t) {
        return O(t) === s;
      }, e.isStrictMode = function (t) {
        return O(t) === a;
      }, e.isSuspense = function (t) {
        return O(t) === p;
      }, e.isValidElementType = function (t) {
        return "string" == typeof t || "function" == typeof t || t === i || t === f || t === s || t === a || t === p || t === d || "object" == typeof t && null !== t && (t.$$typeof === m || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === h || t.$$typeof === g || t.$$typeof === b || t.$$typeof === w || t.$$typeof === v);
      }, e.typeOf = O;
    },
    9864: function _(t, e, r) {
      "use strict";

      t.exports = r(9921);
    },
    6626: function _(t, e, r) {
      "use strict";

      r.d(e, {
        collect: function collect() {
          return $;
        },
        store: function store() {
          return J;
        }
      });

      var n = {
        currentComponent: null,
        isBatchUpdating: !1,
        isInBrowser: "undefined" != typeof window,
        listeners: new Map(),
        manualListeners: [],
        nextVersionMap: new WeakMap(),
        proxyIsMuted: !1,
        redirectToNext: !0,
        store: {}
      },
          o = Symbol("PATH"),
          i = Symbol("ORIGINAL"),
          a = "RR_DEBUG",
          s = function s(t) {
        return !!t && "object" == typeof t && t.constructor === Object;
      },
          c = function c(t) {
        return Array.isArray(t);
      },
          u = function u(t) {
        return t instanceof Map;
      },
          l = function l(t) {
        return t instanceof Set;
      },
          f = function f(t) {
        return s(t) || c(t) || u(t) || l(t);
      },
          h = function h(t) {
        return t === o || "constructor" === t || "toJSON" === t || "@@toStringTag" === t || t === Symbol.toStringTag;
      },
          p = function p(t) {
        return "function" == typeof t;
      },
          d = function d(t) {
        return s(t) ? Object.assign({}, t) : c(t) ? t.slice() : u(t) ? new Map(t) : l(t) ? new Set(t) : t;
      },
          y = function y(t, e) {
        return u(t) ? t.get(e) : l(t) ? e : (c(t), t[e]);
      },
          m = function m(t, e, r) {
        if (s(t)) t[e] = r;else if (c(t)) t[e] = r;else if (u(t)) t.set(e, r);else {
          if (!l(t)) throw Error("Unexpected type");
          t.add(r);
        }
      },
          v = function v(t) {
        if (s(t)) return Object.keys(t).length;
        if (c(t)) return t.length;
        if (u(t) || l(t)) return t.size;
        throw Error("Unexpected type");
      },
          g = function g(t, e) {
        var r = [],
            n = function n(t) {
          var o = e(t, r.slice()),
              i = void 0 !== o ? o : t,
              a = function a(t, e) {
            r.push(t);
            var o = n(e);
            r.pop(), m(i, t, o);
          };

          if (s(i)) Object.entries(i).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                t = _ref2[0],
                e = _ref2[1];

            a(t, e);
          });else if (c(i) || u(i)) i.forEach(function (t, e) {
            a(e, t);
          });else if (l(i)) {
            var _t5 = Array.from(i);

            i.clear(), _t5.forEach(function (t) {
              a(t, t);
            });
          }
          return i;
        };

        return n(t);
      },
          b = function b(t) {
        n.proxyIsMuted = !0;
        var e = t();
        return n.proxyIsMuted = !1, e;
      },
          w = function w(t, e) {
        return t.map(function (t) {
          return t.toString();
        }).join(e);
      },
          O = function O(t) {
        return w(t, ".");
      },
          _ = function _(t) {
        return w(t, "~~~");
      },
          x = function x(t, e) {
        var r = t[o] || [];
        return void 0 === e ? r : r.concat(e);
      },
          L = function L(t, e) {
        return O(x(t, e));
      },
          E = function E(t, e) {
        t && Object.defineProperty(t, o, {
          value: e,
          writable: !0
        });
      },
          A = function A(t) {
        return t[o] || [];
      },
          R = "undefined" != typeof window && !!window.localStorage,
          T = function T(t, e) {
        if (R) try {
          var _r8 = "string" == typeof e ? e : JSON.stringify(e);

          return localStorage.setItem(t, _r8);
        } catch (t) {
          return;
        }
      },
          P = "on",
          S = "off";

      var k = function (t) {
        if (!R) return;
        var e = localStorage.getItem("RR_DEBUG");
        if (!e) return e;

        try {
          return JSON.parse(e);
        } catch (t) {
          return e;
        }
      }() || S;

      k === P && console.info("Recollect debugging is enabled. Type __RR__.debugOff() to turn it off.");

      var j = function j(t) {
        k === P && t();
      },
          Z = function Z(t, e, r) {
        j(function () {
          console.groupCollapsed("GET: ".concat(L(t, e))), console.info("Component: <".concat(n.currentComponent._name, ">")), void 0 !== r && console.info("Value:", r), console.groupEnd();
        });
      },
          M = function M(t, e, r) {
        j(function () {
          console.groupCollapsed("SET: ".concat(L(t, e))), console.info("From:", y(t, e)), console.info("To:  ", r), console.groupEnd();
        });
      },
          C = {},
          F = function F(t) {
        return C.UpdateNextStore(t);
      },
          W = function W(t) {
        if (!n.currentComponent) return;

        var e = _(t),
            r = n.listeners.get(e) || new Set();

        r.add(n.currentComponent), n.listeners.set(e, r);
      },
          B = function B(t) {
        return new Proxy(t, u(e = t) || l(e) ? {
          get: function get(t, e) {
            if (e === i) return t;
            var r = Reflect.get(t, e);
            if (p(r) && (r = r.bind(t)), n.proxyIsMuted || h(e)) return r;

            if (!n.currentComponent && n.redirectToNext) {
              var _r9 = n.nextVersionMap.get(t);

              if (_r9) return Reflect.get(_r9, e);
            }

            return "set" === e ? new Proxy(r, {
              apply: function apply(r, n, _ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    o = _ref4[0],
                    i = _ref4[1];

                return n.get(o) === i || F({
                  target: n,
                  prop: o,
                  value: i,
                  updater: function updater(r, n) {
                    return M(t, e, n), Reflect.apply(r[e], r, [o, n]);
                  }
                });
              }
            }) : "add" === e ? new Proxy(r, {
              apply: function apply(r, n, _ref5) {
                var _ref6 = _slicedToArray(_ref5, 1),
                    o = _ref6[0];

                return !!n.has(o) || F({
                  target: n,
                  notifyTarget: !0,
                  value: o,
                  updater: function updater(r, n) {
                    return M(t, e, n), Reflect.apply(r[e], r, [n]);
                  }
                });
              }
            }) : "clear" === e || "delete" === e ? new Proxy(r, {
              apply: function apply(r, n, _ref7) {
                var _ref8 = _slicedToArray(_ref7, 1),
                    o = _ref8[0];

                return !(!n.size || "delete" === e && !n.has(o)) && F({
                  target: n,
                  notifyTarget: !0,
                  updater: function updater(r) {
                    return M(t, e), Reflect.apply(r[e], r, [o]);
                  }
                });
              }
            }) : n.currentComponent && u(t) && "get" === e ? new Proxy(r, {
              apply: function apply(e, r, n) {
                return W(x(t, n[0])), Reflect.apply(e, r, n);
              }
            }) : r;
          }
        } : {
          get: function get(t, e) {
            if (e === i) return t;
            var r = Reflect.get(t, e);
            if (n.proxyIsMuted || h(e)) return r;
            if (function (t, e) {
              return c(t) && ["copyWithin", "fill", "pop", "push", "reverse", "shift", "sort", "splice", "unshift"].includes(e);
            }(t, e)) return new Proxy(r, {
              apply: function apply(r, n, o) {
                return F({
                  target: n,
                  notifyTarget: !0,
                  value: o,
                  updater: function updater(r, n) {
                    M(t, e, n);
                    var o = Reflect.apply(r[e], r, n),
                        i = A(t);
                    return g(r, function (t, e) {
                      f(t) && E(t, [].concat(_toConsumableArray(i), _toConsumableArray(e)));
                    }), o;
                  }
                });
              }
            });
            if (p(t[e])) return r;
            if (n.currentComponent) c(t) && "length" === e || (Z(t, e, r), W(x(t, e)));else if (n.redirectToNext) {
              var _r10 = n.nextVersionMap.get(t);

              if (_r10) return Reflect.get(_r10, e);
            }
            return r;
          },
          has: function has(t, e) {
            var r = Reflect.has(t, e);
            if (n.proxyIsMuted || h(e)) return r;
            if (n.currentComponent) c(t) || (Z(t, e), W(x(t, e)));else {
              var _r11 = n.nextVersionMap.get(t);

              if (_r11) return Reflect.has(_r11, e);
            }
            return r;
          },
          ownKeys: function ownKeys(t) {
            var e = Reflect.ownKeys(t);
            if (n.proxyIsMuted) return e;
            if (n.currentComponent) Z(t), W(A(t));else {
              var _e13 = n.nextVersionMap.get(t);

              if (_e13) return Reflect.ownKeys(_e13);
            }
            return e;
          },
          set: function set(t, e, r) {
            return n.proxyIsMuted ? Reflect.set(t, e, r) : t[e] === r || F({
              target: t,
              prop: e,
              value: r,
              updater: function updater(r, n) {
                return M(t, e, n), Reflect.set(r, e, n);
              }
            });
          },
          deleteProperty: function deleteProperty(t, e) {
            return n.proxyIsMuted ? Reflect.deleteProperty(t, e) : F({
              target: t,
              prop: e,
              notifyTarget: !0,
              updater: function updater(r) {
                return function (t, e) {
                  j(function () {
                    console.groupCollapsed("DELETE: ".concat(L(t, e))), console.info("Property: ", L(t, e)), console.groupEnd();
                  });
                }(t, e), Reflect.deleteProperty(r, e);
              }
            });
          }
        });
        var e;
      },
          N = require("react-dom"),
          I = r.n(N)().unstable_batchedUpdates || function (t) {
        t();
      },
          D = {
        components: new Map(),
        changedPaths: new Set()
      };

      var Y;
      n.store = B({}), Y = function Y(_ref9) {
        var t = _ref9.target,
            e = _ref9.prop,
            r = _ref9.value,
            _ref9$notifyTarget = _ref9.notifyTarget,
            o = _ref9$notifyTarget === void 0 ? !1 : _ref9$notifyTarget,
            a = _ref9.updater;
        return b(function () {
          var s;
          var c = A(t),
              u = x(t, e);
          var l = !1;
          var h = v(t);
          var p = r;
          return f(p) && (p = g(r, function (t, e) {
            if (!f(t)) return t;
            var r = d(t);
            return E(r, [].concat(_toConsumableArray(u), _toConsumableArray(e))), B(r);
          })), c.length ? c.reduce(function (e, r, o) {
            var u = y(e, r);
            var f = d(u);
            return E(f, A(u)), f = B(f), m(e, r, f), o === c.length - 1 && (s = a(f, p), l = v(f) !== h, n.nextVersionMap.set(t[i] || t, f)), f;
          }, n.store) : (s = a(n.store, p), l = v(n.store) !== h), function (t) {
            var e = _(t),
                r = O(t);

            D.changedPaths.add(r), n.listeners.forEach(function (t, n) {
              "" !== e && e !== n || t.forEach(function (t) {
                var e = D.components.get(t) || new Set();
                e.add(r), D.components.set(t, e);
              });
            }), n.isBatchUpdating || (I(function () {
              D.components.forEach(function (t, e) {
                (function (t, e) {
                  j(function () {
                    console.groupCollapsed("UPDATE:  <".concat(t._name, ">")), console.info("Changed properties:", e), console.groupEnd();
                  });
                })(e, Array.from(t)), e.update();
              });
            }), n.manualListeners.forEach(function (t) {
              return t({
                changedProps: Array.from(D.changedPaths),
                renderedComponents: Array.from(D.components.keys()),
                store: n.store
              });
            }), D.components.clear(), D.changedPaths.clear());
          }(o || l ? c : u), s;
        });
      }, C.UpdateNextStore = Y;
      var z = r(1974),
          U = r.n(z),
          G = r(8679),
          K = r.n(G);

      var H = [],
          V = function V() {
        n.isInBrowser && (j(function () {
          console.groupEnd();
        }), H.pop(), n.currentComponent = H[H.length - 1] || null);
      },
          q = function q() {
        return b(function () {
          var t = Object.assign({}, n.store);
          return n.nextVersionMap.set(t, n.store), B(t);
        });
      },
          $ = function $(t) {
        var e = t.displayName || t.name || "NamelessComponent";

        var r = /*#__PURE__*/function (_U$PureComponent) {
          _inherits(r, _U$PureComponent);

          var _super2 = _createSuper(r);

          function r() {
            var _this2;

            _classCallCheck(this, r);

            _this2 = _super2.apply(this, arguments), _this2.state = {
              store: q()
            }, _this2._isMounted = !1, _this2._isMounting = !0, _this2._isRendering = !1, _this2._name = e;
            return _this2;
          }

          _createClass(r, [{
            key: "componentDidMount",
            value: function componentDidMount() {
              this._isMounted = !0, this._isMounting = !1, V(), this._isRendering = !1;
            }
          }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
              V(), this._isRendering = !1;
            }
          }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
              var t;
              t = this, n.listeners.forEach(function (e, _r12) {
                var o = Array.from(e).filter(function (e) {
                  return e !== t;
                });
                o.length ? n.listeners.set(_r12, new Set(o)) : n.listeners.delete(_r12);
              }), this._isMounted = !1;
            }
          }, {
            key: "update",
            value: function update() {
              (this._isMounted || this._isMounting) && this.setState({
                store: q()
              });
            }
          }, {
            key: "render",
            value: function render() {
              var e;
              this._isRendering || (e = this, n.isInBrowser && (j(function () {
                console.groupCollapsed("RENDER: <".concat(e._name, ">"));
              }), n.currentComponent = e, H.push(n.currentComponent)), this._isRendering = !0);

              var _r13 = Object.assign(Object.assign({}, this.props), {
                store: this.state.store
              });

              return U().createElement(t, Object.assign({}, _r13));
            }
          }]);

          return r;
        }(U().PureComponent);

        return r.displayName = "Collected(".concat(e, ")"), K()(r, t);
      };

      var X;
      X = r(5697);
      var J = n.store;
      "undefined" != typeof window && ("Proxy" in window ? window.__RR__ = {
        debugOn: function debugOn() {
          k = P, T(a, P);
        },
        debugOff: function debugOff() {
          k = S, T(a, S);
        },
        internals: n
      } : console.warn("This browser doesn't support the Proxy object, which react-recollect needs. See https://caniuse.com/#search=proxy to find out which browsers do support it"));
    },
    5565: function _(t, e, r) {
      t.exports = r(6626);
    },
    3379: function _(t) {
      "use strict";

      var e = [];

      function r(t) {
        for (var r = -1, n = 0; n < e.length; n++) {
          if (e[n].identifier === t) {
            r = n;
            break;
          }
        }

        return r;
      }

      function n(t, n) {
        for (var i = {}, a = [], s = 0; s < t.length; s++) {
          var c = t[s],
              u = n.base ? c[0] + n.base : c[0],
              l = i[u] || 0,
              f = "".concat(u, " ").concat(l);
          i[u] = l + 1;
          var h = r(f),
              p = {
            css: c[1],
            media: c[2],
            sourceMap: c[3],
            supports: c[4],
            layer: c[5]
          };
          if (-1 !== h) e[h].references++, e[h].updater(p);else {
            var d = o(p, n);
            n.byIndex = s, e.splice(s, 0, {
              identifier: f,
              updater: d,
              references: 1
            });
          }
          a.push(f);
        }

        return a;
      }

      function o(t, e) {
        var r = e.domAPI(e);
        return r.update(t), function (e) {
          if (e) {
            if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap && e.supports === t.supports && e.layer === t.layer) return;
            r.update(t = e);
          } else r.remove();
        };
      }

      t.exports = function (t, o) {
        var i = n(t = t || [], o = o || {});
        return function (t) {
          t = t || [];

          for (var a = 0; a < i.length; a++) {
            var s = r(i[a]);
            e[s].references--;
          }

          for (var c = n(t, o), u = 0; u < i.length; u++) {
            var l = r(i[u]);
            0 === e[l].references && (e[l].updater(), e.splice(l, 1));
          }

          i = c;
        };
      };
    },
    569: function _(t) {
      "use strict";

      var e = {};

      t.exports = function (t, r) {
        var n = function (t) {
          if (void 0 === e[t]) {
            var r = document.querySelector(t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (t) {
              r = null;
            }
            e[t] = r;
          }

          return e[t];
        }(t);

        if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        n.appendChild(r);
      };
    },
    9216: function _(t) {
      "use strict";

      t.exports = function (t) {
        var e = document.createElement("style");
        return t.setAttributes(e, t.attributes), t.insert(e, t.options), e;
      };
    },
    3565: function _(t, e, r) {
      "use strict";

      t.exports = function (t) {
        var e = r.nc;
        e && t.setAttribute("nonce", e);
      };
    },
    7795: function _(t) {
      "use strict";

      t.exports = function (t) {
        var e = t.insertStyleElement(t);
        return {
          update: function update(r) {
            !function (t, e, r) {
              var n = "";
              r.supports && (n += "@supports (".concat(r.supports, ") {")), r.media && (n += "@media ".concat(r.media, " {"));
              var o = void 0 !== r.layer;
              o && (n += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), n += r.css, o && (n += "}"), r.media && (n += "}"), r.supports && (n += "}");
              var i = r.sourceMap;
              i && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), e.styleTagTransform(n, t, e.options);
            }(e, t, r);
          },
          remove: function remove() {
            !function (t) {
              if (null === t.parentNode) return !1;
              t.parentNode.removeChild(t);
            }(e);
          }
        };
      };
    },
    4589: function _(t) {
      "use strict";

      t.exports = function (t, e) {
        if (e.styleSheet) e.styleSheet.cssText = t;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(t));
        }
      };
    },
    3333: function _(t, e, r) {
      var n = {
        "./animate.jsx": 5061,
        "./changezone.jsx": 1183,
        "./chat.jsx": 5317,
        "./dance.jsx": 8304,
        "./dialogue.jsx": 2282,
        "./face.jsx": 2813,
        "./greeting.jsx": 1162,
        "./interact.jsx": 5544,
        "./move.jsx": 2897,
        "./patrol.jsx": 2704,
        "./prompt.jsx": 3382,
        "./script.jsx": 5744
      };

      function o(t) {
        var e = i(t);
        return r(e);
      }

      function i(t) {
        if (!r.o(n, t)) {
          var e = new Error("Cannot find module '" + t + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }

        return n[t];
      }

      o.keys = function () {
        return Object.keys(n);
      }, o.resolve = i, t.exports = o, o.id = 3333;
    },
    4472: function _(t, e, r) {
      var n = {
        "./chat.jsx": 5830,
        "./menu.jsx": 4726
      };

      function o(t) {
        var e = i(t);
        return r(e);
      }

      function i(t) {
        if (!r.o(n, t)) {
          var e = new Error("Cannot find module '" + t + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }

        return n[t];
      }

      o.keys = function () {
        return Object.keys(n);
      }, o.resolve = i, t.exports = o, o.id = 4472;
    },
    2903: function _(t, e, r) {
      "use strict";

      e.NQ = void 0;
      var n = r(9100);
      n.default;
      var o = r(2534);
      o.Material, o.MaterialLibrary;
      var i = r(9933);
      i.Layout, i.TYPES, i.DuplicateAttributeException, i.Attribute;
      var a = r(8352);
      a.downloadModels, a.downloadMeshes, a.initMeshBuffers, a.deleteMeshBuffers;
      e.NQ = {
        Attribute: i.Attribute,
        DuplicateAttributeException: i.DuplicateAttributeException,
        Layout: i.Layout,
        Material: o.Material,
        MaterialLibrary: o.MaterialLibrary,
        Mesh: n.default,
        TYPES: i.TYPES,
        downloadModels: a.downloadModels,
        downloadMeshes: a.downloadMeshes,
        initMeshBuffers: a.initMeshBuffers,
        deleteMeshBuffers: a.deleteMeshBuffers,
        version: "2.0.3"
      };
    },
    9933: function _(t, e) {
      "use strict";

      var _r14,
          n,
          o = this && this.__extends || (_r14 = function r(t, e) {
        return _r14 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }
        }, _r14(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function n() {
          this.constructor = t;
        }

        _r14(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }),
          i = this && this.__values || function (t) {
        var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
        if (r) return r.call(t);
        if (t && "number" == typeof t.length) return {
          next: function next() {
            return t && n >= t.length && (t = void 0), {
              value: t && t[n++],
              done: !t
            };
          }
        };
        throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };

      e.__esModule = !0, e.Layout = e.Attribute = e.DuplicateAttributeException = e.TYPES = void 0, function (t) {
        t.BYTE = "BYTE", t.UNSIGNED_BYTE = "UNSIGNED_BYTE", t.SHORT = "SHORT", t.UNSIGNED_SHORT = "UNSIGNED_SHORT", t.FLOAT = "FLOAT";
      }(n = e.TYPES || (e.TYPES = {}));

      var a = function (t) {
        function e(e) {
          return t.call(this, "found duplicate attribute: ".concat(e.key)) || this;
        }

        return o(e, t), e;
      }(Error);

      e.DuplicateAttributeException = a;

      var s = function s(t, e, r, n) {
        switch (void 0 === n && (n = !1), this.key = t, this.size = e, this.type = r, this.normalized = n, r) {
          case "BYTE":
          case "UNSIGNED_BYTE":
            this.sizeOfType = 1;
            break;

          case "SHORT":
          case "UNSIGNED_SHORT":
            this.sizeOfType = 2;
            break;

          case "FLOAT":
            this.sizeOfType = 4;
            break;

          default:
            throw new Error("Unknown gl type: ".concat(r));
        }

        this.sizeInBytes = this.sizeOfType * e;
      };

      e.Attribute = s;

      var c = function () {
        function t() {
          for (var t, e, r, n, o = [], s = 0; s < arguments.length; s++) {
            o[s] = arguments[s];
          }

          this.attributes = o, this.attributeMap = {};
          var c = 0,
              u = 0;

          try {
            for (var l = i(o), f = l.next(); !f.done; f = l.next()) {
              var h = f.value;
              if (this.attributeMap[h.key]) throw new a(h);
              c % h.sizeOfType != 0 && (c += h.sizeOfType - c % h.sizeOfType, console.warn("Layout requires padding before " + h.key + " attribute")), this.attributeMap[h.key] = {
                attribute: h,
                size: h.size,
                type: h.type,
                normalized: h.normalized,
                offset: c
              }, c += h.sizeInBytes, u = Math.max(u, h.sizeOfType);
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              f && !f.done && (e = l.return) && e.call(l);
            } finally {
              if (t) throw t.error;
            }
          }

          c % u != 0 && (c += u - c % u, console.warn("Layout requires padding at the back")), this.stride = c;

          try {
            for (var p = i(o), d = p.next(); !d.done; d = p.next()) {
              h = d.value, this.attributeMap[h.key].stride = this.stride;
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              d && !d.done && (n = p.return) && n.call(p);
            } finally {
              if (r) throw r.error;
            }
          }
        }

        return t.POSITION = new s("position", 3, n.FLOAT), t.NORMAL = new s("normal", 3, n.FLOAT), t.TANGENT = new s("tangent", 3, n.FLOAT), t.BITANGENT = new s("bitangent", 3, n.FLOAT), t.UV = new s("uv", 2, n.FLOAT), t.MATERIAL_INDEX = new s("materialIndex", 1, n.SHORT), t.MATERIAL_ENABLED = new s("materialEnabled", 1, n.UNSIGNED_SHORT), t.AMBIENT = new s("ambient", 3, n.FLOAT), t.DIFFUSE = new s("diffuse", 3, n.FLOAT), t.SPECULAR = new s("specular", 3, n.FLOAT), t.SPECULAR_EXPONENT = new s("specularExponent", 3, n.FLOAT), t.EMISSIVE = new s("emissive", 3, n.FLOAT), t.TRANSMISSION_FILTER = new s("transmissionFilter", 3, n.FLOAT), t.DISSOLVE = new s("dissolve", 1, n.FLOAT), t.ILLUMINATION = new s("illumination", 1, n.UNSIGNED_SHORT), t.REFRACTION_INDEX = new s("refractionIndex", 1, n.FLOAT), t.SHARPNESS = new s("sharpness", 1, n.FLOAT), t.MAP_DIFFUSE = new s("mapDiffuse", 1, n.SHORT), t.MAP_AMBIENT = new s("mapAmbient", 1, n.SHORT), t.MAP_SPECULAR = new s("mapSpecular", 1, n.SHORT), t.MAP_SPECULAR_EXPONENT = new s("mapSpecularExponent", 1, n.SHORT), t.MAP_DISSOLVE = new s("mapDissolve", 1, n.SHORT), t.ANTI_ALIASING = new s("antiAliasing", 1, n.UNSIGNED_SHORT), t.MAP_BUMP = new s("mapBump", 1, n.SHORT), t.MAP_DISPLACEMENT = new s("mapDisplacement", 1, n.SHORT), t.MAP_DECAL = new s("mapDecal", 1, n.SHORT), t.MAP_EMISSIVE = new s("mapEmissive", 1, n.SHORT), t;
      }();

      e.Layout = c;
    },
    2534: function _(t, e) {
      "use strict";

      var r = this && this.__read || function (t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            o,
            i = r.call(t),
            a = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
            a.push(n.value);
          }
        } catch (t) {
          o = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = i.return) && r.call(i);
          } finally {
            if (o) throw o.error;
          }
        }

        return a;
      },
          n = this && this.__values || function (t) {
        var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
        if (r) return r.call(t);
        if (t && "number" == typeof t.length) return {
          next: function next() {
            return t && n >= t.length && (t = void 0), {
              value: t && t[n++],
              done: !t
            };
          }
        };
        throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };

      e.__esModule = !0, e.MaterialLibrary = e.Material = void 0;

      var o = function o(t) {
        this.name = t, this.ambient = [0, 0, 0], this.diffuse = [0, 0, 0], this.specular = [0, 0, 0], this.emissive = [0, 0, 0], this.transmissionFilter = [0, 0, 0], this.dissolve = 0, this.specularExponent = 0, this.transparency = 0, this.illumination = 0, this.refractionIndex = 1, this.sharpness = 0, this.mapDiffuse = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.mapAmbient = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.mapSpecular = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.mapSpecularExponent = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.mapDissolve = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.antiAliasing = !1, this.mapBump = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.mapDisplacement = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.mapDecal = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.mapEmissive = {
          colorCorrection: !1,
          horizontalBlending: !0,
          verticalBlending: !0,
          boostMipMapSharpness: 0,
          modifyTextureMap: {
            brightness: 0,
            contrast: 1
          },
          offset: {
            u: 0,
            v: 0,
            w: 0
          },
          scale: {
            u: 1,
            v: 1,
            w: 1
          },
          turbulence: {
            u: 0,
            v: 0,
            w: 0
          },
          clamp: !1,
          textureResolution: null,
          bumpMultiplier: 1,
          imfChan: null,
          filename: ""
        }, this.mapReflections = [];
      };

      e.Material = o;

      var i = new o("sentinel"),
          a = function () {
        function t(t) {
          this.data = t, this.currentMaterial = i, this.materials = {}, this.parse();
        }

        return t.prototype.parse_newmtl = function (t) {
          var e = t[0];
          this.currentMaterial = new o(e), this.materials[e] = this.currentMaterial;
        }, t.prototype.parseColor = function (t) {
          if ("spectral" == t[0]) throw new Error("The MTL parser does not support spectral curve files. You will need to convert the MTL colors to either RGB or CIEXYZ.");
          if ("xyz" == t[0]) throw new Error("The MTL parser does not currently support XYZ colors. Either convert the XYZ values to RGB or create an issue to add support for XYZ");

          if (3 == t.length) {
            var e = r(t, 3),
                n = e[0],
                o = e[1],
                i = e[2];
            return [parseFloat(n), parseFloat(o), parseFloat(i)];
          }

          var a = parseFloat(t[0]);
          return [a, a, a];
        }, t.prototype.parse_Ka = function (t) {
          this.currentMaterial.ambient = this.parseColor(t);
        }, t.prototype.parse_Kd = function (t) {
          this.currentMaterial.diffuse = this.parseColor(t);
        }, t.prototype.parse_Ks = function (t) {
          this.currentMaterial.specular = this.parseColor(t);
        }, t.prototype.parse_Ke = function (t) {
          this.currentMaterial.emissive = this.parseColor(t);
        }, t.prototype.parse_Tf = function (t) {
          this.currentMaterial.transmissionFilter = this.parseColor(t);
        }, t.prototype.parse_d = function (t) {
          this.currentMaterial.dissolve = parseFloat(t.pop() || "0");
        }, t.prototype.parse_illum = function (t) {
          this.currentMaterial.illumination = parseInt(t[0]);
        }, t.prototype.parse_Ni = function (t) {
          this.currentMaterial.refractionIndex = parseFloat(t[0]);
        }, t.prototype.parse_Ns = function (t) {
          this.currentMaterial.specularExponent = parseInt(t[0]);
        }, t.prototype.parse_sharpness = function (t) {
          this.currentMaterial.sharpness = parseInt(t[0]);
        }, t.prototype.parse_cc = function (t, e) {
          e.colorCorrection = "on" == t[0];
        }, t.prototype.parse_blendu = function (t, e) {
          e.horizontalBlending = "on" == t[0];
        }, t.prototype.parse_blendv = function (t, e) {
          e.verticalBlending = "on" == t[0];
        }, t.prototype.parse_boost = function (t, e) {
          e.boostMipMapSharpness = parseFloat(t[0]);
        }, t.prototype.parse_mm = function (t, e) {
          e.modifyTextureMap.brightness = parseFloat(t[0]), e.modifyTextureMap.contrast = parseFloat(t[1]);
        }, t.prototype.parse_ost = function (t, e, r) {
          for (; t.length < 3;) {
            t.push(r.toString());
          }

          e.u = parseFloat(t[0]), e.v = parseFloat(t[1]), e.w = parseFloat(t[2]);
        }, t.prototype.parse_o = function (t, e) {
          this.parse_ost(t, e.offset, 0);
        }, t.prototype.parse_s = function (t, e) {
          this.parse_ost(t, e.scale, 1);
        }, t.prototype.parse_t = function (t, e) {
          this.parse_ost(t, e.turbulence, 0);
        }, t.prototype.parse_texres = function (t, e) {
          e.textureResolution = parseFloat(t[0]);
        }, t.prototype.parse_clamp = function (t, e) {
          e.clamp = "on" == t[0];
        }, t.prototype.parse_bm = function (t, e) {
          e.bumpMultiplier = parseFloat(t[0]);
        }, t.prototype.parse_imfchan = function (t, e) {
          e.imfChan = t[0];
        }, t.prototype.parse_type = function (t, e) {
          e.reflectionType = t[0];
        }, t.prototype.parseOptions = function (t) {
          var e,
              r,
              n = {
            colorCorrection: !1,
            horizontalBlending: !0,
            verticalBlending: !0,
            boostMipMapSharpness: 0,
            modifyTextureMap: {
              brightness: 0,
              contrast: 1
            },
            offset: {
              u: 0,
              v: 0,
              w: 0
            },
            scale: {
              u: 1,
              v: 1,
              w: 1
            },
            turbulence: {
              u: 0,
              v: 0,
              w: 0
            },
            clamp: !1,
            textureResolution: null,
            bumpMultiplier: 1,
            imfChan: null,
            filename: ""
          },
              o = {};

          for (t.reverse(); t.length;) {
            var i = t.pop();
            i.startsWith("-") ? o[e = i.substr(1)] = [] : e && o[e].push(i);
          }

          for (e in o) {
            if (o.hasOwnProperty(e)) {
              r = o[e];
              var a = this["parse_".concat(e)];
              a && a.bind(this)(r, n);
            }
          }

          return n;
        }, t.prototype.parseMap = function (t) {
          var e,
              n,
              o = "";
          t[0].startsWith("-") ? (o = t.pop(), n = t) : (o = (e = r(t))[0], n = e.slice(1));
          var i = this.parseOptions(n);
          return i.filename = o.replace(/\\/g, "/"), i;
        }, t.prototype.parse_map_Ka = function (t) {
          this.currentMaterial.mapAmbient = this.parseMap(t);
        }, t.prototype.parse_map_Kd = function (t) {
          this.currentMaterial.mapDiffuse = this.parseMap(t);
        }, t.prototype.parse_map_Ks = function (t) {
          this.currentMaterial.mapSpecular = this.parseMap(t);
        }, t.prototype.parse_map_Ke = function (t) {
          this.currentMaterial.mapEmissive = this.parseMap(t);
        }, t.prototype.parse_map_Ns = function (t) {
          this.currentMaterial.mapSpecularExponent = this.parseMap(t);
        }, t.prototype.parse_map_d = function (t) {
          this.currentMaterial.mapDissolve = this.parseMap(t);
        }, t.prototype.parse_map_aat = function (t) {
          this.currentMaterial.antiAliasing = "on" == t[0];
        }, t.prototype.parse_map_bump = function (t) {
          this.currentMaterial.mapBump = this.parseMap(t);
        }, t.prototype.parse_bump = function (t) {
          this.parse_map_bump(t);
        }, t.prototype.parse_disp = function (t) {
          this.currentMaterial.mapDisplacement = this.parseMap(t);
        }, t.prototype.parse_decal = function (t) {
          this.currentMaterial.mapDecal = this.parseMap(t);
        }, t.prototype.parse_refl = function (t) {
          this.currentMaterial.mapReflections.push(this.parseMap(t));
        }, t.prototype.parse = function () {
          var t,
              e,
              o = this.data.split(/\r?\n/);

          try {
            for (var a = n(o), s = a.next(); !s.done; s = a.next()) {
              var c = s.value;

              if ((c = c.trim()) && !c.startsWith("#")) {
                var u = r(c.split(/\s/)),
                    l = u[0],
                    f = u.slice(1),
                    h = this["parse_".concat(l)];
                h ? h.bind(this)(f) : console.warn("Don't know how to parse the directive: \"".concat(l, '"'));
              }
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (e = a.return) && e.call(a);
            } finally {
              if (t) throw t.error;
            }
          }

          delete this.data, this.currentMaterial = i;
        }, t;
      }();

      e.MaterialLibrary = a;
    },
    9100: function _(t, e, r) {
      "use strict";

      var n = this && this.__generator || function (t, e) {
        var r,
            n,
            o,
            i,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function s(i) {
          return function (s) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return a.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      a.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        a.label = i[1];
                        break;
                      }

                      if (6 === i[0] && a.label < o[1]) {
                        a.label = o[1], o = i;
                        break;
                      }

                      if (o && a.label < o[2]) {
                        a.label = o[2], a.ops.push(i);
                        break;
                      }

                      o[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  i = e.call(t, a);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
          o = this && this.__values || function (t) {
        var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
        if (r) return r.call(t);
        if (t && "number" == typeof t.length) return {
          next: function next() {
            return t && n >= t.length && (t = void 0), {
              value: t && t[n++],
              done: !t
            };
          }
        };
        throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
      },
          i = this && this.__read || function (t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            o,
            i = r.call(t),
            a = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
            a.push(n.value);
          }
        } catch (t) {
          o = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = i.return) && r.call(i);
          } finally {
            if (o) throw o.error;
          }
        }

        return a;
      },
          a = this && this.__spreadArray || function (t, e, r) {
        if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) {
          !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
        }
        return t.concat(n || Array.prototype.slice.call(e));
      };

      e.__esModule = !0;

      var s = r(9933),
          c = function () {
        function t(t, e) {
          var r, n, s, c;
          this.name = "", this.indicesPerMaterial = [], this.materialsByIndex = {}, this.tangents = [], this.bitangents = [], (e = e || {}).materials = e.materials || {}, e.enableWTextureCoord = !!e.enableWTextureCoord, this.vertexNormals = [], this.textures = [], this.indices = [], this.textureStride = e.enableWTextureCoord ? 3 : 2;
          var l = [],
              f = [],
              h = [],
              p = [],
              d = {},
              y = -1,
              m = 0,
              v = {
            verts: [],
            norms: [],
            textures: [],
            hashindices: {},
            indices: [[]],
            materialIndices: [],
            index: 0
          },
              g = /^v\s/,
              b = /^vn\s/,
              w = /^vt\s/,
              O = /^f\s/,
              _ = /\s+/,
              x = /^usemtl/,
              L = t.split("\n");

          try {
            for (var E = o(L), A = E.next(); !A.done; A = E.next()) {
              var R = A.value;

              if ((R = R.trim()) && !R.startsWith("#")) {
                var T = R.split(_);
                if (T.shift(), g.test(R)) l.push.apply(l, a([], i(T), !1));else if (b.test(R)) f.push.apply(f, a([], i(T), !1));else if (w.test(R)) {
                  var P = T;
                  T.length > 2 && !e.enableWTextureCoord ? P = T.slice(0, 2) : 2 === T.length && e.enableWTextureCoord && P.push("0"), h.push.apply(h, a([], i(P), !1));
                } else if (x.test(R)) {
                  var S = T[0];
                  S in d || (p.push(S), d[S] = p.length - 1, d[S] > 0 && v.indices.push([])), m = y = d[S];
                } else if (O.test(R)) {
                  var k = u(T);

                  try {
                    for (var j = (s = void 0, o(k)), Z = j.next(); !Z.done; Z = j.next()) {
                      for (var M = Z.value, C = 0, F = M.length; C < F; C++) {
                        var W = M[C] + "," + y;
                        if (W in v.hashindices) v.indices[m].push(v.hashindices[W]);else {
                          var B = M[C].split("/"),
                              N = B.length - 1;

                          if (v.verts.push(+l[3 * (+B[0] - 1) + 0]), v.verts.push(+l[3 * (+B[0] - 1) + 1]), v.verts.push(+l[3 * (+B[0] - 1) + 2]), h.length) {
                            var I = e.enableWTextureCoord ? 3 : 2;
                            v.textures.push(+h[(+B[1] - 1) * I + 0]), v.textures.push(+h[(+B[1] - 1) * I + 1]), e.enableWTextureCoord && v.textures.push(+h[(+B[1] - 1) * I + 2]);
                          }

                          v.norms.push(+f[3 * (+B[N] - 1) + 0]), v.norms.push(+f[3 * (+B[N] - 1) + 1]), v.norms.push(+f[3 * (+B[N] - 1) + 2]), v.materialIndices.push(y), v.hashindices[W] = v.index, v.indices[m].push(v.hashindices[W]), v.index += 1;
                        }
                      }
                    }
                  } catch (t) {
                    s = {
                      error: t
                    };
                  } finally {
                    try {
                      Z && !Z.done && (c = j.return) && c.call(j);
                    } finally {
                      if (s) throw s.error;
                    }
                  }
                }
              }
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              A && !A.done && (n = E.return) && n.call(E);
            } finally {
              if (r) throw r.error;
            }
          }

          this.vertices = v.verts, this.vertexNormals = v.norms, this.textures = v.textures, this.vertexMaterialIndices = v.materialIndices, this.indices = v.indices[m], this.indicesPerMaterial = v.indices, this.materialNames = p, this.materialIndices = d, this.materialsByIndex = {}, e.calcTangentsAndBitangents && this.calculateTangentsAndBitangents();
        }

        return t.prototype.calculateTangentsAndBitangents = function () {
          console.assert(!!(this.vertices && this.vertices.length && this.vertexNormals && this.vertexNormals.length && this.textures && this.textures.length), "Missing attributes for calculating tangents and bitangents");

          for (var t = {
            tangents: a([], i(new Array(this.vertices.length)), !1).map(function (t) {
              return 0;
            }),
            bitangents: a([], i(new Array(this.vertices.length)), !1).map(function (t) {
              return 0;
            })
          }, e = this.indices, r = this.vertices, n = this.vertexNormals, o = this.textures, s = 0; s < e.length; s += 3) {
            var c = e[s + 0],
                u = e[s + 1],
                l = e[s + 2],
                f = r[3 * c + 0],
                h = r[3 * c + 1],
                p = r[3 * c + 2],
                d = o[2 * c + 0],
                y = o[2 * c + 1],
                m = r[3 * u + 0],
                v = r[3 * u + 1],
                g = r[3 * u + 2],
                b = o[2 * u + 0],
                w = o[2 * u + 1],
                O = m - f,
                _ = v - h,
                x = g - p,
                L = r[3 * l + 0] - f,
                E = r[3 * l + 1] - h,
                A = r[3 * l + 2] - p,
                R = b - d,
                T = w - y,
                P = o[2 * l + 0] - d,
                S = o[2 * l + 1] - y,
                k = R * S - T * P,
                j = 1 / Math.abs(k < 1e-4 ? 1 : k),
                Z = (O * S - L * T) * j,
                M = (_ * S - E * T) * j,
                C = (x * S - A * T) * j,
                F = (L * R - O * P) * j,
                W = (E * R - _ * P) * j,
                B = (A * R - x * P) * j,
                N = n[3 * c + 0],
                I = n[3 * c + 1],
                D = n[3 * c + 2],
                Y = n[3 * u + 0],
                z = n[3 * u + 1],
                U = n[3 * u + 2],
                G = n[3 * l + 0],
                K = n[3 * l + 1],
                H = n[3 * l + 2],
                V = Z * N + M * I + C * D,
                q = Z * Y + M * z + C * U,
                $ = Z * G + M * K + C * H,
                X = Z - N * V,
                J = M - I * V,
                Q = C - D * V,
                tt = Z - Y * q,
                et = M - z * q,
                rt = C - U * q,
                nt = Z - G * $,
                ot = M - K * $,
                it = C - H * $,
                at = Math.sqrt(X * X + J * J + Q * Q),
                st = Math.sqrt(tt * tt + et * et + rt * rt),
                ct = Math.sqrt(nt * nt + ot * ot + it * it),
                ut = F * N + W * I + B * D,
                lt = F * Y + W * z + B * U,
                ft = F * G + W * K + B * H,
                ht = F - N * ut,
                pt = W - I * ut,
                dt = B - D * ut,
                yt = F - Y * lt,
                mt = W - z * lt,
                vt = B - U * lt,
                gt = F - G * ft,
                bt = W - K * ft,
                wt = B - H * ft,
                Ot = Math.sqrt(ht * ht + pt * pt + dt * dt),
                _t = Math.sqrt(yt * yt + mt * mt + vt * vt),
                xt = Math.sqrt(gt * gt + bt * bt + wt * wt);

            t.tangents[3 * c + 0] += X / at, t.tangents[3 * c + 1] += J / at, t.tangents[3 * c + 2] += Q / at, t.tangents[3 * u + 0] += tt / st, t.tangents[3 * u + 1] += et / st, t.tangents[3 * u + 2] += rt / st, t.tangents[3 * l + 0] += nt / ct, t.tangents[3 * l + 1] += ot / ct, t.tangents[3 * l + 2] += it / ct, t.bitangents[3 * c + 0] += ht / Ot, t.bitangents[3 * c + 1] += pt / Ot, t.bitangents[3 * c + 2] += dt / Ot, t.bitangents[3 * u + 0] += yt / _t, t.bitangents[3 * u + 1] += mt / _t, t.bitangents[3 * u + 2] += vt / _t, t.bitangents[3 * l + 0] += gt / xt, t.bitangents[3 * l + 1] += bt / xt, t.bitangents[3 * l + 2] += wt / xt;
          }

          this.tangents = t.tangents, this.bitangents = t.bitangents;
        }, t.prototype.makeBufferData = function (t) {
          var e,
              r,
              n = this.vertices.length / 3,
              i = new ArrayBuffer(t.stride * n);
          i.numItems = n;

          for (var a = new DataView(i), c = 0, u = 0; c < n; c++) {
            u = c * t.stride;

            try {
              for (var l = (e = void 0, o(t.attributes)), f = l.next(); !f.done; f = l.next()) {
                var h = f.value,
                    p = u + t.attributeMap[h.key].offset;

                switch (h.key) {
                  case s.Layout.POSITION.key:
                    a.setFloat32(p, this.vertices[3 * c], !0), a.setFloat32(p + 4, this.vertices[3 * c + 1], !0), a.setFloat32(p + 8, this.vertices[3 * c + 2], !0);
                    break;

                  case s.Layout.UV.key:
                    a.setFloat32(p, this.textures[2 * c], !0), a.setFloat32(p + 4, this.textures[2 * c + 1], !0);
                    break;

                  case s.Layout.NORMAL.key:
                    a.setFloat32(p, this.vertexNormals[3 * c], !0), a.setFloat32(p + 4, this.vertexNormals[3 * c + 1], !0), a.setFloat32(p + 8, this.vertexNormals[3 * c + 2], !0);
                    break;

                  case s.Layout.MATERIAL_INDEX.key:
                    a.setInt16(p, this.vertexMaterialIndices[c], !0);
                    break;

                  case s.Layout.AMBIENT.key:
                    var d = this.vertexMaterialIndices[c];

                    if (!(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.ambient[0], !0), a.setFloat32(p + 4, y.ambient[1], !0), a.setFloat32(p + 8, y.ambient[2], !0);
                    break;

                  case s.Layout.DIFFUSE.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.diffuse[0], !0), a.setFloat32(p + 4, y.diffuse[1], !0), a.setFloat32(p + 8, y.diffuse[2], !0);
                    break;

                  case s.Layout.SPECULAR.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.specular[0], !0), a.setFloat32(p + 4, y.specular[1], !0), a.setFloat32(p + 8, y.specular[2], !0);
                    break;

                  case s.Layout.SPECULAR_EXPONENT.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.specularExponent, !0);
                    break;

                  case s.Layout.EMISSIVE.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.emissive[0], !0), a.setFloat32(p + 4, y.emissive[1], !0), a.setFloat32(p + 8, y.emissive[2], !0);
                    break;

                  case s.Layout.TRANSMISSION_FILTER.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.transmissionFilter[0], !0), a.setFloat32(p + 4, y.transmissionFilter[1], !0), a.setFloat32(p + 8, y.transmissionFilter[2], !0);
                    break;

                  case s.Layout.DISSOLVE.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.dissolve, !0);
                    break;

                  case s.Layout.ILLUMINATION.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setInt16(p, y.illumination, !0);
                    break;

                  case s.Layout.REFRACTION_INDEX.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.refractionIndex, !0);
                    break;

                  case s.Layout.SHARPNESS.key:
                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setFloat32(p, y.sharpness, !0);
                    break;

                  case s.Layout.ANTI_ALIASING.key:
                    var y;

                    if (d = this.vertexMaterialIndices[c], !(y = this.materialsByIndex[d])) {
                      console.warn('Material "' + this.materialNames[d] + '" not found in mesh. Did you forget to call addMaterialLibrary(...)?"');
                      break;
                    }

                    a.setInt16(p, y.antiAliasing ? 1 : 0, !0);
                }
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                f && !f.done && (r = l.return) && r.call(l);
              } finally {
                if (e) throw e.error;
              }
            }
          }

          return i;
        }, t.prototype.makeIndexBufferData = function () {
          var t = new Uint16Array(this.indices);
          return t.numItems = this.indices.length, t;
        }, t.prototype.makeIndexBufferDataForMaterials = function () {
          for (var t, e = this, r = [], n = 0; n < arguments.length; n++) {
            r[n] = arguments[n];
          }

          var o = (t = new Array()).concat.apply(t, a([], i(r.map(function (t) {
            return e.indicesPerMaterial[t];
          })), !1)),
              s = new Uint16Array(o);
          return s.numItems = o.length, s;
        }, t.prototype.addMaterialLibrary = function (t) {
          for (var e in t.materials) {
            if (e in this.materialIndices) {
              var r = t.materials[e],
                  n = this.materialIndices[r.name];
              this.materialsByIndex[n] = r;
            }
          }
        }, t;
      }();

      function u(t) {
        var e;
        return n(this, function (r) {
          switch (r.label) {
            case 0:
              return t.length <= 3 ? [4, t] : [3, 2];

            case 1:
              return r.sent(), [3, 9];

            case 2:
              return 4 !== t.length ? [3, 5] : [4, [t[0], t[1], t[2]]];

            case 3:
              return r.sent(), [4, [t[2], t[3], t[0]]];

            case 4:
              return r.sent(), [3, 9];

            case 5:
              e = 1, r.label = 6;

            case 6:
              return e < t.length - 1 ? [4, [t[0], t[e], t[e + 1]]] : [3, 9];

            case 7:
              r.sent(), r.label = 8;

            case 8:
              return e++, [3, 6];

            case 9:
              return [2];
          }
        });
      }

      e.default = c;
    },
    8352: function _(t, e, r) {
      "use strict";

      var n = this && this.__values || function (t) {
        var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
        if (r) return r.call(t);
        if (t && "number" == typeof t.length) return {
          next: function next() {
            return t && n >= t.length && (t = void 0), {
              value: t && t[n++],
              done: !t
            };
          }
        };
        throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
      },
          o = this && this.__read || function (t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            o,
            i = r.call(t),
            a = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
            a.push(n.value);
          }
        } catch (t) {
          o = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = i.return) && r.call(i);
          } finally {
            if (o) throw o.error;
          }
        }

        return a;
      };

      e.__esModule = !0, e.deleteMeshBuffers = e.initMeshBuffers = e._buildBuffer = e.downloadMeshes = e.downloadModels = void 0;
      var i = r(9100),
          a = r(2534);

      function s(t, e) {
        var r = t.createTexture();
        return t.bindTexture(t.TEXTURE_2D, r), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, new Uint8Array(e)), r;
      }

      function c(t, e, r) {
        var o,
            i,
            a = ["mapDiffuse", "mapAmbient", "mapSpecular", "mapDissolve", "mapBump", "mapDisplacement", "mapDecal", "mapEmissive"];
        r.endsWith("/") || (r += "/");
        var c = [];

        for (var u in e.materials) {
          if (e.materials.hasOwnProperty(u)) {
            var l = e.materials[u],
                f = function f(e) {
              var n = l[e];
              if (!n || !n.filename) return "continue";
              var o = r + n.filename;
              c.push(fetch(o).then(function (t) {
                if (!t.ok) throw new Error();
                return t.blob();
              }).then(function (e) {
                var r = new Image();
                r.src = URL.createObjectURL(e), n.texture = r;
                var o = s(t, [128, 192, 86, 255]);
                return n.glTexture = o, t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST), t.bindTexture(t.TEXTURE_2D, n.glTexture), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n.texture), r.onload = function () {
                  t.bindTexture(t.TEXTURE_2D, n.glTexture), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n.texture);
                }, new Promise(function (t) {
                  return r.onload = function () {
                    return t(n);
                  };
                });
              }).catch(function () {
                console.error("Unable to download texture: ".concat(o));
              }));
            };

            try {
              for (var h = (o = void 0, n(a)), p = h.next(); !p.done; p = h.next()) {
                f(p.value);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (i = h.return) && i.call(h);
              } finally {
                if (o) throw o.error;
              }
            }
          }
        }

        return Promise.all(c);
      }

      function u(t, e, r, n) {
        var o = t.createBuffer(),
            i = e === t.ARRAY_BUFFER ? Float32Array : Uint16Array;
        return t.bindBuffer(e, o), t.bufferData(e, new i(r), t.STATIC_DRAW), o.itemSize = n, o.numItems = r.length / n, o;
      }

      e.downloadModels = function (t, e) {
        var r,
            s,
            u = [],
            l = function l(e) {
          if (!e.obj) throw new Error('"obj" attribute of model object not set. The .obj file is required to be set in order to use downloadModels()');
          var r = {
            indicesPerMaterial: !!e.indicesPerMaterial,
            calcTangentsAndBitangents: !!e.calcTangentsAndBitangents
          },
              n = e.name;

          if (!n) {
            var o = e.obj.split("/");
            n = o[o.length - 1].replace(".obj", "");
          }

          var s,
              l = Promise.resolve(n),
              f = fetch(e.obj).then(function (t) {
            return t.text();
          }).then(function (t) {
            return new i.default(t, r);
          }),
              h = void 0;

          if (e.mtl) {
            var p = "string" != typeof (s = e).mtl ? s.obj.replace(/\.obj$/, ".mtl") : s.mtl;
            h = fetch(p).then(function (t) {
              return t.text();
            }).then(function (r) {
              var n = new a.MaterialLibrary(r);

              if (!1 !== e.downloadMtlTextures) {
                var o = e.mtlTextureRoot;
                return o || (o = p.substr(0, p.lastIndexOf("/"))), Promise.all([Promise.resolve(n), c(t, n, o)]);
              }

              return Promise.all([Promise.resolve(n), void 0]);
            }).then(function (t) {
              return t;
            });
          }

          var d = [l, f, h];
          u.push(Promise.all(d));
        };

        try {
          for (var f = n(e), h = f.next(); !h.done; h = f.next()) {
            l(h.value);
          }
        } catch (t) {
          r = {
            error: t
          };
        } finally {
          try {
            h && !h.done && (s = f.return) && s.call(f);
          } finally {
            if (r) throw r.error;
          }
        }

        return Promise.all(u).then(function (t) {
          var e,
              r,
              i = {};

          try {
            for (var a = n(t), s = a.next(); !s.done; s = a.next()) {
              var c = s.value,
                  u = o(c, 3),
                  l = u[0],
                  f = u[1],
                  h = u[2];
              f.name = l, h && f.addMaterialLibrary(h[0]), i[l] = f;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              s && !s.done && (r = a.return) && r.call(a);
            } finally {
              if (e) throw e.error;
            }
          }

          return i;
        });
      }, e.downloadMeshes = function (t, e, r) {
        void 0 === r && (r = {});

        var a = [],
            s = function s(e) {
          if (!t.hasOwnProperty(e)) return "continue";
          var r = t[e];
          a.push(fetch(r).then(function (t) {
            return t.text();
          }).then(function (t) {
            return [e, new i.default(t)];
          }));
        };

        for (var c in t) {
          s(c);
        }

        Promise.all(a).then(function (t) {
          var i, a;

          try {
            for (var s = n(t), c = s.next(); !c.done; c = s.next()) {
              var u = o(c.value, 2),
                  l = u[0],
                  f = u[1];
              r[l] = f;
            }
          } catch (t) {
            i = {
              error: t
            };
          } finally {
            try {
              c && !c.done && (a = s.return) && a.call(s);
            } finally {
              if (i) throw i.error;
            }
          }

          return e(r);
        });
      }, e._buildBuffer = u, e.initMeshBuffers = function (t, e) {
        return e.normalBuffer = u(t, t.ARRAY_BUFFER, e.vertexNormals, 3), e.textureBuffer = u(t, t.ARRAY_BUFFER, e.textures, e.textureStride), e.vertexBuffer = u(t, t.ARRAY_BUFFER, e.vertices, 3), e.indexBuffer = u(t, t.ELEMENT_ARRAY_BUFFER, e.indices, 1), e;
      }, e.deleteMeshBuffers = function (t, e) {
        t.deleteBuffer(e.normalBuffer), t.deleteBuffer(e.textureBuffer), t.deleteBuffer(e.vertexBuffer), t.deleteBuffer(e.indexBuffer);
      };
    },
    9245: function _(t, e, r) {
      var n = {
        "./default/index.jsx": 9176,
        "./default/maps/dungeon-bottom/cells.jsx": 5253,
        "./default/maps/dungeon-bottom/map.jsx": 49,
        "./default/maps/dungeon-top/cells.jsx": 6268,
        "./default/maps/dungeon-top/map.jsx": 1689,
        "./default/maps/room/cells.jsx": 7730,
        "./default/maps/room/map.jsx": 5722,
        "./default/menus/main.jsx": 8030,
        "./default/sprites/characters/female.jsx": 2090,
        "./default/sprites/characters/male.jsx": 3764,
        "./default/sprites/effects/fireplace.jsx": 1493,
        "./default/sprites/furniture/door.jsx": 6575,
        "./default/sprites/furniture/fireplace.jsx": 740,
        "./default/sprites/furniture/tree.jsx": 6301,
        "./default/sprites/npc/air-knight.jsx": 9508,
        "./default/sprites/npc/darkness.jsx": 6463,
        "./default/sprites/npc/earth-knight.jsx": 1350,
        "./default/sprites/npc/fire-knight.jsx": 7238,
        "./default/sprites/npc/water-knight.jsx": 6905,
        "./default/sprites/objects/chests/blue.jsx": 3188,
        "./default/sprites/objects/chests/metal.jsx": 9554,
        "./default/sprites/objects/chests/red.jsx": 5999,
        "./default/sprites/objects/chests/wood.jsx": 9843,
        "./peacefulGarden/index.jsx": 4829,
        "./peacefulGarden/maps/dungeon/cells.jsx": 7449,
        "./peacefulGarden/maps/dungeon/map.jsx": 5512,
        "./peacefulGarden/maps/field/map.jsx": 5092,
        "./peacefulGarden/maps/ice/map.jsx": 7934,
        "./peacefulGarden/maps/jungle/map.jsx": 817,
        "./peacefulGarden/maps/mountain/map.jsx": 4605,
        "./peacefulGarden/maps/room/cells.jsx": 4837,
        "./peacefulGarden/maps/room/map.jsx": 5397,
        "./peacefulGarden/maps/sewer/map.jsx": 7047,
        "./peacefulGarden/menus/main.jsx": 5412,
        "./peacefulGarden/sprites/characters/female.jsx": 1785,
        "./peacefulGarden/sprites/characters/male.jsx": 298,
        "./peacefulGarden/sprites/effects/fireplace.jsx": 9863,
        "./peacefulGarden/sprites/effects/lavaspurt.jsx": 5876,
        "./peacefulGarden/sprites/effects/waterspurt.jsx": 3771,
        "./peacefulGarden/sprites/furniture/door.jsx": 7634,
        "./peacefulGarden/sprites/furniture/fireplace.jsx": 1803,
        "./peacefulGarden/sprites/furniture/portal.jsx": 6823,
        "./peacefulGarden/sprites/furniture/tree.jsx": 4416,
        "./peacefulGarden/sprites/monsters/air_elemental.jsx": 9986,
        "./peacefulGarden/sprites/npc/air-knight.jsx": 7588,
        "./peacefulGarden/sprites/npc/darkness.jsx": 5349,
        "./peacefulGarden/sprites/npc/earth-knight.jsx": 5798,
        "./peacefulGarden/sprites/npc/fire-knight.jsx": 7884,
        "./peacefulGarden/sprites/npc/water-knight.jsx": 4806,
        "./peacefulGarden/sprites/objects/chests/blue.jsx": 7477,
        "./peacefulGarden/sprites/objects/chests/metal.jsx": 1285,
        "./peacefulGarden/sprites/objects/chests/red.jsx": 1642,
        "./peacefulGarden/sprites/objects/chests/wood.jsx": 5016,
        "./peacefulGarden/sprites/objects/plants/random.jsx": 3081
      };

      function o(t) {
        var e = i(t);
        return r(e);
      }

      function i(t) {
        if (!r.o(n, t)) {
          var e = new Error("Cannot find module '" + t + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }

        return n[t];
      }

      o.keys = function () {
        return Object.keys(n);
      }, o.resolve = i, t.exports = o, o.id = 9245;
    },
    3998: function _(t, e, r) {
      var n = {
        "./default/maps/dungeon-bottom/map.jsx": 49,
        "./default/maps/dungeon-top/map.jsx": 1689,
        "./default/maps/room/map.jsx": 5722,
        "./peacefulGarden/maps/dungeon/map.jsx": 5512,
        "./peacefulGarden/maps/field/map.jsx": 5092,
        "./peacefulGarden/maps/ice/map.jsx": 7934,
        "./peacefulGarden/maps/jungle/map.jsx": 817,
        "./peacefulGarden/maps/mountain/map.jsx": 4605,
        "./peacefulGarden/maps/room/map.jsx": 5397,
        "./peacefulGarden/maps/sewer/map.jsx": 7047
      };

      function o(t) {
        var e = i(t);
        return r(e);
      }

      function i(t) {
        if (!r.o(n, t)) {
          var e = new Error("Cannot find module '" + t + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }

        return n[t];
      }

      o.keys = function () {
        return Object.keys(n);
      }, o.resolve = i, t.exports = o, o.id = 3998;
    },
    7092: function _(t, e, r) {
      var n = {
        "./common/tileset.jsx": 8046,
        "./field/tileset.jsx": 6382,
        "./ice/tileset.jsx": 6841,
        "./jungle/tileset.jsx": 826,
        "./mountain/tileset.jsx": 9663,
        "./sewer/tileset.jsx": 2155,
        "./void/tileset.jsx": 6321
      };

      function o(t) {
        var e = i(t);
        return r(e);
      }

      function i(t) {
        if (!r.o(n, t)) {
          var e = new Error("Cannot find module '" + t + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }

        return n[t];
      }

      o.keys = function () {
        return Object.keys(n);
      }, o.resolve = i, t.exports = o, o.id = 7092;
    },
    1974: function _(t) {
      "use strict";

      t.exports = require("react");
    },
    4570: function _(t) {
      "use strict";

      t.exports = JSON.parse('{"objects":[],"sprites":[["flowers",70],["furniture/tree",1000],["objects/chests/wood",10000]],"npcs":[["darkness",1000],["water-knight",100],["water-knight",100],["earth-knight",100],["fire-knight",100]],"flags":[["fantastic-journey",200],["old-secrets",100],["special-place",1000]],"questions":[["How are you doing today?",100],["Have you seen my glasses?",1000],["I am lost, do you know this area well?",300]],"quotes":["To err is human, to forgive divine.","We don\'t always get what we want, but usually get what we need.","The road less traveled brings new opportunities.","Chance is what we make of our fate."],"triggers":[{"fantastic-journey":["You have stumbled across a fantastic journey."],"old-secrets":["This may hint at some great secrets..."],"special-place":["What a unique place..."]}]}');
    }
  },
      e = {};

  function r(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var i = e[n] = {
      id: n,
      exports: {}
    };
    return t[n].call(i.exports, i, i.exports, r), i.exports;
  }

  r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return r.d(e, {
      a: e
    }), e;
  }, r.d = function (t, e) {
    for (var n in e) {
      r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
        enumerable: !0,
        get: e[n]
      });
    }
  }, r.g = function () {
    if ("object" == typeof globalThis) return globalThis;

    try {
      return this || new Function("return this")();
    } catch (t) {
      if ("object" == typeof window) return window;
    }
  }(), r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, r.nc = void 0;
  var n = {};
  (function () {
    "use strict";

    r.r(n), r.d(n, {
      default: function _default() {
        return Oo;
      }
    });
    var t = r(1974),
        e = r.n(t),
        o = r(5565),
        i = r(5697),
        a = r.n(i);
    var s = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : global,
        c = Object.keys,
        u = Array.isArray;

    function l(t, e) {
      return "object" != typeof e || c(e).forEach(function (r) {
        t[r] = e[r];
      }), t;
    }

    "undefined" == typeof Promise || s.Promise || (s.Promise = Promise);
    var f = Object.getPrototypeOf,
        h = {}.hasOwnProperty;

    function p(t, e) {
      return h.call(t, e);
    }

    function d(t, e) {
      "function" == typeof e && (e = e(f(t))), ("undefined" == typeof Reflect ? c : Reflect.ownKeys)(e).forEach(function (r) {
        m(t, r, e[r]);
      });
    }

    var y = Object.defineProperty;

    function m(t, e, r, n) {
      y(t, e, l(r && p(r, "get") && "function" == typeof r.get ? {
        get: r.get,
        set: r.set,
        configurable: !0
      } : {
        value: r,
        configurable: !0,
        writable: !0
      }, n));
    }

    function v(t) {
      return {
        from: function from(e) {
          return t.prototype = Object.create(e.prototype), m(t.prototype, "constructor", t), {
            extend: d.bind(null, t.prototype)
          };
        }
      };
    }

    var g = Object.getOwnPropertyDescriptor;

    function b(t, e) {
      var r;
      return g(t, e) || (r = f(t)) && b(r, e);
    }

    var w = [].slice;

    function O(t, e, r) {
      return w.call(t, e, r);
    }

    function _(t, e) {
      return e(t);
    }

    function x(t) {
      if (!t) throw new Error("Assertion Failed");
    }

    function L(t) {
      s.setImmediate ? setImmediate(t) : setTimeout(t, 0);
    }

    function E(t, e) {
      return t.reduce(function (t, r, n) {
        var o = e(r, n);
        return o && (t[o[0]] = o[1]), t;
      }, {});
    }

    function A(t, e) {
      if (p(t, e)) return t[e];
      if (!e) return t;

      if ("string" != typeof e) {
        for (var r = [], n = 0, o = e.length; n < o; ++n) {
          var i = A(t, e[n]);
          r.push(i);
        }

        return r;
      }

      var a = e.indexOf(".");

      if (-1 !== a) {
        var s = t[e.substr(0, a)];
        return void 0 === s ? void 0 : A(s, e.substr(a + 1));
      }
    }

    function R(t, e, r) {
      if (t && void 0 !== e && (!("isFrozen" in Object) || !Object.isFrozen(t))) if ("string" != typeof e && "length" in e) {
        x("string" != typeof r && "length" in r);

        for (var n = 0, o = e.length; n < o; ++n) {
          R(t, e[n], r[n]);
        }
      } else {
        var i = e.indexOf(".");

        if (-1 !== i) {
          var a = e.substr(0, i),
              s = e.substr(i + 1);
          if ("" === s) void 0 === r ? u(t) && !isNaN(parseInt(a)) ? t.splice(a, 1) : delete t[a] : t[a] = r;else {
            var c = t[a];
            c || (c = t[a] = {}), R(c, s, r);
          }
        } else void 0 === r ? u(t) && !isNaN(parseInt(e)) ? t.splice(e, 1) : delete t[e] : t[e] = r;
      }
    }

    function T(t) {
      var e = {};

      for (var r in t) {
        p(t, r) && (e[r] = t[r]);
      }

      return e;
    }

    var P = [].concat;

    function S(t) {
      return P.apply([], t);
    }

    var k = "Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(S([8, 16, 32, 64].map(function (t) {
      return ["Int", "Uint", "Float"].map(function (e) {
        return e + t + "Array";
      });
    }))).filter(function (t) {
      return s[t];
    }),
        j = k.map(function (t) {
      return s[t];
    });
    E(k, function (t) {
      return [t, !0];
    });
    var Z = null;

    function M(t) {
      Z = "undefined" != typeof WeakMap && new WeakMap();
      var e = C(t);
      return Z = null, e;
    }

    function C(t) {
      if (!t || "object" != typeof t) return t;
      var e = Z && Z.get(t);
      if (e) return e;

      if (u(t)) {
        e = [], Z && Z.set(t, e);

        for (var r = 0, n = t.length; r < n; ++r) {
          e.push(C(t[r]));
        }
      } else if (j.indexOf(t.constructor) >= 0) e = t;else {
        var _r15 = f(t);

        for (var o in e = _r15 === Object.prototype ? {} : Object.create(_r15), Z && Z.set(t, e), t) {
          p(t, o) && (e[o] = C(t[o]));
        }
      }

      return e;
    }

    var _ref10 = {},
        F = _ref10.toString;

    function W(t) {
      return F.call(t).slice(8, -1);
    }

    var B = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator",
        N = "symbol" == typeof B ? function (t) {
      var e;
      return null != t && (e = t[B]) && e.apply(t);
    } : function () {
      return null;
    },
        I = {};

    function D(t) {
      var e, r, n, o;

      if (1 === arguments.length) {
        if (u(t)) return t.slice();
        if (this === I && "string" == typeof t) return [t];

        if (o = N(t)) {
          for (r = []; !(n = o.next()).done;) {
            r.push(n.value);
          }

          return r;
        }

        if (null == t) return [t];

        if ("number" == typeof (e = t.length)) {
          for (r = new Array(e); e--;) {
            r[e] = t[e];
          }

          return r;
        }

        return [t];
      }

      for (e = arguments.length, r = new Array(e); e--;) {
        r[e] = arguments[e];
      }

      return r;
    }

    var Y = "undefined" != typeof Symbol ? function (t) {
      return "AsyncFunction" === t[Symbol.toStringTag];
    } : function () {
      return !1;
    };
    var z = "undefined" != typeof location && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);

    function U(t, e) {
      z = t, G = e;
    }

    var G = function G() {
      return !0;
    };

    var K = !new Error("").stack;

    function H() {
      if (K) try {
        throw H.arguments, new Error();
      } catch (t) {
        return t;
      }
      return new Error();
    }

    function V(t, e) {
      var r = t.stack;
      return r ? (e = e || 0, 0 === r.indexOf(t.name) && (e += (t.name + t.message).split("\n").length), r.split("\n").slice(e).filter(G).map(function (t) {
        return "\n" + t;
      }).join("")) : "";
    }

    var q = ["Unknown", "Constraint", "Data", "TransactionInactive", "ReadOnly", "Version", "NotFound", "InvalidState", "InvalidAccess", "Abort", "Timeout", "QuotaExceeded", "Syntax", "DataClone"],
        $ = ["Modify", "Bulk", "OpenFailed", "VersionChange", "Schema", "Upgrade", "InvalidTable", "MissingAPI", "NoSuchDatabase", "InvalidArgument", "SubTransaction", "Unsupported", "Internal", "DatabaseClosed", "PrematureCommit", "ForeignAwait"].concat(q),
        X = {
      VersionChanged: "Database version changed by other database connection",
      DatabaseClosed: "Database has been closed",
      Abort: "Transaction aborted",
      TransactionInactive: "Transaction has already completed or failed",
      MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
    };

    function J(t, e) {
      this._e = H(), this.name = t, this.message = e;
    }

    function Q(t, e) {
      return t + ". Errors: " + Object.keys(e).map(function (t) {
        return e[t].toString();
      }).filter(function (t, e, r) {
        return r.indexOf(t) === e;
      }).join("\n");
    }

    function tt(t, e, r, n) {
      this._e = H(), this.failures = e, this.failedKeys = n, this.successCount = r, this.message = Q(t, e);
    }

    function et(t, e) {
      this._e = H(), this.name = "BulkError", this.failures = Object.keys(e).map(function (t) {
        return e[t];
      }), this.failuresByPos = e, this.message = Q(t, e);
    }

    v(J).from(Error).extend({
      stack: {
        get: function get() {
          return this._stack || (this._stack = this.name + ": " + this.message + V(this._e, 2));
        }
      },
      toString: function toString() {
        return this.name + ": " + this.message;
      }
    }), v(tt).from(J), v(et).from(J);
    var rt = $.reduce(function (t, e) {
      return t[e] = e + "Error", t;
    }, {});
    var nt = J;
    var ot = $.reduce(function (t, e) {
      var r = e + "Error";

      function n(t, n) {
        this._e = H(), this.name = r, t ? "string" == typeof t ? (this.message = "".concat(t).concat(n ? "\n " + n : ""), this.inner = n || null) : "object" == typeof t && (this.message = "".concat(t.name, " ").concat(t.message), this.inner = t) : (this.message = X[e] || r, this.inner = null);
      }

      return v(n).from(nt), t[e] = n, t;
    }, {});
    ot.Syntax = SyntaxError, ot.Type = TypeError, ot.Range = RangeError;
    var it = q.reduce(function (t, e) {
      return t[e + "Error"] = ot[e], t;
    }, {}),
        at = $.reduce(function (t, e) {
      return -1 === ["Syntax", "Type", "Range"].indexOf(e) && (t[e + "Error"] = ot[e]), t;
    }, {});

    function st() {}

    function ct(t) {
      return t;
    }

    function ut(t, e) {
      return null == t || t === ct ? e : function (r) {
        return e(t(r));
      };
    }

    function lt(t, e) {
      return function () {
        t.apply(this, arguments), e.apply(this, arguments);
      };
    }

    function ft(t, e) {
      return t === st ? e : function () {
        var r = t.apply(this, arguments);
        void 0 !== r && (arguments[0] = r);
        var n = this.onsuccess,
            o = this.onerror;
        this.onsuccess = null, this.onerror = null;
        var i = e.apply(this, arguments);
        return n && (this.onsuccess = this.onsuccess ? lt(n, this.onsuccess) : n), o && (this.onerror = this.onerror ? lt(o, this.onerror) : o), void 0 !== i ? i : r;
      };
    }

    function ht(t, e) {
      return t === st ? e : function () {
        t.apply(this, arguments);
        var r = this.onsuccess,
            n = this.onerror;
        this.onsuccess = this.onerror = null, e.apply(this, arguments), r && (this.onsuccess = this.onsuccess ? lt(r, this.onsuccess) : r), n && (this.onerror = this.onerror ? lt(n, this.onerror) : n);
      };
    }

    function pt(t, e) {
      return t === st ? e : function (r) {
        var n = t.apply(this, arguments);
        l(r, n);
        var o = this.onsuccess,
            i = this.onerror;
        this.onsuccess = null, this.onerror = null;
        var a = e.apply(this, arguments);
        return o && (this.onsuccess = this.onsuccess ? lt(o, this.onsuccess) : o), i && (this.onerror = this.onerror ? lt(i, this.onerror) : i), void 0 === n ? void 0 === a ? void 0 : a : l(n, a);
      };
    }

    function dt(t, e) {
      return t === st ? e : function () {
        return !1 !== e.apply(this, arguments) && t.apply(this, arguments);
      };
    }

    function yt(t, e) {
      return t === st ? e : function () {
        var r = t.apply(this, arguments);

        if (r && "function" == typeof r.then) {
          for (var n = this, o = arguments.length, i = new Array(o); o--;) {
            i[o] = arguments[o];
          }

          return r.then(function () {
            return e.apply(n, i);
          });
        }

        return e.apply(this, arguments);
      };
    }

    at.ModifyError = tt, at.DexieError = J, at.BulkError = et;
    var mt = {};

    var _ref11 = "undefined" == typeof Promise ? [] : function () {
      var t = Promise.resolve();
      if ("undefined" == typeof crypto || !crypto.subtle) return [t, f(t), t];
      var e = crypto.subtle.digest("SHA-512", new Uint8Array([0]));
      return [e, f(e), t];
    }(),
        _ref12 = _slicedToArray(_ref11, 3),
        vt = _ref12[0],
        gt = _ref12[1],
        bt = _ref12[2],
        wt = gt && gt.then,
        Ot = vt && vt.constructor,
        _t = !!bt;

    var xt = !1,
        Lt = bt ? function () {
      bt.then(Ht);
    } : s.setImmediate ? setImmediate.bind(null, Ht) : s.MutationObserver ? function () {
      var t = document.createElement("div");
      new MutationObserver(function () {
        Ht(), t = null;
      }).observe(t, {
        attributes: !0
      }), t.setAttribute("i", "1");
    } : function () {
      setTimeout(Ht, 0);
    },
        Et = function Et(t, e) {
      Mt.push([t, e]), Rt && (Lt(), Rt = !1);
    },
        At = !0,
        Rt = !0,
        Tt = [],
        Pt = [],
        St = null,
        kt = ct,
        jt = {
      id: "global",
      global: !0,
      ref: 0,
      unhandleds: [],
      onunhandled: ge,
      pgp: !1,
      env: {},
      finalize: function finalize() {
        this.unhandleds.forEach(function (t) {
          try {
            ge(t[0], t[1]);
          } catch (t) {}
        });
      }
    },
        Zt = jt,
        Mt = [],
        Ct = 0,
        Ft = [];

    function Wt(t) {
      if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
      this._listeners = [], this.onuncatched = st, this._lib = !1;
      var e = this._PSD = Zt;

      if (z && (this._stackHolder = H(), this._prev = null, this._numPrev = 0), "function" != typeof t) {
        if (t !== mt) throw new TypeError("Not a function");
        return this._state = arguments[1], this._value = arguments[2], void (!1 === this._state && Dt(this, this._value));
      }

      this._state = null, this._value = null, ++e.ref, It(this, t);
    }

    var Bt = {
      get: function get() {
        var t = Zt,
            e = ne;

        function r(r, n) {
          var _this3 = this;

          var o = !t.global && (t !== Zt || e !== ne);
          var i = o && !se();
          var a = new Wt(function (e, a) {
            zt(_this3, new Nt(ye(r, t, o, i), ye(n, t, o, i), e, a, t));
          });
          return z && Kt(a, this), a;
        }

        return r.prototype = mt, r;
      },
      set: function set(t) {
        m(this, "then", t && t.prototype === mt ? Bt : {
          get: function get() {
            return t;
          },
          set: Bt.set
        });
      }
    };

    function Nt(t, e, r, n, o) {
      this.onFulfilled = "function" == typeof t ? t : null, this.onRejected = "function" == typeof e ? e : null, this.resolve = r, this.reject = n, this.psd = o;
    }

    function It(t, e) {
      try {
        e(function (e) {
          if (null === t._state) {
            if (e === t) throw new TypeError("A promise cannot be resolved with itself.");
            var r = t._lib && Vt();
            e && "function" == typeof e.then ? It(t, function (t, r) {
              e instanceof Wt ? e._then(t, r) : e.then(t, r);
            }) : (t._state = !0, t._value = e, Yt(t)), r && qt();
          }
        }, Dt.bind(null, t));
      } catch (e) {
        Dt(t, e);
      }
    }

    function Dt(t, e) {
      if (Pt.push(e), null === t._state) {
        var r = t._lib && Vt();
        e = kt(e), t._state = !1, t._value = e, z && null !== e && "object" == typeof e && !e._promise && function (r, n, o) {
          try {
            (function () {
              var r = b(e, "stack");
              e._promise = t, m(e, "stack", {
                get: function get() {
                  return xt ? r && (r.get ? r.get.apply(e) : r.value) : t.stack;
                }
              });
            }).apply(null, void 0);
          } catch (t) {}
        }(), function (t) {
          Tt.some(function (e) {
            return e._value === t._value;
          }) || Tt.push(t);
        }(t), Yt(t), r && qt();
      }
    }

    function Yt(t) {
      var e = t._listeners;
      t._listeners = [];

      for (var r = 0, n = e.length; r < n; ++r) {
        zt(t, e[r]);
      }

      var o = t._PSD;
      --o.ref || o.finalize(), 0 === Ct && (++Ct, Et(function () {
        0 == --Ct && $t();
      }, []));
    }

    function zt(t, e) {
      if (null !== t._state) {
        var r = t._state ? e.onFulfilled : e.onRejected;
        if (null === r) return (t._state ? e.resolve : e.reject)(t._value);
        ++e.psd.ref, ++Ct, Et(Ut, [r, t, e]);
      } else t._listeners.push(e);
    }

    function Ut(t, e, r) {
      try {
        St = e;
        var n,
            o = e._value;
        e._state ? n = t(o) : (Pt.length && (Pt = []), n = t(o), -1 === Pt.indexOf(o) && function (t) {
          for (var e = Tt.length; e;) {
            if (Tt[--e]._value === t._value) return void Tt.splice(e, 1);
          }
        }(e)), r.resolve(n);
      } catch (t) {
        r.reject(t);
      } finally {
        St = null, 0 == --Ct && $t(), --r.psd.ref || r.psd.finalize();
      }
    }

    function Gt(t, e, r) {
      if (e.length === r) return e;
      var n = "";

      if (!1 === t._state) {
        var o,
            i,
            a = t._value;
        null != a ? (o = a.name || "Error", i = a.message || a, n = V(a, 0)) : (o = a, i = ""), e.push(o + (i ? ": " + i : "") + n);
      }

      return z && ((n = V(t._stackHolder, 2)) && -1 === e.indexOf(n) && e.push(n), t._prev && Gt(t._prev, e, r)), e;
    }

    function Kt(t, e) {
      var r = e ? e._numPrev + 1 : 0;
      r < 100 && (t._prev = e, t._numPrev = r);
    }

    function Ht() {
      Vt() && qt();
    }

    function Vt() {
      var t = At;
      return At = !1, Rt = !1, t;
    }

    function qt() {
      var t, e, r;

      do {
        for (; Mt.length > 0;) {
          for (t = Mt, Mt = [], r = t.length, e = 0; e < r; ++e) {
            var n = t[e];
            n[0].apply(null, n[1]);
          }
        }
      } while (Mt.length > 0);

      At = !0, Rt = !0;
    }

    function $t() {
      var t = Tt;
      Tt = [], t.forEach(function (t) {
        t._PSD.onunhandled.call(null, t._value, t);
      });

      for (var e = Ft.slice(0), r = e.length; r;) {
        e[--r]();
      }
    }

    function Xt(t) {
      return new Wt(mt, !1, t);
    }

    function Jt(t, e) {
      var r = Zt;
      return function () {
        var n = Vt(),
            o = Zt;

        try {
          return fe(r, !0), t.apply(this, arguments);
        } catch (t) {
          e && e(t);
        } finally {
          fe(o, !1), n && qt();
        }
      };
    }

    d(Wt.prototype, {
      then: Bt,
      _then: function _then(t, e) {
        zt(this, new Nt(null, null, t, e, Zt));
      },
      catch: function _catch(t) {
        if (1 === arguments.length) return this.then(null, t);
        var e = arguments[0],
            r = arguments[1];
        return "function" == typeof e ? this.then(null, function (t) {
          return t instanceof e ? r(t) : Xt(t);
        }) : this.then(null, function (t) {
          return t && t.name === e ? r(t) : Xt(t);
        });
      },
      finally: function _finally(t) {
        return this.then(function (e) {
          return t(), e;
        }, function (e) {
          return t(), Xt(e);
        });
      },
      stack: {
        get: function get() {
          if (this._stack) return this._stack;

          try {
            xt = !0;
            var t = Gt(this, [], 20).join("\nFrom previous: ");
            return null !== this._state && (this._stack = t), t;
          } finally {
            xt = !1;
          }
        }
      },
      timeout: function timeout(t, e) {
        var _this4 = this;

        return t < 1 / 0 ? new Wt(function (r, n) {
          var o = setTimeout(function () {
            return n(new ot.Timeout(e));
          }, t);

          _this4.then(r, n).finally(clearTimeout.bind(null, o));
        }) : this;
      }
    }), "undefined" != typeof Symbol && Symbol.toStringTag && m(Wt.prototype, Symbol.toStringTag, "Dexie.Promise"), jt.env = he(), d(Wt, {
      all: function all() {
        var t = D.apply(null, arguments).map(ce);
        return new Wt(function (e, r) {
          0 === t.length && e([]);
          var n = t.length;
          t.forEach(function (o, i) {
            return Wt.resolve(o).then(function (r) {
              t[i] = r, --n || e(t);
            }, r);
          });
        });
      },
      resolve: function resolve(t) {
        if (t instanceof Wt) return t;
        if (t && "function" == typeof t.then) return new Wt(function (e, r) {
          t.then(e, r);
        });
        var e = new Wt(mt, !0, t);
        return Kt(e, St), e;
      },
      reject: Xt,
      race: function race() {
        var t = D.apply(null, arguments).map(ce);
        return new Wt(function (e, r) {
          t.map(function (t) {
            return Wt.resolve(t).then(e, r);
          });
        });
      },
      PSD: {
        get: function get() {
          return Zt;
        },
        set: function set(t) {
          return Zt = t;
        }
      },
      totalEchoes: {
        get: function get() {
          return ne;
        }
      },
      newPSD: ie,
      usePSD: pe,
      scheduler: {
        get: function get() {
          return Et;
        },
        set: function set(t) {
          Et = t;
        }
      },
      rejectionMapper: {
        get: function get() {
          return kt;
        },
        set: function set(t) {
          kt = t;
        }
      },
      follow: function follow(t, e) {
        return new Wt(function (r, n) {
          return ie(function (e, r) {
            var n = Zt;
            n.unhandleds = [], n.onunhandled = r, n.finalize = lt(function () {
              var _this5 = this;

              !function (t) {
                Ft.push(function e() {
                  t(), Ft.splice(Ft.indexOf(e), 1);
                }), ++Ct, Et(function () {
                  0 == --Ct && $t();
                }, []);
              }(function () {
                0 === _this5.unhandleds.length ? e() : r(_this5.unhandleds[0]);
              });
            }, n.finalize), t();
          }, e, r, n);
        });
      }
    }), Ot && (Ot.allSettled && m(Wt, "allSettled", function () {
      var t = D.apply(null, arguments).map(ce);
      return new Wt(function (e) {
        0 === t.length && e([]);
        var r = t.length;
        var n = new Array(r);
        t.forEach(function (t, o) {
          return Wt.resolve(t).then(function (t) {
            return n[o] = {
              status: "fulfilled",
              value: t
            };
          }, function (t) {
            return n[o] = {
              status: "rejected",
              reason: t
            };
          }).then(function () {
            return --r || e(n);
          });
        });
      });
    }), Ot.any && "undefined" != typeof AggregateError && m(Wt, "any", function () {
      var t = D.apply(null, arguments).map(ce);
      return new Wt(function (e, r) {
        0 === t.length && r(new AggregateError([]));
        var n = t.length;
        var o = new Array(n);
        t.forEach(function (t, i) {
          return Wt.resolve(t).then(function (t) {
            return e(t);
          }, function (t) {
            o[i] = t, --n || r(new AggregateError(o));
          });
        });
      });
    }));
    var Qt = {
      awaits: 0,
      echoes: 0,
      id: 0
    };
    var te = 0,
        ee = [],
        re = 0,
        ne = 0,
        oe = 0;

    function ie(t, e, r, n) {
      var o = Zt,
          i = Object.create(o);
      i.parent = o, i.ref = 0, i.global = !1, i.id = ++oe;
      var a = jt.env;
      i.env = _t ? {
        Promise: Wt,
        PromiseProp: {
          value: Wt,
          configurable: !0,
          writable: !0
        },
        all: Wt.all,
        race: Wt.race,
        allSettled: Wt.allSettled,
        any: Wt.any,
        resolve: Wt.resolve,
        reject: Wt.reject,
        nthen: me(a.nthen, i),
        gthen: me(a.gthen, i)
      } : {}, e && l(i, e), ++o.ref, i.finalize = function () {
        --this.parent.ref || this.parent.finalize();
      };
      var s = pe(i, t, r, n);
      return 0 === i.ref && i.finalize(), s;
    }

    function ae() {
      return Qt.id || (Qt.id = ++te), ++Qt.awaits, Qt.echoes += 100, Qt.id;
    }

    function se() {
      return !!Qt.awaits && (0 == --Qt.awaits && (Qt.id = 0), Qt.echoes = 100 * Qt.awaits, !0);
    }

    function ce(t) {
      return Qt.echoes && t && t.constructor === Ot ? (ae(), t.then(function (t) {
        return se(), t;
      }, function (t) {
        return se(), be(t);
      })) : t;
    }

    function ue(t) {
      ++ne, Qt.echoes && 0 != --Qt.echoes || (Qt.echoes = Qt.id = 0), ee.push(Zt), fe(t, !0);
    }

    function le() {
      var t = ee[ee.length - 1];
      ee.pop(), fe(t, !1);
    }

    function fe(t, e) {
      var r = Zt;

      if ((e ? !Qt.echoes || re++ && t === Zt : !re || --re && t === Zt) || de(e ? ue.bind(null, t) : le), t !== Zt && (Zt = t, r === jt && (jt.env = he()), _t)) {
        var n = jt.env.Promise,
            o = t.env;
        gt.then = o.nthen, n.prototype.then = o.gthen, (r.global || t.global) && (Object.defineProperty(s, "Promise", o.PromiseProp), n.all = o.all, n.race = o.race, n.resolve = o.resolve, n.reject = o.reject, o.allSettled && (n.allSettled = o.allSettled), o.any && (n.any = o.any));
      }
    }

    function he() {
      var t = s.Promise;
      return _t ? {
        Promise: t,
        PromiseProp: Object.getOwnPropertyDescriptor(s, "Promise"),
        all: t.all,
        race: t.race,
        allSettled: t.allSettled,
        any: t.any,
        resolve: t.resolve,
        reject: t.reject,
        nthen: gt.then,
        gthen: t.prototype.then
      } : {};
    }

    function pe(t, e, r, n, o) {
      var i = Zt;

      try {
        return fe(t, !0), e(r, n, o);
      } finally {
        fe(i, !1);
      }
    }

    function de(t) {
      wt.call(vt, t);
    }

    function ye(t, e, r, n) {
      return "function" != typeof t ? t : function () {
        var o = Zt;
        r && ae(), fe(e, !0);

        try {
          return t.apply(this, arguments);
        } finally {
          fe(o, !1), n && de(se);
        }
      };
    }

    function me(t, e) {
      return function (r, n) {
        return t.call(this, ye(r, e), ye(n, e));
      };
    }

    -1 === ("" + wt).indexOf("[native code]") && (ae = se = st);
    var ve = "unhandledrejection";

    function ge(t, e) {
      var r;

      try {
        r = e.onuncatched(t);
      } catch (t) {}

      if (!1 !== r) try {
        var n,
            o = {
          promise: e,
          reason: t
        };
        if (s.document && document.createEvent ? ((n = document.createEvent("Event")).initEvent(ve, !0, !0), l(n, o)) : s.CustomEvent && l(n = new CustomEvent(ve, {
          detail: o
        }), o), n && s.dispatchEvent && (dispatchEvent(n), !s.PromiseRejectionEvent && s.onunhandledrejection)) try {
          s.onunhandledrejection(n);
        } catch (t) {}
        z && n && !n.defaultPrevented && console.warn("Unhandled rejection: ".concat(t.stack || t));
      } catch (t) {}
    }

    var be = Wt.reject;

    function we(t, e, r, n) {
      if (t.idbdb && (t._state.openComplete || Zt.letThrough || t._vip)) {
        var o = t._createTransaction(e, r, t._dbSchema);

        try {
          o.create();
        } catch (t) {
          return be(t);
        }

        return o._promise(e, function (t, e) {
          return ie(function () {
            return Zt.trans = o, n(t, e, o);
          });
        }).then(function (t) {
          return o._completion.then(function () {
            return t;
          });
        });
      }

      if (t._state.openComplete) return be(new ot.DatabaseClosed(t._state.dbOpenError));

      if (!t._state.isBeingOpened) {
        if (!t._options.autoOpen) return be(new ot.DatabaseClosed());
        t.open().catch(st);
      }

      return t._state.dbReadyPromise.then(function () {
        return we(t, e, r, n);
      });
    }

    var Oe = "3.2.0",
        _e = String.fromCharCode(65535),
        xe = -1 / 0,
        Le = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.",
        Ee = "String expected.",
        Ae = [],
        Re = "undefined" != typeof navigator && /(MSIE|Trident|Edge)/.test(navigator.userAgent),
        Te = Re,
        Pe = Re,
        Se = function Se(t) {
      return !/(dexie\.js|dexie\.min\.js)/.test(t);
    },
        ke = "__dbnames",
        je = "readonly",
        Ze = "readwrite";

    function Me(t, e) {
      return t ? e ? function () {
        return t.apply(this, arguments) && e.apply(this, arguments);
      } : t : e;
    }

    var Ce = {
      type: 3,
      lower: -1 / 0,
      lowerOpen: !1,
      upper: [[]],
      upperOpen: !1
    };

    function Fe(t) {
      return "string" != typeof t || /\./.test(t) ? function (t) {
        return t;
      } : function (e) {
        return void 0 === e[t] && t in e && delete (e = M(e))[t], e;
      };
    }

    var We = /*#__PURE__*/function () {
      function We() {
        _classCallCheck(this, We);
      }

      _createClass(We, [{
        key: "_trans",
        value: function _trans(t, e, r) {
          var n = this._tx || Zt.trans,
              o = this.name;

          function i(t, r, n) {
            if (!n.schema[o]) throw new ot.NotFound("Table " + o + " not part of transaction");
            return e(n.idbtrans, n);
          }

          var a = Vt();

          try {
            return n && n.db === this.db ? n === Zt.trans ? n._promise(t, i, r) : ie(function () {
              return n._promise(t, i, r);
            }, {
              trans: n,
              transless: Zt.transless || Zt
            }) : we(this.db, t, [this.name], i);
          } finally {
            a && qt();
          }
        }
      }, {
        key: "get",
        value: function get(t, e) {
          var _this6 = this;

          return t && t.constructor === Object ? this.where(t).first(e) : this._trans("readonly", function (e) {
            return _this6.core.get({
              trans: e,
              key: t
            }).then(function (t) {
              return _this6.hook.reading.fire(t);
            });
          }).then(e);
        }
      }, {
        key: "where",
        value: function where(t) {
          if ("string" == typeof t) return new this.db.WhereClause(this, t);
          if (u(t)) return new this.db.WhereClause(this, "[".concat(t.join("+"), "]"));
          var e = c(t);
          if (1 === e.length) return this.where(e[0]).equals(t[e[0]]);
          var r = this.schema.indexes.concat(this.schema.primKey).filter(function (t) {
            return t.compound && e.every(function (e) {
              return t.keyPath.indexOf(e) >= 0;
            }) && t.keyPath.every(function (t) {
              return e.indexOf(t) >= 0;
            });
          })[0];
          if (r && this.db._maxKey !== _e) return this.where(r.name).equals(r.keyPath.map(function (e) {
            return t[e];
          }));
          !r && z && console.warn("The query ".concat(JSON.stringify(t), " on ").concat(this.name, " would benefit of a compound index [").concat(e.join("+"), "]"));
          var n = this.schema.idxByName,
              o = this.db._deps.indexedDB;

          function i(t, e) {
            try {
              return 0 === o.cmp(t, e);
            } catch (t) {
              return !1;
            }
          }

          var _e$reduce = e.reduce(function (_ref13, o) {
            var _ref14 = _slicedToArray(_ref13, 2),
                e = _ref14[0],
                r = _ref14[1];

            var a = n[o],
                s = t[o];
            return [e || a, e || !a ? Me(r, a && a.multi ? function (t) {
              var e = A(t, o);
              return u(e) && e.some(function (t) {
                return i(s, t);
              });
            } : function (t) {
              return i(s, A(t, o));
            }) : r];
          }, [null, null]),
              _e$reduce2 = _slicedToArray(_e$reduce, 2),
              a = _e$reduce2[0],
              s = _e$reduce2[1];

          return a ? this.where(a.name).equals(t[a.keyPath]).filter(s) : r ? this.filter(s) : this.where(e).equals("");
        }
      }, {
        key: "filter",
        value: function filter(t) {
          return this.toCollection().and(t);
        }
      }, {
        key: "count",
        value: function count(t) {
          return this.toCollection().count(t);
        }
      }, {
        key: "offset",
        value: function offset(t) {
          return this.toCollection().offset(t);
        }
      }, {
        key: "limit",
        value: function limit(t) {
          return this.toCollection().limit(t);
        }
      }, {
        key: "each",
        value: function each(t) {
          return this.toCollection().each(t);
        }
      }, {
        key: "toArray",
        value: function toArray(t) {
          return this.toCollection().toArray(t);
        }
      }, {
        key: "toCollection",
        value: function toCollection() {
          return new this.db.Collection(new this.db.WhereClause(this));
        }
      }, {
        key: "orderBy",
        value: function orderBy(t) {
          return new this.db.Collection(new this.db.WhereClause(this, u(t) ? "[".concat(t.join("+"), "]") : t));
        }
      }, {
        key: "reverse",
        value: function reverse() {
          return this.toCollection().reverse();
        }
      }, {
        key: "mapToClass",
        value: function mapToClass(t) {
          this.schema.mappedClass = t;

          var e = function e(_e14) {
            if (!_e14) return _e14;
            var r = Object.create(t.prototype);

            for (var n in _e14) {
              if (p(_e14, n)) try {
                r[n] = _e14[n];
              } catch (t) {}
            }

            return r;
          };

          return this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook), this.schema.readHook = e, this.hook("reading", e), t;
        }
      }, {
        key: "defineClass",
        value: function defineClass() {
          return this.mapToClass(function (t) {
            l(this, t);
          });
        }
      }, {
        key: "add",
        value: function add(t, e) {
          var _this7 = this;

          var _this$schema$primKey = this.schema.primKey,
              r = _this$schema$primKey.auto,
              n = _this$schema$primKey.keyPath;
          var o = t;
          return n && r && (o = Fe(n)(t)), this._trans("readwrite", function (t) {
            return _this7.core.mutate({
              trans: t,
              type: "add",
              keys: null != e ? [e] : null,
              values: [o]
            });
          }).then(function (t) {
            return t.numFailures ? Wt.reject(t.failures[0]) : t.lastResult;
          }).then(function (e) {
            if (n) try {
              R(t, n, e);
            } catch (t) {}
            return e;
          });
        }
      }, {
        key: "update",
        value: function update(t, e) {
          if ("object" != typeof t || u(t)) return this.where(":id").equals(t).modify(e);
          {
            var _r16 = A(t, this.schema.primKey.keyPath);

            if (void 0 === _r16) return be(new ot.InvalidArgument("Given object does not contain its primary key"));

            try {
              "function" != typeof e ? c(e).forEach(function (r) {
                R(t, r, e[r]);
              }) : e(t, {
                value: t,
                primKey: _r16
              });
            } catch (t) {}

            return this.where(":id").equals(_r16).modify(e);
          }
        }
      }, {
        key: "put",
        value: function put(t, e) {
          var _this8 = this;

          var _this$schema$primKey2 = this.schema.primKey,
              r = _this$schema$primKey2.auto,
              n = _this$schema$primKey2.keyPath;
          var o = t;
          return n && r && (o = Fe(n)(t)), this._trans("readwrite", function (t) {
            return _this8.core.mutate({
              trans: t,
              type: "put",
              values: [o],
              keys: null != e ? [e] : null
            });
          }).then(function (t) {
            return t.numFailures ? Wt.reject(t.failures[0]) : t.lastResult;
          }).then(function (e) {
            if (n) try {
              R(t, n, e);
            } catch (t) {}
            return e;
          });
        }
      }, {
        key: "delete",
        value: function _delete(t) {
          var _this9 = this;

          return this._trans("readwrite", function (e) {
            return _this9.core.mutate({
              trans: e,
              type: "delete",
              keys: [t]
            });
          }).then(function (t) {
            return t.numFailures ? Wt.reject(t.failures[0]) : void 0;
          });
        }
      }, {
        key: "clear",
        value: function clear() {
          var _this10 = this;

          return this._trans("readwrite", function (t) {
            return _this10.core.mutate({
              trans: t,
              type: "deleteRange",
              range: Ce
            });
          }).then(function (t) {
            return t.numFailures ? Wt.reject(t.failures[0]) : void 0;
          });
        }
      }, {
        key: "bulkGet",
        value: function bulkGet(t) {
          var _this11 = this;

          return this._trans("readonly", function (e) {
            return _this11.core.getMany({
              keys: t,
              trans: e
            }).then(function (t) {
              return t.map(function (t) {
                return _this11.hook.reading.fire(t);
              });
            });
          });
        }
      }, {
        key: "bulkAdd",
        value: function bulkAdd(t, e, r) {
          var _this12 = this;

          var n = Array.isArray(e) ? e : void 0,
              o = (r = r || (n ? void 0 : e)) ? r.allKeys : void 0;
          return this._trans("readwrite", function (e) {
            var _this12$schema$primKe = _this12.schema.primKey,
                r = _this12$schema$primKe.auto,
                i = _this12$schema$primKe.keyPath;
            if (i && n) throw new ot.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (n && n.length !== t.length) throw new ot.InvalidArgument("Arguments objects and keys must have the same length");
            var a = t.length;
            var s = i && r ? t.map(Fe(i)) : t;
            return _this12.core.mutate({
              trans: e,
              type: "add",
              keys: n,
              values: s,
              wantResults: o
            }).then(function (_ref15) {
              var t = _ref15.numFailures,
                  e = _ref15.results,
                  r = _ref15.lastResult,
                  n = _ref15.failures;
              if (0 === t) return o ? e : r;
              throw new et("".concat(_this12.name, ".bulkAdd(): ").concat(t, " of ").concat(a, " operations failed"), n);
            });
          });
        }
      }, {
        key: "bulkPut",
        value: function bulkPut(t, e, r) {
          var _this13 = this;

          var n = Array.isArray(e) ? e : void 0,
              o = (r = r || (n ? void 0 : e)) ? r.allKeys : void 0;
          return this._trans("readwrite", function (e) {
            var _this13$schema$primKe = _this13.schema.primKey,
                r = _this13$schema$primKe.auto,
                i = _this13$schema$primKe.keyPath;
            if (i && n) throw new ot.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (n && n.length !== t.length) throw new ot.InvalidArgument("Arguments objects and keys must have the same length");
            var a = t.length;
            var s = i && r ? t.map(Fe(i)) : t;
            return _this13.core.mutate({
              trans: e,
              type: "put",
              keys: n,
              values: s,
              wantResults: o
            }).then(function (_ref16) {
              var t = _ref16.numFailures,
                  e = _ref16.results,
                  r = _ref16.lastResult,
                  n = _ref16.failures;
              if (0 === t) return o ? e : r;
              throw new et("".concat(_this13.name, ".bulkPut(): ").concat(t, " of ").concat(a, " operations failed"), n);
            });
          });
        }
      }, {
        key: "bulkDelete",
        value: function bulkDelete(t) {
          var _this14 = this;

          var e = t.length;
          return this._trans("readwrite", function (e) {
            return _this14.core.mutate({
              trans: e,
              type: "delete",
              keys: t
            });
          }).then(function (_ref17) {
            var t = _ref17.numFailures,
                r = _ref17.lastResult,
                n = _ref17.failures;
            if (0 === t) return r;
            throw new et("".concat(_this14.name, ".bulkDelete(): ").concat(t, " of ").concat(e, " operations failed"), n);
          });
        }
      }]);

      return We;
    }();

    function Be(t) {
      var e = {},
          r = function r(_r17, n) {
        if (n) {
          for (var o = arguments.length, i = new Array(o - 1); --o;) {
            i[o - 1] = arguments[o];
          }

          return e[_r17].subscribe.apply(null, i), t;
        }

        if ("string" == typeof _r17) return e[_r17];
      };

      r.addEventType = i;

      for (var n = 1, o = arguments.length; n < o; ++n) {
        i(arguments[n]);
      }

      return r;

      function i(t, n, o) {
        if ("object" == typeof t) return a(t);
        n || (n = dt), o || (o = st);
        var i = {
          subscribers: [],
          fire: o,
          subscribe: function subscribe(t) {
            -1 === i.subscribers.indexOf(t) && (i.subscribers.push(t), i.fire = n(i.fire, t));
          },
          unsubscribe: function unsubscribe(t) {
            i.subscribers = i.subscribers.filter(function (e) {
              return e !== t;
            }), i.fire = i.subscribers.reduce(n, o);
          }
        };
        return e[t] = r[t] = i, i;
      }

      function a(t) {
        c(t).forEach(function (e) {
          var r = t[e];
          if (u(r)) i(e, t[e][0], t[e][1]);else {
            if ("asap" !== r) throw new ot.InvalidArgument("Invalid event config");
            var n = i(e, ct, function () {
              for (var t = arguments.length, e = new Array(t); t--;) {
                e[t] = arguments[t];
              }

              n.subscribers.forEach(function (t) {
                L(function () {
                  t.apply(null, e);
                });
              });
            });
          }
        });
      }
    }

    function Ne(t, e) {
      return v(e).from({
        prototype: t
      }), e;
    }

    function Ie(t, e) {
      return !(t.filter || t.algorithm || t.or) && (e ? t.justLimit : !t.replayFilter);
    }

    function De(t, e) {
      t.filter = Me(t.filter, e);
    }

    function Ye(t, e, r) {
      var n = t.replayFilter;
      t.replayFilter = n ? function () {
        return Me(n(), e());
      } : e, t.justLimit = r && !n;
    }

    function ze(t, e) {
      if (t.isPrimKey) return e.primaryKey;
      var r = e.getIndexByKeyPath(t.index);
      if (!r) throw new ot.Schema("KeyPath " + t.index + " on object store " + e.name + " is not indexed");
      return r;
    }

    function Ue(t, e, r) {
      var n = ze(t, e.schema);
      return e.openCursor({
        trans: r,
        values: !t.keysOnly,
        reverse: "prev" === t.dir,
        unique: !!t.unique,
        query: {
          index: n,
          range: t.range
        }
      });
    }

    function Ge(t, e, r, n) {
      var o = t.replayFilter ? Me(t.filter, t.replayFilter()) : t.filter;

      if (t.or) {
        var _i4 = {},
            _a5 = function _a5(t, r, n) {
          if (!o || o(r, n, function (t) {
            return r.stop(t);
          }, function (t) {
            return r.fail(t);
          })) {
            var a = r.primaryKey,
                s = "" + a;
            "[object ArrayBuffer]" === s && (s = "" + new Uint8Array(a)), p(_i4, s) || (_i4[s] = !0, e(t, r, n));
          }
        };

        return Promise.all([t.or._iterate(_a5, r), Ke(Ue(t, n, r), t.algorithm, _a5, !t.keysOnly && t.valueMapper)]);
      }

      return Ke(Ue(t, n, r), Me(t.algorithm, o), e, !t.keysOnly && t.valueMapper);
    }

    function Ke(t, e, r, n) {
      var o = Jt(n ? function (t, e, o) {
        return r(n(t), e, o);
      } : r);
      return t.then(function (t) {
        if (t) return t.start(function () {
          var r = function r() {
            return t.continue();
          };

          e && !e(t, function (t) {
            return r = t;
          }, function (e) {
            t.stop(e), r = st;
          }, function (e) {
            t.fail(e), r = st;
          }) || o(t.value, t, function (t) {
            return r = t;
          }), r();
        });
      });
    }

    function He(t, e) {
      try {
        var _r18 = Ve(t),
            _n12 = Ve(e);

        if (_r18 !== _n12) return "Array" === _r18 ? 1 : "Array" === _n12 ? -1 : "binary" === _r18 ? 1 : "binary" === _n12 ? -1 : "string" === _r18 ? 1 : "string" === _n12 ? -1 : "Date" === _r18 ? 1 : "Date" !== _n12 ? NaN : -1;

        switch (_r18) {
          case "number":
          case "Date":
          case "string":
            return t > e ? 1 : t < e ? -1 : 0;

          case "binary":
            return function (t, e) {
              var r = t.length,
                  n = e.length,
                  o = r < n ? r : n;

              for (var _r19 = 0; _r19 < o; ++_r19) {
                if (t[_r19] !== e[_r19]) return t[_r19] < e[_r19] ? -1 : 1;
              }

              return r === n ? 0 : r < n ? -1 : 1;
            }(qe(t), qe(e));

          case "Array":
            return function (t, e) {
              var r = t.length,
                  n = e.length,
                  o = r < n ? r : n;

              for (var _r20 = 0; _r20 < o; ++_r20) {
                var _n13 = He(t[_r20], e[_r20]);

                if (0 !== _n13) return _n13;
              }

              return r === n ? 0 : r < n ? -1 : 1;
            }(t, e);
        }
      } catch (t) {}

      return NaN;
    }

    function Ve(t) {
      var e = typeof t;
      if ("object" !== e) return e;
      if (ArrayBuffer.isView(t)) return "binary";
      var r = W(t);
      return "ArrayBuffer" === r ? "binary" : r;
    }

    function qe(t) {
      return t instanceof Uint8Array ? t : ArrayBuffer.isView(t) ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : new Uint8Array(t);
    }

    var $e = /*#__PURE__*/function () {
      function $e() {
        _classCallCheck(this, $e);
      }

      _createClass($e, [{
        key: "_read",
        value: function _read(t, e) {
          var r = this._ctx;
          return r.error ? r.table._trans(null, be.bind(null, r.error)) : r.table._trans("readonly", t).then(e);
        }
      }, {
        key: "_write",
        value: function _write(t) {
          var e = this._ctx;
          return e.error ? e.table._trans(null, be.bind(null, e.error)) : e.table._trans("readwrite", t, "locked");
        }
      }, {
        key: "_addAlgorithm",
        value: function _addAlgorithm(t) {
          var e = this._ctx;
          e.algorithm = Me(e.algorithm, t);
        }
      }, {
        key: "_iterate",
        value: function _iterate(t, e) {
          return Ge(this._ctx, t, e, this._ctx.table.core);
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var e = Object.create(this.constructor.prototype),
              r = Object.create(this._ctx);
          return t && l(r, t), e._ctx = r, e;
        }
      }, {
        key: "raw",
        value: function raw() {
          return this._ctx.valueMapper = null, this;
        }
      }, {
        key: "each",
        value: function each(t) {
          var e = this._ctx;
          return this._read(function (r) {
            return Ge(e, t, r, e.table.core);
          });
        }
      }, {
        key: "count",
        value: function count(t) {
          var _this15 = this;

          return this._read(function (t) {
            var e = _this15._ctx,
                r = e.table.core;
            if (Ie(e, !0)) return r.count({
              trans: t,
              query: {
                index: ze(e, r.schema),
                range: e.range
              }
            }).then(function (t) {
              return Math.min(t, e.limit);
            });
            var n = 0;
            return Ge(e, function () {
              return ++n, !1;
            }, t, r).then(function () {
              return n;
            });
          }).then(t);
        }
      }, {
        key: "sortBy",
        value: function sortBy(t, e) {
          var r = t.split(".").reverse(),
              n = r[0],
              o = r.length - 1;

          function i(t, e) {
            return e ? i(t[r[e]], e - 1) : t[n];
          }

          var a = "next" === this._ctx.dir ? 1 : -1;

          function s(t, e) {
            var r = i(t, o),
                n = i(e, o);
            return r < n ? -a : r > n ? a : 0;
          }

          return this.toArray(function (t) {
            return t.sort(s);
          }).then(e);
        }
      }, {
        key: "toArray",
        value: function toArray(t) {
          var _this16 = this;

          return this._read(function (t) {
            var e = _this16._ctx;

            if ("next" === e.dir && Ie(e, !0) && e.limit > 0) {
              var _r21 = e.valueMapper,
                  _n14 = ze(e, e.table.core.schema);

              return e.table.core.query({
                trans: t,
                limit: e.limit,
                values: !0,
                query: {
                  index: _n14,
                  range: e.range
                }
              }).then(function (_ref18) {
                var t = _ref18.result;
                return _r21 ? t.map(_r21) : t;
              });
            }

            {
              var _r22 = [];
              return Ge(e, function (t) {
                return _r22.push(t);
              }, t, e.table.core).then(function () {
                return _r22;
              });
            }
          }, t);
        }
      }, {
        key: "offset",
        value: function offset(t) {
          var e = this._ctx;
          return t <= 0 || (e.offset += t, Ie(e) ? Ye(e, function () {
            var e = t;
            return function (t, r) {
              return 0 === e || (1 === e ? (--e, !1) : (r(function () {
                t.advance(e), e = 0;
              }), !1));
            };
          }) : Ye(e, function () {
            var e = t;
            return function () {
              return --e < 0;
            };
          })), this;
        }
      }, {
        key: "limit",
        value: function limit(t) {
          return this._ctx.limit = Math.min(this._ctx.limit, t), Ye(this._ctx, function () {
            var e = t;
            return function (t, r, n) {
              return --e <= 0 && r(n), e >= 0;
            };
          }, !0), this;
        }
      }, {
        key: "until",
        value: function until(t, e) {
          return De(this._ctx, function (r, n, o) {
            return !t(r.value) || (n(o), e);
          }), this;
        }
      }, {
        key: "first",
        value: function first(t) {
          return this.limit(1).toArray(function (t) {
            return t[0];
          }).then(t);
        }
      }, {
        key: "last",
        value: function last(t) {
          return this.reverse().first(t);
        }
      }, {
        key: "filter",
        value: function filter(t) {
          var e, r;
          return De(this._ctx, function (e) {
            return t(e.value);
          }), e = this._ctx, r = t, e.isMatch = Me(e.isMatch, r), this;
        }
      }, {
        key: "and",
        value: function and(t) {
          return this.filter(t);
        }
      }, {
        key: "or",
        value: function or(t) {
          return new this.db.WhereClause(this._ctx.table, t, this);
        }
      }, {
        key: "reverse",
        value: function reverse() {
          return this._ctx.dir = "prev" === this._ctx.dir ? "next" : "prev", this._ondirectionchange && this._ondirectionchange(this._ctx.dir), this;
        }
      }, {
        key: "desc",
        value: function desc() {
          return this.reverse();
        }
      }, {
        key: "eachKey",
        value: function eachKey(t) {
          var e = this._ctx;
          return e.keysOnly = !e.isMatch, this.each(function (e, r) {
            t(r.key, r);
          });
        }
      }, {
        key: "eachUniqueKey",
        value: function eachUniqueKey(t) {
          return this._ctx.unique = "unique", this.eachKey(t);
        }
      }, {
        key: "eachPrimaryKey",
        value: function eachPrimaryKey(t) {
          var e = this._ctx;
          return e.keysOnly = !e.isMatch, this.each(function (e, r) {
            t(r.primaryKey, r);
          });
        }
      }, {
        key: "keys",
        value: function keys(t) {
          var e = this._ctx;
          e.keysOnly = !e.isMatch;
          var r = [];
          return this.each(function (t, e) {
            r.push(e.key);
          }).then(function () {
            return r;
          }).then(t);
        }
      }, {
        key: "primaryKeys",
        value: function primaryKeys(t) {
          var e = this._ctx;
          if ("next" === e.dir && Ie(e, !0) && e.limit > 0) return this._read(function (t) {
            var r = ze(e, e.table.core.schema);
            return e.table.core.query({
              trans: t,
              values: !1,
              limit: e.limit,
              query: {
                index: r,
                range: e.range
              }
            });
          }).then(function (_ref19) {
            var t = _ref19.result;
            return t;
          }).then(t);
          e.keysOnly = !e.isMatch;
          var r = [];
          return this.each(function (t, e) {
            r.push(e.primaryKey);
          }).then(function () {
            return r;
          }).then(t);
        }
      }, {
        key: "uniqueKeys",
        value: function uniqueKeys(t) {
          return this._ctx.unique = "unique", this.keys(t);
        }
      }, {
        key: "firstKey",
        value: function firstKey(t) {
          return this.limit(1).keys(function (t) {
            return t[0];
          }).then(t);
        }
      }, {
        key: "lastKey",
        value: function lastKey(t) {
          return this.reverse().firstKey(t);
        }
      }, {
        key: "distinct",
        value: function distinct() {
          var t = this._ctx,
              e = t.index && t.table.schema.idxByName[t.index];
          if (!e || !e.multi) return this;
          var r = {};
          return De(this._ctx, function (t) {
            var e = t.primaryKey.toString(),
                n = p(r, e);
            return r[e] = !0, !n;
          }), this;
        }
      }, {
        key: "modify",
        value: function modify(t) {
          var _this17 = this;

          var e = this._ctx;
          return this._write(function (r) {
            var n;
            if ("function" == typeof t) n = t;else {
              var o = c(t),
                  i = o.length;

              n = function n(e) {
                for (var r = !1, n = 0; n < i; ++n) {
                  var a = o[n],
                      s = t[a];
                  A(e, a) !== s && (R(e, a, s), r = !0);
                }

                return r;
              };
            }
            var a = e.table.core,
                _a$schema$primaryKey = a.schema.primaryKey,
                s = _a$schema$primaryKey.outbound,
                u = _a$schema$primaryKey.extractKey,
                l = _this17.db._options.modifyChunkSize || 200,
                f = [];
            var h = 0;

            var p = [],
                d = function d(t, e) {
              var r = e.failures,
                  n = e.numFailures;
              h += t - n;

              var _iterator = _createForOfIteratorHelper(c(r)),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _t6 = _step.value;
                  f.push(r[_t6]);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            };

            return _this17.clone().primaryKeys().then(function (o) {
              var i = function i(c) {
                var f = Math.min(l, o.length - c);
                return a.getMany({
                  trans: r,
                  keys: o.slice(c, c + f),
                  cache: "immutable"
                }).then(function (h) {
                  var p = [],
                      y = [],
                      m = s ? [] : null,
                      v = [];

                  for (var _t7 = 0; _t7 < f; ++_t7) {
                    var _e15 = h[_t7],
                        _r23 = {
                      value: M(_e15),
                      primKey: o[c + _t7]
                    };
                    !1 !== n.call(_r23, _r23.value, _r23) && (null == _r23.value ? v.push(o[c + _t7]) : s || 0 === He(u(_e15), u(_r23.value)) ? (y.push(_r23.value), s && m.push(o[c + _t7])) : (v.push(o[c + _t7]), p.push(_r23.value)));
                  }

                  var g = Ie(e) && e.limit === 1 / 0 && ("function" != typeof t || t === Xe) && {
                    index: e.index,
                    range: e.range
                  };
                  return Promise.resolve(p.length > 0 && a.mutate({
                    trans: r,
                    type: "add",
                    values: p
                  }).then(function (t) {
                    for (var _e16 in t.failures) {
                      v.splice(parseInt(_e16), 1);
                    }

                    d(p.length, t);
                  })).then(function () {
                    return (y.length > 0 || g && "object" == typeof t) && a.mutate({
                      trans: r,
                      type: "put",
                      keys: m,
                      values: y,
                      criteria: g,
                      changeSpec: "function" != typeof t && t
                    }).then(function (t) {
                      return d(y.length, t);
                    });
                  }).then(function () {
                    return (v.length > 0 || g && t === Xe) && a.mutate({
                      trans: r,
                      type: "delete",
                      keys: v,
                      criteria: g
                    }).then(function (t) {
                      return d(v.length, t);
                    });
                  }).then(function () {
                    return o.length > c + f && i(c + l);
                  });
                });
              };

              return i(0).then(function () {
                if (f.length > 0) throw new tt("Error modifying one or more objects", f, h, p);
                return o.length;
              });
            });
          });
        }
      }, {
        key: "delete",
        value: function _delete() {
          var t = this._ctx,
              e = t.range;
          return Ie(t) && (t.isPrimKey && !Pe || 3 === e.type) ? this._write(function (r) {
            var n = t.table.core.schema.primaryKey,
                o = e;
            return t.table.core.count({
              trans: r,
              query: {
                index: n,
                range: o
              }
            }).then(function (e) {
              return t.table.core.mutate({
                trans: r,
                type: "deleteRange",
                range: o
              }).then(function (_ref20) {
                var t = _ref20.failures,
                    r = _ref20.lastResult,
                    n = _ref20.results,
                    o = _ref20.numFailures;
                if (o) throw new tt("Could not delete some values", Object.keys(t).map(function (e) {
                  return t[e];
                }), e - o);
                return e - o;
              });
            });
          }) : this.modify(Xe);
        }
      }]);

      return $e;
    }();

    var Xe = function Xe(t, e) {
      return e.value = null;
    };

    function Je(t, e) {
      return t < e ? -1 : t === e ? 0 : 1;
    }

    function Qe(t, e) {
      return t > e ? -1 : t === e ? 0 : 1;
    }

    function tr(t, e, r) {
      var n = t instanceof ar ? new t.Collection(t) : t;
      return n._ctx.error = r ? new r(e) : new TypeError(e), n;
    }

    function er(t) {
      return new t.Collection(t, function () {
        return ir("");
      }).limit(0);
    }

    function rr(t, e, r, n, o, i) {
      for (var a = Math.min(t.length, n.length), s = -1, c = 0; c < a; ++c) {
        var u = e[c];
        if (u !== n[c]) return o(t[c], r[c]) < 0 ? t.substr(0, c) + r[c] + r.substr(c + 1) : o(t[c], n[c]) < 0 ? t.substr(0, c) + n[c] + r.substr(c + 1) : s >= 0 ? t.substr(0, s) + e[s] + r.substr(s + 1) : null;
        o(t[c], u) < 0 && (s = c);
      }

      return a < n.length && "next" === i ? t + r.substr(t.length) : a < t.length && "prev" === i ? t.substr(0, r.length) : s < 0 ? null : t.substr(0, s) + n[s] + r.substr(s + 1);
    }

    function nr(t, e, r, n) {
      var o,
          i,
          a,
          s,
          c,
          u,
          l,
          f = r.length;
      if (!r.every(function (t) {
        return "string" == typeof t;
      })) return tr(t, Ee);

      function h(t) {
        o = function (t) {
          return "next" === t ? function (t) {
            return t.toUpperCase();
          } : function (t) {
            return t.toLowerCase();
          };
        }(t), i = function (t) {
          return "next" === t ? function (t) {
            return t.toLowerCase();
          } : function (t) {
            return t.toUpperCase();
          };
        }(t), a = "next" === t ? Je : Qe;
        var e = r.map(function (t) {
          return {
            lower: i(t),
            upper: o(t)
          };
        }).sort(function (t, e) {
          return a(t.lower, e.lower);
        });
        s = e.map(function (t) {
          return t.upper;
        }), c = e.map(function (t) {
          return t.lower;
        }), u = t, l = "next" === t ? "" : n;
      }

      h("next");
      var p = new t.Collection(t, function () {
        return or(s[0], c[f - 1] + n);
      });

      p._ondirectionchange = function (t) {
        h(t);
      };

      var d = 0;
      return p._addAlgorithm(function (t, r, n) {
        var o = t.key;
        if ("string" != typeof o) return !1;
        var h = i(o);
        if (e(h, c, d)) return !0;

        for (var p = null, y = d; y < f; ++y) {
          var m = rr(o, h, s[y], c[y], a, u);
          null === m && null === p ? d = y + 1 : (null === p || a(p, m) > 0) && (p = m);
        }

        return r(null !== p ? function () {
          t.continue(p + l);
        } : n), !1;
      }), p;
    }

    function or(t, e, r, n) {
      return {
        type: 2,
        lower: t,
        upper: e,
        lowerOpen: r,
        upperOpen: n
      };
    }

    function ir(t) {
      return {
        type: 1,
        lower: t,
        upper: t
      };
    }

    var ar = /*#__PURE__*/function () {
      function ar() {
        _classCallCheck(this, ar);
      }

      _createClass(ar, [{
        key: "Collection",
        get: function get() {
          return this._ctx.table.db.Collection;
        }
      }, {
        key: "between",
        value: function between(t, e, r, n) {
          r = !1 !== r, n = !0 === n;

          try {
            return this._cmp(t, e) > 0 || 0 === this._cmp(t, e) && (r || n) && (!r || !n) ? er(this) : new this.Collection(this, function () {
              return or(t, e, !r, !n);
            });
          } catch (t) {
            return tr(this, Le);
          }
        }
      }, {
        key: "equals",
        value: function equals(t) {
          return null == t ? tr(this, Le) : new this.Collection(this, function () {
            return ir(t);
          });
        }
      }, {
        key: "above",
        value: function above(t) {
          return null == t ? tr(this, Le) : new this.Collection(this, function () {
            return or(t, void 0, !0);
          });
        }
      }, {
        key: "aboveOrEqual",
        value: function aboveOrEqual(t) {
          return null == t ? tr(this, Le) : new this.Collection(this, function () {
            return or(t, void 0, !1);
          });
        }
      }, {
        key: "below",
        value: function below(t) {
          return null == t ? tr(this, Le) : new this.Collection(this, function () {
            return or(void 0, t, !1, !0);
          });
        }
      }, {
        key: "belowOrEqual",
        value: function belowOrEqual(t) {
          return null == t ? tr(this, Le) : new this.Collection(this, function () {
            return or(void 0, t);
          });
        }
      }, {
        key: "startsWith",
        value: function startsWith(t) {
          return "string" != typeof t ? tr(this, Ee) : this.between(t, t + _e, !0, !0);
        }
      }, {
        key: "startsWithIgnoreCase",
        value: function startsWithIgnoreCase(t) {
          return "" === t ? this.startsWith(t) : nr(this, function (t, e) {
            return 0 === t.indexOf(e[0]);
          }, [t], _e);
        }
      }, {
        key: "equalsIgnoreCase",
        value: function equalsIgnoreCase(t) {
          return nr(this, function (t, e) {
            return t === e[0];
          }, [t], "");
        }
      }, {
        key: "anyOfIgnoreCase",
        value: function anyOfIgnoreCase() {
          var t = D.apply(I, arguments);
          return 0 === t.length ? er(this) : nr(this, function (t, e) {
            return -1 !== e.indexOf(t);
          }, t, "");
        }
      }, {
        key: "startsWithAnyOfIgnoreCase",
        value: function startsWithAnyOfIgnoreCase() {
          var t = D.apply(I, arguments);
          return 0 === t.length ? er(this) : nr(this, function (t, e) {
            return e.some(function (e) {
              return 0 === t.indexOf(e);
            });
          }, t, _e);
        }
      }, {
        key: "anyOf",
        value: function anyOf() {
          var _this18 = this;

          var t = D.apply(I, arguments);
          var e = this._cmp;

          try {
            t.sort(e);
          } catch (t) {
            return tr(this, Le);
          }

          if (0 === t.length) return er(this);
          var r = new this.Collection(this, function () {
            return or(t[0], t[t.length - 1]);
          });

          r._ondirectionchange = function (r) {
            e = "next" === r ? _this18._ascending : _this18._descending, t.sort(e);
          };

          var n = 0;
          return r._addAlgorithm(function (r, o, i) {
            var a = r.key;

            for (; e(a, t[n]) > 0;) {
              if (++n, n === t.length) return o(i), !1;
            }

            return 0 === e(a, t[n]) || (o(function () {
              r.continue(t[n]);
            }), !1);
          }), r;
        }
      }, {
        key: "notEqual",
        value: function notEqual(t) {
          return this.inAnyRange([[xe, t], [t, this.db._maxKey]], {
            includeLowers: !1,
            includeUppers: !1
          });
        }
      }, {
        key: "noneOf",
        value: function noneOf() {
          var t = D.apply(I, arguments);
          if (0 === t.length) return new this.Collection(this);

          try {
            t.sort(this._ascending);
          } catch (t) {
            return tr(this, Le);
          }

          var e = t.reduce(function (t, e) {
            return t ? t.concat([[t[t.length - 1][1], e]]) : [[xe, e]];
          }, null);
          return e.push([t[t.length - 1], this.db._maxKey]), this.inAnyRange(e, {
            includeLowers: !1,
            includeUppers: !1
          });
        }
      }, {
        key: "inAnyRange",
        value: function inAnyRange(t, e) {
          var _this19 = this;

          var r = this._cmp,
              n = this._ascending,
              o = this._descending,
              i = this._min,
              a = this._max;
          if (0 === t.length) return er(this);
          if (!t.every(function (t) {
            return void 0 !== t[0] && void 0 !== t[1] && n(t[0], t[1]) <= 0;
          })) return tr(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", ot.InvalidArgument);
          var s = !e || !1 !== e.includeLowers,
              c = e && !0 === e.includeUppers;
          var u,
              l = n;

          function f(t, e) {
            return l(t[0], e[0]);
          }

          try {
            u = t.reduce(function (t, e) {
              var n = 0,
                  o = t.length;

              for (; n < o; ++n) {
                var _o6 = t[n];

                if (r(e[0], _o6[1]) < 0 && r(e[1], _o6[0]) > 0) {
                  _o6[0] = i(_o6[0], e[0]), _o6[1] = a(_o6[1], e[1]);
                  break;
                }
              }

              return n === o && t.push(e), t;
            }, []), u.sort(f);
          } catch (t) {
            return tr(this, Le);
          }

          var h = 0;
          var p = c ? function (t) {
            return n(t, u[h][1]) > 0;
          } : function (t) {
            return n(t, u[h][1]) >= 0;
          },
              d = s ? function (t) {
            return o(t, u[h][0]) > 0;
          } : function (t) {
            return o(t, u[h][0]) >= 0;
          };
          var y = p;
          var m = new this.Collection(this, function () {
            return or(u[0][0], u[u.length - 1][1], !s, !c);
          });
          return m._ondirectionchange = function (t) {
            "next" === t ? (y = p, l = n) : (y = d, l = o), u.sort(f);
          }, m._addAlgorithm(function (t, e, r) {
            for (var o = t.key; y(o);) {
              if (++h, h === u.length) return e(r), !1;
            }

            return !!function (t) {
              return !p(t) && !d(t);
            }(o) || (0 === _this19._cmp(o, u[h][1]) || 0 === _this19._cmp(o, u[h][0]) || e(function () {
              l === n ? t.continue(u[h][0]) : t.continue(u[h][1]);
            }), !1);
          }), m;
        }
      }, {
        key: "startsWithAnyOf",
        value: function startsWithAnyOf() {
          var t = D.apply(I, arguments);
          return t.every(function (t) {
            return "string" == typeof t;
          }) ? 0 === t.length ? er(this) : this.inAnyRange(t.map(function (t) {
            return [t, t + _e];
          })) : tr(this, "startsWithAnyOf() only works with strings");
        }
      }]);

      return ar;
    }();

    function sr(t) {
      return Jt(function (e) {
        return cr(e), t(e.target.error), !1;
      });
    }

    function cr(t) {
      t.stopPropagation && t.stopPropagation(), t.preventDefault && t.preventDefault();
    }

    var ur = "storagemutated",
        lr = "x-storagemutated-1",
        fr = Be(null, ur);

    var hr = /*#__PURE__*/function () {
      function hr() {
        _classCallCheck(this, hr);
      }

      _createClass(hr, [{
        key: "_lock",
        value: function _lock() {
          return x(!Zt.global), ++this._reculock, 1 !== this._reculock || Zt.global || (Zt.lockOwnerFor = this), this;
        }
      }, {
        key: "_unlock",
        value: function _unlock() {
          if (x(!Zt.global), 0 == --this._reculock) for (Zt.global || (Zt.lockOwnerFor = null); this._blockedFuncs.length > 0 && !this._locked();) {
            var t = this._blockedFuncs.shift();

            try {
              pe(t[1], t[0]);
            } catch (t) {}
          }
          return this;
        }
      }, {
        key: "_locked",
        value: function _locked() {
          return this._reculock && Zt.lockOwnerFor !== this;
        }
      }, {
        key: "create",
        value: function create(t) {
          var _this20 = this;

          if (!this.mode) return this;
          var e = this.db.idbdb,
              r = this.db._state.dbOpenError;
          if (x(!this.idbtrans), !t && !e) switch (r && r.name) {
            case "DatabaseClosedError":
              throw new ot.DatabaseClosed(r);

            case "MissingAPIError":
              throw new ot.MissingAPI(r.message, r);

            default:
              throw new ot.OpenFailed(r);
          }
          if (!this.active) throw new ot.TransactionInactive();
          return x(null === this._completion._state), (t = this.idbtrans = t || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
          }) : e.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
          }))).onerror = Jt(function (e) {
            cr(e), _this20._reject(t.error);
          }), t.onabort = Jt(function (e) {
            cr(e), _this20.active && _this20._reject(new ot.Abort(t.error)), _this20.active = !1, _this20.on("abort").fire(e);
          }), t.oncomplete = Jt(function () {
            _this20.active = !1, _this20._resolve(), "mutatedParts" in t && fr.storagemutated.fire(t.mutatedParts);
          }), this;
        }
      }, {
        key: "_promise",
        value: function _promise(t, e, r) {
          var _this21 = this;

          if ("readwrite" === t && "readwrite" !== this.mode) return be(new ot.ReadOnly("Transaction is readonly"));
          if (!this.active) return be(new ot.TransactionInactive());
          if (this._locked()) return new Wt(function (n, o) {
            _this21._blockedFuncs.push([function () {
              _this21._promise(t, e, r).then(n, o);
            }, Zt]);
          });
          if (r) return ie(function () {
            var t = new Wt(function (t, r) {
              _this21._lock();

              var n = e(t, r, _this21);
              n && n.then && n.then(t, r);
            });
            return t.finally(function () {
              return _this21._unlock();
            }), t._lib = !0, t;
          });
          var n = new Wt(function (t, r) {
            var n = e(t, r, _this21);
            n && n.then && n.then(t, r);
          });
          return n._lib = !0, n;
        }
      }, {
        key: "_root",
        value: function _root() {
          return this.parent ? this.parent._root() : this;
        }
      }, {
        key: "waitFor",
        value: function waitFor(t) {
          var e = this._root();

          var r = Wt.resolve(t);
          if (e._waitingFor) e._waitingFor = e._waitingFor.then(function () {
            return r;
          });else {
            e._waitingFor = r, e._waitingQueue = [];
            var n = e.idbtrans.objectStore(e.storeNames[0]);
            !function t() {
              for (++e._spinCount; e._waitingQueue.length;) {
                e._waitingQueue.shift()();
              }

              e._waitingFor && (n.get(-1 / 0).onsuccess = t);
            }();
          }
          var o = e._waitingFor;
          return new Wt(function (t, n) {
            r.then(function (r) {
              return e._waitingQueue.push(Jt(t.bind(null, r)));
            }, function (t) {
              return e._waitingQueue.push(Jt(n.bind(null, t)));
            }).finally(function () {
              e._waitingFor === o && (e._waitingFor = null);
            });
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.active && (this.active = !1, this.idbtrans && this.idbtrans.abort(), this._reject(new ot.Abort()));
        }
      }, {
        key: "table",
        value: function table(t) {
          var e = this._memoizedTables || (this._memoizedTables = {});
          if (p(e, t)) return e[t];
          var r = this.schema[t];
          if (!r) throw new ot.NotFound("Table " + t + " not part of transaction");
          var n = new this.db.Table(t, r, this);
          return n.core = this.db.core.table(t), e[t] = n, n;
        }
      }]);

      return hr;
    }();

    function pr(t, e, r, n, o, i, a) {
      return {
        name: t,
        keyPath: e,
        unique: r,
        multi: n,
        auto: o,
        compound: i,
        src: (r && !a ? "&" : "") + (n ? "*" : "") + (o ? "++" : "") + dr(e)
      };
    }

    function dr(t) {
      return "string" == typeof t ? t : t ? "[" + [].join.call(t, "+") + "]" : "";
    }

    function yr(t, e, r) {
      return {
        name: t,
        primKey: e,
        indexes: r,
        mappedClass: null,
        idxByName: E(r, function (t) {
          return [t.name, t];
        })
      };
    }

    var _mr = function mr(t) {
      try {
        return t.only([[]]), _mr = function mr() {
          return [[]];
        }, [[]];
      } catch (t) {
        return _mr = function mr() {
          return _e;
        }, _e;
      }
    };

    function vr(t) {
      return null == t ? function () {} : "string" == typeof t ? function (t) {
        return 1 === t.split(".").length ? function (e) {
          return e[t];
        } : function (e) {
          return A(e, t);
        };
      }(t) : function (e) {
        return A(e, t);
      };
    }

    function gr(t) {
      return [].slice.call(t);
    }

    var br = 0;

    function wr(t) {
      return null == t ? ":id" : "string" == typeof t ? t : "[".concat(t.join("+"), "]");
    }

    function Or(_ref21, e) {
      var t = _ref21._novip;

      var r = e.db,
          n = function (t, e, _ref22, o) {
        var r = _ref22.IDBKeyRange,
            n = _ref22.indexedDB;

        var i = function (t, e) {
          return e.reduce(function (t, _ref23) {
            var e = _ref23.create;
            return _objectSpread(_objectSpread({}, t), e(t));
          }, t);
        }(function (t, e, r) {
          function n(t) {
            if (3 === t.type) return null;
            if (4 === t.type) throw new Error("Cannot convert never type to IDBKeyRange");
            var r = t.lower,
                n = t.upper,
                o = t.lowerOpen,
                i = t.upperOpen;
            return void 0 === r ? void 0 === n ? null : e.upperBound(n, !!i) : void 0 === n ? e.lowerBound(r, !!o) : e.bound(r, n, !!o, !!i);
          }

          var _ref24 = function (t, e) {
            var r = gr(t.objectStoreNames);
            return {
              schema: {
                name: t.name,
                tables: r.map(function (t) {
                  return e.objectStore(t);
                }).map(function (t) {
                  var e = t.keyPath,
                      r = t.autoIncrement,
                      n = u(e),
                      o = null == e,
                      i = {},
                      a = {
                    name: t.name,
                    primaryKey: {
                      name: null,
                      isPrimaryKey: !0,
                      outbound: o,
                      compound: n,
                      keyPath: e,
                      autoIncrement: r,
                      unique: !0,
                      extractKey: vr(e)
                    },
                    indexes: gr(t.indexNames).map(function (e) {
                      return t.index(e);
                    }).map(function (t) {
                      var e = t.name,
                          r = t.unique,
                          n = t.multiEntry,
                          o = t.keyPath,
                          a = {
                        name: e,
                        compound: u(o),
                        keyPath: o,
                        unique: r,
                        multiEntry: n,
                        extractKey: vr(o)
                      };
                      return i[wr(o)] = a, a;
                    }),
                    getIndexByKeyPath: function getIndexByKeyPath(t) {
                      return i[wr(t)];
                    }
                  };
                  return i[":id"] = a.primaryKey, null != e && (i[wr(e)] = a.primaryKey), a;
                })
              },
              hasGetAll: r.length > 0 && "getAll" in e.objectStore(r[0]) && !("undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
            };
          }(t, r),
              o = _ref24.schema,
              i = _ref24.hasGetAll,
              a = o.tables.map(function (t) {
            return function (t) {
              var e = t.name;
              return {
                name: e,
                schema: t,
                mutate: function mutate(_ref25) {
                  var t = _ref25.trans,
                      r = _ref25.type,
                      o = _ref25.keys,
                      i = _ref25.values,
                      a = _ref25.range;
                  return new Promise(function (s, c) {
                    s = Jt(s);
                    var u = t.objectStore(e),
                        l = null == u.keyPath,
                        f = "put" === r || "add" === r;
                    if (!f && "delete" !== r && "deleteRange" !== r) throw new Error("Invalid operation type: " + r);

                    var _ref26 = o || i || {
                      length: 1
                    },
                        h = _ref26.length;

                    if (o && i && o.length !== i.length) throw new Error("Given keys array must have same length as given values array.");
                    if (0 === h) return s({
                      numFailures: 0,
                      failures: {},
                      results: [],
                      lastResult: void 0
                    });
                    var p;
                    var d = [],
                        y = [];
                    var m = 0;

                    var v = function v(t) {
                      ++m, cr(t);
                    };

                    if ("deleteRange" === r) {
                      if (4 === a.type) return s({
                        numFailures: m,
                        failures: y,
                        results: [],
                        lastResult: void 0
                      });
                      3 === a.type ? d.push(p = u.clear()) : d.push(p = u.delete(n(a)));
                    } else {
                      var _ref27 = f ? l ? [i, o] : [i, null] : [o, null],
                          _ref28 = _slicedToArray(_ref27, 2),
                          _t8 = _ref28[0],
                          _e17 = _ref28[1];

                      if (f) for (var _n15 = 0; _n15 < h; ++_n15) {
                        d.push(p = _e17 && void 0 !== _e17[_n15] ? u[r](_t8[_n15], _e17[_n15]) : u[r](_t8[_n15])), p.onerror = v;
                      } else for (var _e18 = 0; _e18 < h; ++_e18) {
                        d.push(p = u[r](_t8[_e18])), p.onerror = v;
                      }
                    }

                    var g = function g(t) {
                      var e = t.target.result;
                      d.forEach(function (t, e) {
                        return null != t.error && (y[e] = t.error);
                      }), s({
                        numFailures: m,
                        failures: y,
                        results: "delete" === r ? o : d.map(function (t) {
                          return t.result;
                        }),
                        lastResult: e
                      });
                    };

                    p.onerror = function (t) {
                      v(t), g(t);
                    }, p.onsuccess = g;
                  });
                },
                getMany: function getMany(_ref29) {
                  var t = _ref29.trans,
                      r = _ref29.keys;
                  return new Promise(function (n, o) {
                    n = Jt(n);
                    var i = t.objectStore(e),
                        a = r.length,
                        s = new Array(a);
                    var c,
                        u = 0,
                        l = 0;

                    var f = function f(t) {
                      var e = t.target;
                      s[e._pos] = e.result, ++l === u && n(s);
                    },
                        h = sr(o);

                    for (var _t9 = 0; _t9 < a; ++_t9) {
                      null != r[_t9] && (c = i.get(r[_t9]), c._pos = _t9, c.onsuccess = f, c.onerror = h, ++u);
                    }

                    0 === u && n(s);
                  });
                },
                get: function get(_ref30) {
                  var t = _ref30.trans,
                      r = _ref30.key;
                  return new Promise(function (n, o) {
                    n = Jt(n);
                    var i = t.objectStore(e).get(r);
                    i.onsuccess = function (t) {
                      return n(t.target.result);
                    }, i.onerror = sr(o);
                  });
                },
                query: function (t) {
                  return function (r) {
                    return new Promise(function (o, i) {
                      o = Jt(o);
                      var a = r.trans,
                          s = r.values,
                          c = r.limit,
                          u = r.query,
                          l = c === 1 / 0 ? void 0 : c,
                          f = u.index,
                          h = u.range,
                          p = a.objectStore(e),
                          d = f.isPrimaryKey ? p : p.index(f.name),
                          y = n(h);
                      if (0 === c) return o({
                        result: []
                      });

                      if (t) {
                        var _t10 = s ? d.getAll(y, l) : d.getAllKeys(y, l);

                        _t10.onsuccess = function (t) {
                          return o({
                            result: t.target.result
                          });
                        }, _t10.onerror = sr(i);
                      } else {
                        var _t11 = 0;

                        var _e19 = s || !("openKeyCursor" in d) ? d.openCursor(y) : d.openKeyCursor(y),
                            _r24 = [];

                        _e19.onsuccess = function (n) {
                          var i = _e19.result;
                          return i ? (_r24.push(s ? i.value : i.primaryKey), ++_t11 === c ? o({
                            result: _r24
                          }) : void i.continue()) : o({
                            result: _r24
                          });
                        }, _e19.onerror = sr(i);
                      }
                    });
                  };
                }(i),
                openCursor: function openCursor(_ref31) {
                  var t = _ref31.trans,
                      r = _ref31.values,
                      o = _ref31.query,
                      i = _ref31.reverse,
                      a = _ref31.unique;
                  return new Promise(function (s, c) {
                    s = Jt(s);
                    var u = o.index,
                        l = o.range,
                        f = t.objectStore(e),
                        h = u.isPrimaryKey ? f : f.index(u.name),
                        p = i ? a ? "prevunique" : "prev" : a ? "nextunique" : "next",
                        d = r || !("openKeyCursor" in h) ? h.openCursor(n(l), p) : h.openKeyCursor(n(l), p);
                    d.onerror = sr(c), d.onsuccess = Jt(function (e) {
                      var r = d.result;
                      if (!r) return void s(null);
                      r.___id = ++br, r.done = !1;
                      var n = r.continue.bind(r);
                      var o = r.continuePrimaryKey;
                      o && (o = o.bind(r));

                      var i = r.advance.bind(r),
                          a = function a() {
                        throw new Error("Cursor not stopped");
                      };

                      r.trans = t, r.stop = r.continue = r.continuePrimaryKey = r.advance = function () {
                        throw new Error("Cursor not started");
                      }, r.fail = Jt(c), r.next = function () {
                        var _this22 = this;

                        var t = 1;
                        return this.start(function () {
                          return t-- ? _this22.continue() : _this22.stop();
                        }).then(function () {
                          return _this22;
                        });
                      }, r.start = function (t) {
                        var e = new Promise(function (t, e) {
                          t = Jt(t), d.onerror = sr(e), r.fail = e, r.stop = function (e) {
                            r.stop = r.continue = r.continuePrimaryKey = r.advance = a, t(e);
                          };
                        }),
                            s = function s() {
                          if (d.result) try {
                            t();
                          } catch (t) {
                            r.fail(t);
                          } else r.done = !0, r.start = function () {
                            throw new Error("Cursor behind last entry");
                          }, r.stop();
                        };

                        return d.onsuccess = Jt(function (t) {
                          d.onsuccess = s, s();
                        }), r.continue = n, r.continuePrimaryKey = o, r.advance = i, s(), e;
                      }, s(r);
                    }, c);
                  });
                },
                count: function count(_ref32) {
                  var t = _ref32.query,
                      r = _ref32.trans;
                  var o = t.index,
                      i = t.range;
                  return new Promise(function (t, a) {
                    var s = r.objectStore(e),
                        c = o.isPrimaryKey ? s : s.index(o.name),
                        u = n(i),
                        l = u ? c.count(u) : c.count();
                    l.onsuccess = Jt(function (e) {
                      return t(e.target.result);
                    }), l.onerror = sr(a);
                  });
                }
              };
            }(t);
          }),
              s = {};

          return a.forEach(function (t) {
            return s[t.name] = t;
          }), {
            stack: "dbcore",
            transaction: t.transaction.bind(t),
            table: function table(t) {
              if (!s[t]) throw new Error("Table '".concat(t, "' not found"));
              return s[t];
            },
            MIN_KEY: -1 / 0,
            MAX_KEY: _mr(e),
            schema: o
          };
        }(e, r, o), t.dbcore);

        return {
          dbcore: i
        };
      }(t._middlewares, r, t._deps, e);

      t.core = n.dbcore, t.tables.forEach(function (e) {
        var r = e.name;
        t.core.schema.tables.some(function (t) {
          return t.name === r;
        }) && (e.core = t.core.table(r), t[r] instanceof t.Table && (t[r].core = e.core));
      });
    }

    function _r(_ref33, e, r, n) {
      var t = _ref33._novip;
      r.forEach(function (r) {
        var o = n[r];
        e.forEach(function (e) {
          var n = b(e, r);
          (!n || "value" in n && void 0 === n.value) && (e === t.Transaction.prototype || e instanceof t.Transaction ? m(e, r, {
            get: function get() {
              return this.table(r);
            },
            set: function set(t) {
              y(this, r, {
                value: t,
                writable: !0,
                configurable: !0,
                enumerable: !0
              });
            }
          }) : e[r] = new t.Table(r, o));
        });
      });
    }

    function xr(_ref34, e) {
      var t = _ref34._novip;
      e.forEach(function (e) {
        for (var _r25 in e) {
          e[_r25] instanceof t.Table && delete e[_r25];
        }
      });
    }

    function Lr(t, e) {
      return t._cfg.version - e._cfg.version;
    }

    function Er(t, e) {
      var r = {
        del: [],
        add: [],
        change: []
      };
      var n;

      for (n in t) {
        e[n] || r.del.push(n);
      }

      for (n in e) {
        var _o7 = t[n],
            _i5 = e[n];

        if (_o7) {
          var _t12 = {
            name: n,
            def: _i5,
            recreate: !1,
            del: [],
            add: [],
            change: []
          };
          if ("" + (_o7.primKey.keyPath || "") != "" + (_i5.primKey.keyPath || "") || _o7.primKey.auto !== _i5.primKey.auto && !Re) _t12.recreate = !0, r.change.push(_t12);else {
            var _e20 = _o7.idxByName,
                _n16 = _i5.idxByName;

            var _a6 = void 0;

            for (_a6 in _e20) {
              _n16[_a6] || _t12.del.push(_a6);
            }

            for (_a6 in _n16) {
              var _r26 = _e20[_a6],
                  _o8 = _n16[_a6];
              _r26 ? _r26.src !== _o8.src && _t12.change.push(_o8) : _t12.add.push(_o8);
            }

            (_t12.del.length > 0 || _t12.add.length > 0 || _t12.change.length > 0) && r.change.push(_t12);
          }
        } else r.add.push([n, _i5]);
      }

      return r;
    }

    function Ar(t, e, r, n) {
      var o = t.db.createObjectStore(e, r.keyPath ? {
        keyPath: r.keyPath,
        autoIncrement: r.auto
      } : {
        autoIncrement: r.auto
      });
      return n.forEach(function (t) {
        return Rr(o, t);
      }), o;
    }

    function Rr(t, e) {
      t.createIndex(e.name, e.keyPath, {
        unique: e.unique,
        multiEntry: e.multi
      });
    }

    function Tr(t, e, r) {
      var n = {};
      return O(e.objectStoreNames, 0).forEach(function (t) {
        var e = r.objectStore(t);
        var o = e.keyPath;
        var i = pr(dr(o), o || "", !1, !1, !!e.autoIncrement, o && "string" != typeof o, !0),
            a = [];

        for (var _t13 = 0; _t13 < e.indexNames.length; ++_t13) {
          var _r27 = e.index(e.indexNames[_t13]);

          o = _r27.keyPath;
          var s = pr(_r27.name, o, !!_r27.unique, !!_r27.multiEntry, !1, o && "string" != typeof o, !1);
          a.push(s);
        }

        n[t] = yr(t, i, a);
      }), n;
    }

    function Pr(_ref35, e, r) {
      var t = _ref35._novip;
      var n = r.db.objectStoreNames;

      for (var _o9 = 0; _o9 < n.length; ++_o9) {
        var _i6 = n[_o9],
            _a7 = r.objectStore(_i6);

        t._hasGetAll = "getAll" in _a7;

        for (var _t14 = 0; _t14 < _a7.indexNames.length; ++_t14) {
          var _r28 = _a7.indexNames[_t14],
              _n17 = _a7.index(_r28).keyPath,
              _o10 = "string" == typeof _n17 ? _n17 : "[" + O(_n17).join("+") + "]";

          if (e[_i6]) {
            var _t15 = e[_i6].idxByName[_o10];
            _t15 && (_t15.name = _r28, delete e[_i6].idxByName[_o10], e[_i6].idxByName[_r28] = _t15);
          }
        }
      }

      "undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && s.WorkerGlobalScope && s instanceof s.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 && (t._hasGetAll = !1);
    }

    var Sr = /*#__PURE__*/function () {
      function Sr() {
        _classCallCheck(this, Sr);
      }

      _createClass(Sr, [{
        key: "_parseStoresSpec",
        value: function _parseStoresSpec(t, e) {
          c(t).forEach(function (r) {
            if (null !== t[r]) {
              var n = t[r].split(",").map(function (t, e) {
                var r = (t = t.trim()).replace(/([&*]|\+\+)/g, ""),
                    n = /^\[/.test(r) ? r.match(/^\[(.*)\]$/)[1].split("+") : r;
                return pr(r, n || null, /\&/.test(t), /\*/.test(t), /\+\+/.test(t), u(n), 0 === e);
              }),
                  o = n.shift();
              if (o.multi) throw new ot.Schema("Primary key cannot be multi-valued");
              n.forEach(function (t) {
                if (t.auto) throw new ot.Schema("Only primary key can be marked as autoIncrement (++)");
                if (!t.keyPath) throw new ot.Schema("Index must have a name and cannot be an empty string");
              }), e[r] = yr(r, o, n);
            }
          });
        }
      }, {
        key: "stores",
        value: function stores(t) {
          var e = this.db;
          this._cfg.storesSource = this._cfg.storesSource ? l(this._cfg.storesSource, t) : t;
          var r = e._versions,
              n = {};
          var o = {};
          return r.forEach(function (t) {
            l(n, t._cfg.storesSource), o = t._cfg.dbschema = {}, t._parseStoresSpec(n, o);
          }), e._dbSchema = o, xr(e, [e._allTables, e, e.Transaction.prototype]), _r(e, [e._allTables, e, e.Transaction.prototype, this._cfg.tables], c(o), o), e._storeNames = c(o), this;
        }
      }, {
        key: "upgrade",
        value: function upgrade(t) {
          return this._cfg.contentUpgrade = yt(this._cfg.contentUpgrade || st, t), this;
        }
      }]);

      return Sr;
    }();

    function kr(t, e) {
      var r = t._dbNamesDB;
      return r || (r = t._dbNamesDB = new Qr(ke, {
        addons: [],
        indexedDB: t,
        IDBKeyRange: e
      }), r.version(1).stores({
        dbnames: "name"
      })), r.table("dbnames");
    }

    function jr(t) {
      return t && "function" == typeof t.databases;
    }

    function Zr(t) {
      return ie(function () {
        return Zt.letThrough = !0, t();
      });
    }

    function Mr() {
      var t;
      return !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent) && indexedDB.databases ? new Promise(function (e) {
        var r = function r() {
          return indexedDB.databases().finally(e);
        };

        t = setInterval(r, 100), r();
      }).finally(function () {
        return clearInterval(t);
      }) : Promise.resolve();
    }

    function Cr(t) {
      var e = t._state,
          r = t._deps.indexedDB;
      if (e.isBeingOpened || t.idbdb) return e.dbReadyPromise.then(function () {
        return e.dbOpenError ? be(e.dbOpenError) : t;
      });
      z && (e.openCanceller._stackHolder = H()), e.isBeingOpened = !0, e.dbOpenError = null, e.openComplete = !1;
      var n = e.openCanceller;

      function o() {
        if (e.openCanceller !== n) throw new ot.DatabaseClosed("db.open() was cancelled");
      }

      var i = e.dbReadyResolve,
          a = null,
          s = !1;
      return Wt.race([n, ("undefined" == typeof navigator ? Wt.resolve() : Mr()).then(function () {
        return new Wt(function (n, i) {
          if (o(), !r) throw new ot.MissingAPI();
          var u = t.name,
              l = e.autoSchema ? r.open(u) : r.open(u, Math.round(10 * t.verno));
          if (!l) throw new ot.MissingAPI();
          l.onerror = sr(i), l.onblocked = Jt(t._fireOnBlocked), l.onupgradeneeded = Jt(function (n) {
            if (a = l.transaction, e.autoSchema && !t._options.allowEmptyDB) {
              l.onerror = cr, a.abort(), l.result.close();

              var _t16 = r.deleteDatabase(u);

              _t16.onsuccess = _t16.onerror = Jt(function () {
                i(new ot.NoSuchDatabase("Database ".concat(u, " doesnt exist")));
              });
            } else {
              a.onerror = sr(i);
              var o = n.oldVersion > Math.pow(2, 62) ? 0 : n.oldVersion;
              s = o < 1, t._novip.idbdb = l.result, function (t, e, r, n) {
                var o = t._dbSchema,
                    i = t._createTransaction("readwrite", t._storeNames, o);

                i.create(r), i._completion.catch(n);

                var a = i._reject.bind(i),
                    s = Zt.transless || Zt;

                ie(function () {
                  Zt.trans = i, Zt.transless = s, 0 === e ? (c(o).forEach(function (t) {
                    Ar(r, t, o[t].primKey, o[t].indexes);
                  }), Or(t, r), Wt.follow(function () {
                    return t.on.populate.fire(i);
                  }).catch(a)) : function (_ref36, e, r, n) {
                    var t = _ref36._novip;
                    var o = [],
                        i = t._versions;
                    var a = t._dbSchema = Tr(0, t.idbdb, n),
                        s = !1;
                    return i.filter(function (t) {
                      return t._cfg.version >= e;
                    }).forEach(function (i) {
                      o.push(function () {
                        var o = a,
                            u = i._cfg.dbschema;
                        Pr(t, o, n), Pr(t, u, n), a = t._dbSchema = u;
                        var l = Er(o, u);
                        l.add.forEach(function (t) {
                          Ar(n, t[0], t[1].primKey, t[1].indexes);
                        }), l.change.forEach(function (t) {
                          if (t.recreate) throw new ot.Upgrade("Not yet support for changing primary key");
                          {
                            var _e21 = n.objectStore(t.name);

                            t.add.forEach(function (t) {
                              return Rr(_e21, t);
                            }), t.change.forEach(function (t) {
                              _e21.deleteIndex(t.name), Rr(_e21, t);
                            }), t.del.forEach(function (t) {
                              return _e21.deleteIndex(t);
                            });
                          }
                        });
                        var f = i._cfg.contentUpgrade;

                        if (f && i._cfg.version > e) {
                          Or(t, n), r._memoizedTables = {}, s = !0;

                          var _e22 = T(u);

                          l.del.forEach(function (t) {
                            _e22[t] = o[t];
                          }), xr(t, [t.Transaction.prototype]), _r(t, [t.Transaction.prototype], c(_e22), _e22), r.schema = _e22;

                          var _i7 = Y(f);

                          var _a8;

                          _i7 && ae();

                          var _h = Wt.follow(function () {
                            if (_a8 = f(r), _a8 && _i7) {
                              var t = se.bind(null, null);

                              _a8.then(t, t);
                            }
                          });

                          return _a8 && "function" == typeof _a8.then ? Wt.resolve(_a8) : _h.then(function () {
                            return _a8;
                          });
                        }
                      }), o.push(function (e) {
                        s && Te || function (t, e) {
                          [].slice.call(e.db.objectStoreNames).forEach(function (r) {
                            return null == t[r] && e.db.deleteObjectStore(r);
                          });
                        }(i._cfg.dbschema, e), xr(t, [t.Transaction.prototype]), _r(t, [t.Transaction.prototype], t._storeNames, t._dbSchema), r.schema = t._dbSchema;
                      });
                    }), function t() {
                      return o.length ? Wt.resolve(o.shift()(r.idbtrans)).then(t) : Wt.resolve();
                    }().then(function () {
                      var t, e;
                      e = n, c(t = a).forEach(function (r) {
                        e.db.objectStoreNames.contains(r) || Ar(e, r, t[r].primKey, t[r].indexes);
                      });
                    });
                  }(t, e, i, r).catch(a);
                });
              }(t, o / 10, a, i);
            }
          }, i), l.onsuccess = Jt(function () {
            a = null;
            var r = t._novip.idbdb = l.result,
                o = O(r.objectStoreNames);
            if (o.length > 0) try {
              var _n18 = r.transaction(1 === (i = o).length ? i[0] : i, "readonly");

              e.autoSchema ? function (_ref37, e, r) {
                var t = _ref37._novip;
                t.verno = e.version / 10;
                var n = t._dbSchema = Tr(0, e, r);
                t._storeNames = O(e.objectStoreNames, 0), _r(t, [t._allTables], c(n), n);
              }(t, r, _n18) : (Pr(t, t._dbSchema, _n18), function (t, e) {
                var r = Er(Tr(0, t.idbdb, e), t._dbSchema);
                return !(r.add.length || r.change.some(function (t) {
                  return t.add.length || t.change.length;
                }));
              }(t, _n18) || console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.")), Or(t, _n18);
            } catch (t) {}
            var i;
            Ae.push(t), r.onversionchange = Jt(function (r) {
              e.vcFired = !0, t.on("versionchange").fire(r);
            }), r.onclose = Jt(function (e) {
              t.on("close").fire(e);
            }), s && function (_ref38, r) {
              var t = _ref38.indexedDB,
                  e = _ref38.IDBKeyRange;
              !jr(t) && r !== ke && kr(t, e).put({
                name: r
              }).catch(st);
            }(t._deps, u), n();
          }, i);
        });
      })]).then(function () {
        return o(), e.onReadyBeingFired = [], Wt.resolve(Zr(function () {
          return t.on.ready.fire(t.vip);
        })).then(function r() {
          if (e.onReadyBeingFired.length > 0) {
            var _n19 = e.onReadyBeingFired.reduce(yt, st);

            return e.onReadyBeingFired = [], Wt.resolve(Zr(function () {
              return _n19(t.vip);
            })).then(r);
          }
        });
      }).finally(function () {
        e.onReadyBeingFired = null, e.isBeingOpened = !1;
      }).then(function () {
        return t;
      }).catch(function (r) {
        e.dbOpenError = r;

        try {
          a && a.abort();
        } catch (t) {}

        return n === e.openCanceller && t._close(), be(r);
      }).finally(function () {
        e.openComplete = !0, i();
      });
    }

    function Fr(t) {
      var e = function e(_e23) {
        return t.next(_e23);
      },
          r = o(e),
          n = o(function (e) {
        return t.throw(e);
      });

      function o(t) {
        return function (e) {
          var o = t(e),
              i = o.value;
          return o.done ? i : i && "function" == typeof i.then ? i.then(r, n) : u(i) ? Promise.all(i).then(r, n) : r(i);
        };
      }

      return o(e)();
    }

    function Wr(t, e, r) {
      var n = arguments.length;
      if (n < 2) throw new ot.InvalidArgument("Too few arguments");

      for (var o = new Array(n - 1); --n;) {
        o[n - 1] = arguments[n];
      }

      r = o.pop();
      var i = S(o);
      return [t, i, r];
    }

    function Br(t, e, r, n, o) {
      return Wt.resolve().then(function () {
        var i = Zt.transless || Zt,
            a = t._createTransaction(e, r, t._dbSchema, n),
            s = {
          trans: a,
          transless: i
        };

        n ? a.idbtrans = n.idbtrans : a.create();
        var c = Y(o);
        var u;
        c && ae();
        var l = Wt.follow(function () {
          if (u = o.call(a, a), u) if (c) {
            var t = se.bind(null, null);
            u.then(t, t);
          } else "function" == typeof u.next && "function" == typeof u.throw && (u = Fr(u));
        }, s);
        return (u && "function" == typeof u.then ? Wt.resolve(u).then(function (t) {
          return a.active ? t : be(new ot.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : l.then(function () {
          return u;
        })).then(function (t) {
          return n && a._resolve(), a._completion.then(function () {
            return t;
          });
        }).catch(function (t) {
          return a._reject(t), be(t);
        });
      });
    }

    function Nr(t, e, r) {
      var n = u(t) ? t.slice() : [t];

      for (var _t17 = 0; _t17 < r; ++_t17) {
        n.push(e);
      }

      return n;
    }

    var Ir = {
      stack: "dbcore",
      name: "VirtualIndexMiddleware",
      level: 1,
      create: function create(t) {
        return _objectSpread(_objectSpread({}, t), {}, {
          table: function table(e) {
            var r = t.table(e),
                n = r.schema,
                o = {},
                i = [];

            function a(t, e, r) {
              var n = wr(t),
                  s = o[n] = o[n] || [],
                  c = null == t ? 0 : "string" == typeof t ? 1 : t.length,
                  u = e > 0,
                  l = _objectSpread(_objectSpread({}, r), {}, {
                isVirtual: u,
                keyTail: e,
                keyLength: c,
                extractKey: vr(t),
                unique: !u && r.unique
              });

              return s.push(l), l.isPrimaryKey || i.push(l), c > 1 && a(2 === c ? t[0] : t.slice(0, c - 1), e + 1, r), s.sort(function (t, e) {
                return t.keyTail - e.keyTail;
              }), l;
            }

            var s = a(n.primaryKey.keyPath, 0, n.primaryKey);
            o[":id"] = [s];

            var _iterator2 = _createForOfIteratorHelper(n.indexes),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _t18 = _step2.value;
                a(_t18.keyPath, 0, _t18);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            function c(e) {
              var r = e.query.index;
              return r.isVirtual ? _objectSpread(_objectSpread({}, e), {}, {
                query: {
                  index: r,
                  range: (n = e.query.range, o = r.keyTail, {
                    type: 1 === n.type ? 2 : n.type,
                    lower: Nr(n.lower, n.lowerOpen ? t.MAX_KEY : t.MIN_KEY, o),
                    lowerOpen: !0,
                    upper: Nr(n.upper, n.upperOpen ? t.MIN_KEY : t.MAX_KEY, o),
                    upperOpen: !0
                  })
                }
              }) : e;
              var n, o;
            }

            var u = _objectSpread(_objectSpread({}, r), {}, {
              schema: _objectSpread(_objectSpread({}, n), {}, {
                primaryKey: s,
                indexes: i,
                getIndexByKeyPath: function getIndexByKeyPath(t) {
                  var e = o[wr(t)];
                  return e && e[0];
                }
              }),
              count: function count(t) {
                return r.count(c(t));
              },
              query: function query(t) {
                return r.query(c(t));
              },
              openCursor: function openCursor(e) {
                var _e$query$index = e.query.index,
                    n = _e$query$index.keyTail,
                    o = _e$query$index.isVirtual,
                    i = _e$query$index.keyLength;
                return o ? r.openCursor(c(e)).then(function (r) {
                  return r && function (r) {
                    var o = Object.create(r, {
                      continue: {
                        value: function value(o) {
                          null != o ? r.continue(Nr(o, e.reverse ? t.MAX_KEY : t.MIN_KEY, n)) : e.unique ? r.continue(r.key.slice(0, i).concat(e.reverse ? t.MIN_KEY : t.MAX_KEY, n)) : r.continue();
                        }
                      },
                      continuePrimaryKey: {
                        value: function value(e, o) {
                          r.continuePrimaryKey(Nr(e, t.MAX_KEY, n), o);
                        }
                      },
                      primaryKey: {
                        get: function get() {
                          return r.primaryKey;
                        }
                      },
                      key: {
                        get: function get() {
                          var t = r.key;
                          return 1 === i ? t[0] : t.slice(0, i);
                        }
                      },
                      value: {
                        get: function get() {
                          return r.value;
                        }
                      }
                    });
                    return o;
                  }(r);
                }) : r.openCursor(e);
              }
            });

            return u;
          }
        });
      }
    };

    function Dr(t, e, r, n) {
      return r = r || {}, n = n || "", c(t).forEach(function (o) {
        if (p(e, o)) {
          var i = t[o],
              a = e[o];

          if ("object" == typeof i && "object" == typeof a && i && a) {
            var _t19 = W(i);

            _t19 !== W(a) ? r[n + o] = e[o] : "Object" === _t19 ? Dr(i, a, r, n + o + ".") : i !== a && (r[n + o] = e[o]);
          } else i !== a && (r[n + o] = e[o]);
        } else r[n + o] = void 0;
      }), c(e).forEach(function (o) {
        p(t, o) || (r[n + o] = e[o]);
      }), r;
    }

    var Yr = {
      stack: "dbcore",
      name: "HooksMiddleware",
      level: 2,
      create: function create(t) {
        return _objectSpread(_objectSpread({}, t), {}, {
          table: function table(e) {
            var r = t.table(e),
                n = r.schema.primaryKey,
                o = _objectSpread(_objectSpread({}, r), {}, {
              mutate: function mutate(t) {
                var o = Zt.trans,
                    _o$table$hook = o.table(e).hook,
                    i = _o$table$hook.deleting,
                    a = _o$table$hook.creating,
                    s = _o$table$hook.updating;

                switch (t.type) {
                  case "add":
                    if (a.fire === st) break;
                    return o._promise("readwrite", function () {
                      return c(t);
                    }, !0);

                  case "put":
                    if (a.fire === st && s.fire === st) break;
                    return o._promise("readwrite", function () {
                      return c(t);
                    }, !0);

                  case "delete":
                    if (i.fire === st) break;
                    return o._promise("readwrite", function () {
                      return c(t);
                    }, !0);

                  case "deleteRange":
                    if (i.fire === st) break;
                    return o._promise("readwrite", function () {
                      return function (t) {
                        return u(t.trans, t.range, 1e4);
                      }(t);
                    }, !0);
                }

                return r.mutate(t);

                function c(t) {
                  var e = Zt.trans,
                      o = t.keys || function (t, e) {
                    return "delete" === e.type ? e.keys : e.keys || e.values.map(t.extractKey);
                  }(n, t);

                  if (!o) throw new Error("Keys missing");
                  return "delete" !== (t = "add" === t.type || "put" === t.type ? _objectSpread(_objectSpread({}, t), {}, {
                    keys: o
                  }) : _objectSpread({}, t)).type && (t.values = _toConsumableArray(t.values)), t.keys && (t.keys = _toConsumableArray(t.keys)), function (t, e, r) {
                    return "add" === e.type ? Promise.resolve([]) : t.getMany({
                      trans: e.trans,
                      keys: r,
                      cache: "immutable"
                    });
                  }(r, t, o).then(function (c) {
                    var u = o.map(function (r, o) {
                      var u = c[o],
                          l = {
                        onerror: null,
                        onsuccess: null
                      };
                      if ("delete" === t.type) i.fire.call(l, r, u, e);else if ("add" === t.type || void 0 === u) {
                        var _i8 = a.fire.call(l, r, t.values[o], e);

                        null == r && null != _i8 && (r = _i8, t.keys[o] = r, n.outbound || R(t.values[o], n.keyPath, r));
                      } else {
                        var _n20 = Dr(u, t.values[o]),
                            _i9 = s.fire.call(l, _n20, r, u, e);

                        if (_i9) {
                          var _e24 = t.values[o];
                          Object.keys(_i9).forEach(function (t) {
                            p(_e24, t) ? _e24[t] = _i9[t] : R(_e24, t, _i9[t]);
                          });
                        }
                      }
                      return l;
                    });
                    return r.mutate(t).then(function (_ref39) {
                      var e = _ref39.failures,
                          r = _ref39.results,
                          n = _ref39.numFailures,
                          i = _ref39.lastResult;

                      for (var _n21 = 0; _n21 < o.length; ++_n21) {
                        var _i10 = r ? r[_n21] : o[_n21],
                            _a9 = u[_n21];

                        null == _i10 ? _a9.onerror && _a9.onerror(e[_n21]) : _a9.onsuccess && _a9.onsuccess("put" === t.type && c[_n21] ? t.values[_n21] : _i10);
                      }

                      return {
                        failures: e,
                        results: r,
                        numFailures: n,
                        lastResult: i
                      };
                    }).catch(function (t) {
                      return u.forEach(function (e) {
                        return e.onerror && e.onerror(t);
                      }), Promise.reject(t);
                    });
                  });
                }

                function u(t, e, o) {
                  return r.query({
                    trans: t,
                    values: !1,
                    query: {
                      index: n,
                      range: e
                    },
                    limit: o
                  }).then(function (_ref40) {
                    var r = _ref40.result;
                    return c({
                      type: "delete",
                      keys: r,
                      trans: t
                    }).then(function (n) {
                      return n.numFailures > 0 ? Promise.reject(n.failures[0]) : r.length < o ? {
                        failures: [],
                        numFailures: 0,
                        lastResult: void 0
                      } : u(t, _objectSpread(_objectSpread({}, e), {}, {
                        lower: r[r.length - 1],
                        lowerOpen: !0
                      }), o);
                    });
                  });
                }
              }
            });

            return o;
          }
        });
      }
    };

    function zr(t, e, r) {
      try {
        if (!e) return null;
        if (e.keys.length < t.length) return null;
        var _n22 = [];

        for (var _o11 = 0, _i11 = 0; _o11 < e.keys.length && _i11 < t.length; ++_o11) {
          0 === He(e.keys[_o11], t[_i11]) && (_n22.push(r ? M(e.values[_o11]) : e.values[_o11]), ++_i11);
        }

        return _n22.length === t.length ? _n22 : null;
      } catch (t) {
        return null;
      }
    }

    var Ur = {
      stack: "dbcore",
      level: -1,
      create: function create(t) {
        return {
          table: function table(e) {
            var r = t.table(e);
            return _objectSpread(_objectSpread({}, r), {}, {
              getMany: function getMany(t) {
                if (!t.cache) return r.getMany(t);
                var e = zr(t.keys, t.trans._cache, "clone" === t.cache);
                return e ? Wt.resolve(e) : r.getMany(t).then(function (e) {
                  return t.trans._cache = {
                    keys: t.keys,
                    values: "clone" === t.cache ? M(e) : e
                  }, e;
                });
              },
              mutate: function mutate(t) {
                return "add" !== t.type && (t.trans._cache = null), r.mutate(t);
              }
            });
          }
        };
      }
    };

    function Gr(t) {
      return !("from" in t);
    }

    var Kr = function Kr(t, e) {
      if (!this) {
        var _e25 = new Kr();

        return t && "d" in t && l(_e25, t), _e25;
      }

      l(this, arguments.length ? {
        d: 1,
        from: t,
        to: arguments.length > 1 ? e : t
      } : {
        d: 0
      });
    };

    function Hr(t, e, r) {
      var n = He(e, r);
      if (isNaN(n)) return;
      if (n > 0) throw RangeError();
      if (Gr(t)) return l(t, {
        from: e,
        to: r,
        d: 1
      });
      var o = t.l,
          i = t.r;
      if (He(r, t.from) < 0) return o ? Hr(o, e, r) : t.l = {
        from: e,
        to: r,
        d: 1,
        l: null,
        r: null
      }, $r(t);
      if (He(e, t.to) > 0) return i ? Hr(i, e, r) : t.r = {
        from: e,
        to: r,
        d: 1,
        l: null,
        r: null
      }, $r(t);
      He(e, t.from) < 0 && (t.from = e, t.l = null, t.d = i ? i.d + 1 : 1), He(r, t.to) > 0 && (t.to = r, t.r = null, t.d = t.l ? t.l.d + 1 : 1);
      var a = !t.r;
      o && !t.l && Vr(t, o), i && a && Vr(t, i);
    }

    function Vr(t, e) {
      Gr(e) || function t(e, _ref41) {
        var r = _ref41.from,
            n = _ref41.to,
            o = _ref41.l,
            i = _ref41.r;
        Hr(e, r, n), o && t(e, o), i && t(e, i);
      }(t, e);
    }

    function qr(t) {
      var e = Gr(t) ? null : {
        s: 0,
        n: t
      };
      return {
        next: function next(t) {
          var r = arguments.length > 0;

          for (; e;) {
            switch (e.s) {
              case 0:
                if (e.s = 1, r) for (; e.n.l && He(t, e.n.from) < 0;) {
                  e = {
                    up: e,
                    n: e.n.l,
                    s: 1
                  };
                } else for (; e.n.l;) {
                  e = {
                    up: e,
                    n: e.n.l,
                    s: 1
                  };
                }

              case 1:
                if (e.s = 2, !r || He(t, e.n.to) <= 0) return {
                  value: e.n,
                  done: !1
                };

              case 2:
                if (e.n.r) {
                  e.s = 3, e = {
                    up: e,
                    n: e.n.r,
                    s: 0
                  };
                  continue;
                }

              case 3:
                e = e.up;
            }
          }

          return {
            done: !0
          };
        }
      };
    }

    function $r(t) {
      var e, r;
      var n = ((null === (e = t.r) || void 0 === e ? void 0 : e.d) || 0) - ((null === (r = t.l) || void 0 === r ? void 0 : r.d) || 0),
          o = n > 1 ? "r" : n < -1 ? "l" : "";

      if (o) {
        var _e26 = "r" === o ? "l" : "r",
            _r29 = _objectSpread({}, t),
            _n23 = t[o];

        t.from = _n23.from, t.to = _n23.to, t[o] = _n23[o], _r29[o] = _n23[_e26], t[_e26] = _r29, _r29.d = Xr(_r29);
      }

      t.d = Xr(t);
    }

    function Xr(_ref42) {
      var t = _ref42.r,
          e = _ref42.l;
      return (t ? e ? Math.max(t.d, e.d) : t.d : e ? e.d : 0) + 1;
    }

    d(Kr.prototype, _defineProperty({
      add: function add(t) {
        return Vr(this, t), this;
      },
      addKey: function addKey(t) {
        return Hr(this, t, t), this;
      },
      addKeys: function addKeys(t) {
        var _this23 = this;

        return t.forEach(function (t) {
          return Hr(_this23, t, t);
        }), this;
      }
    }, B, function () {
      return qr(this);
    }));
    var Jr = {
      stack: "dbcore",
      level: 0,
      create: function create(t) {
        var e = t.schema.name,
            r = new Kr(t.MIN_KEY, t.MAX_KEY);
        return _objectSpread(_objectSpread({}, t), {}, {
          table: function table(n) {
            var o = t.table(n),
                i = o.schema,
                a = i.primaryKey,
                s = a.extractKey,
                l = a.outbound,
                f = _objectSpread(_objectSpread({}, o), {}, {
              mutate: function mutate(t) {
                var a = t.trans,
                    s = a.mutatedParts || (a.mutatedParts = {}),
                    c = function c(t) {
                  var r = "idb://".concat(e, "/").concat(n, "/").concat(t);
                  return s[r] || (s[r] = new Kr());
                },
                    l = c(""),
                    f = c(":dels"),
                    h = t.type;

                var _ref43 = "deleteRange" === t.type ? [t.range] : "delete" === t.type ? [t.keys] : t.values.length < 50 ? [[], t.values] : [],
                    _ref44 = _slicedToArray(_ref43, 2),
                    p = _ref44[0],
                    d = _ref44[1];

                var y = t.trans._cache;
                return o.mutate(t).then(function (t) {
                  if (u(p)) {
                    "delete" !== h && (p = t.results), l.addKeys(p);

                    var _e27 = zr(p, y);

                    _e27 || "add" === h || f.addKeys(p), (_e27 || d) && function (t, e, r, n) {
                      e.indexes.forEach(function (e) {
                        var o = t(e.name || "");

                        function i(t) {
                          return null != t ? e.extractKey(t) : null;
                        }

                        var a = function a(t) {
                          return e.multiEntry && u(t) ? t.forEach(function (t) {
                            return o.addKey(t);
                          }) : o.addKey(t);
                        };

                        (r || n).forEach(function (t, e) {
                          var o = r && i(r[e]),
                              s = n && i(n[e]);
                          0 !== He(o, s) && (null != o && a(o), null != s && a(s));
                        });
                      });
                    }(c, i, _e27, d);
                  } else if (p) {
                    var _t20 = {
                      from: p.lower,
                      to: p.upper
                    };
                    f.add(_t20), l.add(_t20);
                  } else l.add(r), f.add(r), i.indexes.forEach(function (t) {
                    return c(t.name).add(r);
                  });

                  return t;
                });
              }
            }),
                h = function h(_ref45) {
              var _ref45$query = _ref45.query,
                  e = _ref45$query.index,
                  r = _ref45$query.range;
              var n, o;
              return [e, new Kr(null !== (n = r.lower) && void 0 !== n ? n : t.MIN_KEY, null !== (o = r.upper) && void 0 !== o ? o : t.MAX_KEY)];
            },
                p = {
              get: function get(t) {
                return [a, new Kr(t.key)];
              },
              getMany: function getMany(t) {
                return [a, new Kr().addKeys(t.keys)];
              },
              count: h,
              query: h,
              openCursor: h
            };

            return c(p).forEach(function (t) {
              f[t] = function (i) {
                var _Zt = Zt,
                    a = _Zt.subscr;

                if (a) {
                  var _c2 = function _c2(t) {
                    var r = "idb://".concat(e, "/").concat(n, "/").concat(t);
                    return a[r] || (a[r] = new Kr());
                  },
                      _u = _c2(""),
                      _f = _c2(":dels"),
                      _p$t = p[t](i),
                      _p$t2 = _slicedToArray(_p$t, 2),
                      _h2 = _p$t2[0],
                      _d2 = _p$t2[1];

                  if (_c2(_h2.name || "").add(_d2), !_h2.isPrimaryKey) {
                    if ("count" !== t) {
                      var _e28 = "query" === t && l && i.values && o.query(_objectSpread(_objectSpread({}, i), {}, {
                        values: !1
                      }));

                      return o[t].apply(this, arguments).then(function (r) {
                        if ("query" === t) {
                          if (l && i.values) return _e28.then(function (_ref46) {
                            var t = _ref46.result;
                            return _u.addKeys(t), r;
                          });

                          var _t21 = i.values ? r.result.map(s) : r.result;

                          i.values ? _u.addKeys(_t21) : _f.addKeys(_t21);
                        } else if ("openCursor" === t) {
                          var _t22 = r,
                              _e29 = i.values;
                          return _t22 && Object.create(_t22, {
                            key: {
                              get: function get() {
                                return _f.addKey(_t22.primaryKey), _t22.key;
                              }
                            },
                            primaryKey: {
                              get: function get() {
                                var e = _t22.primaryKey;
                                return _f.addKey(e), e;
                              }
                            },
                            value: {
                              get: function get() {
                                return _e29 && _u.addKey(_t22.primaryKey), _t22.value;
                              }
                            }
                          });
                        }

                        return r;
                      });
                    }

                    _f.add(r);
                  }
                }

                return o[t].apply(this, arguments);
              };
            }), f;
          }
        });
      }
    };

    var Qr = /*#__PURE__*/function () {
      function Qr(t, e) {
        var _this24 = this;

        _classCallCheck(this, Qr);

        this._middlewares = {}, this.verno = 0;
        var r = Qr.dependencies;
        this._options = e = _objectSpread({
          addons: Qr.addons,
          autoOpen: !0,
          indexedDB: r.indexedDB,
          IDBKeyRange: r.IDBKeyRange
        }, e), this._deps = {
          indexedDB: e.indexedDB,
          IDBKeyRange: e.IDBKeyRange
        };
        var _e30 = e,
            n = _e30.addons;
        this._dbSchema = {}, this._versions = [], this._storeNames = [], this._allTables = {}, this.idbdb = null, this._novip = this;
        var o = {
          dbOpenError: null,
          isBeingOpened: !1,
          onReadyBeingFired: null,
          openComplete: !1,
          dbReadyResolve: st,
          dbReadyPromise: null,
          cancelOpen: st,
          openCanceller: null,
          autoSchema: !0
        };
        var i;
        o.dbReadyPromise = new Wt(function (t) {
          o.dbReadyResolve = t;
        }), o.openCanceller = new Wt(function (t, e) {
          o.cancelOpen = e;
        }), this._state = o, this.name = t, this.on = Be(this, "populate", "blocked", "versionchange", "close", {
          ready: [yt, st]
        }), this.on.ready.subscribe = _(this.on.ready.subscribe, function (t) {
          return function (e, r) {
            Qr.vip(function () {
              var n = _this24._state;
              if (n.openComplete) n.dbOpenError || Wt.resolve().then(e), r && t(e);else if (n.onReadyBeingFired) n.onReadyBeingFired.push(e), r && t(e);else {
                t(e);
                var _n24 = _this24;
                r || t(function t() {
                  _n24.on.ready.unsubscribe(e), _n24.on.ready.unsubscribe(t);
                });
              }
            });
          };
        }), this.Collection = (i = this, Ne($e.prototype, function (t, e) {
          this.db = i;
          var r = Ce,
              n = null;
          if (e) try {
            r = e();
          } catch (t) {
            n = t;
          }
          var o = t._ctx,
              a = o.table,
              s = a.hook.reading.fire;
          this._ctx = {
            table: a,
            index: o.index,
            isPrimKey: !o.index || a.schema.primKey.keyPath && o.index === a.schema.primKey.name,
            range: r,
            keysOnly: !1,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: !0,
            isMatch: null,
            offset: 0,
            limit: 1 / 0,
            error: n,
            or: o.or,
            valueMapper: s !== ct ? s : null
          };
        })), this.Table = function (t) {
          return Ne(We.prototype, function (e, r, n) {
            this.db = t, this._tx = n, this.name = e, this.schema = r, this.hook = t._allTables[e] ? t._allTables[e].hook : Be(null, {
              creating: [ft, st],
              reading: [ut, ct],
              updating: [pt, st],
              deleting: [ht, st]
            });
          });
        }(this), this.Transaction = function (t) {
          return Ne(hr.prototype, function (e, r, n, o, i) {
            var _this25 = this;

            this.db = t, this.mode = e, this.storeNames = r, this.schema = n, this.chromeTransactionDurability = o, this.idbtrans = null, this.on = Be(this, "complete", "error", "abort"), this.parent = i || null, this.active = !0, this._reculock = 0, this._blockedFuncs = [], this._resolve = null, this._reject = null, this._waitingFor = null, this._waitingQueue = null, this._spinCount = 0, this._completion = new Wt(function (t, e) {
              _this25._resolve = t, _this25._reject = e;
            }), this._completion.then(function () {
              _this25.active = !1, _this25.on.complete.fire();
            }, function (t) {
              var e = _this25.active;
              return _this25.active = !1, _this25.on.error.fire(t), _this25.parent ? _this25.parent._reject(t) : e && _this25.idbtrans && _this25.idbtrans.abort(), be(t);
            });
          });
        }(this), this.Version = function (t) {
          return Ne(Sr.prototype, function (e) {
            this.db = t, this._cfg = {
              version: e,
              storesSource: null,
              dbschema: {},
              tables: {},
              contentUpgrade: null
            };
          });
        }(this), this.WhereClause = function (t) {
          return Ne(ar.prototype, function (e, r, n) {
            this.db = t, this._ctx = {
              table: e,
              index: ":id" === r ? null : r,
              or: n
            };
            var o = t._deps.indexedDB;
            if (!o) throw new ot.MissingAPI();
            this._cmp = this._ascending = o.cmp.bind(o), this._descending = function (t, e) {
              return o.cmp(e, t);
            }, this._max = function (t, e) {
              return o.cmp(t, e) > 0 ? t : e;
            }, this._min = function (t, e) {
              return o.cmp(t, e) < 0 ? t : e;
            }, this._IDBKeyRange = t._deps.IDBKeyRange;
          });
        }(this), this.on("versionchange", function (t) {
          t.newVersion > 0 ? console.warn("Another connection wants to upgrade database '".concat(_this24.name, "'. Closing db now to resume the upgrade.")) : console.warn("Another connection wants to delete database '".concat(_this24.name, "'. Closing db now to resume the delete request.")), _this24.close();
        }), this.on("blocked", function (t) {
          !t.newVersion || t.newVersion < t.oldVersion ? console.warn("Dexie.delete('".concat(_this24.name, "') was blocked")) : console.warn("Upgrade '".concat(_this24.name, "' blocked by other connection holding version ").concat(t.oldVersion / 10));
        }), this._maxKey = _mr(e.IDBKeyRange), this._createTransaction = function (t, e, r, n) {
          return new _this24.Transaction(t, e, r, _this24._options.chromeTransactionDurability, n);
        }, this._fireOnBlocked = function (t) {
          _this24.on("blocked").fire(t), Ae.filter(function (t) {
            return t.name === _this24.name && t !== _this24 && !t._state.vcFired;
          }).map(function (e) {
            return e.on("versionchange").fire(t);
          });
        }, this.use(Ir), this.use(Yr), this.use(Jr), this.use(Ur), this.vip = Object.create(this, {
          _vip: {
            value: !0
          }
        }), n.forEach(function (t) {
          return t(_this24);
        });
      }

      _createClass(Qr, [{
        key: "version",
        value: function version(t) {
          if (isNaN(t) || t < .1) throw new ot.Type("Given version is not a positive number");
          if (t = Math.round(10 * t) / 10, this.idbdb || this._state.isBeingOpened) throw new ot.Schema("Cannot add version when database is open");
          this.verno = Math.max(this.verno, t);
          var e = this._versions;
          var r = e.filter(function (e) {
            return e._cfg.version === t;
          })[0];
          return r || (r = new this.Version(t), e.push(r), e.sort(Lr), r.stores({}), this._state.autoSchema = !1, r);
        }
      }, {
        key: "_whenReady",
        value: function _whenReady(t) {
          var _this26 = this;

          return this.idbdb && (this._state.openComplete || Zt.letThrough || this._vip) ? t() : new Wt(function (t, e) {
            if (_this26._state.openComplete) return e(new ot.DatabaseClosed(_this26._state.dbOpenError));

            if (!_this26._state.isBeingOpened) {
              if (!_this26._options.autoOpen) return void e(new ot.DatabaseClosed());

              _this26.open().catch(st);
            }

            _this26._state.dbReadyPromise.then(t, e);
          }).then(t);
        }
      }, {
        key: "use",
        value: function use(_ref47) {
          var t = _ref47.stack,
              e = _ref47.create,
              r = _ref47.level,
              n = _ref47.name;
          n && this.unuse({
            stack: t,
            name: n
          });
          var o = this._middlewares[t] || (this._middlewares[t] = []);
          return o.push({
            stack: t,
            create: e,
            level: null == r ? 10 : r,
            name: n
          }), o.sort(function (t, e) {
            return t.level - e.level;
          }), this;
        }
      }, {
        key: "unuse",
        value: function unuse(_ref48) {
          var t = _ref48.stack,
              e = _ref48.name,
              r = _ref48.create;
          return t && this._middlewares[t] && (this._middlewares[t] = this._middlewares[t].filter(function (t) {
            return r ? t.create !== r : !!e && t.name !== e;
          })), this;
        }
      }, {
        key: "open",
        value: function open() {
          return Cr(this);
        }
      }, {
        key: "_close",
        value: function _close() {
          var t = this._state,
              e = Ae.indexOf(this);

          if (e >= 0 && Ae.splice(e, 1), this.idbdb) {
            try {
              this.idbdb.close();
            } catch (t) {}

            this._novip.idbdb = null;
          }

          t.dbReadyPromise = new Wt(function (e) {
            t.dbReadyResolve = e;
          }), t.openCanceller = new Wt(function (e, r) {
            t.cancelOpen = r;
          });
        }
      }, {
        key: "close",
        value: function close() {
          this._close();

          var t = this._state;
          this._options.autoOpen = !1, t.dbOpenError = new ot.DatabaseClosed(), t.isBeingOpened && t.cancelOpen(t.dbOpenError);
        }
      }, {
        key: "delete",
        value: function _delete() {
          var _this27 = this;

          var t = arguments.length > 0,
              e = this._state;
          return new Wt(function (r, n) {
            var o = function o() {
              _this27.close();

              var t = _this27._deps.indexedDB.deleteDatabase(_this27.name);

              t.onsuccess = Jt(function () {
                !function (_ref49, r) {
                  var t = _ref49.indexedDB,
                      e = _ref49.IDBKeyRange;
                  !jr(t) && r !== ke && kr(t, e).delete(r).catch(st);
                }(_this27._deps, _this27.name), r();
              }), t.onerror = sr(n), t.onblocked = _this27._fireOnBlocked;
            };

            if (t) throw new ot.InvalidArgument("Arguments not allowed in db.delete()");
            e.isBeingOpened ? e.dbReadyPromise.then(o) : o();
          });
        }
      }, {
        key: "backendDB",
        value: function backendDB() {
          return this.idbdb;
        }
      }, {
        key: "isOpen",
        value: function isOpen() {
          return null !== this.idbdb;
        }
      }, {
        key: "hasBeenClosed",
        value: function hasBeenClosed() {
          var t = this._state.dbOpenError;
          return t && "DatabaseClosed" === t.name;
        }
      }, {
        key: "hasFailed",
        value: function hasFailed() {
          return null !== this._state.dbOpenError;
        }
      }, {
        key: "dynamicallyOpened",
        value: function dynamicallyOpened() {
          return this._state.autoSchema;
        }
      }, {
        key: "tables",
        get: function get() {
          var _this28 = this;

          return c(this._allTables).map(function (t) {
            return _this28._allTables[t];
          });
        }
      }, {
        key: "transaction",
        value: function transaction() {
          var t = Wr.apply(this, arguments);
          return this._transaction.apply(this, t);
        }
      }, {
        key: "_transaction",
        value: function _transaction(t, e, r) {
          var _this29 = this;

          var n = Zt.trans;
          n && n.db === this && -1 === t.indexOf("!") || (n = null);
          var o = -1 !== t.indexOf("?");
          var i, a;
          t = t.replace("!", "").replace("?", "");

          try {
            if (a = e.map(function (t) {
              var e = t instanceof _this29.Table ? t.name : t;
              if ("string" != typeof e) throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
              return e;
            }), "r" == t || t === je) i = je;else {
              if ("rw" != t && t != Ze) throw new ot.InvalidArgument("Invalid transaction mode: " + t);
              i = Ze;
            }

            if (n) {
              if (n.mode === je && i === Ze) {
                if (!o) throw new ot.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                n = null;
              }

              n && a.forEach(function (t) {
                if (n && -1 === n.storeNames.indexOf(t)) {
                  if (!o) throw new ot.SubTransaction("Table " + t + " not included in parent transaction.");
                  n = null;
                }
              }), o && n && !n.active && (n = null);
            }
          } catch (t) {
            return n ? n._promise(null, function (e, r) {
              r(t);
            }) : be(t);
          }

          var s = Br.bind(null, this, i, a, n, r);
          return n ? n._promise(i, s, "lock") : Zt.trans ? pe(Zt.transless, function () {
            return _this29._whenReady(s);
          }) : this._whenReady(s);
        }
      }, {
        key: "table",
        value: function table(t) {
          if (!p(this._allTables, t)) throw new ot.InvalidTable("Table ".concat(t, " does not exist"));
          return this._allTables[t];
        }
      }]);

      return Qr;
    }();

    var tn = "undefined" != typeof Symbol && "observable" in Symbol ? Symbol.observable : "@@observable";

    var en = /*#__PURE__*/function () {
      function en(t) {
        _classCallCheck(this, en);

        this._subscribe = t;
      }

      _createClass(en, [{
        key: "subscribe",
        value: function subscribe(t, e, r) {
          return this._subscribe(t && "function" != typeof t ? t : {
            next: t,
            error: e,
            complete: r
          });
        }
      }, {
        key: tn,
        value: function value() {
          return this;
        }
      }]);

      return en;
    }();

    function rn(t, e) {
      return c(e).forEach(function (r) {
        Vr(t[r] || (t[r] = new Kr()), e[r]);
      }), t;
    }

    var nn;

    try {
      nn = {
        indexedDB: s.indexedDB || s.mozIndexedDB || s.webkitIndexedDB || s.msIndexedDB,
        IDBKeyRange: s.IDBKeyRange || s.webkitIDBKeyRange
      };
    } catch (t) {
      nn = {
        indexedDB: null,
        IDBKeyRange: null
      };
    }

    var on = Qr;

    function an(t) {
      var e = sn;

      try {
        sn = !0, fr.storagemutated.fire(t);
      } finally {
        sn = e;
      }
    }

    d(on, _objectSpread(_objectSpread({}, at), {}, {
      delete: function _delete(t) {
        return new on(t, {
          addons: []
        }).delete();
      },
      exists: function exists(t) {
        return new on(t, {
          addons: []
        }).open().then(function (t) {
          return t.close(), !0;
        }).catch("NoSuchDatabaseError", function () {
          return !1;
        });
      },
      getDatabaseNames: function getDatabaseNames(t) {
        try {
          return function (_ref50) {
            var t = _ref50.indexedDB,
                e = _ref50.IDBKeyRange;
            return jr(t) ? Promise.resolve(t.databases()).then(function (t) {
              return t.map(function (t) {
                return t.name;
              }).filter(function (t) {
                return t !== ke;
              });
            }) : kr(t, e).toCollection().primaryKeys();
          }(on.dependencies).then(t);
        } catch (t) {
          return be(new ot.MissingAPI());
        }
      },
      defineClass: function defineClass() {
        return function (t) {
          l(this, t);
        };
      },
      ignoreTransaction: function ignoreTransaction(t) {
        return Zt.trans ? pe(Zt.transless, t) : t();
      },
      vip: Zr,
      async: function async(t) {
        return function () {
          try {
            var e = Fr(t.apply(this, arguments));
            return e && "function" == typeof e.then ? e : Wt.resolve(e);
          } catch (t) {
            return be(t);
          }
        };
      },
      spawn: function spawn(t, e, r) {
        try {
          var n = Fr(t.apply(r, e || []));
          return n && "function" == typeof n.then ? n : Wt.resolve(n);
        } catch (t) {
          return be(t);
        }
      },
      currentTransaction: {
        get: function get() {
          return Zt.trans || null;
        }
      },
      waitFor: function waitFor(t, e) {
        var r = Wt.resolve("function" == typeof t ? on.ignoreTransaction(t) : t).timeout(e || 6e4);
        return Zt.trans ? Zt.trans.waitFor(r) : r;
      },
      Promise: Wt,
      debug: {
        get: function get() {
          return z;
        },
        set: function set(t) {
          U(t, "dexie" === t ? function () {
            return !0;
          } : Se);
        }
      },
      derive: v,
      extend: l,
      props: d,
      override: _,
      Events: Be,
      on: fr,
      liveQuery: function liveQuery(t) {
        return new en(function (e) {
          var r = Y(t);
          var n = !1,
              o = {},
              i = {};
          var a = {
            get closed() {
              return n;
            },

            unsubscribe: function unsubscribe() {
              n = !0, fr.storagemutated.unsubscribe(f);
            }
          };
          e.start && e.start(a);
          var s = !1,
              u = !1;

          function l() {
            return c(i).some(function (t) {
              return o[t] && function (t, e) {
                var r = qr(e);
                var n = r.next();
                if (n.done) return !1;
                var o = n.value;
                var i = qr(t);
                var a = i.next(o.from),
                    s = a.value;

                for (; !n.done && !a.done;) {
                  if (He(s.from, o.to) <= 0 && He(s.to, o.from) >= 0) return !0;
                  He(o.from, s.from) < 0 ? o = (n = r.next(s.from)).value : s = (a = i.next(o.from)).value;
                }

                return !1;
              }(o[t], i[t]);
            });
          }

          var f = function f(t) {
            rn(o, t), l() && h();
          },
              h = function h() {
            if (s || n) return;
            o = {};

            var c = {},
                p = function (e) {
              r && ae();

              var n = function n() {
                return ie(t, {
                  subscr: e,
                  trans: null
                });
              },
                  o = Zt.trans ? pe(Zt.transless, n) : n();

              return r && o.then(se, se), o;
            }(c);

            u || (fr(ur, f), u = !0), s = !0, Promise.resolve(p).then(function (t) {
              s = !1, n || (l() ? h() : (o = {}, i = c, e.next && e.next(t)));
            }, function (t) {
              s = !1, e.error && e.error(t), a.unsubscribe();
            });
          };

          return h(), a;
        });
      },
      extendObservabilitySet: rn,
      getByKeyPath: A,
      setByKeyPath: R,
      delByKeyPath: function delByKeyPath(t, e) {
        "string" == typeof e ? R(t, e, void 0) : "length" in e && [].map.call(e, function (e) {
          R(t, e, void 0);
        });
      },
      shallowClone: T,
      deepClone: M,
      getObjectDiff: Dr,
      cmp: He,
      asap: L,
      minKey: xe,
      addons: [],
      connections: Ae,
      errnames: rt,
      dependencies: nn,
      semVer: Oe,
      version: Oe.split(".").map(function (t) {
        return parseInt(t);
      }).reduce(function (t, e, r) {
        return t + e / Math.pow(10, 2 * r);
      })
    })), on.maxKey = _mr(on.dependencies.IDBKeyRange), "undefined" != typeof dispatchEvent && "undefined" != typeof addEventListener && (fr(ur, function (t) {
      if (!sn) {
        var _e31;

        Re ? (_e31 = document.createEvent("CustomEvent"), _e31.initCustomEvent(lr, !0, !0, t)) : _e31 = new CustomEvent(lr, {
          detail: t
        }), sn = !0, dispatchEvent(_e31), sn = !1;
      }
    }), addEventListener(lr, function (_ref51) {
      var t = _ref51.detail;
      sn || an(t);
    }));
    var sn = !1;

    if ("undefined" != typeof BroadcastChannel) {
      var _t23 = new BroadcastChannel(lr);

      fr(ur, function (e) {
        sn || _t23.postMessage(e);
      }), _t23.onmessage = function (t) {
        t.data && an(t.data);
      };
    } else if ("undefined" != typeof self && "undefined" != typeof navigator) {
      fr(ur, function (t) {
        try {
          sn || ("undefined" != typeof localStorage && localStorage.setItem(lr, JSON.stringify({
            trig: Math.random(),
            changedParts: t
          })), "object" == typeof self.clients && _toConsumableArray(self.clients.matchAll({
            includeUncontrolled: !0
          })).forEach(function (e) {
            return e.postMessage({
              type: lr,
              changedParts: t
            });
          }));
        } catch (t) {}
      }), addEventListener("storage", function (t) {
        if (t.key === lr) {
          var _e32 = JSON.parse(t.newValue);

          _e32 && an(_e32.changedParts);
        }
      });

      var _t24 = self.document && navigator.serviceWorker;

      _t24 && _t24.addEventListener("message", function (_ref52) {
        var t = _ref52.data;
        t && t.type === lr && an(t.changedParts);
      });
    }

    Wt.rejectionMapper = function (t, e) {
      if (!t || t instanceof J || t instanceof TypeError || t instanceof SyntaxError || !t.name || !it[t.name]) return t;
      var r = new it[t.name](e || t.message, t);
      return "stack" in t && m(r, "stack", {
        get: function get() {
          return this.inner.stack;
        }
      }), r;
    }, U(z, Se);
    var cn = r(9175),
        un = r(8348),
        ln = r(7408);

    function fn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    var hn = function () {
      function t(e, r) {
        (function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        })(this, t), this.engine = r, this.src = e, this.glTexture = r.gl.createTexture(), this.image = new Image(), this.image.onload = this.onImageLoaded.bind(this), this.image.src = e, this.loaded = !1, this.onLoadActions = new ln.Z();
      }

      return e = t, (r = [{
        key: "runWhenLoaded",
        value: function value(t) {
          this.loaded ? t() : this.onLoadActions.add(t);
        }
      }, {
        key: "onImageLoaded",
        value: function value() {
          var t = this.engine.gl;
          t.bindTexture(t.TEXTURE_2D, this.glTexture), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, this.image), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST), t.bindTexture(t.TEXTURE_2D, null), this.loaded = !0, this.onLoadActions.run();
        }
      }, {
        key: "attach",
        value: function value() {
          var t = this.engine.gl;
          t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, this.glTexture), t.uniform1i(this.engine.shaderProgram.samplerUniform, 0);
        }
      }]) && fn(e.prototype, r), n && fn(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
      var e, r, n;
    }();

    function pn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    var dn = new FontFace("minecraftia", "url(/pixos/font/minecraftia.ttf)"),
        yn = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.ctx = e, this.dirty = !0, this.scrollY = 0, this.fontSize = 24, this.font = "minecraftia", this.align = "left", this.background = "#999", this.border = {
          lineWidth: 4,
          style: "white",
          corner: "round"
        }, this.scrollBox = {
          width: 5,
          background: "#568",
          color: "#78a"
        }, this.fontStyle = "white", this.lines = [];
      }

      var e, r;
      return e = t, r = [{
        key: "init",
        value: function value(t, e, r, n, o) {
          var i,
              a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
          this.text = t, this.x = e, this.y = r, this.width = n, this.height = o, this.portrait = null !== (i = a.portrait) && void 0 !== i ? i : null, this.setOptions(a), this.cleanit();
        }
      }, {
        key: "cleanit",
        value: function value(t) {
          this.dirty && (this.setFont(), this.getTextPos(), this.dirty = !1, t || this.fitText());
        }
      }, {
        key: "setOptions",
        value: function value(t) {
          var e = this;
          Object.keys(this).forEach(function (r) {
            void 0 !== t[r] && (e[r] = t[r], e.dirty = !0);
          });
        }
      }, {
        key: "setFont",
        value: function value() {
          this.fontStr = this.fontSize + "px " + this.font, this.textHeight = this.fontSize + Math.ceil(.05 * this.fontSize);
        }
      }, {
        key: "getTextPos",
        value: function value() {
          "left" === this.align ? this.textPos = 2 : "right" === this.align ? this.textPos = Math.floor(this.width - this.scrollBox.width - this.fontSize / 4) : this.textPos = Math.floor((this.width - -this.scrollBox.width) / 2);
        }
      }, {
        key: "fitText",
        value: function value() {
          var t = this.ctx;
          this.cleanit(!0), t.font = this.fontStr, t.textAlign = this.align, t.textBaseline = "top";
          var e = this.text.split(" ");
          this.lines.length = 0;

          for (var r = "", n = ""; e.length > 0;) {
            var o = e.shift();
            t.measureText(r + n + o).width < this.width - this.scrollBox.width - this.scrollBox.width - (this.portrait ? 84 : 0) ? (r += n + o, n = " ") : ("" === n ? r += o : e.unshift(o), this.lines.push(r), n = "", r = "");
          }

          "" !== r && this.lines.push(r), this.maxScroll = (this.lines.length + .5) * this.textHeight - this.height;
        }
      }, {
        key: "drawBorder",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              e = this.ctx,
              r = this.border.lineWidth / 2;
          e.lineJoin = this.border.corner, e.lineWidth = this.border.lineWidth, e.strokeStyle = this.border.style, t ? e.strokeRect(this.x - r + 84, this.y - r, this.width + 2 * r - 84, this.height + 2 * r) : e.strokeRect(this.x - r, this.y - r, this.width + 2 * r, this.height + 2 * r);
        }
      }, {
        key: "drawScrollBox",
        value: function value() {
          var t = this.ctx,
              e = this.height / (this.lines.length * this.textHeight);
          t.fillStyle = this.scrollBox.background, t.fillRect(this.x + this.width - this.scrollBox.width, this.y, this.scrollBox.width, this.height), t.fillStyle = this.scrollBox.color;
          var r = this.height * e;
          r > this.height && (r = this.height), t.fillRect(this.x + this.width - this.scrollBox.width, this.y - this.scrollY * e, this.scrollBox.width, r);
        }
      }, {
        key: "drawPortrait",
        value: function value() {
          this.ctx.drawImage(this.portrait.image, this.x, this.y + 38, 76, 76);
        }
      }, {
        key: "scroll",
        value: function value(t) {
          this.cleanit(), this.scrollY = -t, this.scrollY > 0 ? this.scrollY = 0 : this.scrollY < -this.maxScroll && (this.scrollY = -this.maxScroll);
        }
      }, {
        key: "scrollLines",
        value: function value(t) {
          this.cleanit(), this.scrollY = -this.textHeight * t, this.scrollY > 0 ? this.scrollY = 0 : this.scrollY < -this.maxScroll && (this.scrollY = -this.maxScroll);
        }
      }, {
        key: "render",
        value: function value() {
          var t = this.ctx;
          this.cleanit(), t.font = this.fontStr, t.textAlign = this.align, this.portrait ? (this.drawBorder(!0), this.drawPortrait(), t.save(), t.fillStyle = this.background, t.fillRect(this.x + 84, this.y, this.width - 84, this.height)) : (this.drawBorder(), t.save(), t.fillStyle = this.background, t.fillRect(this.x, this.y, this.width, this.height)), this.drawScrollBox(), this.portrait ? (t.beginPath(), t.rect(this.x + 84, this.y, this.width - this.scrollBox.width - 84, this.height), t.clip(), t.setTransform(1, 0, 0, 1, this.x + 84, Math.floor(this.y + this.scrollY))) : (t.beginPath(), t.rect(this.x, this.y, this.width - this.scrollBox.width, this.height), t.clip(), t.setTransform(1, 0, 0, 1, this.x, Math.floor(this.y + this.scrollY))), t.fillStyle = this.fontStyle;

          for (var e = 0; e < this.lines.length; e++) {
            t.fillText(this.lines[e], this.textPos, Math.floor(e * this.textHeight) + 2);
          }

          t.restore();
        }
      }], r && pn(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function mn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    var vn = function () {
      function t(e, r, n, o, i, a) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.ctx = e, this.gamepad = a, this.width = e.canvas.width, this.height = e.canvas.height, this.layout = r, this.touches = n, this.radius = i, this.x = 0, this.y = 0, this.dx = 0, this.dy = 0, this.gamepad.map["x-dir"] = 0, this.gamepad.map["y-dir"] = 0, this.gamepad.map["x-axis"] = 0, this.gamepad.map["y-axis"] = 0, this.colours = o, this.init = this.init.bind(this), this.draw = this.draw.bind(this);
      }

      var e, r;
      return e = t, r = [{
        key: "init",
        value: function value() {
          var t = this.layout,
              e = this.width;
          this.x = e - t.x, this.y = t.y + 3 * this.radius / 8, this.dx = this.x, this.dy = this.y, this.gamepad.map["x-dir"] = 0, this.gamepad.map["y-dir"] = 0, this.gamepad.map["x-axis"] = 0, this.gamepad.map["y-axis"] = 0;
        }
      }, {
        key: "draw",
        value: function value() {
          var t = this.ctx;
          t.fillStyle = this.colours.joystick.base, t.beginPath(), t.arc(this.x, this.y, this.radius, 0, 2 * Math.PI, !1), t.fill(), t.closePath(), t.fillStyle = this.colours.joystick.dust, t.beginPath(), t.arc(this.x, this.y, this.radius - 5, 0, 2 * Math.PI, !1), t.fill(), t.closePath(), t.fillStyle = this.colours.joystick.stick, t.beginPath(), t.arc(this.x, this.y, 10, 0, 2 * Math.PI, !1), t.fill(), t.closePath(), t.fillStyle = this.colours.joystick.ball, t.beginPath(), t.arc(this.dx, this.dy, this.radius - 10, 0, 2 * Math.PI, !1), t.fill(), t.closePath();
        }
      }, {
        key: "state",
        value: function value(t, e) {
          var r = this.gamepad,
              n = r.touches,
              o = r.map,
              i = r.checkInput,
              a = n[t].x,
              s = n[t].y,
              c = parseInt(a - this.x),
              u = parseInt(s - this.y),
              l = parseInt(Math.sqrt(c * c + u * u));
          l < 1.2 * this.radius && (e ? "mousedown" === e && (n[t].id = "stick") : n[t].id = "stick"), l < 2.5 * this.radius && (e ? "stick" == n[t].id && "mouseup" === e && (delete n[t].id, this.reset()) : n[t].id = "stick"), "stick" == n[t].id && (Math.abs(parseInt(c)) < this.radius / 2 && (this.dx = this.x + c), Math.abs(parseInt(u)) < this.radius / 2 && (this.dy = this.y + u), o["x-axis"] = (this.dx - this.x) / (this.radius / 2), o["y-axis"] = (this.dy - this.y) / (this.radius / 2), o["x-dir"] = Math.round(o["x-axis"]), o["y-dir"] = Math.round(o["y-axis"]), l > 2.5 * this.radius && (this.reset(), delete n[t].id), "function" == typeof i && this.gamepad.checkInput());
        }
      }, {
        key: "reset",
        value: function value() {
          var t = this.gamepad.map;
          this.dx = this.x, this.dy = this.y, t["x-dir"] = 0, t["y-dir"] = 0, t["x-axis"] = 0, t["y-axis"] = 0;
        }
      }], r && mn(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function gn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    CanvasRenderingContext2D.prototype.roundRect = function (t, e, r, n, o) {
      return r < 2 * o && (o = r / 2), n < 2 * o && (o = n / 2), this.beginPath(), this.moveTo(t + o, e), this.arcTo(t + r, e, t + r, e + n, o), this.arcTo(t + r, e + n, t, e + n, o), this.arcTo(t, e + n, t, e, o), this.arcTo(t, e, t + r, e, o), this.closePath(), this;
    };

    var bn = function () {
      function t(e, r, n, o, i, a, s, c) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.ctx = e, this.gamepad = c, this.layout = r, this.radius = s, this.touches = n, this.start = o, this.select = i, this.colours = a;
      }

      var e, r;
      return e = t, r = [{
        key: "init",
        value: function value() {
          for (var t = this.layout, e = this.ctx, r = this.gamepad.buttons_layout, n = e.canvas.width, o = 0; o < r.length; o++) {
            var i = r[o],
                a = t.x - i.x,
                s = t.y - i.y;

            if (i.r) {
              var c = i.r;
              r[o].hit = {
                x: [a - c, a + 2 * c],
                y: [s - c, s + 2 * c],
                active: !1
              };
            } else {
              if (i.x = n / 3 - i.w, this.start && this.select) switch (i.name) {
                case "select":
                  i.x = n / 2 - i.w - 2 * i.h;
                  break;

                case "start":
                  i.x = n / 2;
              }
              a = i.x, s = t.y - i.y, r[o].hit = {
                x: [a, a + i.w],
                y: [s, s + i.h],
                active: !1
              };
            }

            this.gamepad.map[i.name] = 0;
          }
        }
      }, {
        key: "draw",
        value: function value() {
          for (var t = this.ctx, e = this.layout, r = 0; r < this.gamepad.buttons_layout.length; r++) {
            var n = this.gamepad.buttons_layout[r],
                o = n.color,
                i = e.x - n.x,
                a = e.y - n.y;

            if (n.dx = i, n.dy = a, n.r) {
              var s = n.r;
              n.hit && n.hit.active && (t.fillStyle = o, t.beginPath(), t.arc(i, a, s + 5, 0, 2 * Math.PI, !1), t.fill(), t.closePath()), t.fillStyle = o, t.beginPath(), t.arc(i, a, s, 0, 2 * Math.PI, !1), t.fill(), t.closePath(), t.strokeStyle = o, t.lineWidth = 2, t.stroke(), t.fillStyle = "rgba(255,255,255,1)", t.textAlign = "center", t.textBaseline = "middle", t.font = "minecraftia 12px", t.fillText(n.name, i, a);
            } else {
              var c = n.w,
                  u = n.h;
              i = isNaN(n.x) ? t.canvas.width / 2 : n.x, s = 10, t.fillStyle = o, n.hit && n.hit.active && t.roundRect(i - 5, a - 5, c + 10, u + 10, 2 * s).fill(), t.roundRect(i, a, c, u, s).fill(), t.strokeStyle = o, t.lineWidth = 2, t.stroke(), t.fillStyle = "rgba(0,0,0,0.5)", t.textAlign = "center", t.textBaseline = "middle", t.font = "minecraftia 12px", t.fillText(n.name, i + c / 2, a + 2 * u);
            }

            n.key && (t.fillStyle = "rgba(0,0,0,0.25)", t.textAlign = "center", t.textBaseline = "middle", t.font = "minecraftia 12px", "start" != n.name && "select" != n.name || (i += c / 2), t.fillText(n.key, i, a - 1.5 * s));
          }
        }
      }, {
        key: "state",
        value: function value(t, e, r) {
          var n = this.gamepad,
              o = n.touches,
              i = n.checkInput,
              a = n.width;

          if ("stick" != o[t].id) {
            var s = {
              x: o[t].x,
              y: o[t].y
            },
                c = this.gamepad.buttons_layout[e],
                u = c.name,
                l = parseInt(s.x - c.dx),
                f = parseInt(s.y - c.dy),
                h = a;
            if (c.r ? h = parseInt(Math.sqrt(l * l + f * f)) : s.x > c.hit.x[0] && s.x < c.hit.x[1] && s.y > c.hit.y[0] && s.y < c.hit.y[1] && (h = 0), h < this.radius && "stick" != o[t].id) if (r) switch (r) {
              case "mousedown":
                o[t].id = u;
                break;

              case "mouseup":
                delete o[t].id, this.reset(e);
            } else o[t].id = u;
            o[t].id == u && (this.gamepad.map[u] = 1, c.hit.active = !0, h > this.radius && (c.hit.active = !1, this.gamepad.map[u] = 0, delete o[t].id), "function" == typeof i && this.gamepad.checkInput());
          }
        }
      }, {
        key: "reset",
        value: function value(t) {
          this.gamepad.buttons_layout[t].hit.active = !1, this.gamepad.map[this.gamepad.buttons_layout[t].name] = 0;
        }
      }], r && gn(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function wn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    var On = function () {
      function t(e, r, n, o, i, a, s) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.ctx = e, this.gamepad = s, this.width = e.canvas.width, this.height = e.canvas.height, this.radius = e.canvas.width / 10, this.touches = n, this.start = o, this.select = i, this.button_offset = r, this.colours = a, this.layout = {
          x: this.width - this.button_offset.x,
          y: this.height - this.button_offset.y
        }, this.stick = new vn(this.ctx, this.layout, this.touches, this.colours, this.radius, this.gamepad), this.buttons = new bn(this.ctx, this.layout, this.touches, this.start, this.select, this.colours, this.radius, this.gamepad);
      }

      var e, r;
      return e = t, (r = [{
        key: "init",
        value: function value() {
          this.stick.init(), this.buttons.init();
        }
      }, {
        key: "draw",
        value: function value() {
          this.stick.draw(), this.buttons.draw();
        }
      }]) && wn(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function _n(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    var xn = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.ctx = e, this.dirty = !0, this.showTrace = !0, this.showDebug = !0, this.fontSize = e.canvas.width / 12, this.opacity = .4, this.font = "minecraftia", this.start = !1, this.select = !1, this.touches = {}, this.lastKey = new Date().getTime(), this.listeners = [], this.map = {}, this.radius = e.canvas.width / 12, this.button_offset = {
          x: 2.5 * this.radius,
          y: 105
        }, this.colours = {
          red: "rgba(255,0,0,".concat(this.opacity, ")"),
          green: "rgba(5,220,30,".concat(this.opacity, ")"),
          blue: "rgba(5,30,220,".concat(this.opacity, ")"),
          purple: "rgba(240,5,240,".concat(this.opacity, ")"),
          yellow: "rgba(240,240,5,".concat(this.opacity, ")"),
          cyan: "rgba(5,240,240,".concat(this.opacity, ")"),
          black: "rgba(5,5,5,".concat(this.opacity, ")"),
          white: "rgba(250,250,250,".concat(this.opacity, ")"),
          joystick: {
            base: "rgba(0,0,0,".concat(this.opacity, ")"),
            dust: "rgba(0,0,0,".concat(this.opacity, ")"),
            stick: "rgba(214,214,214,1)",
            ball: "rgba(245,245,245,1)"
          }
        };
        var r = [{
          x: -this.radius - this.radius / 2 + this.radius / 4,
          y: -this.radius / 4,
          r: 3 / 4 * this.radius,
          color: this.colours.red,
          name: "b"
        }, {
          x: this.radius - this.radius / 2,
          y: -(this.radius + this.radius / 2),
          r: 3 / 4 * this.radius,
          color: this.colours.green,
          name: "a"
        }, {
          x: this.radius - this.radius / 2,
          y: this.radius,
          r: 3 / 4 * this.radius,
          color: this.colours.blue,
          name: "x"
        }, {
          x: 3 * this.radius - this.radius / 2 - this.radius / 4,
          y: 0 - this.radius / 4,
          r: 3 / 4 * this.radius,
          color: this.colours.yellow,
          name: "y"
        }];
        this.start && r.push({
          color: this.colours.black,
          y: -55,
          w: 50,
          h: 15,
          name: "start"
        }), this.select && r.push({
          y: -55,
          w: 50,
          h: 15,
          color: this.colours.black,
          name: "select"
        }), this.buttons_layout = r, this.controller = new On(e, this.button_offset, this.touches, this.start, this.select, this.colours, this);
      }

      var e, r;
      return e = t, r = [{
        key: "init",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          console.log("initing"), this.setOptions(t), this.resize(), this.loadCanvas();
        }
      }, {
        key: "attachListener",
        value: function value(t) {
          return this.listeners.push(t);
        }
      }, {
        key: "removeListener",
        value: function value(t) {
          this.listeners.splice(t - 1, 1);
        }
      }, {
        key: "checkInput",
        value: function value() {
          return this.map;
        }
      }, {
        key: "resize",
        value: function value() {
          this.width = this.ctx.canvas.width, this.height = this.ctx.canvas.height, this.controller.init();
        }
      }, {
        key: "loadCanvas",
        value: function value() {
          var t = this,
              e = this.ctx,
              r = this.controller,
              n = this.width,
              o = this.height;
          e.fillStyle = "rgba(70,70,70,0.5)", e.textAlign = "center", e.textBaseline = "middle", e.font = "minecraftia 14px", e.fillText("loading", n / 2, o / 2), r.stick.draw(), r.buttons.draw(), window.addEventListener("resize", function () {
            return t.resize();
          }), setTimeout(function () {
            this.ready = !0;
          }, 250);
        }
      }, {
        key: "setOptions",
        value: function value(t) {
          var e = this;
          Object.keys(this).forEach(function (r) {
            void 0 !== t[r] && (e[r] = t[r], e.dirty = !0);
          });
        }
      }, {
        key: "debounce",
        value: function value() {
          var t = this.controller,
              e = this.buttons_layout,
              r = this.lastKey;
          this.lastKey = new Date().getTime() + 100;

          for (var n = 0; n < e.length; n++) {
            t.buttons.reset(n);
          }

          return r < this.lastKey;
        }
      }, {
        key: "keyPressed",
        value: function value(t) {
          return 1 === this.map[t] && this.debounce();
        }
      }, {
        key: "listen",
        value: function value(t) {
          var e = this.ctx,
              r = this.touches,
              n = this.controller,
              o = this.buttons_layout;

          if (t.type) {
            var i = t.type;
            -1 != t.type.indexOf("mouse") && (t.identifier = "desktop", t = {
              touches: [t]
            });
            var a = this.getPosition(e.canvas);
            this.listeners.map(function (e) {
              if (e[i]) return e[i](t);
            });

            for (var s = 0; s < (t.touches.length > 5 ? 5 : t.touches.length); s++) {
              r[c = t.touches[s].identifier] ? (r[c].x = t.touches[s].pageX - a.x, r[c].y = t.touches[s].pageY - a.y) : r[c] = {
                x: t.touches[s].pageX - a.x,
                y: t.touches[s].pageY - a.y
              };
            }

            for (var c in r) {
              switch (i) {
                case "touchstart":
                case "touchmove":
                  if (this.disableScroll(), n.stick.state(c), new Date().getTime() > this.lastKey + 150) {
                    for (s = 0; s < o.length; s++) {
                      n.buttons.state(c, s);
                    }

                    this.lastKey = new Date().getTime();
                  }

                  break;

                case "touchend":
                  for (s = 0; s < o.length; s++) {
                    n.buttons.reset(s);
                  }

                  break;

                case "mousedown":
                case "mousemove":
                case "mouseup":
                  for (n.stick.state(c, i), s = 0; s < o.length; s++) {
                    n.buttons.state(c, s, i);
                  }

              }
            }

            if ("touchend" == t.type) {
              for ("stick" == r[c = t.changedTouches[0].identifier].id && n.stick.reset(), s = 0; s < o.length; s++) {
                r[c].id == o[s].name && n.buttons.reset(s);
              }

              if (r[c] && delete r[c], t.changedTouches.length > t.touches.length) {
                var u = 0,
                    l = t.changedTouches.length - t.touches.length;

                for (var c in r) {
                  u >= l && delete r[c], u++;
                }
              }

              if (0 == t.touches.length) {
                for (r = {}, s = 0; s < o.length; s++) {
                  n.buttons.reset(s);
                }

                n.stick.reset();
              }

              this.enableScroll();
            }
          } else {
            var f = t,
                h = 0;

            for (var p in f) {
              switch (p) {
                case "%":
                  f[p] && (h += 1);
                  break;

                case "&":
                  f[p] && (h += 2);
                  break;

                case "'":
                  f[p] && (h += 4);
                  break;

                case "(":
                  f[p] && (h += 8);
                  break;

                default:
                  if (f[p]) for (s = 0; s < o.length; s++) {
                    o[s].key && o[s].key == p && (r[o[s].name] = {
                      id: o[s].name,
                      x: o[s].hit.x[0] + o[s].w / 2,
                      y: o[s].hit.y[0] + o[s].h / 2
                    }, n.buttons.state(o[s].name, s, "mousedown"));
                  } else if (!f[p]) {
                    for (s = 0; s < o.length; s++) {
                      o[s].key && o[s].key == p && (n.buttons.reset(s), delete r[o[s].name]);
                    }

                    delete f[p];
                  }
              }

              switch (n.stick.dx = n.stick.x, n.stick.dy = n.stick.y, h) {
                case 1:
                  n.stick.dx = n.stick.x - n.stick.radius / 2;
                  break;

                case 2:
                  n.stick.dy = n.stick.y - n.stick.radius / 2;
                  break;

                case 3:
                  n.stick.dx = n.stick.x - n.stick.radius / 2, n.stick.dy = n.stick.y - n.stick.radius / 2;
                  break;

                case 4:
                  n.stick.dx = n.stick.x + n.stick.radius / 2;
                  break;

                case 6:
                  n.stick.dx = n.stick.x + n.stick.radius / 2, n.stick.dy = n.stick.y - n.stick.radius / 2;
                  break;

                case 8:
                  n.stick.dy = n.stick.y + n.stick.radius / 2;
                  break;

                case 9:
                  n.stick.dx = n.stick.x - n.stick.radius / 2, n.stick.dy = n.stick.y + n.stick.radius / 2;
                  break;

                case 12:
                  n.stick.dx = n.stick.x + n.stick.radius / 2, n.stick.dy = n.stick.y + n.stick.radius / 2;
                  break;

                default:
                  n.stick.dx = n.stick.x, n.stick.dy = n.stick.y;
              }

              0 != h ? (r.stick = {
                id: "stick"
              }, n.stick.state("stick", "mousemove")) : (n.stick.reset(), delete r.stick);
            }
          }

          return this.map;
        }
      }, {
        key: "render",
        value: function value() {
          var t = this.ctx;
          t.clearRect(0, 0, t.canvas.width, t.canvas.height), this.showDebug && this.debug(), this.showTrace && this.trace(), this.controller.stick.draw(), this.controller.buttons.draw();
        }
      }, {
        key: "debug",
        value: function value() {
          var t = this.ctx,
              e = (this.map, this.touches);

          for (var r in this.dy = 30, t.fillStyle = "rgba(70,70,70,0.5)", t.textAlign = "left", t.textBaseline = "middle", t.font = "minecraftia 20px", t.fillText("debug", 10, this.dy), t.font = "minecraftia 14px", this.dy += 5, e) {
            this.dy += 10;
            var n = r + " : " + JSON.stringify(e[r]).slice(1, -1);
            t.fillText(n, 10, this.dy);
          }
        }
      }, {
        key: "trace",
        value: function value() {
          var t = this.ctx,
              e = this.map;

          for (var r in this.dy = 30, t.fillStyle = "rgba(70,70,70,0.5)", t.textAlign = "right", t.textBaseline = "middle", t.font = "minecraftia 20px", t.fillText("trace", this.width - 10, this.dy), t.font = "minecraftia 14px", this.dy += 5, e) {
            this.dy += 10;
            var n = r + " : " + e[r];
            t.fillText(n, this.width - 10, this.dy);
          }
        }
      }, {
        key: "getPosition",
        value: function value(t) {
          for (var e = 0, r = 0; t;) {
            e += t.offsetLeft - t.scrollLeft + t.clientLeft, r += t.offsetTop - t.scrollTop + t.clientTop, t = t.offsetParent;
          }

          return {
            x: e,
            y: r
          };
        }
      }, {
        key: "enableScroll",
        value: function value() {
          document.body.removeEventListener("touchmove", this.preventDefault);
        }
      }, {
        key: "disableScroll",
        value: function value() {
          document.body.addEventListener("touchmove", this.preventDefault, {
            passive: !1
          });
        }
      }, {
        key: "preventDefault",
        value: function value(t) {
          t.preventDefault(), t.stopPropagation();
        }
      }], r && _n(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function Ln(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    var En = function () {
      function t(e, r, n) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.id = n, this.engine = r, this.canvas = e, this.ctx = e.getContext("2d"), this.glTexture = r.gl.createTexture(), this.loaded = !1, this.onLoadActions = new ln.Z(), this.loadImage();
      }

      var e, r;
      return e = t, r = [{
        key: "runWhenLoaded",
        value: function value(t) {
          this.loaded ? t() : this.onLoadActions.add(t);
        }
      }, {
        key: "loadImage",
        value: function value() {
          var t = this.engine.gl;
          t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, !0), t.bindTexture(t.TEXTURE_2D, this.glTexture), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, this.canvas), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR_MIPMAP_NEAREST), t.generateMipmap(t.TEXTURE_2D), t.bindTexture(t.TEXTURE_2D, null), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, !1), this.loaded = !0, this.onLoadActions.run();
        }
      }, {
        key: "attach",
        value: function value() {
          var t = this.engine.gl;
          t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, this.glTexture), t.uniform1i(this.engine.shaderProgram.samplerUniform, 0);
        }
      }, {
        key: "clearHud",
        value: function value() {
          var t = this.ctx;
          t.clearRect(0, 0, t.canvas.width, t.canvas.height), this.loadImage();
        }
      }, {
        key: "writeText",
        value: function value(t, e, r) {
          var n = this.ctx;
          n.save(), n.font = "32px minecraftia", n.textAlign = "center", n.textBaseline = "middle", n.fillStyle = "white", n.fillText(t, null != e ? e : n.canvas.width / 2, null != r ? r : n.canvas.height / 2), n.restore();
        }
      }, {
        key: "scrollText",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              n = new yn(this.ctx);
          return r.portrait ? n.init(t, 10, 10, this.canvas.width - 20 - 84, 2 * this.canvas.height / 3 - 20, r) : n.init(t, 10, 10, this.canvas.width - 20, 2 * this.canvas.height / 3 - 20, r), n.setOptions(r), e && n.scroll((Math.sin(new Date().getTime() / 3e3) + 1) * n.maxScroll * .5), n.render(), n;
        }
      }], r && Ln(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }(),
        An = r(2903);

    function Rn(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Tn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function Pn(t, e, r) {
      return e && Tn(t.prototype, e), r && Tn(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
    }

    var Sn = function () {
      function t(e) {
        Rn(this, t), this.engine = e, this.definitions = [], this.instances = {};
      }

      return Pn(t, [{
        key: "load",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          if (this.instances[t]) return this.instances[t];
          var r = new kn(t, e);
          this.instances[t] = r;
          var n = this;
          return e && Object.keys(n.instances).filter(function (e) {
            return t !== e;
          }).forEach(function (t) {
            n.instances[t].pauseAudio();
          }), r.loaded = !0, r;
        }
      }]), t;
    }(),
        kn = function () {
      function t(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        Rn(this, t), this.src = e, this.playing = !1, this.audio = new Audio(e), r && this.audio.addEventListener("ended", function () {
          this.currentTime = 0, this.play();
        }, !1), this.audio.load();
      }

      return Pn(t, [{
        key: "isPlaying",
        value: function value() {
          return this.playing;
        }
      }, {
        key: "playAudio",
        value: function value() {
          var t = this.audio.play();
          this.playing = !0, void 0 !== t && t.then(function (t) {}).catch(function (t) {
            console.info(t);
          });
        }
      }, {
        key: "pauseAudio",
        value: function value() {
          var t = this.audio.pause();
          this.playing = !1, void 0 !== t && t.then(function (t) {}).catch(function (t) {
            console.info(t);
          });
        }
      }]), t;
    }();

    function jn(t) {
      return jn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, jn(t);
    }

    function Zn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Mn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Zn(Object(r), !0).forEach(function (e) {
          Nn(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Zn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function Cn() {
      Cn = function Cn() {
        return t;
      };

      var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n = "function" == typeof Symbol ? Symbol : {},
          o = n.iterator || "@@iterator",
          i = n.asyncIterator || "@@asyncIterator",
          a = n.toStringTag || "@@toStringTag";

      function s(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }

      try {
        s({}, "");
      } catch (t) {
        s = function s(t, e, r) {
          return t[e] = r;
        };
      }

      function c(t, e, r, n) {
        var o = e && e.prototype instanceof f ? e : f,
            i = Object.create(o.prototype),
            a = new x(n || []);
        return i._invoke = function (t, e, r) {
          var n = "suspendedStart";
          return function (o, i) {
            if ("executing" === n) throw new Error("Generator is already running");

            if ("completed" === n) {
              if ("throw" === o) throw i;
              return {
                value: void 0,
                done: !0
              };
            }

            for (r.method = o, r.arg = i;;) {
              var a = r.delegate;

              if (a) {
                var s = w(a, r);

                if (s) {
                  if (s === l) continue;
                  return s;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw n = "completed", r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var c = u(t, e, r);

              if ("normal" === c.type) {
                if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                return {
                  value: c.arg,
                  done: r.done
                };
              }

              "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
            }
          };
        }(t, r, a), i;
      }

      function u(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = c;
      var l = {};

      function f() {}

      function h() {}

      function p() {}

      var d = {};
      s(d, o, function () {
        return this;
      });
      var y = Object.getPrototypeOf,
          m = y && y(y(L([])));
      m && m !== e && r.call(m, o) && (d = m);
      var v = p.prototype = f.prototype = Object.create(d);

      function g(t) {
        ["next", "throw", "return"].forEach(function (e) {
          s(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }

      function b(t, e) {
        function n(o, i, a, s) {
          var c = u(t[o], t, i);

          if ("throw" !== c.type) {
            var l = c.arg,
                f = l.value;
            return f && "object" == jn(f) && r.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
              n("next", t, a, s);
            }, function (t) {
              n("throw", t, a, s);
            }) : e.resolve(f).then(function (t) {
              l.value = t, a(l);
            }, function (t) {
              return n("throw", t, a, s);
            });
          }

          s(c.arg);
        }

        var o;

        this._invoke = function (t, r) {
          function i() {
            return new e(function (e, o) {
              n(t, r, e, o);
            });
          }

          return o = o ? o.then(i, i) : i();
        };
      }

      function w(t, e) {
        var r = t.iterator[e.method];

        if (void 0 === r) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = void 0, w(t, e), "throw" === e.method)) return l;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return l;
        }

        var n = u(r, t.iterator, e.arg);
        if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
        var o = n.arg;
        return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
      }

      function O(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function _(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function x(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(O, this), this.reset(!0);
      }

      function L(t) {
        if (t) {
          var e = t[o];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var n = -1,
                i = function e() {
              for (; ++n < t.length;) {
                if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
              }

              return e.value = void 0, e.done = !0, e;
            };

            return i.next = i;
          }
        }

        return {
          next: E
        };
      }

      function E() {
        return {
          value: void 0,
          done: !0
        };
      }

      return h.prototype = p, s(v, "constructor", p), s(p, "constructor", h), h.displayName = s(p, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === h || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, p) : (t.__proto__ = p, s(t, a, "GeneratorFunction")), t.prototype = Object.create(v), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, g(b.prototype), s(b.prototype, i, function () {
        return this;
      }), t.AsyncIterator = b, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new b(c(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, g(v), s(v, a, "Generator"), s(v, o, function () {
        return this;
      }), s(v, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e.reverse(), function r() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, t.values = L, x.prototype = {
        constructor: x,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_), !t) for (var e in this) {
            "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function n(r, n) {
            return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
                a = i.completion;
            if ("root" === i.tryLoc) return n("end");

            if (i.tryLoc <= this.prev) {
              var s = r.call(i, "catchLoc"),
                  c = r.call(i, "finallyLoc");

              if (s && c) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              } else if (s) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];

            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), _(r), l;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;

                _(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, r) {
          return this.delegate = {
            iterator: L(t),
            resultName: e,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), l;
        }
      }, t;
    }

    function Fn(t, e, r, n, o, i, a) {
      try {
        var s = t[i](a),
            c = s.value;
      } catch (t) {
        return void r(t);
      }

      s.done ? e(c) : Promise.resolve(c).then(n, o);
    }

    function Wn(t) {
      return function () {
        var e = this,
            r = arguments;
        return new Promise(function (n, o) {
          var i = t.apply(e, r);

          function a(t) {
            Fn(i, n, o, a, s, "next", t);
          }

          function s(t) {
            Fn(i, n, o, a, s, "throw", t);
          }

          a(void 0);
        });
      };
    }

    function Bn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function Nn(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    var In = function () {
      function t(e, r, n, i, a, s) {
        var c = this;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Nn(this, "initShaderProgram", function (t, e) {
          var r = e.vs,
              n = e.fs,
              o = c,
              i = c.loadShader(t, t.VERTEX_SHADER, r),
              a = c.loadShader(t, t.FRAGMENT_SHADER, n),
              s = t.createProgram();
          if (t.attachShader(s, i), t.attachShader(s, a), t.linkProgram(s), !t.getProgramParameter(s, t.LINK_STATUS)) throw new Error("WebGL unable to initialize the shader program: ".concat(s));
          t.useProgram(s), s.aVertexNormal = t.getAttribLocation(s, "aVertexNormal"), t.enableVertexAttribArray(s.aVertexNormal), s.aVertexPosition = t.getAttribLocation(s, "aVertexPosition"), t.enableVertexAttribArray(s.aVertexPosition), s.aTextureCoord = t.getAttribLocation(s, "aTextureCoord"), t.enableVertexAttribArray(s.aTextureCoord), s.uDiffuse = t.getUniformLocation(s, "uDiffuse"), s.uSpecular = t.getUniformLocation(s, "uSpecular"), s.uSpecularExponent = t.getUniformLocation(s, "uSpecularExponent"), s.pMatrixUniform = t.getUniformLocation(s, "uPMatrix"), s.mvMatrixUniform = t.getUniformLocation(s, "uMVMatrix"), s.nMatrixUniform = t.getUniformLocation(s, "uNormalMatrix"), s.samplerUniform = t.getUniformLocation(s, "uSampler"), s.diffuseMapUniform = t.getUniformLocation(s, "uDiffuseMap"), s.scale = t.getUniformLocation(s, "u_scale"), s.useSampler = t.getUniformLocation(s, "useSampler"), s.useDiffuse = t.getUniformLocation(s, "useDiffuse"), s.setMatrixUniforms = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            t.uniformMatrix4fv(this.pMatrixUniform, !1, o.uProjMat), t.uniformMatrix4fv(this.mvMatrixUniform, !1, o.uViewMat), o.normalMat = (0, cn.Ez)(), (0, cn.XL)(o.normalMat, o.uViewMat), t.uniformMatrix3fv(this.nMatrixUniform, !1, o.normalMat), t.uniform3fv(this.scale, e ? e.toArray() : o.scale.toArray()), t.uniform1f(this.useSampler, r);
          };
          var u = {
            aVertexPosition: An.NQ.Layout.POSITION.key,
            aVertexNormal: An.NQ.Layout.NORMAL.key,
            aTextureCoord: An.NQ.Layout.UV.key
          };
          return s.applyAttributePointers = function (e) {
            var r = e.vertexBuffer.layout;

            for (var n in u) {
              if (u.hasOwnProperty(n) && -1 != s[n]) {
                var o = u[n];

                if (-1 != s[n]) {
                  var i = r.attributeMap[o];
                  t.vertexAttribPointer(s[n], i.size, t[i.type], i.normalized, i.stride, i.offset);
                }
              }
            }
          }, t.disableVertexAttribArray(s.aVertexNormal), c.shaderProgram = s, s;
        }), this.uViewMat = (0, cn.Ue)(), this.uProjMat = (0, cn.Ue)(), this.normalMat = (0, cn.Ez)(), this.scale = new un.OW(1, 1, 1), this.canvas = e, this.hud = r, this.gamepadcanvas = i, this.mipmap = n, this.width = a, this.height = s, this.modelViewMatrixStack = [], this.globalStore = {}, this.textures = [], this.speeches = [], this.cameraAngle = 45, this.fov = 45, this.cameraPosition = new un.OW(8, 8, -1), this.cameraOffset = new un.OW(0, 0, 0), this.setCamera = this.setCamera.bind(this), this.render = this.render.bind(this), this.objLoader = An.NQ, this.voice = new SpeechSynthesisUtterance(), this.audioLoader = new Sn(this), this.db = new Qr("hyperspace"), this.db.version(1).stores({
          tileset: "++id, name, creator, type, checksum, signature, timestamp",
          inventory: "++id, name, creator, type, checksum, signature, timestamp",
          spirits: "++id, name, creator, type, checksum, signature, timestamp",
          abilities: "++id, name, creator, type checksum, signature, timestamp",
          models: "++id, name, creator, type, checksum, signature, timestamp",
          accounts: "++id, name, type, checksum, signature, timestamp",
          dht: "++id, name, type, ip, checksum, signature, timestamp",
          msg: "++id, name, type, ip, checksum, signature, timestamp",
          tmp: "++id, key, value, timestamp"
        }), o.store.pixos = {}, this.store = o.store.pixos;
      }

      var e, r, n, i, a, s, c;
      return e = t, r = [{
        key: "init",
        value: (c = Wn(Cn().mark(function t(e, r) {
          var n, o, i, a;
          return Cn().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (n = this.hud.getContext("2d"), o = this.canvas.getContext("webgl"), i = this.gamepadcanvas.getContext("2d"), o) {
                    t.next = 5;
                    break;
                  }

                  throw new Error("WebGL : unable to initialize");

                case 5:
                  if (n) {
                    t.next = 7;
                    break;
                  }

                  throw new Error("Canvas : unable to initialize HUD");

                case 7:
                  if (i) {
                    t.next = 9;
                    break;
                  }

                  throw new Error("Gamepad : unable to initialize Mobile Canvas");

                case 9:
                  return this.gl = o, this.ctx = n, this.gp = i, this.time = new Date().getTime(), this.scene = e, this.keyboard = r, this.fullscreen = !1, (a = new xn(i)).init(), this.touch = a.listen.bind(a), this.gamepad = a, n.canvas.width = o.canvas.clientWidth, n.canvas.height = o.canvas.clientHeight, o.clearColor(0, 1, 0, 1), o.clearDepth(1), o.enable(o.DEPTH_TEST), o.blendFunc(o.SRC_ALPHA, o.ONE_MINUS_SRC_ALPHA), o.enable(o.BLEND), this.initializedWebGl = !0, this.initShaderProgram(o, e.shaders), this.initProjection(o), t.next = 32, e.init(this);

                case 32:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return c.apply(this, arguments);
        })
      }, {
        key: "dbGet",
        value: (s = Wn(Cn().mark(function t(e, r) {
          return Cn().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.db[e].get(r);

                case 2:
                  return t.abrupt("return", t.sent);

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return s.apply(this, arguments);
        })
      }, {
        key: "dbAdd",
        value: (a = Wn(Cn().mark(function t(e, r) {
          return Cn().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.db[e].add(Mn({}, r));

                case 2:
                  return t.abrupt("return", t.sent);

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return a.apply(this, arguments);
        })
      }, {
        key: "dbUpdate",
        value: (i = Wn(Cn().mark(function t(e, r, n) {
          return Cn().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.db[e].update(r, Mn({}, n));

                case 2:
                  return t.abrupt("return", t.sent);

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r) {
          return i.apply(this, arguments);
        })
      }, {
        key: "dbRemove",
        value: (n = Wn(Cn().mark(function t(e, r) {
          return Cn().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.db[e].delete(r);

                case 2:
                  return t.abrupt("return", t.sent);

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return n.apply(this, arguments);
        })
      }, {
        key: "fetchStore",
        value: function value(t) {
          return this.store[t];
        }
      }, {
        key: "addStore",
        value: function value(t, e) {
          return this.store[t] = Mn({}, e);
        }
      }, {
        key: "updateStore",
        value: function value(t, e) {
          return this.store[t] = Mn({}, e);
        }
      }, {
        key: "delStore",
        value: function value(t) {
          return this.store[t] = null;
        }
      }, {
        key: "loadShader",
        value: function value(t, e, r) {
          var n = t.createShader(e);

          if (t.shaderSource(n, r), t.compileShader(n), !t.getShaderParameter(n, t.COMPILE_STATUS)) {
            var o = t.getShaderInfoLog(n);
            throw t.deleteShader(n), new Error("An error occurred compiling the shaders: ".concat(o));
          }

          return n;
        }
      }, {
        key: "initProjection",
        value: function value(t) {
          var e = this.degToRad(this.fov),
              r = t.canvas.clientWidth / t.canvas.clientHeight;
          this.uProjMat = (0, cn.G3)(e, r, .1, 100), this.uViewMat = (0, cn.Ue)(), this.uProjMat[5] *= -1;
        }
      }, {
        key: "setCamera",
        value: function value() {
          (0, cn.Iu)(this.uViewMat, this.uViewMat, [0, 0, -15]), (0, cn.U1)(this.uViewMat, this.uViewMat, this.degToRad(this.cameraAngle), [1, 0, 0]), (0, un.tk)(this.cameraPosition, this.cameraOffset), (0, cn.Iu)(this.uViewMat, this.uViewMat, this.cameraOffset.toArray());
        }
      }, {
        key: "clearScreen",
        value: function value() {
          var t = this.gl;
          t.viewport(0, 0, this.ctx.canvas.clientWidth, this.ctx.canvas.clientHeight), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT), (0, cn.G3)(this.degToRad(this.fov), this.ctx.canvas.clientWidth / this.ctx.canvas.clientHeight, .1, 100, this.uProjMat), this.uViewMat = (0, cn.Ue)();
        }
      }, {
        key: "clearHud",
        value: function value() {
          var t = this.ctx;
          t.clearRect(0, 0, t.canvas.width, t.canvas.height);
        }
      }, {
        key: "writeText",
        value: function value(t, e, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
              o = this.ctx;
          o.save(), o.font = "20px invasion2000", o.textAlign = "center", o.textBaseline = "middle", o.fillStyle = "white", n ? (o.fillText(t, null != e ? e : o.canvas.width / 2 + 76, null != r ? r : o.canvas.height / 2), o.drawImage(n, null != e ? e : o.canvas.width / 2, null != r ? r : o.canvas.height / 2, 76, 76)) : o.fillText(t, null != e ? e : o.canvas.width / 2, null != r ? r : o.canvas.height / 2), o.restore();
        }
      }, {
        key: "speechSynthesis",
        value: function value(t) {
          var e,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "en",
              n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
              o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
              i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
              a = this.voice,
              s = null !== (e = window.speechSynthesis.getVoices()) && void 0 !== e ? e : [];
          console.log(s), a.voice = s[0], n && (a.rate = n), o && (a.volume = o), i && (a.pitch = i), a.text = t, a.lang = r, window.speechSynthesis.speak(a);
        }
      }, {
        key: "setGreeting",
        value: function value(t) {
          this.globalStore.greeting = t;
        }
      }, {
        key: "scrollText",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              n = new yn(this.ctx);
          return n.init(t, 10, 2 * this.canvas.clientHeight / 3, this.canvas.clientWidth - 20, this.canvas.clientHeight / 3 - 20, r), n.setOptions(r), e && n.scroll((Math.sin(new Date().getTime() / 3e3) + 1) * n.maxScroll * .5), n.render(), n;
        }
      }, {
        key: "screenSize",
        value: function value() {
          return {
            width: this.canvas.clientWidth,
            height: this.canvas.clientHeight
          };
        }
      }, {
        key: "drawButton",
        value: function value(t, e, r, n, o, i) {
          var a = this.ctx,
              s = o / 2;
          a.save(), a.fillStyle = i.background, a.beginPath(), a.rect(e, r, n, o), a.rect(e, r, n, o), a.fill(), a.clip();
          var c = a.createLinearGradient(e, r, e, r + s);
          c.addColorStop(0, "rgb(221,181,155)"), c.addColorStop(1, "rgb(22,13,8)"), a.fillStyle = c, a.globalAlpha = .5, a.fillRect(e, r, n, o), a.fillStyle = i.top;

          for (var u = 0; u < o; u += s) {
            a.fillStyle = 0 === u ? i.top : i.bottom;

            for (var l = 0; l < 50; l++) {
              var f = e + Math.random() * n,
                  h = r + u + Math.random() * s,
                  p = 10 * Math.random(),
                  d = 10 * Math.random(),
                  y = 360 * Math.random(),
                  m = Math.random();
              a.save(), a.translate(f, h), a.rotate(y * Math.PI / 180), a.translate(-f, -h), a.globalAlpha = m, a.fillRect(f, h, p, d), a.restore();
            }
          }

          a.font = "20px invasion2000", a.textAlign = "center", a.textBaseline = "middle", a.fillStyle = "white", a.fillText(t, e + n / 2, r + o / 2, n), a.restore();
        }
      }, {
        key: "render",
        value: function value() {
          this.requestId = requestAnimationFrame(this.render), this.clearScreen(), this.clearHud(), this.gamepad.render(), this.scene.render(this, new Date().getTime());
        }
      }, {
        key: "toggleFullscreen",
        value: function value() {
          if (this.fullscreen) {
            try {
              document.exitFullscreen();
            } catch (t) {}

            this.fullscreen = !1;
          } else try {
            this.gamepadcanvas.parentElement.requestFullscreen(), this.fullscreen = !0;
          } catch (t) {}
        }
      }, {
        key: "createBuffer",
        value: function value(t, e, r) {
          var n = this.gl,
              o = n.createBuffer();
          return o.itemSize = r, o.numItems = t.length / r, n.bindBuffer(n.ARRAY_BUFFER, o), n.bufferData(n.ARRAY_BUFFER, new Float32Array(t), e), n.bindBuffer(n.ARRAY_BUFFER, null), o;
        }
      }, {
        key: "updateBuffer",
        value: function value(t, e) {
          var r = this.gl;
          r.bindBuffer(r.ARRAY_BUFFER, t), r.bufferSubData(r.ARRAY_BUFFER, 0, new Float32Array(e)), r.bindBuffer(r.ARRAY_BUFFER, null);
        }
      }, {
        key: "bindBuffer",
        value: function value(t, e) {
          var r = this.gl;
          r.bindBuffer(r.ARRAY_BUFFER, t), r.vertexAttribPointer(e, t.itemSize, r.FLOAT, !1, 0, 0);
        }
      }, {
        key: "loadTexture",
        value: function value(t) {
          return this.textures[t] || (this.textures[t] = new hn(t, this)), this.textures[t];
        }
      }, {
        key: "loadSpeech",
        value: function value(t, e) {
          return this.speeches[t] || (this.speeches[t] = new En(e, this, t)), this.speeches[t];
        }
      }, {
        key: "mvPushMatrix",
        value: function value() {
          var t = (0, cn.Ue)();
          (0, cn.t8)(this.uViewMat, t), this.modelViewMatrixStack.push(t);
        }
      }, {
        key: "initCanvasTexture",
        value: function value() {
          var t = this.gl.createTexture();
          return this.handleLoadedTexture(t, this.mipmap), t;
        }
      }, {
        key: "handleLoadedTexture",
        value: function value(t, e) {
          var r = this.gl;
          r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, !0), r.bindTexture(r.TEXTURE_2D, t), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, r.RGBA, r.UNSIGNED_BYTE, e), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR_MIPMAP_NEAREST), r.generateMipmap(r.TEXTURE_2D), r.bindTexture(r.TEXTURE_2D, null);
        }
      }, {
        key: "mvPopMatrix",
        value: function value() {
          if (0 == this.modelViewMatrixStack.length) throw "Invalid popMatrix!";
          this.uViewMat = this.modelViewMatrixStack.pop();
        }
      }, {
        key: "close",
        value: function value() {
          cancelAnimationFrame(this.requestId);
        }
      }, {
        key: "degToRad",
        value: function value(t) {
          return t * Math.PI / 180;
        }
      }], r && Bn(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function Dn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    var Yn = function () {
      function t() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), t._instance || (this.activeKeys = [], this.activeCodes = [], this.shift = !1, t._instance = this), t._instance;
      }

      var e, r;
      return e = t, r = [{
        key: "onKeyDown",
        value: function value(e) {
          e.preventDefault();
          var r = String.fromCharCode(e.keyCode).toLowerCase();
          t._instance.activeKeys.indexOf(r) < 0 && t._instance.activeKeys.push(r), t._instance.activeCodes.indexOf(e.key) < 0 && t._instance.activeCodes.push(e.key), t._instance.shift = e.shiftKey;
        }
      }, {
        key: "onKeyUp",
        value: function value(e) {
          var r = String.fromCharCode(e.keyCode).toLowerCase(),
              n = t._instance.activeKeys.indexOf(r);

          t._instance.activeKeys.splice(n, 1), t._instance.activeCodes.splice(n, 1);
        }
      }, {
        key: "lastPressed",
        value: function value(e) {
          for (var r = e.toLowerCase(), n = null, o = -1, i = 0; i < e.length; i++) {
            var a = r[i],
                s = t._instance.activeKeys.indexOf(a);

            s > o && (n = a, o = s);
          }

          return n;
        }
      }, {
        key: "lastPressedCode",
        value: function value() {
          for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", r = t._instance.activeCodes.pop(), n = e.toLowerCase(), o = 0; o < n.length; o++) {
            var i = t._instance.activeKeys.indexOf(r);

            i < 0 && (r = t._instance.activeCodes.pop());
          }

          return r;
        }
      }, {
        key: "lastPressedKey",
        value: function value() {
          return t._instance.activeKeys[t._instance.activeKeys.length - 1];
        }
      }], r && Dn(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function zn(t) {
      return zn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, zn(t);
    }

    function Un(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Gn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Un(Object(r), !0).forEach(function (e) {
          Kn(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Un(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function Kn(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function Hn() {
      Hn = function Hn() {
        return t;
      };

      var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n = "function" == typeof Symbol ? Symbol : {},
          o = n.iterator || "@@iterator",
          i = n.asyncIterator || "@@asyncIterator",
          a = n.toStringTag || "@@toStringTag";

      function s(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }

      try {
        s({}, "");
      } catch (t) {
        s = function s(t, e, r) {
          return t[e] = r;
        };
      }

      function c(t, e, r, n) {
        var o = e && e.prototype instanceof f ? e : f,
            i = Object.create(o.prototype),
            a = new x(n || []);
        return i._invoke = function (t, e, r) {
          var n = "suspendedStart";
          return function (o, i) {
            if ("executing" === n) throw new Error("Generator is already running");

            if ("completed" === n) {
              if ("throw" === o) throw i;
              return {
                value: void 0,
                done: !0
              };
            }

            for (r.method = o, r.arg = i;;) {
              var a = r.delegate;

              if (a) {
                var s = w(a, r);

                if (s) {
                  if (s === l) continue;
                  return s;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw n = "completed", r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var c = u(t, e, r);

              if ("normal" === c.type) {
                if (n = r.done ? "completed" : "suspendedYield", c.arg === l) continue;
                return {
                  value: c.arg,
                  done: r.done
                };
              }

              "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
            }
          };
        }(t, r, a), i;
      }

      function u(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = c;
      var l = {};

      function f() {}

      function h() {}

      function p() {}

      var d = {};
      s(d, o, function () {
        return this;
      });
      var y = Object.getPrototypeOf,
          m = y && y(y(L([])));
      m && m !== e && r.call(m, o) && (d = m);
      var v = p.prototype = f.prototype = Object.create(d);

      function g(t) {
        ["next", "throw", "return"].forEach(function (e) {
          s(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }

      function b(t, e) {
        function n(o, i, a, s) {
          var c = u(t[o], t, i);

          if ("throw" !== c.type) {
            var l = c.arg,
                f = l.value;
            return f && "object" == zn(f) && r.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
              n("next", t, a, s);
            }, function (t) {
              n("throw", t, a, s);
            }) : e.resolve(f).then(function (t) {
              l.value = t, a(l);
            }, function (t) {
              return n("throw", t, a, s);
            });
          }

          s(c.arg);
        }

        var o;

        this._invoke = function (t, r) {
          function i() {
            return new e(function (e, o) {
              n(t, r, e, o);
            });
          }

          return o = o ? o.then(i, i) : i();
        };
      }

      function w(t, e) {
        var r = t.iterator[e.method];

        if (void 0 === r) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = void 0, w(t, e), "throw" === e.method)) return l;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return l;
        }

        var n = u(r, t.iterator, e.arg);
        if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, l;
        var o = n.arg;
        return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
      }

      function O(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function _(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function x(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(O, this), this.reset(!0);
      }

      function L(t) {
        if (t) {
          var e = t[o];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var n = -1,
                i = function e() {
              for (; ++n < t.length;) {
                if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
              }

              return e.value = void 0, e.done = !0, e;
            };

            return i.next = i;
          }
        }

        return {
          next: E
        };
      }

      function E() {
        return {
          value: void 0,
          done: !0
        };
      }

      return h.prototype = p, s(v, "constructor", p), s(p, "constructor", h), h.displayName = s(p, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === h || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, p) : (t.__proto__ = p, s(t, a, "GeneratorFunction")), t.prototype = Object.create(v), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, g(b.prototype), s(b.prototype, i, function () {
        return this;
      }), t.AsyncIterator = b, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new b(c(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, g(v), s(v, a, "Generator"), s(v, o, function () {
        return this;
      }), s(v, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e.reverse(), function r() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, t.values = L, x.prototype = {
        constructor: x,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_), !t) for (var e in this) {
            "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function n(r, n) {
            return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
                a = i.completion;
            if ("root" === i.tryLoc) return n("end");

            if (i.tryLoc <= this.prev) {
              var s = r.call(i, "catchLoc"),
                  c = r.call(i, "finallyLoc");

              if (s && c) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              } else if (s) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];

            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, l) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), _(r), l;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;

                _(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, r) {
          return this.delegate = {
            iterator: L(t),
            resultName: e,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), l;
        }
      }, t;
    }

    function Vn(t, e, r, n, o, i, a) {
      try {
        var s = t[i](a),
            c = s.value;
      } catch (t) {
        return void r(t);
      }

      s.done ? e(c) : Promise.resolve(c).then(n, o);
    }

    function qn(t) {
      return function () {
        var e = this,
            r = arguments;
        return new Promise(function (n, o) {
          var i = t.apply(e, r);

          function a(t) {
            Vn(i, n, o, a, s, "next", t);
          }

          function s(t) {
            Vn(i, n, o, a, s, "throw", t);
          }

          a(void 0);
        });
      };
    }

    function $n(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var r = 0, n = new Array(e); r < e; r++) {
        n[r] = t[r];
      }

      return n;
    }

    var Xn = function Xn(r) {
      var n,
          o,
          i = r.width,
          a = r.height,
          s = r.SceneProvider,
          c = r.class,
          u = (0, t.useRef)(),
          l = (0, t.useRef)(),
          f = (0, t.useRef)(),
          h = (0, t.useRef)(),
          p = new Yn(),
          d = s.onKeyEvent,
          y = s.onTouchEvent,
          m = null,
          v = (n = (0, t.useState)({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      }), o = 2, function (t) {
        if (Array.isArray(t)) return t;
      }(n) || function (t, e) {
        var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

        if (null != r) {
          var n,
              o,
              i = [],
              a = !0,
              s = !1;

          try {
            for (r = r.call(t); !(a = (n = r.next()).done) && (i.push(n.value), !e || i.length !== e); a = !0) {
              ;
            }
          } catch (t) {
            s = !0, o = t;
          } finally {
            try {
              a || null == r.return || r.return();
            } finally {
              if (s) throw o;
            }
          }

          return i;
        }
      }(n, o) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return $n(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? $n(t, e) : void 0;
        }
      }(n, o) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
          g = v[0],
          b = v[1],
          w = function w() {
        b({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        });
      };

      function O() {
        return _.apply(this, arguments);
      }

      function _() {
        return (_ = qn(Hn().mark(function t() {
          return Hn().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, dn.load();

                case 2:
                  document.fonts.add(dn);

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }))).apply(this, arguments);
      }

      (0, t.useEffect)(qn(Hn().mark(function t() {
        var e, r, n, o;
        return Hn().wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return window.addEventListener("resize", w), e = u.current, r = l.current, n = h.current, o = f.current, m = new In(e, r, n, o, i, a), t.next = 8, O();

              case 8:
                return t.next = 10, m.init(s, p);

              case 10:
                return m.render(), t.abrupt("return", function () {
                  window.removeEventListener("resize", w), m.close();
                });

              case 12:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })), [s]);
      var x = 3 * g.dynamicWidth / 4 > 900 ? 900 : g.dynamicHeight - 200,
          L = g.dynamicWidth <= 900;
      return e().createElement("div", {
        style: {
          position: "relative",
          padding: "none",
          background: "slategrey",
          width: "100%"
        },
        onKeyDownCapture: function onKeyDownCapture(t) {
          return d(t.nativeEvent);
        },
        onKeyUpCapture: function onKeyUpCapture(t) {
          return d(t.nativeEvent);
        },
        tabIndex: 0
      }, e().createElement("canvas", {
        style: {
          position: "absolute",
          zIndex: 1,
          top: 0,
          left: 0,
          maxHeight: "100vh"
        },
        ref: u,
        width: g.dynamicWidth > 1440 ? 1440 : g.dynamicWidth,
        height: x,
        className: c
      }), e().createElement("canvas", {
        style: {
          position: "absolute",
          zIndex: 2,
          top: 0,
          left: 0,
          background: "none",
          maxHeight: "100vh"
        },
        ref: l,
        width: g.dynamicWidth > 1440 ? 1440 : g.dynamicWidth,
        height: x,
        className: c,
        onMouseUp: L ? null : function (t) {
          return y(t.nativeEvent);
        },
        onMouseDown: L ? null : function (t) {
          return y(t.nativeEvent);
        },
        onMouseMove: L ? null : function (t) {
          return y(t.nativeEvent);
        }
      }), e().createElement("canvas", {
        style: {
          position: "relative",
          zIndex: 5,
          top: 0,
          left: 0,
          background: "none",
          display: L ? "block" : "none",
          maxHeight: "100vh"
        },
        ref: f,
        hidden: !L,
        width: g.dynamicWidth > 1440 ? 1440 : g.dynamicWidth,
        height: x + 200,
        className: c,
        onMouseUp: function onMouseUp(t) {
          return y(t.nativeEvent);
        },
        onMouseDown: function onMouseDown(t) {
          return y(t.nativeEvent);
        },
        onMouseMove: function onMouseMove(t) {
          return y(t.nativeEvent);
        },
        onTouchMoveCapture: function onTouchMoveCapture(t) {
          return y(t.nativeEvent);
        },
        onTouchCancelCapture: function onTouchCancelCapture(t) {
          return y(t.nativeEvent);
        },
        onTouchStartCapture: function onTouchStartCapture(t) {
          return y(t.nativeEvent);
        },
        onTouchEndCapture: function onTouchEndCapture(t) {
          return y(t.nativeEvent);
        }
      }), e().createElement("canvas", {
        style: {
          display: "none"
        },
        ref: h,
        width: 256,
        height: 256
      }), (null === m || m.store["garden-tome"].rain) && e().createElement("div", {
        className: "rain back-row"
      }, [{
        right: "2%",
        bottom: "103%",
        "animation-delay": "0.75s",
        "animation-duration": "0.575s"
      }, {
        right: "6%",
        bottom: "107%",
        "animation-delay": "0.80s",
        "animation-duration": "0.580s"
      }, {
        right: "13%",
        bottom: "107%",
        "animation-delay": "0.55s",
        "animation-duration": "0.555s"
      }, {
        right: "15%",
        bottom: "103%",
        "animation-delay": "0.77s",
        "animation-duration": "0.577s"
      }, {
        right: "19%",
        bottom: "107%",
        "animation-delay": "0.63s",
        "animation-duration": "0.563s"
      }, {
        right: "24%",
        bottom: "109%",
        "animation-delay": "0.63s",
        "animation-duration": "0.563s"
      }, {
        right: "36%",
        bottom: "107%",
        "animation-delay": "0.80s",
        "animation-duration": "0.580s"
      }, {
        right: "44%",
        bottom: "107%",
        "animation-delay": "0.55s",
        "animation-duration": "0.555s"
      }, {
        right: "23%",
        bottom: "103%",
        "animation-delay": "0.27s",
        "animation-duration": "0.527s"
      }, {
        right: "54%",
        bottom: "107%",
        "animation-delay": "0.33s",
        "animation-duration": "0.533s"
      }, {
        right: "99%",
        bottom: "109%",
        "animation-delay": "0.63s",
        "animation-duration": "0.563s"
      }, {
        right: "9%",
        bottom: "105%",
        "animation-delay": "0.13s",
        "animation-duration": "0.512s"
      }, {
        right: "52%",
        bottom: "103%",
        "animation-delay": "0.27s",
        "animation-duration": "0.527s"
      }, {
        right: "66%",
        bottom: "107%",
        "animation-delay": "0.33s",
        "animation-duration": "0.533s"
      }, {
        right: "28%",
        bottom: "107%",
        "animation-delay": "0.55s",
        "animation-duration": "0.555s"
      }, {
        right: "23%",
        bottom: "103%",
        "animation-delay": "0.28s",
        "animation-duration": "0.528s"
      }, {
        right: "34%",
        bottom: "107%",
        "animation-delay": "0.33s",
        "animation-duration": "0.533s"
      }, {
        right: "99%",
        bottom: "109%",
        "animation-delay": "0.63s",
        "animation-duration": "0.563s"
      }, {
        right: "9%",
        bottom: "105%",
        "animation-delay": "0.19s",
        "animation-duration": "0.519s"
      }, {
        right: "52%",
        bottom: "103%",
        "animation-delay": "0.27s",
        "animation-duration": "0.527s"
      }, {
        right: "66%",
        bottom: "107%",
        "animation-delay": "0.21s",
        "animation-duration": "0.521s"
      }, {
        right: "71%",
        bottom: "109%",
        "animation-delay": "0.63s",
        "animation-duration": "0.563s"
      }, {
        right: "79%",
        bottom: "103%",
        "animation-delay": "0.17s",
        "animation-duration": "0.517s"
      }, {
        right: "85%",
        bottom: "101%",
        "animation-delay": "0.11s",
        "animation-duration": "0.511s"
      }, {
        right: "89%",
        bottom: "109%",
        "animation-delay": "0.13s",
        "animation-duration": "0.512s"
      }].map(function (t) {
        return e().createElement("div", {
          className: "drop",
          style: Gn({}, t)
        }, e().createElement("div", {
          className: "stem",
          style: {
            "animation-delay": t["animation-delay"],
            "animation-duration": t["animation-duration"]
          }
        }), e().createElement("div", {
          className: "splat",
          style: {
            "animation-delay": t["animation-delay"],
            "animation-duration": t["animation-duration"]
          }
        }));
      })), " ", null !== m && m.store["garden-tome"].snow && e().createElement("div", {
        className: "snow back-row"
      }, [{
        right: "2%",
        bottom: "103%",
        "animation-delay": "1.75s",
        "animation-duration": "1.575s"
      }, {
        right: "6%",
        bottom: "107%",
        "animation-delay": "2.80s",
        "animation-duration": "1.580s"
      }, {
        right: "13%",
        bottom: "107%",
        "animation-delay": "1.55s",
        "animation-duration": "2.555s"
      }, {
        right: "15%",
        bottom: "103%",
        "animation-delay": "1.77s",
        "animation-duration": "1.577s"
      }, {
        right: "19%",
        bottom: "107%",
        "animation-delay": "1.63s",
        "animation-duration": "2.563s"
      }, {
        right: "22%",
        bottom: "109%",
        "animation-delay": "1.63s",
        "animation-duration": "2.563s"
      }, {
        right: "36%",
        bottom: "107%",
        "animation-delay": "1.80s",
        "animation-duration": "1.580s"
      }, {
        right: "44%",
        bottom: "107%",
        "animation-delay": "2.55s",
        "animation-duration": "2.555s"
      }, {
        right: "23%",
        bottom: "103%",
        "animation-delay": "1.27s",
        "animation-duration": "1.527s"
      }, {
        right: "54%",
        bottom: "107%",
        "animation-delay": "1.33s",
        "animation-duration": "1.533s"
      }, {
        right: "45%",
        bottom: "109%",
        "animation-delay": "1.63s",
        "animation-duration": "1.563s"
      }, {
        right: "91%",
        bottom: "105%",
        "animation-delay": "1.13s",
        "animation-duration": "1.512s"
      }, {
        right: "52%",
        bottom: "103%",
        "animation-delay": "1.27s",
        "animation-duration": "1.527s"
      }, {
        right: "66%",
        bottom: "107%",
        "animation-delay": "1.33s",
        "animation-duration": "2.533s"
      }, {
        right: "28%",
        bottom: "107%",
        "animation-delay": "1.55s",
        "animation-duration": "1.555s"
      }, {
        right: "23%",
        bottom: "103%",
        "animation-delay": "2.28s",
        "animation-duration": "2.528s"
      }, {
        right: "34%",
        bottom: "107%",
        "animation-delay": "1.33s",
        "animation-duration": "2.533s"
      }, {
        right: "99%",
        bottom: "109%",
        "animation-delay": "1.63s",
        "animation-duration": "1.563s"
      }, {
        right: "9%",
        bottom: "105%",
        "animation-delay": "2.19s",
        "animation-duration": "1.519s"
      }, {
        right: "52%",
        bottom: "103%",
        "animation-delay": "1.27s",
        "animation-duration": "1.527s"
      }, {
        right: "66%",
        bottom: "107%",
        "animation-delay": "1.21s",
        "animation-duration": "1.521s"
      }, {
        right: "71%",
        bottom: "109%",
        "animation-delay": "2.63s",
        "animation-duration": "1.563s"
      }, {
        right: "79%",
        bottom: "103%",
        "animation-delay": "1.17s",
        "animation-duration": "2.517s"
      }, {
        right: "85%",
        bottom: "101%",
        "animation-delay": "1.11s",
        "animation-duration": "1.511s"
      }, {
        right: "89%",
        bottom: "109%",
        "animation-delay": "1.13s",
        "animation-duration": "2.512s"
      }].map(function (t) {
        return e().createElement("div", {
          className: "flake",
          style: Gn({}, t)
        }, e().createElement("div", {
          className: "stem",
          style: {
            "animation-delay": t["animation-delay"],
            "animation-duration": t["animation-duration"]
          }
        }));
      })), " ");
    };

    Xn.propTypes = {
      width: a().number.isRequired,
      height: a().number.isRequired,
      SceneProvider: a().object.isRequired,
      class: a().string.isRequired
    };
    var Jn = Xn;
    var Qn = r(4829),
        to = r(3379),
        eo = r.n(to),
        ro = r(7795),
        no = r.n(ro),
        oo = r(569),
        io = r.n(oo),
        ao = r(3565),
        so = r.n(ao),
        co = r(9216),
        uo = r.n(co),
        lo = r(4589),
        fo = r.n(lo),
        ho = r(4913),
        po = {};

    function yo(t) {
      return yo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, yo(t);
    }

    function mo(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function vo(t, e) {
      return vo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, vo(t, e);
    }

    function go(t, e) {
      if (e && ("object" === yo(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t);
    }

    function bo(t) {
      return bo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, bo(t);
    }

    po.styleTagTransform = fo(), po.setAttributes = so(), po.insert = io().bind(null, "head"), po.domAPI = no(), po.insertStyleElement = uo(), eo()(ho.Z, po), ho.Z && ho.Z.locals && ho.Z.locals;

    var wo = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e && vo(t, e);
      }(s, t);
      var r,
          n,
          o,
          i,
          a = (o = s, i = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = bo(o);

        if (i) {
          var r = bo(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return go(this, t);
      });

      function s(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, s), (e = a.call(this, t)).state = {
          scene: new Qn.default(),
          updated: Date.now()
        }, e;
      }

      return r = s, (n = [{
        key: "componentWillReceiveProps",
        value: function value(t) {
          JSON.stringify(this.props.networkString) != JSON.stringify(t.networkString) && this.setState({
            networkString: t.networkString,
            updated: Date.now()
          });
        }
      }, {
        key: "render",
        value: function value() {
          var t = this.state,
              r = t.updated,
              n = t.scene;
          return e().createElement("div", {
            style: {
              margin: 0,
              minHeight: "480px",
              maxHeight: "100vh"
            }
          }, e().createElement(Jn, {
            class: "pixos",
            key: "pixos-".concat(r),
            width: window.innerWidth,
            height: window.innerHeight,
            SceneProvider: n
          }));
        }
      }]) && mo(r.prototype, n), Object.defineProperty(r, "prototype", {
        writable: !1
      }), s;
    }(t.Component);

    var Oo = (0, o.collect)(wo);
  })(), module.exports["calliope-pixos"] = n;
})();